{
  "_meta": {
    "locale": "el",
    "status": "complete"
  },
  "app": {
    "name": "AVRASTRO",
    "tagline": "Advisor OS",
    "workspace": "Χώρος εργασίας",
    "update_ready": "Υπάρχει νέα έκδοση του AVRASTRO. Πατήστε «Ανανέωση» για να τη χρησιμοποιήσετε.",
    "update_reload": "Ανανέωση"
  },
  "nav": {
    "today": "Τώρα",
    "people": "Άνθρωποι",
    "cases": "Υποθέσεις",
    "agenda": "Ατζέντα",
    "reviews": "Επανεξετάσεις",
    "prospects": "Προσέγγιση",
    "insights": "Εικόνα",
    "data": "Δεδομένα & ασφάλεια",
    "settings": "Ρυθμίσεις",
    "lens": "Φακός",
    "comparator": "Σύγκριση",
    "service": "Εξυπηρέτηση & αποζημιώσεις",
    "pipeline": "Pipeline",
    "decisions": "Αποφάσεις",
    "referrals": "Συστάσεις",
    "needs": "Ανάλυση αναγκών",
    "quotes": "Προσφορές",
    "proposals": "Προτάσεις",
    "business": "Business center",
    "quality": "Ποιότητα δεδομένων",
    "compliance": "Συμμόρφωση",
    "templates": "Πρότυπα μηνυμάτων",
    "day": "Η μέρα μου",
    "renewals": "Ανανεώσεις",
    "retention": "Διατήρηση",
    "vault": "Έγγραφα",
    "campaigns": "Καμπάνιες",
    "protection": "Προστασία",
    "tax": "Φορολογικό κέντρο",
    "production": "Παραγωγή",
    "assistant": "Ρώτα το AVRASTRO",
    "automations": "Αυτοματισμοί",
    "fields": "Προσαρμοσμένα πεδία",
    "sync": "Συγχρονισμός",
    "security": "Ασφάλεια",
    "account": "Λογαριασμός",
    "team": "Ομάδα",
    "branding": "Ταυτότητα",
    "radar": "Ευκαιρίες",
    "analytics": "Αναλυτικά ανάπτυξης",
    "inbox": "Εισερχόμενα ιστότοπου",
    "portal": "Πύλη πελάτη",
    "groups": "Ομαδικά σχέδια",
    "drafts": "Προσχέδια AI",
    "register": "Λίστα πελατών",
    "setup": "Οδηγός ρύθμισης",
    "help": "Βοήθεια",
    "lessons": "Μαθήματα",
    "salefiles": "Φάκελοι πώλησης",
    "calls": "Τηλεφωνική προσέγγιση",
    "callstats": "Η βελτίωσή μου",
    "gaps": "Χάρτης κενών προστασίας",
    "auditpack": "Φάκελος ελέγχου",
    "performance": "Μηνιαία απόδοση",
    "studio": "AI Studio",
    "taxfolder": "Ο φορολογικός μου φάκελος"
  },
  "common": {
    "save": "Αποθήκευση",
    "cancel": "Ακύρωση",
    "close": "Κλείσιμο",
    "delete": "Διαγραφή",
    "edit": "Επεξεργασία",
    "add": "Προσθήκη",
    "new": "Νέο",
    "back": "Πίσω",
    "open": "Άνοιγμα",
    "confirm": "Επιβεβαίωση",
    "search": "Αναζήτηση",
    "filter": "Φίλτρο",
    "all": "Όλα",
    "none": "Κανένα",
    "yes": "Ναι",
    "no": "Όχι",
    "today": "Σήμερα",
    "tomorrow": "Αύριο",
    "yesterday": "Χθες",
    "loading": "Φόρτωση…",
    "saved": "Αποθηκεύτηκε",
    "error": "Κάτι πήγε στραβά",
    "optional": "προαιρετικό",
    "more": "Περισσότερα",
    "less": "Λιγότερα",
    "details": "Λεπτομέρειες",
    "done": "Ολοκληρώθηκε",
    "reopen": "Επαναφορά",
    "export": "Εξαγωγή",
    "import": "Εισαγωγή",
    "print": "Εκτύπωση",
    "download": "Λήψη",
    "copy": "Αντιγραφή",
    "copied": "Αντιγράφηκε",
    "call": "Κλήση",
    "email": "Email",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "not_set": "Δεν έχει οριστεί",
    "unknown": "Άγνωστο",
    "empty": "Δεν υπάρχει τίποτα ακόμη",
    "name": "Όνομα",
    "phone": "Τηλέφωνο",
    "notes": "Σημειώσεις",
    "date": "Ημερομηνία",
    "time": "Ώρα",
    "status": "Κατάσταση",
    "priority": "Προτεραιότητα",
    "type": "Τύπος",
    "person": "Πρόσωπο",
    "all_people": "Όλοι",
    "select_person": "Επίλεξε πρόσωπο…",
    "required": "Υποχρεωτικό",
    "continue": "Συνέχεια",
    "undo": "Αναίρεση",
    "view_all": "Προβολή όλων",
    "items": "{count, plural, one {# στοιχείο} other {# στοιχεία}}",
    "days": "{count, plural, one {# ημέρα} other {# ημέρες}}",
    "unsaved": "Μη αποθηκευμένες αλλαγές",
    "keyboard_hint": "Πάτησε {key}",
    "nothing_to_undo": "Δεν υπάρχει κάτι για αναίρεση",
    "active": "Ενεργό",
    "inactive": "ανενεργό",
    "next": "Επόμενο",
    "deleted": "Διαγράφηκε",
    "remove": "Αφαίρεση"
  },
  "enum": {
    "stage": {
      "lead": "Επαφή",
      "prospect": "Υποψήφιος",
      "client": "Πελάτης",
      "former": "Πρώην πελάτης",
      "dependent": "Εξαρτώμενο μέλος"
    },
    "branch": {
      "life": "Ζωή & υγεία",
      "general": "Γενικές ασφαλίσεις"
    },
    "policyStatus": {
      "offer": "Προσφορά",
      "pending": "Σε εκκρεμότητα",
      "active": "Ενεργό",
      "renewed": "Ανανεώθηκε",
      "lapsed": "Ανενεργό",
      "cancelled": "Ακυρώθηκε",
      "matured": "Έληξε"
    },
    "frequency": {
      "monthly": "Μηνιαία",
      "quarterly": "Τριμηνιαία",
      "semiannual": "Εξαμηνιαία",
      "annual": "Ετήσια",
      "single": "Εφάπαξ"
    },
    "caseStage": {
      "draft": "Προσχέδιο",
      "submitted": "Υποβλήθηκε",
      "documents": "Έγγραφα",
      "underwriting": "Underwriting",
      "decision": "Απόφαση",
      "issued": "Εκδόθηκε",
      "declined": "Απορρίφθηκε",
      "postponed": "Αναβλήθηκε",
      "withdrawn": "Αποσύρθηκε"
    },
    "requirement": {
      "identity": "Ταυτότητα / Διαβατήριο",
      "address": "Απόδειξη διεύθυνσης",
      "bank": "Τραπεζικά / SEPA",
      "questionnaire": "Ερωτηματολόγιο",
      "financial": "Οικονομικά στοιχεία",
      "medical": "Ιατρικά / εξετάσεις",
      "signature": "Υπογραφές",
      "other": "Πρόσθετα έγγραφα"
    },
    "taskKind": {
      "task": "Εργασία",
      "call": "Κλήση",
      "followup": "Follow-up",
      "appointment": "Ραντεβού",
      "review": "Επανεξέταση",
      "document": "Υπενθύμιση εγγράφου",
      "renewal": "Ανανέωση",
      "application": "Αίτηση",
      "other": "Άλλο"
    },
    "taskStatus": {
      "open": "Ανοιχτό",
      "done": "Ολοκληρώθηκε",
      "cancelled": "Ακυρώθηκε"
    },
    "priority": {
      "low": "Χαμηλή",
      "normal": "Κανονική",
      "high": "Υψηλή",
      "urgent": "Επείγον"
    },
    "location": {
      "office": "Στο γραφείο",
      "client": "Στον πελάτη",
      "online": "Online",
      "phone": "Τηλεφωνικά",
      "custom": "Άλλο σημείο"
    },
    "reviewOutcome": {
      "completed": "Ολοκληρώθηκε",
      "open": "Ανοιχτό",
      "needs_followup": "Χρειάζεται follow-up",
      "no_change": "Καμία αλλαγή",
      "declined": "Ο πελάτης αρνήθηκε"
    },
    "prospectStatus": {
      "new": "Νέος",
      "called": "Τηλεφωνήθηκε",
      "no_answer": "Δεν απάντησε",
      "callback": "Να ξαναπάρω",
      "interested": "Ενδιαφέρεται",
      "appointment": "Ραντεβού",
      "not_interested": "Δεν ενδιαφέρεται",
      "wrong_number": "Λάθος αριθμός",
      "converted": "Μετατράπηκε"
    },
    "outcome": {
      "positive": "Θετικό",
      "neutral": "Ουδέτερο",
      "negative": "Αρνητικό"
    },
    "occupationRisk": {
      "low": "Επάγγελμα χαμηλού κινδύνου",
      "medium": "Επάγγελμα μεσαίου κινδύνου",
      "high": "Επάγγελμα υψηλού κινδύνου"
    },
    "severity": {
      "critical": "Κρίσιμο",
      "high": "Υψηλό",
      "medium": "Μεσαίο",
      "low": "Χαμηλό"
    },
    "reviewState": {
      "not_applicable": "Χωρίς ενεργά συμβόλαια",
      "never": "Δεν έχει γίνει ποτέ review",
      "overdue": "Εκπρόθεσμο review",
      "due_soon": "Επανεξέταση σύντομα",
      "ok": "Ενημερωμένο"
    },
    "serviceStatus": {
      "open": "Ανοιχτό",
      "in_progress": "Σε εξέλιξη",
      "waiting": "Σε αναμονή",
      "closed": "Κλειστό"
    },
    "householdRole": {
      "primary": "Κύριο μέλος",
      "spouse": "Σύζυγος / σύντροφος",
      "child": "Παιδί",
      "dependent": "Εξαρτώμενο μέλος",
      "other": "Άλλο"
    },
    "timeline": {
      "created": "Δημιουργία",
      "note": "Σημείωση",
      "call": "Κλήση",
      "message": "Μήνυμα",
      "email": "Email",
      "meeting": "Συνάντηση",
      "appointment": "Ραντεβού",
      "task": "Εργασία",
      "policy": "Συμβόλαιο",
      "case": "Υπόθεση",
      "review": "Επανεξέταση",
      "document": "Έγγραφο",
      "service": "Εξυπηρέτηση",
      "proposal": "Πρόταση",
      "comparison": "Σύγκριση",
      "import": "Εισαγωγή",
      "system": "Σύστημα",
      "legacy": "Ιστορική εγγραφή"
    },
    "riskAttitude": {
      "conservative": "Συντηρητικό",
      "balanced": "Ισορροπημένο",
      "growth": "Αναπτυξιακό",
      "unknown": "Δεν αξιολογήθηκε"
    },
    "quoteStatus": {
      "draft": "Πρόχειρη",
      "sent": "Εστάλη",
      "accepted": "Αποδεκτή",
      "declined": "Απορρίφθηκε",
      "expired": "Έληξε"
    },
    "opportunityStage": {
      "lead": "Επαφή",
      "qualified": "Αξιολογημένη",
      "proposal": "Πρόταση",
      "decision": "Απόφαση",
      "won": "Κερδήθηκε",
      "lost": "Χάθηκε",
      "deferred": "Αναβλήθηκε"
    },
    "referralStatus": {
      "new": "Νέα",
      "contacted": "Επικοινωνήσαμε",
      "meeting": "Συνάντηση",
      "converted": "Μετατράπηκε",
      "declined": "Αρνήθηκε"
    },
    "commChannel": {
      "phone": "Τηλέφωνο",
      "email": "E-mail",
      "sms": "SMS",
      "whatsapp": "WhatsApp",
      "meeting": "Συνάντηση",
      "letter": "Επιστολή",
      "social": "Social",
      "other": "Άλλο"
    },
    "commDirection": {
      "out": "Εξερχόμενη",
      "in": "Εισερχόμενη"
    },
    "claimStatus": {
      "open": "Ανοιχτή",
      "submitted": "Υποβλήθηκε",
      "pending_documents": "Εκκρεμούν έγγραφα",
      "approved": "Εγκρίθηκε",
      "paid": "Πληρώθηκε",
      "declined": "Απορρίφθηκε",
      "closed": "Έκλεισε"
    },
    "policyCategory": {
      "life": "Ζωής",
      "medical": "Ιατροφαρμακευτικό",
      "savings": "Αποταμιευτικό",
      "pension": "Συνταξιοδοτικό",
      "education": "Σπουδών",
      "accident": "Ατυχημάτων",
      "critical_illness": "Σοβαρών ασθενειών",
      "disability": "Αναπηρίας",
      "credit_life": "Ζωής δανείου",
      "motor": "Αυτοκινήτου",
      "home": "Κατοικίας",
      "travel": "Ταξιδιωτική",
      "liability": "Αστικής ευθύνης",
      "business": "Επιχείρησης",
      "group": "Ομαδική",
      "other": "Άλλη"
    },
    "partyRole": {
      "owner": "Συμβαλλόμενος",
      "insured": "Ασφαλισμένος",
      "beneficiary": "Δικαιούχος",
      "payer": "Πληρωτής",
      "advisor": "Σύμβουλος"
    },
    "benefit": {
      "death": "Θάνατος",
      "critical_illness": "Σοβαρές ασθένειες",
      "disability": "Αναπηρία",
      "waiver": "Απαλλαγή ασφαλίστρων",
      "income": "Παροχή εισοδήματος",
      "medical": "Ιατροφαρμακευτική",
      "hospital": "Νοσοκομειακή",
      "accident": "Ατύχημα",
      "savings": "Αποταμίευση",
      "maturity": "Λήξη",
      "mortgage": "Στεγαστικό",
      "other": "Άλλη"
    },
    "lifeEvent": {
      "marriage": "Γάμος",
      "new_child": "Νέο παιδί",
      "new_job": "Νέα εργασία",
      "salary_increase": "Αύξηση μισθού",
      "home_purchase": "Αγορά κατοικίας",
      "mortgage": "Νέο στεγαστικό",
      "new_loan": "Νέο δάνειο",
      "business_start": "Έναρξη επιχείρησης",
      "retirement_planning": "Σχεδιασμός σύνταξης",
      "divorce": "Διαζύγιο",
      "new_property": "Νέο ακίνητο",
      "other": "Άλλο γεγονός ζωής"
    },
    "docCategory": {
      "identity": "Ταυτοποίηση",
      "policies": "Συμβόλαια",
      "applications": "Αιτήσεις",
      "tax": "Φορολογικά",
      "income": "Εισόδημα",
      "medical": "Ιατρικά",
      "loans": "Δάνεια",
      "claims": "Αποζημιώσεις",
      "quotations": "Προσφορές",
      "signed": "Υπογεγραμμένα",
      "other": "Άλλα"
    }
  },
  "today": {
    "greeting": "{part, select, morning {Καλημέρα} afternoon {Καλό απόγευμα} other {Καλησπέρα}}{name, select, none {} other {, {name}}}",
    "summary": "{attention, plural, =0 {Τίποτα δεν σε χρειάζεται επειγόντως.} one {# σχέση χρειάζεται την προσοχή σου.} other {# σχέσεις χρειάζονται την προσοχή σου.}} {agenda, plural, =0 {Η ατζέντα σου είναι ελεύθερη.} one {# στοιχείο στη σημερινή ατζέντα.} other {# στοιχεία στη σημερινή ατζέντα.}}",
    "attention_title": "Πεδίο προσοχής",
    "attention_hint": "Κατά σειρά προτεραιότητας, με τον λόγο και την επόμενη κίνηση.",
    "attention_empty": "Το χαρτοφυλάκιό σου είναι σε τάξη. Αξιοποίησε τον χρόνο για να πάρεις κάποιον που δεν έχετε μιλήσει καιρό.",
    "agenda_title": "Σήμερα",
    "agenda_empty": "Δεν υπάρχουν ραντεβού ή εργασίες για σήμερα.",
    "overdue_title": "Εκπρόθεσμα",
    "cases_title": "Υποθέσεις σε κίνηση",
    "cases_empty": "Δεν υπάρχουν ενεργές αιτήσεις.",
    "moments_title": "Στιγμές",
    "moments_empty": "Δεν υπάρχουν γενέθλια ή ονομαστικές εορτές τις επόμενες ημέρες.",
    "stat_people": "Άνθρωποι",
    "stat_clients": "Πελάτες",
    "stat_portfolio": "Ετήσιο χαρτοφυλάκιο",
    "stat_open_cases": "Ενεργές υποθέσεις",
    "stat_reviews_due": "Επανεξετάσεις σε εκκρεμότητα",
    "stat_overdue": "Εκπρόθεσμες ενέργειες",
    "show_more": "Εμφάνιση {count} ακόμη",
    "focus_mode": "Εστίαση",
    "waiting_title": "Αποφάσεις & αναμονές",
    "waiting_client": "Αναμονή για {name}"
  },
  "attention": {
    "reason": {
      "task_overdue": "{title} — εκπρόθεσμο {days, plural, one {# ημέρα} other {# ημέρες}}",
      "task_today": "{title} — λήγει σήμερα{time, select, none {} other { στις {time}}}",
      "appointment_today": "Ραντεβού σήμερα στις {time}: {title}",
      "appointment_tomorrow": "Ραντεβού αύριο στις {time} — ετοίμασε το meeting pack",
      "case_stalled": "{product}: καμία κίνηση εδώ και {days} ημέρες ({stage})",
      "case_missing": "{product}: {count, plural, one {λείπει # δικαιολογητικό} other {λείπουν # δικαιολογητικά}}",
      "case_no_next": "{product} ({stage}) χωρίς προγραμματισμένη επόμενη ενέργεια",
      "case_target": "{product}: στόχος έκδοσης {date}",
      "review_overdue": "Το ετήσιο review καθυστερεί {days} ημέρες",
      "review_never": "Έχει {policies, plural, one {# ενεργό συμβόλαιο} other {# ενεργά συμβόλαια}} και δεν έχει γίνει ποτέ review",
      "review_due_soon": "Ετήσιο review στις {date}",
      "renewal_soon": "{product}: ανανέωση στις {date}",
      "birthday": "{when, select, today {Γενέθλια σήμερα} tomorrow {Γενέθλια αύριο} other {Γενέθλια στις {date}}} — κλείνει τα {age}",
      "nameday": "{when, select, today {Γιορτάζει σήμερα} tomorrow {Γιορτάζει αύριο} other {Γιορτάζει στις {date}}} ({feast})",
      "child_milestone": "{child}: κλείνει τα {age} στις {date} — review σπουδών / προστασίας",
      "protection_gap": "Έχει {children, plural, one {# εξαρτώμενο παιδί} other {# εξαρτώμενα παιδιά}} χωρίς ενεργή ασφάλεια ζωής",
      "no_next_step": "Ανοιχτή {kind, select, offer {προσφορά} case {αίτηση} other {ευκαιρία}} χωρίς προγραμματισμένο επόμενο βήμα",
      "silence": "Καμία επαφή εδώ και {days} ημέρες με ενεργό πελάτη",
      "prospect_followup": "Το follow-up με {name} ({list}) έπρεπε να γίνει στις {date}",
      "data_quality": "Λείπουν τηλέφωνο και email — δεν μπορεί να γίνει επικοινωνία",
      "hot": "Ζεστή ευκαιρία: {signal}{more, plural, =0 {} one { + # ακόμα ένδειξη} other { + # ακόμα ενδείξεις}}",
      "promise_overdue": "Υποσχεθήκατε «{title}» — {days, plural, one {# ημέρα καθυστέρηση} other {# ημέρες καθυστέρηση}}",
      "waiting_client": "Αναμονή για τον πελάτη: «{title}» — {days, plural, one {# ημέρα} other {# ημέρες}} μετά την ημερομηνία",
      "quote_expiring": "Προσφορά {product} {when, select, past {έληξε στις {date}} other {λήγει στις {date}}}",
      "decision_pending": "Εκκρεμεί απόφαση για «{title}» εδώ και {days} ημέρες — χωρίς προγραμματισμένη επικοινωνία",
      "needs_missing": "{children, plural, one {# παιδί εξαρτάται} other {# παιδιά εξαρτώνται}} από τον πελάτη — δεν υπάρχει ανάλυση αναγκών",
      "claim_followup": "Αποζημίωση {type} ({status}) χρειάζεται παρακολούθηση — {days, plural, =0 {ενημέρωση σήμερα} one {τελευταία ενημέρωση πριν # ημέρα} other {τελευταία ενημέρωση πριν # ημέρες}}",
      "service_open": "Αίτημα εξυπηρέτησης «{title}» ανοιχτό εδώ και {days} ημέρες",
      "referral_thanks": "Σύστησε τον/την {name} — πείτε ευχαριστώ",
      "policy_lapsed": "Το {product} ακυρώθηκε λόγω μη πληρωμής {days, plural, =0 {σήμερα} one {πριν από # ημέρα} other {πριν από # ημέρες}} — μια κλήση συχνά αρκεί για επαναφορά",
      "payment_late_verified": "{product}: η εταιρεία επιβεβαιώνει καθυστέρηση πληρωμής",
      "payment_late_note": "{product}: σημειώσατε πιθανή καθυστέρηση πληρωμής (δεν έχει επιβεβαιωθεί από την εταιρεία)",
      "life_event": "Γεγονός ζωής: {event} ({date}) — η κάλυψη ίσως χρειάζεται επανεξέταση",
      "loan_maturity": "{label}: λήγει στις {date}",
      "mortgage_gap": "Υπόλοιπο στεγαστικού {balance, number, currency} αλλά μόνο {cover, number, currency} κάλυψη ζωής γι’ αυτό",
      "education_milestone": "Ο/Η {child} κλείνει τα {age} στις {date} — καλή στιγμή για κουβέντα για σπουδές",
      "extraction_review": "{count, plural, one {# τιμή από έγγραφο περιμένει} other {# τιμές από έγγραφο περιμένουν}} τον έλεγχό σας",
      "sync_conflict": "Μια εγγραφή ({table}) άλλαξε σε δύο συσκευές — επιλέξτε ποια εκδοχή κρατάτε",
      "insured_due": "{what} για {label} στις {date}",
      "premium_overdue": "{product}: το ασφάλιστρο της {date} δεν έχει εισπραχθεί ακόμη ({days, plural, one {# ημέρα} other {# ημέρες}})",
      "premium_lapse_risk": "{product}: ασφάλιστρο ληξιπρόθεσμο εδώ και {days, plural, one {# ημέρα} other {# ημέρες}} — κίνδυνος ακύρωσης",
      "kyc_due": "Επανεξέταση KYC/AML στις {date}",
      "kyc_overdue": "Η επανεξέταση KYC/AML έληγε στις {date} — ενημερώστε τον φάκελο"
    },
    "action": {
      "complete_task": "Ολοκλήρωση",
      "call": "Κλήση",
      "open_case": "Άνοιγμα υπόθεσης",
      "schedule_next": "Προγραμμάτισε επόμενη ενέργεια",
      "request_documents": "Ζήτα τα έγγραφα",
      "start_review": "Ξεκίνα review",
      "schedule_review": "Κλείσε review",
      "send_wishes": "Στείλε ευχές",
      "prepare_meeting": "Προετοιμασία ραντεβού",
      "discuss_protection": "Συζήτηση προστασίας",
      "reconnect": "Επανασύνδεση",
      "call_prospect": "Κάλεσε τον υποψήφιο",
      "complete_profile": "Συμπλήρωσε το προφίλ",
      "open": "Άνοιγμα",
      "keep_promise": "Τηρήστε την υπόσχεση",
      "chase_client": "Υπενθύμιση στον πελάτη",
      "follow_quote": "Παρακολούθηση προσφοράς",
      "start_needs": "Ανάλυση αναγκών",
      "open_service": "Άνοιγμα εξυπηρέτησης",
      "thank": "Ευχαριστήστε",
      "resolve_conflict": "Επίλυση",
      "review_extraction": "Έλεγχος τιμών",
      "open_insured": "Άνοιγμα αντικειμένων",
      "open_kyc": "Άνοιγμα KYC"
    },
    "why": "Γιατί",
    "evidence": "Με βάση",
    "dismiss": "Αναβολή για αύριο",
    "snoozed": "Αναβλήθηκε για αύριο"
  },
  "brief": {
    "title": "Σύνοψη σχέσης",
    "who": "Ποιος",
    "why": "Γιατί τώρα",
    "done": "Τι έχουμε κάνει",
    "missing": "Τι λείπει",
    "next": "Επόμενη σωστή κίνηση",
    "last_contact": "Τελευταία επαφή {date} · {what}",
    "never_contacted": "Δεν έχει καταγραφεί επαφή ακόμη",
    "nothing_missing": "Δεν λείπει τίποτα — η σχέση είναι σε καλή κατάσταση",
    "no_reason": "Κανένας επείγων λόγος — κράτα τη σχέση ζεστή",
    "since": "Σχέση από {date}",
    "age": "{age} ετών",
    "children": "{count, plural, one {# παιδί} other {# παιδιά}}",
    "open_items": "{count, plural, =0 {καμία ανοιχτή ενέργεια} one {# ανοιχτή ενέργεια} other {# ανοιχτές ενέργειες}}"
  },
  "people": {
    "title": "Άνθρωποι",
    "subtitle": "Πελάτες, υποψήφιοι και οι οικογένειές τους",
    "search": "Αναζήτηση ονόματος, τηλεφώνου, email, επαγγέλματος…",
    "new": "Νέο πρόσωπο",
    "count": "{count, plural, one {# πρόσωπο} other {# πρόσωπα}}",
    "empty": "Κανένα πρόσωπο δεν ταιριάζει με τα φίλτρα.",
    "filter_stage": "Στάδιο",
    "filter_attention": "Χρειάζονται προσοχή",
    "filter_review": "Επανεξέταση σε εκκρεμότητα",
    "filter_hot": "Hot",
    "filter_policies": "Με συμβόλαια",
    "sort_attention": "Κατά προτεραιότητα",
    "sort_name": "Κατά όνομα",
    "sort_recent": "Πρόσφατες αλλαγές",
    "archived": "Αρχειοθετημένοι",
    "register": "Λίστα πελατών",
    "register_hint": "Εκτύπωση ή εξαγωγή όλων των πελατών με το πότε έγιναν πελάτες και την πηγή τους",
    "filter_source": "Πηγή"
  },
  "person": {
    "display_name": "Ονοματεπώνυμο",
    "first_name": "Όνομα",
    "last_name": "Επώνυμο",
    "stage": "Στάδιο",
    "phone": "Κινητό τηλέφωνο",
    "email": "Email",
    "birth_date": "Ημερομηνία γέννησης",
    "name_day": "Ονομαστική εορτή (ΜΜ-ΗΗ, προαιρετική παράκαμψη)",
    "occupation": "Επάγγελμα",
    "employer": "Εργοδότης",
    "address": "Διεύθυνση",
    "city": "Πόλη",
    "region": "Περιοχή / επαρχία",
    "source": "Πηγή",
    "referred_by": "Σύσταση από",
    "gender": "Φύλο",
    "marital_status": "Οικογενειακή κατάσταση",
    "notes": "Σημαντικές σημειώσεις",
    "hot": "Hot ευκαιρία",
    "new_title": "Νέο πρόσωπο",
    "edit_title": "Επεξεργασία προσώπου",
    "archive": "Αρχειοθέτηση",
    "archive_confirm": "Αρχειοθέτηση του/της {name}; Το ιστορικό διατηρείται και μπορεί να επανέλθει.",
    "created": "Προστέθηκε: {name}",
    "updated": "Οι αλλαγές αποθηκεύτηκαν",
    "duplicate_warning": "Πιθανό διπλότυπο: ο/η {name} έχει το ίδιο τηλέφωνο ή email.",
    "client_since": "Πελάτης από",
    "client_since_hint": "Η ημέρα που έγινε πελάτης σας.",
    "client_since_hint_derived": "Αν μείνει κενό: {date} ({basis}).",
    "source_other": "Άλλη πηγή…",
    "source_own": "Η δική σας πηγή",
    "source_own_ph": "π.χ. Γυμναστήριο, Σύλλογος γονέων",
    "referred_by_hint": "Διαλέξτε υπάρχον πρόσωπο ή γράψτε όνομα",
    "since_basis": {
      "recorded": "καταχωρισμένη",
      "first_policy": "πρώτο συμβόλαιο",
      "added": "καταχώριση στο AVRASTRO"
    },
    "client_since_label": "Πελάτης από {date}",
    "source_label": "Πηγή: {source}",
    "referred_by_label": "σύσταση από {name}"
  },
  "focus": {
    "tabs": {
      "overview": "Επισκόπηση",
      "policies": "Συμβόλαια",
      "cases": "Υποθέσεις",
      "actions": "Ενέργειες",
      "notes": "Σημειώσεις",
      "reviews": "Επανεξετάσεις",
      "household": "Οικογένεια",
      "documents": "Έγγραφα & εξυπηρέτηση",
      "records": "Αρχείο",
      "comparisons": "Συγκρίσεις",
      "advisory": "Συμβουλευτική",
      "conversations": "Επικοινωνίες",
      "service": "Εξυπηρέτηση",
      "growth": "Ανάπτυξη",
      "protection": "Προστασία",
      "insured": "Αντικείμενα",
      "kyc": "KYC / AML",
      "risk": "Προφίλ κινδύνου"
    },
    "more": {
      "contact": "Επικοινωνία",
      "advice": "Συμβουλευτική και πωλήσεις",
      "service": "Εξυπηρέτηση",
      "docs": "Έγγραφα και φορολογικά"
    },
    "quick": {
      "note": "Σημείωση",
      "followup": "Follow-up",
      "appointment": "Ραντεβού",
      "case": "Αίτηση",
      "policy": "Συμβόλαιο",
      "review": "Επανεξέταση"
    },
    "timeline": "Χρονολόγιο",
    "timeline_empty": "Δεν υπάρχει ιστορικό ακόμη.",
    "attention": "Χρειάζεται προσοχή",
    "contact": "Επικοινωνία"
  },
  "pulse": {
    "policies": "Ενεργά συμβόλαια",
    "portfolio": "Ετήσιο χαρτοφυλάκιο",
    "open_actions": "Ανοιχτές ενέργειες",
    "review": "Επανεξέταση",
    "cases": "Ενεργές υποθέσεις",
    "next_move": "Επόμενη κίνηση",
    "none": "—"
  },
  "policy": {
    "title": "Συμβόλαια",
    "new": "Νέο συμβόλαιο",
    "edit": "Επεξεργασία συμβολαίου",
    "product": "Προϊόν / πλάνο",
    "carrier": "Ασφαλιστική",
    "number": "Αριθμός συμβολαίου",
    "branch": "Κλάδος",
    "status": "Κατάσταση",
    "start": "Έναρξη",
    "renewal": "Ανανέωση / επέτειος",
    "end": "Λήξη / ωρίμανση",
    "premium_annual": "Ετήσιο ασφάλιστρο",
    "premium_monthly": "Μηνιαίο ισοδύναμο",
    "frequency": "Συχνότητα πληρωμής",
    "method": "Τρόπος πληρωμής",
    "sum_assured": "Ασφαλισμένο ποσό / παροχή",
    "insured": "Ασφαλισμένος",
    "beneficiaries": "Δικαιούχοι",
    "current_premium": "Τρέχον ασφάλιστρο",
    "adjustments": "{count, plural, one {# αναπροσαρμογή ασφαλίστρου} other {# αναπροσαρμογές ασφαλίστρου}}",
    "empty": "Δεν έχουν καταχωρηθεί συμβόλαια.",
    "premium_suspicious": "Έλεγξε το ασφάλιστρο — πιθανό σφάλμα υποδιαστολής από το παλιό CRM",
    "next_anniversary": "Επόμενη επέτειος {date}",
    "total": "Σύνολο ετήσιων ασφαλίστρων",
    "owner": "Συμβαλλόμενος",
    "service_health": "Εξυπηρέτηση",
    "health_ok": "Όλα εντάξει",
    "health_open": "Ανοιχτά θέματα",
    "open_items": "{count, plural, =0 {τίποτα ανοιχτό} one {# ανοιχτό θέμα} other {# ανοιχτά θέματα}}",
    "in_days": "{days, plural, =0 {σήμερα} one {σε # ημέρα} other {σε # ημέρες}}",
    "premium_history": "Ιστορικό ασφαλίστρου",
    "initial": "Αρχικό ασφάλιστρο",
    "premium": "Ασφάλιστρο",
    "instalment": "Δόση",
    "instalment_for": "Δόση ({freq})",
    "single_premium": "Εφάπαξ ασφάλιστρο",
    "single_hint": "Καταβάλλεται μία φορά — δεν ετησιοποιείται και δεν μετρά ως επαναλαμβανόμενο ασφάλιστρο.",
    "annual_eq_hint": "= {annual} τον χρόνο · {monthly} τον μήνα",
    "eq_annual": "ετήσιο",
    "eq_monthly": "μηνιαίο",
    "equivalent_hint": "Τα ισοδύναμα υπολογίζονται από τη δόση και τη συχνότητα· η δόση είναι αυτό που πληρώνει ο πελάτης.",
    "quoted": "όπως προσφέρθηκε",
    "premium_locked": "Χρησιμοποιήστε «Αλλαγή ασφαλίστρου» ώστε κάθε αλλαγή να έχει ημερομηνία και ιστορικό.",
    "change_premium": "Αλλαγή ασφαλίστρου",
    "change_status": "Αλλαγή κατάστασης",
    "status_from": "Νέα κατάσταση (τώρα: {status})",
    "status_saved": "Η κατάσταση ενημερώθηκε",
    "cancel_reverses": "Ακύρωση εντός {days, plural, one {# ημέρας} other {# ημερών}} από την έκδοση: η πίστωση νέας εργασίας θα αντιλογιστεί στην παραγωγή.",
    "reactivation_note": "Η επαναφορά πιστώνει ξανά το ασφάλιστρο ως επαναφορά, όχι ως νέα εργασία.",
    "adjust_mode": "Πώς θέλετε να το καταχωρίσετε;",
    "adjust_new": "Νέο ποσό",
    "adjust_delta": "Μεταβολή (+ ή −)",
    "adjust_current": "τρέχον {amount}",
    "effective_date": "Ισχύει από",
    "adjust_future": "Ισχύει από {date}. Μέχρι τότε ισχύει το τρέχον ασφάλιστρο.",
    "adjust_backdated": "Αναδρομική: η παραγωγή πιστώνεται σύμφωνα με τις ρυθμίσεις σας και σημειώνεται ως αναδρομική.",
    "adjust_production": "Παραγωγή: {amount} (πιστώνεται μόνο η διαφορά)",
    "adjust_reason": "Αιτιολογία",
    "adjust_reason_ph": "π.χ. τιμαριθμική αναπροσαρμογή, νέα κάλυψη, αίτημα πελάτη",
    "increase_saved": "Η αύξηση ασφαλίστρου καταγράφηκε",
    "decrease_saved": "Η μείωση ασφαλίστρου καταγράφηκε",
    "pending_change": "από {date}: {amount}",
    "future": "προσεχώς",
    "original": "αρχικό ασφάλιστρο",
    "reverse": "Αντιλογισμός",
    "reverse_hint": "Ο αντιλογισμός ακυρώνει την αλλαγή και την πίστωση παραγωγής της. Τίποτα δεν διαγράφεται — και οι δύο εγγραφές μένουν στο ιστορικό.",
    "reversed": "Η αλλαγή αντιλογίστηκε",
    "timeline": "Ιστορικό συμβολαίου",
    "remaining": "Υπόλοιπο διάρκειας",
    "months": "{count, plural, one {# μήνας} other {# μήνες}}",
    "months_left": "{count, plural, one {απομένει # μήνας} other {απομένουν # μήνες}}",
    "category": "Κατηγορία",
    "category_auto": "Αυτόματα ({category})",
    "currency": "Νόμισμα",
    "more_details": "Περισσότερα στοιχεία",
    "parties": "Πρόσωπα του συμβολαίου",
    "party_add": "Προσθήκη προσώπου",
    "party_other": "Άλλο πρόσωπο (μόνο όνομα)",
    "benefits": "Παροχές",
    "benefit_add": "Προσθήκη παροχής",
    "benefits_count": "{count, plural, one {# παροχή} other {# παροχές}}",
    "no_benefits": "δεν έχουν καταγραφεί παροχές",
    "all_insured": "όλοι οι ασφαλισμένοι",
    "amount": "Ποσό",
    "guaranteed": "εγγυημένο",
    "projected": "προβλεπόμενο",
    "tags": "Ανάγκες που καλύπτει",
    "tags_hint": "οι προτάσεις επισημαίνονται",
    "tags_apply": "Εφαρμογή προτάσεων",
    "color": "Χρώμα",
    "color_hint": "υπερισχύει του χρώματος κατηγορίας ή εταιρείας",
    "color_auto": "Αυτόματο",
    "replaces": "Αντικαθιστά το συμβόλαιο",
    "payment_note": "Κατάσταση πληρωμής",
    "payment_hint": "π.χ. η τράπεζα επέστρεψε την πάγια εντολή",
    "payment_verified": "Επιβεβαιωμένο από την εταιρεία",
    "payment": {
      "late": "Καθυστέρηση",
      "ok": "Ενήμερο"
    },
    "payment_late_verified": "Καθυστέρηση πληρωμής (επιβεβαιωμένη)",
    "payment_late_note": "Πιθανή καθυστέρηση πληρωμής (δική σας σημείωση)",
    "color_source": {
      "manual": "επιλεγμένο χρώμα",
      "category": "χρώμα κατηγορίας",
      "insurer": "χρώμα εταιρείας"
    },
    "from_pdf": "Συμβόλαιο από PDF"
  },
  "case": {
    "title": "Υποθέσεις & αιτήσεις",
    "subtitle": "Η διαδρομή της αίτησης από το προσχέδιο μέχρι το συμβόλαιο",
    "new": "Νέα αίτηση",
    "product": "Προϊόν / πλάνο",
    "insurer": "Ασφαλιστική",
    "number": "Αριθμός αίτησης",
    "stage": "Στάδιο",
    "premium": "Ετήσιο ασφάλιστρο",
    "sum_assured": "Ασφαλισμένο ποσό",
    "target": "Στόχος έκδοσης",
    "next_action": "Επόμενη ενέργεια",
    "next_action_date": "Ημερομηνία επόμενης ενέργειας",
    "next_action_time": "Ώρα",
    "requirements": "Δικαιολογητικά",
    "missing": "{count, plural, =0 {Πλήρης λίστα} one {λείπει #} other {λείπουν #}}",
    "age": "{days}η",
    "stalled": "Στάσιμη",
    "history": "Ιστορικό διαδρομής",
    "move_to": "Μετακίνηση σε {stage}",
    "advance": "Επόμενο στάδιο",
    "terminal": "Κλείσιμο ως…",
    "issued_policy": "Δημιουργήθηκε συμβόλαιο από αυτή την υπόθεση",
    "empty": "Δεν υπάρχουν αιτήσεις ακόμη.",
    "add_requirement": "Προσθήκη δικαιολογητικού",
    "journey": "Διαδρομή",
    "all_stages": "Όλα τα στάδια",
    "active": "Ενεργές",
    "closed": "Κλειστές",
    "event": {
      "created": "Δημιουργία υπόθεσης"
    },
    "created": "Η αίτηση δημιουργήθηκε",
    "stage_changed": "Μετακινήθηκε σε {stage}",
    "category": "Κατηγορία προϊόντος",
    "category_ph": "π.χ. ζωής, υγείας, αποταμίευσης",
    "reopened": "Η αίτηση άνοιξε ξανά",
    "reopened_on": "Άνοιξε ξανά {date}"
  },
  "task": {
    "new_followup": "Νέο follow-up",
    "new_appointment": "Νέο ραντεβού",
    "new_task": "Νέα εργασία",
    "edit": "Επεξεργασία",
    "title": "Τίτλος",
    "kind": "Τύπος",
    "due_date": "Ημερομηνία",
    "due_time": "Ώρα",
    "duration": "Διάρκεια (λεπτά)",
    "location_type": "Τοποθεσία",
    "location": "Διεύθυνση / σύνδεσμος",
    "complete": "Ολοκλήρωση",
    "complete_title": "Ολοκλήρωση: {title}",
    "outcome": "Αποτέλεσμα",
    "result_note": "Τι έγινε;",
    "overdue": "Εκπρόθεσμο",
    "no_date": "Χωρίς ημερομηνία",
    "reopen": "Επαναφορά",
    "office_autofill": "Χρησιμοποιείται αυτόματα η διεύθυνση γραφείου από το προφίλ σου.",
    "created": "Προστέθηκε στην ατζέντα",
    "completed": "Ολοκληρώθηκε",
    "delete_confirm": "Διαγραφή αυτής της εργασίας;",
    "prospect": "Υποψήφιος: {name}",
    "edit_appointment": "Αλλαγή ραντεβού",
    "edit_task": "Αλλαγή εργασίας",
    "updated": "Οι αλλαγές αποθηκεύτηκαν",
    "video_moved": "Η βιντεοκλήση μεταφέρθηκε στη νέα ώρα — ο σύνδεσμος του πελάτη μένει ίδιος. Στείλτε του το νέο μήνυμα.",
    "video_keeps_link": "Βιντεοκλήση AVRASTRO · αν αλλάξετε ημερομηνία ή ώρα, η αίθουσα μεταφέρεται μαζί (ο σύνδεσμος του πελάτη μένει ίδιος)."
  },
  "appointment": {
    "calendar_file": "Αρχείο ημερολογίου (.ics)",
    "google": "Προσθήκη στο Google Calendar",
    "drafts": "Προσχέδια μηνυμάτων",
    "draft_note": "Τα προσχέδια ανοίγουν στην εφαρμογή σου — τίποτα δεν στέλνεται αυτόματα.",
    "maps": "Άνοιγμα χάρτη"
  },
  "note": {
    "new": "Νέα σημείωση / επόμενη ενέργεια",
    "title": "Τίτλος",
    "body": "Σημείωση",
    "placeholder": "Γράψε ό,τι χρειάζεται να θυμάσαι, τι υποσχέθηκες, τι πρέπει να γίνει μετά…",
    "remind": "Προσθήκη στην ατζέντα στις",
    "saved": "Η σημείωση αποθηκεύτηκε",
    "empty": "Δεν υπάρχουν σημειώσεις ακόμη.",
    "pinned": "Καρφιτσωμένη",
    "action_type": "Είδος ενέργειας",
    "action": {
      "note": "Σημείωση",
      "call": "Κλήση",
      "followup": "Υπενθύμιση",
      "appointment": "Ραντεβού",
      "waiting": "Αναμονή απάντησης",
      "document": "Έγγραφα",
      "review": "Ανασκόπηση",
      "service": "Εξυπηρέτηση",
      "application": "Αίτηση"
    }
  },
  "review": {
    "title": "Κέντρο επανεξετάσεων",
    "subtitle": "Ετήσιο review για κάθε ενεργή σχέση",
    "due_now": "Εκπρόθεσμα",
    "never": "Χωρίς review ποτέ",
    "due_soon": "Τις επόμενες 30 ημέρες",
    "ok": "Ενημερωμένα",
    "complete": "Καταγραφή review",
    "date": "Ημερομηνία review",
    "outcome": "Αποτέλεσμα",
    "next_date": "Επόμενο review",
    "notes": "Τι άλλαξε; Οικογένεια, εισόδημα, υγεία, στόχοι…",
    "followup": "Ημερομηνία follow-up (προαιρετικά)",
    "saved": "Το review καταγράφηκε",
    "last": "Τελευταίο review {date}",
    "due": "Προθεσμία {date}",
    "followup_title": "Follow-up μετά το review",
    "empty": "Κανένα review σε αυτή την ομάδα.",
    "history": "Ιστορικό reviews",
    "since_last": "Αλλαγές από το τελευταίο review ({date})",
    "no_changes": "Καμία καταγεγραμμένη αλλαγή από το τελευταίο review.",
    "change": {
      "life_event": "Γεγονός ζωής",
      "policy_new": "Νέο συμβόλαιο",
      "premium_change": "Αλλαγή ασφαλίστρου",
      "income": "Εισόδημα",
      "liability": "Δάνειο",
      "child": "Νέο παιδί",
      "needs_revision": "Αναθεώρηση ανάλυσης αναγκών",
      "claim": "Αποζημίωση"
    },
    "questions": "Ερωτήσεις επανεξέτασης",
    "questions_note": "Οι απαντήσεις φυλάσσονται ως τεκμήριο με την επανεξέταση· μια αλλαγή στη ζωή του πελάτη ή ένα «όχι» σε έλεγχο δημιουργεί εργασία επανάληψης.",
    "answer_note": "Σημείωση (προαιρετικό)",
    "a": {
      "yes": "Ναι",
      "no": "Όχι",
      "na": "Δ/Υ"
    },
    "q": {
      "life_changes": "Αλλαγές σε οικογένεια, κατοικία ή εργασία;",
      "income_change": "Άλλαξε αισθητά το εισόδημα;",
      "new_debts": "Νέα δάνεια ή στεγαστικό;",
      "health_changes": "Αλλαγές υγείας που μπορεί να επηρεάζουν την κάλυψη;",
      "dependants_changed": "Νέα εξαρτώμενα μέλη (παιδιά, γονείς);",
      "goals_changed": "Άλλαξαν οι στόχοι (αποταμίευση, σπουδές, σύνταξη);",
      "beneficiaries_ok": "Είναι ακόμη σωστοί οι δικαιούχοι;",
      "cover_adequate": "Είναι ακόμη επαρκής η κάλυψη;",
      "satisfied": "Ικανοποιημένος/η από την εξυπηρέτηση;",
      "referral_asked": "Ρωτήθηκε για φίλους ή συγγενείς που θα ωφελούνταν;"
    },
    "action": {
      "life_changes": "Έλεγχος προστασίας μετά από αλλαγές ζωής",
      "income_change": "Επανέλεγχος προστασίας εισοδήματος και αποταμίευσης",
      "new_debts": "Έλεγχος ασφάλισης δανείου / στεγαστικού",
      "health_changes": "Έλεγχος κάλυψης υγείας και δηλώσεων",
      "dependants_changed": "Ενημέρωση οικογένειας και αναγκών προστασίας",
      "goals_changed": "Ενημέρωση ανάλυσης αναγκών για νέους στόχους",
      "beneficiaries_ok": "Ενημέρωση δικαιούχων στην ασφαλιστική",
      "cover_adequate": "Πρόταση για κάλυψη του κενού",
      "satisfied": "Επικοινωνία για την ικανοποίηση από την εξυπηρέτηση"
    },
    "evidence": "Τεκμήριο: {answered}/{total} απαντήσεις",
    "portfolio_then": "χαρτοφυλάκιο τότε {amount}",
    "actions_count": "{count} για ενέργεια"
  },
  "household": {
    "title": "Οικογένεια",
    "children": "Παιδιά & εξαρτώμενα μέλη",
    "add_child": "Προσθήκη παιδιού",
    "child_name": "Όνομα παιδιού",
    "age": "{age} ετ.",
    "empty": "Δεν έχουν καταχωρηθεί μέλη οικογένειας.",
    "linked": "Συνδεδεμένα πρόσωπα",
    "coverage": "Κάλυψη οικογένειας"
  },
  "documents": {
    "title": "Έγγραφα",
    "service": "Εξυπηρέτηση & αποζημιώσεις",
    "empty": "Δεν έχουν καταχωρηθεί έγγραφα.",
    "service_empty": "Δεν υπάρχουν υποθέσεις εξυπηρέτησης.",
    "note": "Τα αρχεία παραμένουν στο αρχείο εγγράφων σου· το AVRASTRO κρατά τα στοιχεία και τους συνδέσμους.",
    "new": "Νέο έγγραφο",
    "name": "Έγγραφο",
    "reference": "Αναφορά",
    "link": "Σύνδεσμος",
    "link_hint": "Πού βρίσκεται το αρχείο (drive, e-mail, πύλη ασφαλιστικής)",
    "delete_confirm": "Αφαίρεση του «{title}» από το μητρώο;",
    "type": {
      "identity": "Ταυτότητα / διαβατήριο",
      "address": "Αποδεικτικό διεύθυνσης",
      "bank": "Τράπεζα / SEPA",
      "medical": "Ιατρικά",
      "financial": "Οικονομικά",
      "policy": "Συμβόλαιο",
      "application": "Αίτηση",
      "claim": "Αποζημίωση",
      "proposal": "Πρόταση",
      "quotation": "Προσφορά",
      "other": "Άλλο"
    },
    "title_label": "Τίτλος"
  },
  "records": {
    "title": "Διατηρημένες εγγραφές",
    "subtitle": "Δεδομένα από προηγούμενα modules του VÉRO, ανέπαφα μέχρι να ολοκληρωθεί το νέο τους module.",
    "empty": "Δεν υπάρχουν διατηρημένες εγγραφές.",
    "kind": {
      "meeting": "Συνάντηση",
      "needs_analysis": "Ανάλυση αναγκών",
      "tax_profile": "Φορολογικό προφίλ",
      "risk_profile": "Προφίλ κινδύνου",
      "quote": "Προσφορά",
      "proposal": "Πρόταση",
      "comparison": "Σύγκριση συμβολαίων",
      "communication": "Επικοινωνία",
      "feedback": "Feedback",
      "outcome": "Αποτέλεσμα",
      "opportunity": "Ευκαιρία",
      "referral": "Σύσταση",
      "consent": "Συγκατάθεση",
      "weekly_fund": "Εβδομαδιαία ενημέρωση funds",
      "pending_decision": "Εκκρεμής απόφαση",
      "promise": "Δέσμευση",
      "sync_inbox": "Στοιχείο συγχρονισμού tablet",
      "group_plan": "Ομαδικό πλάνο",
      "profile_brief": "Σύνοψη προφίλ",
      "other": "Άλλο"
    }
  },
  "prospects": {
    "title": "Προσέγγιση",
    "subtitle": "Λίστες, συνεδρίες κλήσεων και μετατροπή σε πελάτες",
    "lists": "Λίστες",
    "new_list": "Νέα λίστα",
    "list_name": "Όνομα λίστας",
    "import": "Εισαγωγή επαφών",
    "import_hint": "Επικόλλησε γραμμές από Excel ή CSV. Στήλες: Όνομα, Τηλέφωνο, Email, Επάγγελμα, Εταιρεία, Περιοχή, Πηγή, Σημειώσεις (η γραμμή τίτλων είναι προαιρετική).",
    "preview": "{unique} νέες · {dupes} διπλές · {clients} ήδη πελάτες",
    "legend_unique": "Νέα",
    "legend_dupe": "Διπλή",
    "legend_client": "Ήδη πελάτης",
    "add_rows": "Προσθήκη {count} επαφών",
    "call_sheet": "Εκτύπωση call sheet",
    "convert": "Μετατροπή σε πρόσωπο",
    "converted": "Μετατράπηκε",
    "empty_list": "Η λίστα είναι κενή.",
    "no_lists": "Δημιούργησε την πρώτη σου λίστα για να ξεκινήσεις κλήσεις.",
    "calling": "Συνεδρία κλήσεων",
    "next": "Επόμενη επαφή",
    "followup_on": "Follow-up στις",
    "stats": "{called} από {total} κλήσεις · {interested} ενδιαφέρονται",
    "density": "Πυκνότητα",
    "compact": "Συμπαγές",
    "normal": "Κανονικό",
    "detailed": "Αναλυτικό",
    "handwritten": "Σημειώσεις",
    "import_file": "Επιλογή αρχείου CSV ή Excel",
    "first_row_header": "Η πρώτη γραμμή είναι επικεφαλίδα",
    "ignore": "— παράλειψη —",
    "map_column": "Στήλη {n}",
    "field": {
      "name": "Όνομα",
      "phone": "Τηλέφωνο",
      "email": "E-mail",
      "profession": "Επάγγελμα",
      "company": "Εταιρεία",
      "area": "Περιοχή",
      "source": "Πηγή",
      "notes": "Σημειώσεις"
    }
  },
  "agenda": {
    "day_sheet": "Ημερήσιο φύλλο",
    "day_sheet_hint": "Οι δύο σελίδες Α4 του ημερήσιου προγράμματος, συμπληρωμένες με τα ραντεβού, τις κλήσεις και τα follow-up της ημέρας από το CRM",
    "title": "Ατζέντα",
    "subtitle": "Ραντεβού, follow-ups και εργασίες",
    "week": "Εβδομάδα",
    "list": "Λίστα",
    "prev": "Προηγούμενη",
    "next": "Επόμενη",
    "this_week": "Αυτή η εβδομάδα",
    "overdue": "Εκπρόθεσμα",
    "no_items": "Ελεύθερη",
    "unscheduled": "Χωρίς ημερομηνία",
    "print": "Εκτύπωση ατζέντας",
    "mode": {
      "day": "Ημέρα",
      "week": "Εβδομάδα",
      "month": "Μήνας"
    },
    "day_summary": "Η ημέρα με μια ματιά",
    "markers": "Στιγμές & ημερομηνίες"
  },
  "goals": {
    "title": "Οι στόχοι της ημέρας",
    "subtitle": "Υπολογίζονται σε αυτή τη συσκευή από το ωράριο, την ατζέντα, τις εργασίες, τις λίστες κλήσεων και ό,τι έχει καταγραφεί — χωρίς AI, χωρίς τίποτα επινοημένο.",
    "recompute": "Νέος υπολογισμός",
    "recompute_hint": "Υπολογισμός ξανά με την ατζέντα όπως είναι τώρα — οι δικοί σας αριθμοί και οι παραλείψεις μένουν",
    "recomputed": "Οι στόχοι υπολογίστηκαν ξανά — οι δικοί σας αριθμοί κρατήθηκαν",
    "prefs": "Ρυθμίσεις στόχων",
    "plan_day": "Σχέδιο ημέρας",
    "not_computed": "Δεν υπάρχουν ακόμη στόχοι για αυτή την ημέρα.",
    "compute": "Υπολογισμός στόχων",
    "free_line": "Ελεύθερες {free} από {work} ώρες εργασίας ({from}–{to})",
    "none": "Τίποτα για πρόταση σήμερα: δεν υπάρχει ελεύθερος χρόνος, αριθμοί για κλήση ή κάτι σε καθυστέρηση.",
    "counted": "Η πρόοδος μετρά μόνο ό,τι έχει καταγραφεί — κλήσεις, ολοκληρωμένες εργασίες, μηνύματα, ραντεβού που κλείστηκαν — το καθένα μία φορά.",
    "none_day_off": "Η {date} δεν είναι εργάσιμη στις Ρυθμίσεις → Ωράριο γραφείου, οπότε δεν υπάρχουν στόχοι.",
    "compute_anyway": "Στόχοι παρ’ όλα αυτά",
    "skipped": "Παραλείπεται σήμερα",
    "progress": "{done} από {target}",
    "adjusted": "Δικός σας αριθμός (πρόταση: {n})",
    "decrease": "Μικρότερος στόχος",
    "increase": "Μεγαλύτερος στόχος",
    "target_for": "Στόχος για «{goal}»",
    "resume": "Επαναφορά",
    "skip": "Όχι σήμερα",
    "market": "Σημείωση αγοράς",
    "market_remove": "Αφαίρεση",
    "market_add": "Προσθήκη σημείωσης αγοράς (με την πηγή της)",
    "market_hint": "Μόνο ό,τι προσθέτετε εσείς, με την πηγή του — το CRM δεν γράφει ποτέ ειδήσεις αγοράς.",
    "market_text": "Τι συνέβη",
    "market_source": "Πηγή (π.χ. ανακοίνωση ΕΚΤ)",
    "market_url": "Σύνδεσμος (προαιρετικά)",
    "saved": "Αποθηκεύτηκε",
    "prefs_saved": "Οι ρυθμίσεις στόχων αποθηκεύτηκαν — ισχύουν από τον επόμενο υπολογισμό",
    "pref_goal": "Στόχος",
    "pref_on": "Πρόταση",
    "pref_min": "Ελάχιστο",
    "pref_max": "Μέγιστο",
    "pref_util": "Ποσοστό του ελεύθερου χρόνου για στόχους",
    "prefs_note": "Οι στόχοι που απενεργοποιείτε δεν προτείνονται καθόλου. Ελάχιστο και μέγιστο ισχύουν στην πρόταση· τον αριθμό μιας ημέρας τον αλλάζετε πάντα.",
    "type": {
      "prospecting_calls": "Κλήσεις προσέγγισης",
      "customer_contacts": "Επαφές με υφιστάμενους πελάτες",
      "appointments": "Ραντεβού για κλείσιμο",
      "overdue_followups": "Εκκρεμή follow-up σε καθυστέρηση",
      "renewals": "Ανανεώσεις για επικοινωνία"
    },
    "why": {
      "overdue": "Follow-up σε καθυστέρηση: {count}",
      "time_limited": "Μόνο {hours} ώρες ελεύθερες σήμερα, άρα όχι όλα",
      "renewals": "Πελάτες με ανανέωση στις επόμενες {days} ημέρες, χωρίς επικοινωνία τις 2 τελευταίες εβδομάδες: {count}",
      "contacts_due": "Κλήσεις και follow-up πελατών για σήμερα: {count}",
      "contacts_time": "Περίπου {minutes} λεπτά του ελεύθερου χρόνου για πελάτες",
      "light_day": "Ελαφριά ημέρα: {hours} ώρες ελεύθερες",
      "full_day": "Γεμάτη ημέρα: μόνο {hours} ώρες ελεύθερες",
      "performance_low": "Τις 4 τελευταίες εβδομάδες πετύχατε το {rate}% αυτού του στόχου — λίγο χαμηλότερα",
      "performance_high": "Τις 4 τελευταίες εβδομάδες πετύχατε το {rate}% αυτού του στόχου — λίγο ψηλότερα",
      "calls_time": "{hours} ώρες για κλήσεις → {count} κλήσεις με τον συνηθισμένο σας ρυθμό ({pace} την ώρα)",
      "calls_time_default": "{hours} ώρες για κλήσεις → {count} κλήσεις με {pace} την ώρα (αρχικός ρυθμός μέχρι να καταγραφούν αρκετές κλήσεις)",
      "queue": "Αριθμοί έτοιμοι για κλήση στις λίστες σας: {count} ({fresh} χωρίς καμία κλήση)",
      "queue_limited": "Μέχρι τους {count} αριθμούς των λιστών σας",
      "week_meetings": "Στόχος εβδομάδας: {goal} συναντήσεις, {booked} κλεισμένες ως τώρα → άλλες {need} σε {days} εργάσιμες",
      "expected_from_calls": "Με το ποσοστό σας ({rate}% των κλήσεων) οι σημερινές κλήσεις φέρνουν περίπου {count}",
      "pref_min": "Το ελάχιστό σας: {value}",
      "pref_max": "Το μέγιστό σας: {value}"
    },
    "relationship": "Σχέσεις (καφές / σύσταση): {planned} σχεδιασμένες · {done} έγιναν",
    "relationship_hint": "μετρούν χωριστά — όχι στα ραντεβού",
    "title_for": "Στόχοι · {date}"
  },
  "planner": {
    "title": "Πρόγραμμα ημέρας",
    "hint": "Γρήγορη προσθήκη: τύπος → ώρα → διάρκεια → Enter (πλήκτρο «n» για να πάτε εκεί) · κλικ σε ελεύθερη ώρα για μπλοκ · σύρετε ένα μπλοκ για μετακίνηση, την κάτω άκρη για διάρκεια · πληκτρολόγιο: ↑ ↓ μετακίνηση, Shift + ↑ ↓ διάρκεια, Enter άνοιγμα, Delete ακύρωση, Ctrl + Enter ολοκλήρωση. Τα ραντεβού δεν μετακινούνται από εδώ.",
    "conflicts": "Επικαλύψεις: {count} — φαίνονται, δεν αλλάζουν",
    "outside": "Εκτός των ωρών που φαίνονται: {count}",
    "add": "Μπλοκ",
    "add_at": "Νέο μπλοκ στις {time}",
    "free": "ελεύθερο",
    "suggestion": "πρόταση",
    "committed": "Ραντεβού — αλλάζει από τη δική του φόρμα",
    "overlap": "Επικαλύπτεται με άλλο",
    "accept": "Αποδοχή",
    "dismiss": "Όχι σήμερα",
    "complete": "Ολοκληρώθηκε",
    "edit": "Αλλαγή",
    "open": "Άνοιγμα",
    "cancel": "Ακύρωση μπλοκ",
    "unplanned": "Χωρίς ώρα",
    "plan_task": "Στο πρόγραμμα",
    "legend_own": "Δικά σας μπλοκ και εργασίες",
    "hours_from": "Το πρόγραμμα αρχίζει",
    "hours_to": "Το πρόγραμμα τελειώνει",
    "minutes": "{n} λεπ.",
    "form_title": "Μπλοκ στο πρόγραμμά σας",
    "form_new": "Νέο μπλοκ στο πρόγραμμά σας",
    "field": {
      "title": "Τι",
      "kind": "Είδος",
      "start": "Από",
      "end": "Έως",
      "notes": "Σημειώσεις",
      "person": "Με ποιον (προαιρετικό)"
    },
    "goal_block": "{goal} · {count}",
    "source": {
      "appointment": "Ραντεβού"
    },
    "kind": {
      "focus": "Χρόνος συγκέντρωσης",
      "personal": "Προσωπικό πρόγραμμα",
      "task": "Εργασία",
      "goal": "Στόχος",
      "admin": "Γραφειακά",
      "travel": "Μετακίνηση",
      "break": "Διάλειμμα"
    },
    "moved": "Μετακινήθηκε",
    "done": "Ολοκληρώθηκε",
    "cancelled": "Το μπλοκ ακυρώθηκε",
    "accepted": "Μπήκε στο πρόγραμμά σας",
    "dismissed": "Κρύφτηκε για σήμερα",
    "planned": "Μπήκε στο πρόγραμμα",
    "no_free": "Δεν έμεινε ελεύθερο μισάωρο στις ώρες εργασίας",
    "saved": "Αποθηκεύτηκε στο πρόγραμμα",
    "confirm_conflict": "Επικαλύπτεται με ραντεβού. Το ραντεβού μένει ακριβώς εκεί που είναι. Να κρατηθούν και τα δύο την ίδια ώρα;",
    "type": {
      "client_appointment": "Ραντεβού πελάτη (ασφαλιστικό)",
      "coffee": "Καφές / γνωριμία",
      "referral_meeting": "Συνάντηση για σύσταση",
      "calls": "Τηλεφωνήματα",
      "followup": "Follow-up / επανεπικοινωνία",
      "admin": "Email & γραφειακά",
      "prep": "Προετοιμασία ραντεβού",
      "learning": "Εκπαίδευση / μελέτη",
      "team": "Ομάδα / σύσκεψη γραφείου",
      "travel": "Μετακίνηση",
      "break": "Διάλειμμα",
      "personal": "Προσωπικό",
      "other": "Άλλο",
      "focus": "Συγκεντρωμένη δουλειά",
      "task": "Εργασία",
      "goal": "Στόχος"
    },
    "planning_for": "Σχεδιάζετε για",
    "rel": {
      "today": "Σήμερα",
      "tomorrow": "Αύριο",
      "after": "Μεθαύριο",
      "past": "Παρελθόν"
    },
    "pick_date": "Επιλογή ημερομηνίας",
    "templates": "Πρότυπα ημέρας",
    "copy_from": "Αντιγραφή από…",
    "move": "Μεταφορά σε άλλη ημερομηνία",
    "move_none": "Δεν υπάρχουν δικά σας μπλοκ να μεταφερθούν",
    "print": "Εκτύπωση",
    "accept_all": "Όλες οι προτάσεις στο πρόγραμμα ({count})",
    "accepted_all": "Οι προτάσεις μπήκαν στο πρόγραμμα",
    "done_social": "Ολοκληρώθηκε — καταγράφηκε στο ιστορικό του προσώπου (όχι ως ραντεβού)",
    "duration": "Διάρκεια",
    "qa_add": "Προσθήκη",
    "qa_appointment": "Νέο ραντεβού…",
    "social_hint": "Γνωριμία ή σύσταση χωρίς πώληση: μετρά χωριστά από τα ασφαλιστικά ραντεβού. Αν διαλέξετε πρόσωπο, μόλις ολοκληρωθεί μπαίνει στο ιστορικό του ως τελευταία επαφή.",
    "appointment_hint": "Ένα ασφαλιστικό ραντεβού γίνεται πραγματικό ραντεβού του CRM (με πελάτη, τόπο, υπενθυμίσεις) και μετρά στα ραντεβού.",
    "move_intro": "Μεταφέρονται όλα τα δικά σας μπλοκ και οι αποδεκτές προτάσεις της {date}, στις ίδιες ώρες.",
    "move_what": "Μεταφέρονται: {count} μπλοκ → {date}",
    "move_go": "Μεταφορά ({count})",
    "move_staying": "Μένουν όπου είναι ({count}) — ραντεβού και εργασίες του CRM δεν μετακινούνται από εδώ:",
    "move_over": "Στη νέα ημερομηνία {count} μπλοκ πέφτουν πάνω σε ραντεβού: θα σας ρωτήσει πριν τα κρατήσει (τα ραντεβού δεν αλλάζουν).",
    "move_overlap": "Επικαλύψεις με άλλα μπλοκ της νέας ημέρας: {count} — θα φαίνονται.",
    "move_undo": "Μετά τη μεταφορά, «Αναίρεση» στο μήνυμα τα επιστρέφει όλα μαζί.",
    "moved_day": "Μεταφέρθηκαν {count} μπλοκ στην {date}",
    "copy": {
      "yesterday": "Από χθες",
      "lastWeek": "Από την ίδια μέρα της προηγούμενης εβδομάδας"
    },
    "copy_counts": "Προστίθενται {add} · παραλείπονται {skipped} (πέφτουν πάνω σε κάτι)",
    "copy_go": "Αντιγραφή",
    "copied": "Αντιγράφηκαν {count} μπλοκ",
    "copy_intro": "Αντιγράφονται τα μπλοκ σας (όχι εργασίες) στην {date}· ό,τι πέφτει πάνω σε κάτι ήδη προγραμματισμένο παραλείπεται.",
    "templates_intro": "Ένα πρότυπο γεμίζει την {date} με έτοιμα μπλοκ (τα ενσωματωμένα ακολουθούν την ώρα έναρξης του γραφείου)· τίποτα δεν μπαίνει πάνω σε ραντεβού ή άλλο μπλοκ.",
    "template_own": "δικό μου",
    "template_apply": "Εφαρμογή",
    "template_applied": "«{name}»: {count} μπλοκ στο πρόγραμμα",
    "template_delete": "Διαγραφή προτύπου",
    "template_delete_confirm": "Να διαγραφεί το πρότυπο «{name}»; Τα προγράμματα που φτιάχτηκαν με αυτό μένουν.",
    "template_deleted": "Το πρότυπο διαγράφηκε",
    "template_save_label": "Αποθήκευση αυτής της ημέρας ως πρότυπο ({count} μπλοκ)",
    "template_name_ph": "π.χ. Η Τρίτη μου",
    "template_save": "Αποθήκευση",
    "template_saved": "Το πρότυπο αποθηκεύτηκε",
    "tpl": {
      "office": "Ημέρα γραφείου",
      "appointments": "Ημέρα ραντεβού",
      "calls": "Ημέρα τηλεφωνημάτων"
    },
    "print_kind": {
      "plan": "Πρόγραμμα",
      "blank": "Άδειο φυλλάδιο",
      "sheet": "Ημερήσιο φύλλο (2 σελίδες)"
    },
    "print_hint": {
      "plan": "Το συμπληρωμένο πρόγραμμα ως λίστα: ώρα, τύπος, τι, σημειώσεις — δεν επικαλύπτεται ποτέ· μαζί οι κλήσεις / follow-up του CRM και χώρος για σημειώσεις.",
      "blank": "Κενές ώρες για να γράψετε με το χέρι, με ημερομηνία, όνομα και κουτάκια στόχων.",
      "sheet": "Το χάρτινο ημερήσιο φύλλο: ραντεβού ανά ώρα, κλήσεις, follow-up, νέες επαφές."
    },
    "print_go": "Εκτύπωση",
    "print_due": "Με τις κλήσεις / follow-up του CRM",
    "print_notes": "Χώρος για σημειώσεις",
    "print_goals": "Κουτάκια στόχων"
  },
  "insights": {
    "title": "Εικόνα",
    "subtitle": "Χαρτοφυλάκιο, παραγωγή και pipeline — υπολογισμένα από τα δεδομένα σου",
    "mix": "Χαρτοφυλάκιο ανά κλάδο",
    "carriers": "Κορυφαίες ασφαλιστικές",
    "pipeline": "Pipeline ανά στάδιο",
    "activity": "Τελευταίες 30 ημέρες",
    "calls": "Κλήσεις",
    "meetings": "Συναντήσεις",
    "cases_issued": "Εκδοθείσες υποθέσεις",
    "new_clients": "Νέοι πελάτες"
  },
  "data": {
    "title": "Δεδομένα & ασφάλεια",
    "subtitle": "Εισαγωγή, backup, επαναφορά και διαγνωστικά — κάθε αλλαγή προεπισκοπείται και αναιρείται",
    "import_title": "Εισαγωγή από VÉRO CRM (v1–v910)",
    "import_desc": "Φέρε πελάτες, συμβόλαια, εργασίες, σημειώσεις, αιτήσεις, reviews, υποψηφίους και έγγραφα από το ιστορικό VÉRO HTML CRM. Τίποτα δεν γράφεται πριν επιβεβαιώσεις.",
    "choose_file": "Επιλογή αρχείου backup",
    "or_paste": "…ή επικόλληση JSON",
    "password": "Κωδικός backup (για αρχεία .ICRM)",
    "analyze": "Ανάλυση",
    "analyzing": "Ανάλυση…",
    "detected": "Εντοπίστηκε: {source}",
    "preview": "Προεπισκόπηση εισαγωγής",
    "warnings": "{count, plural, =0 {Καμία προειδοποίηση} one {# προειδοποίηση} other {# προειδοποιήσεις}}",
    "mode": "Τρόπος εισαγωγής",
    "mode_merge": "Συγχώνευση σε αυτόν τον χώρο (ασφαλής επανεισαγωγή)",
    "mode_replace": "Αντικατάσταση του χώρου εργασίας",
    "commit": "Εισαγωγή τώρα",
    "committing": "Εισαγωγή…",
    "done": "Η εισαγωγή ολοκληρώθηκε και επαληθεύτηκε",
    "safety": "Πρώτα δημιουργήθηκε στιγμιότυπο ασφαλείας: {label}",
    "verify_ok": "Η επαλήθευση πέτυχε: {count} εγγραφές",
    "verify_fail": "Η επαλήθευση απέτυχε — οι αλλαγές αναιρέθηκαν",
    "backup_title": "Backup",
    "backup_desc": "Το backup περιέχει κάθε εγγραφή, manifest και SHA-256 checksums.",
    "export_plain": "Εξαγωγή backup (.vero.json)",
    "export_secure": "Εξαγωγή κρυπτογραφημένου backup",
    "secure_password": "Κωδικός κρυπτογράφησης (τουλάχιστον 10 χαρακτήρες)",
    "restore_title": "Επαναφορά",
    "restore_desc": "Κάθε επαναφορά ελέγχεται, προεπισκοπείται και εφαρμόζεται σε μία συναλλαγή. Πριν από αυτήν λαμβάνεται στιγμιότυπο.",
    "diff": "Αλλαγές",
    "added": "Νέα",
    "removed": "Αφαιρούνται",
    "changed": "Αλλάζουν",
    "unchanged": "Ίδια",
    "table": "Δεδομένα",
    "snapshots": "Στιγμιότυπα ασφαλείας",
    "snapshots_empty": "Δεν υπάρχουν στιγμιότυπα ακόμη.",
    "rollback": "Επαναφορά αυτού του στιγμιότυπου",
    "rollback_confirm": "Αντικατάσταση του τρέχοντος χώρου με το στιγμιότυπο «{label}»; Πρώτα θα αποθηκευτεί στιγμιότυπο της τρέχουσας κατάστασης.",
    "diagnostics": "Διαγνωστικά",
    "schema": "Έκδοση σχήματος {version}",
    "integrity": "Έλεγχος ακεραιότητας",
    "integrity_ok": "Δεν βρέθηκαν προβλήματα",
    "integrity_issues": "{count, plural, one {# πρόβλημα} other {# προβλήματα}}",
    "storage": "Αποθήκευση: {engine}",
    "translations": "Μεταφράσεις",
    "exporter_title": "Παλιά δεδομένα browser",
    "exporter_desc": "Αν τα δεδομένα σου υπάρχουν μόνο μέσα στο browser του παλιού CRM, άνοιξε το VÉRO Legacy Exporter στον ίδιο browser για να τα αποθηκεύσεις πρώτα σε αρχείο. Μόνο διαβάζει, δεν αλλάζει τίποτα.",
    "stats": {
      "persons": "Άνθρωποι",
      "policies": "Συμβόλαια",
      "tasks": "Εργασίες & ραντεβού",
      "notes": "Σημειώσεις",
      "cases": "Αιτήσεις",
      "reviews": "Επανεξετάσεις",
      "prospects": "Υποψήφιοι",
      "prospect_lists": "Λίστες προσέγγισης",
      "documents": "Έγγραφα",
      "timeline": "Γεγονότα χρονολογίου",
      "legacy_records": "Διατηρημένες εγγραφές",
      "service_cases": "Υποθέσεις εξυπηρέτησης",
      "households": "Νοικοκυριά"
    },
    "files_corrupt": "{count, plural, one {# αρχείο εγγράφου απέτυχε στον έλεγχο ακεραιότητας και δεν επαναφέρθηκε} other {# αρχεία εγγράφων απέτυχαν στον έλεγχο ακεραιότητας και δεν επαναφέρθηκαν}}"
  },
  "settings": {
    "title": "Ρυθμίσεις",
    "language": "Γλώσσα",
    "language_hint": "Γλώσσα περιβάλλοντος. Τα δεδομένα σου δεν μεταφράζονται ποτέ.",
    "region": "Αγορά / περιοχή",
    "region_hint": "Ορίζει νόμισμα, ονομαστικές εορτές και προεπιλεγμένες λίστες — ανεξάρτητα από τη γλώσσα.",
    "theme": "Εμφάνιση",
    "theme_dark": "Νύχτα",
    "theme_light": "Ημέρα",
    "theme_auto": "Σύστημα",
    "advisor": "Προφίλ συμβούλου",
    "advisor_name": "Το όνομά σου",
    "company": "Εταιρεία / πρακτορείο",
    "phone": "Τηλέφωνο",
    "email": "Email",
    "website": "Ιστοσελίδα",
    "office_address": "Διεύθυνση γραφείου",
    "office_maps": "Σύνδεσμος Google Maps (προαιρετικά)",
    "signature": "Υπογραφή μηνυμάτων",
    "partial_translation": "Μερική μετάφραση — όσα δεν έχουν μεταφραστεί εμφανίζονται στα αγγλικά.",
    "saved": "Οι ρυθμίσεις αποθηκεύτηκαν",
    "about": "Σχετικά με το AVRASTRO OS",
    "license": "Αρ. άδειας",
    "accessibility": "Προσβασιμότητα",
    "ui": {
      "contrast": "Υψηλή αντίθεση",
      "motion": "Λιγότερη κίνηση",
      "compact": "Συμπαγής προβολή"
    },
    "rules": "Έξυπνες ειδοποιήσεις",
    "rules_hint": "Απενεργοποιήστε κανόνα ή ορίστε σταθερή σοβαρότητα. Οι προεπιλογές εξηγούνται σε κάθε κάρτα.",
    "rule_now": "{count} τώρα",
    "rule_auto": "Αυτόματα",
    "rule_off": "Ανενεργός",
    "business_rules": "Επιχειρησιακοί κανόνες",
    "business_rules_note": "Οι αλλαγές ισχύουν μόνο για νέες εγγραφές· η παλαιότερη παραγωγή δεν ξαναγράφεται. Παράθυρο ακύρωσης: {days} ημέρες.",
    "fiscal_start": "Έναρξη οικονομικού έτους",
    "cancel_window": "Παράθυρο ακύρωσης (ημέρες)",
    "cancel_window_hint": "ακυρώσεις εντός της περιόδου αντιλογίζουν τη νέα εργασία",
    "backdated_label": "Αναδρομικές αλλαγές",
    "backdated": {
      "credit_today": "Πίστωση την ημέρα καταχώρισης",
      "credit_effective": "Πίστωση στην ημερομηνία ισχύος"
    },
    "commission_enabled": "Παρακολούθηση προμηθειών",
    "no_contact_days": "«Χωρίς επαφή» μετά από (ημέρες)",
    "emergency_months": "Αποθεματικό (μήνες εξόδων)",
    "attribution_days": "Παράθυρο απόδοσης καμπάνιας (ημέρες)",
    "require_consent": "Οι καμπάνιες απαιτούν συναίνεση marketing",
    "color_precedence": "Το χρώμα συμβολαίου προέρχεται από",
    "insurer_colors": "Χρώματα εταιρειών",
    "rebuild_cost": "Ενδεικτικό κόστος ανοικοδόμησης ανά m²",
    "rebuild_cost_hint": "Χρησιμοποιείται μόνο στον ενδεικτικό έλεγχο ακινήτων (προεπιλογή 1.500 EUR)",
    "gi_days": "Υπενθυμίσεις ανανέωσης γενικού κλάδου (ημέρες πριν τη λήξη)",
    "gi_days_hint": "Χωρισμένες με κόμμα, π.χ. 45, 30, 15",
    "lapse_risk_days": "Κίνδυνος ακύρωσης μετά από (ημέρες καθυστέρησης)",
    "lapse_risk_days_hint": "Ληξιπρόθεσμο ασφάλιστρο ανοιχτό περισσότερο από αυτό δείχνει «κίνδυνος ακύρωσης» (προεπιλογή 15)"
  },
  "region": {
    "CY": "Κύπρος",
    "GR": "Ελλάδα",
    "GB": "Ηνωμένο Βασίλειο",
    "DE": "Γερμανία",
    "RO": "Ρουμανία",
    "AE": "Ηνωμένα Αραβικά Εμιράτα",
    "IL": "Ισραήλ",
    "INTL": "Διεθνές"
  },
  "lens": {
    "placeholder": "Αναζήτηση προσώπων, υποψηφίων, υποθέσεων — ή πληκτρολόγησε εντολή",
    "people": "Άνθρωποι",
    "prospects": "Υποψήφιοι",
    "cases": "Υποθέσεις",
    "commands": "Ενέργειες",
    "go": "Μετάβαση σε",
    "no_results": "Κανένα αποτέλεσμα για «{q}»",
    "hint": "↑↓ μετακίνηση · Enter άνοιγμα · Esc κλείσιμο",
    "cmd": {
      "new_person": "Νέο πρόσωπο",
      "new_note": "Νέα σημείωση",
      "new_followup": "Νέο follow-up",
      "new_appointment": "Νέο ραντεβού",
      "new_case": "Νέα αίτηση",
      "import": "Εισαγωγή δεδομένων",
      "backup": "Εξαγωγή backup",
      "toggle_theme": "Εναλλαγή ημέρα/νύχτα",
      "new_comparison": "Νέα σύγκριση συμβολαίων",
      "start_flow": "Έναρξη Flow — καθάρισμα βιβλίου",
      "new_needs": "Νέα ανάλυση αναγκών",
      "new_quote": "Νέα προσφορά",
      "log_contact": "Καταγραφή επικοινωνίας",
      "new_service": "Νέο αίτημα εξυπηρέτησης",
      "new_claim": "Νέα αποζημίωση",
      "new_opportunity": "Νέα ευκαιρία",
      "new_proposal": "Νέα πρόταση",
      "data_quality": "Έλεγχος ποιότητας δεδομένων",
      "start_my_day": "Έναρξη ημέρας",
      "add_policy": "Νέο συμβόλαιο",
      "add_lead": "Νέος υποψήφιος",
      "new_campaign": "Νέα καμπάνια",
      "upload_document": "Ανέβασμα εγγράφου",
      "ask": "Ρώτα το AVRASTRO",
      "sync": "Συγχρονισμός τώρα",
      "tax_center": "Φορολογικό κέντρο"
    },
    "ai_hint": "αναζήτηση ή γράψτε μια ενέργεια",
    "policies": "Συμβόλαια",
    "quotes": "Προσφορές",
    "documents": "Έγγραφα",
    "children": "Παιδιά",
    "companies": "Εταιρείες",
    "tasks": "Εργασίες",
    "notes": "Σημειώσεις"
  },
  "timeline": {
    "person_created": "Δημιουργία σχέσης",
    "person_archived": "Αρχειοθέτηση",
    "note_added": "Προστέθηκε σημείωση",
    "review_completed": "Καταγράφηκε ετήσιο review",
    "policy_issued_from_case": "Εκδόθηκε από αίτηση",
    "imported": "Εισαγωγή από VÉRO {version}",
    "needs_finalized": "Οριστικοποίηση ανάλυσης αναγκών",
    "quote_added": "Νέα προσφορά",
    "opportunity_opened": "Νέα ευκαιρία",
    "referral_given": "Έδωσε σύσταση",
    "referral_thanked": "Ευχαριστίες για σύσταση",
    "referral_converted": "Η σύσταση έγινε επαφή",
    "meeting_held": "Πραγματοποιήθηκε συνάντηση",
    "claim_opened": "Άνοιξε αποζημίωση",
    "consent_granted": "Δόθηκε συγκατάθεση",
    "consent_withdrawn": "Ανακλήθηκε συγκατάθεση",
    "merged": "Συγχώνευση διπλοεγγραφής",
    "proposal_issued": "Εκδόθηκε πρόταση",
    "search": "Αναζήτηση στο ιστορικό",
    "premium_increase": "Αύξηση ασφαλίστρου",
    "premium_decrease": "Μείωση ασφαλίστρου",
    "premium_reversal": "Αντιλογισμός αλλαγής ασφαλίστρου",
    "payment_late": "Σημείωση καθυστέρησης πληρωμής",
    "payment_ok": "Πληρωμή ενήμερη",
    "tax_snapshot": "Αποθήκευση φορολογικού υπολογισμού",
    "extraction_applied": "Εφαρμογή τιμών από έγγραφο",
    "policy_offer": "Συμβόλαιο σε προσφορά",
    "policy_pending": "Συμβόλαιο σε εκκρεμότητα",
    "policy_active": "Συμβόλαιο ενεργό",
    "policy_renewed": "Ανανέωση συμβολαίου",
    "policy_lapsed": "Ακύρωση λόγω μη πληρωμής",
    "policy_cancelled": "Ακύρωση συμβολαίου",
    "policy_matured": "Λήξη συμβολαίου",
    "renewal_renewed": "Καταγραφή ανανέωσης",
    "renewal_lapsed": "Δεν ανανεώθηκε",
    "renewal_declined": "Ο πελάτης αρνήθηκε την ανανέωση",
    "referral_attempt": "Επικοινωνία με άτομο που σύστησε",
    "payslip_analysed": "Ανάλυση μισθοδοσίας (εκτίμηση φόρου)",
    "insured_item_added": "Προστέθηκε ασφαλισμένο αντικείμενο",
    "insured_item_sold": "Πωλήθηκε ασφαλισμένο αντικείμενο",
    "insured_item_archived": "Αρχειοθετήθηκε ασφαλισμένο αντικείμενο",
    "gi_renewal_requested_quotes": "Ανανέωση: ζητήθηκαν προσφορές",
    "gi_renewal_compared": "Ανανέωση: συγκρίθηκαν προσφορές",
    "gi_renewal_sent_to_client": "Ανανέωση: στάλθηκε στον πελάτη",
    "gi_renewal_approved": "Ανανέωση: εγκρίθηκε από τον πελάτη",
    "gi_renewal_renewed": "Ανανέωση: ανανεώθηκε",
    "gi_renewal_lost": "Ανανέωση: χάθηκε",
    "premium_overdue": "Καταγράφηκε ληξιπρόθεσμο ασφάλιστρο",
    "premium_paid": "Πληρώθηκε το ληξιπρόθεσμο ασφάλιστρο",
    "premium_lapsed": "Το ληξιπρόθεσμο ασφάλιστρο δεν πληρώθηκε — ακύρωση",
    "nps_prepared": "Ετοιμάστηκε ερώτηση γνώμης",
    "nps_answered": "Λήφθηκε γνώμη πελάτη",
    "kyc_created": "Άνοιξε φάκελος KYC/AML",
    "kyc_updated": "Έλεγχος φακέλου KYC/AML",
    "client_report": "Δηλώθηκε από τον πελάτη μέσω της πύλης",
    "esign_signed": "Έγγραφο υπογράφηκε ηλεκτρονικά",
    "sale_file_created": "Άνοιξε φάκελος πώλησης (IDD)",
    "sale_file_complete": "Ο φάκελος πώλησης (IDD) ολοκληρώθηκε",
    "sale_file_reopened": "Ο φάκελος πώλησης (IDD) χρειάζεται συμπλήρωση",
    "do_not_call_on": "Σημειώθηκε «Να μην ξανακληθεί»",
    "do_not_call_off": "Αφαιρέθηκε «Να μην ξανακληθεί»",
    "risk_profile_imported": "Προφίλ κινδύνου από το avrastro.com",
    "risk_profile_saved": "Νέο προφίλ κινδύνου",
    "family_added": "Προστέθηκε συγγενής",
    "summary_meeting": "Προσωπική σύνοψη συνάντησης",
    "summary_transparency": "Σύνοψη διαφάνειας",
    "summary_shared": "Σύνοψη στην πύλη του πελάτη",
    "policy_deleted": "Διαγραφή συμβολαίου (λανθασμένη καταχώριση)",
    "policy_restored": "Επαναφορά διαγραμμένου συμβολαίου",
    "policy_entered_in_error": "Το συμβόλαιο σημειώθηκε ως λανθασμένη καταχώριση"
  },
  "template": {
    "appointment_confirm": "Γεια σας {first}, επιβεβαιώνω τη συνάντησή μας στις {date} και ώρα {time}{location, select, none {} other {, {location}}}. {signature}",
    "appointment_subject": "Η συνάντησή μας στις {date}",
    "birthday": "Χρόνια πολλά, {first}! Σας εύχομαι υγεία και μια υπέροχη χρονιά. {signature}",
    "nameday": "Χρόνια πολλά, {first}! Να είστε πάντα καλά. {signature}",
    "review_invite": "Γεια σας {first}, ήρθε η ώρα για το ετήσιο review των καλύψεών σας — θα είχατε 30 λεπτά αυτή την εβδομάδα; {signature}"
  },
  "errors": {
    "person": {
      "not_found": "Το πρόσωπο δεν βρέθηκε",
      "name_required": "Συμπλήρωσε όνομα",
      "client_since_invalid": "Η ημερομηνία «Πελάτης από» δεν είναι έγκυρη",
      "client_since_future": "Η ημερομηνία «Πελάτης από» δεν μπορεί να είναι μελλοντική"
    },
    "task": {
      "title_required": "Συμπλήρωσε τίτλο",
      "appointment_needs_datetime": "Το ραντεβού χρειάζεται ημερομηνία και ώρα",
      "not_found": "Η εργασία δεν βρέθηκε",
      "not_open": "Η εργασία δεν είναι πλέον ανοιχτή.",
      "same_date": "Επιλέξτε διαφορετική ημερομηνία."
    },
    "case": {
      "product_required": "Συμπλήρωσε το προϊόν",
      "not_found": "Η υπόθεση δεν βρέθηκε",
      "not_closed": "Η αίτηση είναι ακόμη ανοιχτή.",
      "reopen_issued": "Μια εκδοθείσα αίτηση δεν ανοίγει ξανά — εργαστείτε στο συμβόλαιο."
    },
    "policy": {
      "product_required": "Συμπλήρωσε το όνομα του προϊόντος",
      "invalid_transition": "Αυτή η αλλαγή κατάστασης δεν επιτρέπεται από την τρέχουσα κατάσταση.",
      "negative_premium": "Το ασφάλιστρο δεν μπορεί να είναι αρνητικό.",
      "not_found": "Το συμβόλαιο δεν βρέθηκε.",
      "same_status": "Το συμβόλαιο έχει ήδη αυτή την κατάσταση.",
      "deleted": "Αυτό το συμβόλαιο έχει διαγραφεί. Επαναφέρετέ το πρώτα για να το αλλάξετε.",
      "already_deleted": "Το συμβόλαιο έχει ήδη διαγραφεί.",
      "not_deleted": "Το συμβόλαιο δεν είναι διαγραμμένο.",
      "delete_reason_required": "Γράψτε αιτιολογία (τουλάχιστον 3 χαρακτήρες).",
      "stepup_required": "Επιβεβαιώστε πρώτα με κωδικό πρόσβασης και κωδικό εφαρμογής.",
      "restore_window_passed": "Η περίοδος επαναφοράς έχει λήξει."
    },
    "note": {
      "empty": "Η σημείωση είναι κενή",
      "not_found": "Η σημείωση δεν βρέθηκε"
    },
    "prospect": {
      "not_found": "Ο υποψήφιος δεν βρέθηκε",
      "already_converted": "Έχει ήδη μετατραπεί"
    },
    "prospect_list": {
      "name_required": "Δώσε όνομα στη λίστα",
      "not_found": "Η λίστα δεν βρέθηκε"
    },
    "requirement": {
      "not_found": "Το δικαιολογητικό δεν βρέθηκε",
      "status_invalid": "Άγνωστη κατάσταση εγγράφου.",
      "waiting_invalid": "Άγνωστο μέρος."
    },
    "import": {
      "invalid_json": "Το αρχείο δεν είναι έγκυρο JSON ή backup του AVRASTRO.",
      "password_required": "Το backup είναι κρυπτογραφημένο — δώσε τον κωδικό του.",
      "bad_password": "Λάθος κωδικός ή κατεστραμμένο αρχείο.",
      "unsupported": "Μη υποστηριζόμενο αρχείο: δεν βρέθηκαν δεδομένα AVRASTRO.",
      "checksum": "Τα checksums δεν ταιριάζουν — το αρχείο έχει αλλοιωθεί."
    },
    "storage": {
      "failed": "Η αποθήκευση απέτυχε. Η αλλαγή δεν εφαρμόστηκε.",
      "quota": "Ο χώρος αποθήκευσης γέμισε. Κάνε εξαγωγή backup και ελευθέρωσε χώρο.",
      "blocked": "Άλλο παράθυρο του AVRASTRO ενημερώνει τη βάση. Κλείστε το και δοκιμάστε ξανά.",
      "newer_schema": "Τα δεδομένα αποθηκεύτηκαν από νεότερη έκδοση του AVRASTRO. Ενημερώστε την εφαρμογή.",
      "verify_failed": "Τα δεδομένα δεν επαληθεύτηκαν, οπότε δεν άλλαξε τίποτα."
    },
    "comparison": {
      "not_found": "Η σύγκριση δεν βρέθηκε",
      "locked": "Η σύγκριση έχει αποφασιστεί και κλειδώσει",
      "no_plans": "Πρόσθεσε τουλάχιστον ένα πλάνο"
    },
    "undo": {
      "conflict": "Δεν γίνεται αναίρεση — η εγγραφή άλλαξε στο μεταξύ"
    },
    "screen": {
      "title": "Παρουσιάστηκε πρόβλημα σε αυτή την οθόνη",
      "body": "Τα δεδομένα σας είναι ασφαλή. Το σφάλμα καταγράφηκε στα Διαγνωστικά (Δεδομένα & ασφάλεια).",
      "retry": "Δοκιμάστε ξανά"
    },
    "needs": {
      "locked": "Η ανάλυση αναγκών είναι οριστική. Ανοίξτε νέα έκδοση για αλλαγές.",
      "not_found": "Η ανάλυση αναγκών δεν βρέθηκε"
    },
    "quote": {
      "product_required": "Συμπληρώστε το προϊόν",
      "not_found": "Η προσφορά δεν βρέθηκε"
    },
    "opportunity": {
      "title_required": "Δώστε τίτλο στην ευκαιρία",
      "not_found": "Η ευκαιρία δεν βρέθηκε"
    },
    "referral": {
      "name_required": "Συμπληρώστε το όνομα του προσώπου",
      "not_found": "Η σύσταση δεν βρέθηκε",
      "already_converted": "Έχει ήδη μετατραπεί",
      "outcome_invalid": "Άγνωστο αποτέλεσμα."
    },
    "communication": {
      "no_party": "Επιλέξτε με ποιον έγινε η επικοινωνία"
    },
    "meeting": {
      "not_found": "Η συνάντηση δεν βρέθηκε"
    },
    "claim": {
      "type_required": "Συμπληρώστε το είδος αποζημίωσης"
    },
    "service": {
      "title_required": "Περιγράψτε το αίτημα"
    },
    "document": {
      "title_required": "Δώστε όνομα στο έγγραφο",
      "not_found": "Το έγγραφο δεν βρέθηκε"
    },
    "consent": {
      "purpose_required": "Επιλέξτε σκοπό"
    },
    "template": {
      "invalid": "Το πρότυπο χρειάζεται κείμενο"
    },
    "merge": {
      "same": "Επιλέξτε δύο διαφορετικά πρόσωπα"
    },
    "adjustment": {
      "already_reversed": "Αυτή η αλλαγή έχει ήδη αντιλογιστεί.",
      "amount_invalid": "Εισάγετε έγκυρο ποσό.",
      "date_required": "Επιλέξτε την ημερομηνία ισχύος της αλλαγής.",
      "is_reversal": "Ένας αντιλογισμός δεν αντιλογίζεται — καταχωρίστε νέα αλλαγή.",
      "negative": "Το ασφάλιστρο δεν μπορεί να γίνει αρνητικό.",
      "no_change": "Το νέο ασφάλιστρο είναι ίδιο με το τρέχον.",
      "not_found": "Η αλλαγή ασφαλίστρου δεν υπάρχει πλέον.",
      "reason_required": "Δώστε μια αιτιολογία.",
      "single_premium_instalment": "Ένα συμβόλαιο εφάπαξ ασφαλίστρου δεν έχει δόσεις — αλλάξτε το εφάπαξ ποσό."
    },
    "automation": {
      "action_not_allowed": "Οι αυτοματισμοί μπορούν μόνο να δημιουργούν εργασίες.",
      "due_invalid": "Οι ημέρες προθεσμίας πρέπει να είναι από 0 έως 365.",
      "name_required": "Δώστε όνομα στον κανόνα.",
      "not_found": "Ο κανόνας δεν υπάρχει πλέον."
    },
    "campaign": {
      "already_launched": "Η καμπάνια έχει ήδη ξεκινήσει.",
      "closed": "Η καμπάνια έχει κλείσει και δεν αλλάζει πλέον.",
      "not_found": "Η καμπάνια δεν βρέθηκε.",
      "not_prepared": "Ελέγξτε και κλειδώστε πρώτα το κοινό.",
      "segment_required": "Επιλέξτε ομάδα για το κοινό.",
      "title_required": "Δώστε τίτλο στην καμπάνια.",
      "objective_invalid": "Άγνωστος στόχος καμπάνιας."
    },
    "commission": {
      "not_found": "Η γραμμή προμήθειας δεν βρέθηκε.",
      "rate_invalid": "Το ποσοστό πρέπει να είναι από 0 έως 100%.",
      "mapping": "Επιλέξτε τις στήλες αριθμού συμβολαίου, ποσού και περιόδου.",
      "nothing_to_accept": "Δεν υπάρχει κάτι στην κατάσταση για αποδοχή σε αυτή τη γραμμή.",
      "already_accepted": "Η γραμμή της κατάστασης έχει ήδη γίνει αποδεκτή.",
      "already_paid": "Η αναμενόμενη προμήθεια έχει ήδη καταχωριστεί ως πληρωμένη."
    },
    "crypto": {
      "already_enabled": "Η κρυπτογράφηση είναι ήδη ενεργή.",
      "not_enabled": "Η κρυπτογράφηση δεν είναι ενεργή.",
      "passphrase_too_short": "Χρησιμοποιήστε τουλάχιστον 10 χαρακτήρες.",
      "wrong_passphrase": "Η φράση πρόσβασης ή το κλειδί ανάκτησης δεν είναι σωστά."
    },
    "custom": {
      "entity_invalid": "Τα προσαρμοσμένα πεδία δεν είναι διαθέσιμα για αυτόν τον τύπο εγγραφής.",
      "in_use": "Το πεδίο έχει ήδη τιμές, οπότε το κλειδί και ο τύπος του δεν αλλάζουν.",
      "key_exists": "Υπάρχει ήδη πεδίο με αυτό το κλειδί.",
      "key_invalid": "Χρησιμοποιήστε μόνο πεζά λατινικά, ψηφία και _, με αρχικό γράμμα.",
      "label_required": "Δώστε ετικέτα στο πεδίο.",
      "not_date": "Εισάγετε έγκυρη ημερομηνία.",
      "not_number": "Εισάγετε αριθμό.",
      "not_option": "Επιλέξτε μία από τις διαθέσιμες επιλογές.",
      "options_required": "Ένα πεδίο επιλογής χρειάζεται τουλάχιστον μία επιλογή.",
      "required": "Το πεδίο είναι υποχρεωτικό.",
      "unknown_field": "Άγνωστο προσαρμοσμένο πεδίο."
    },
    "extraction": {
      "closed": "Ο έλεγχος έχει ήδη ολοκληρωθεί.",
      "invalid_amount": "Ένα από τα αποδεκτά ποσά δεν είναι έγκυρος αριθμός.",
      "invalid_rate": "Το επιτόκιο πρέπει να είναι από 0 έως 100%.",
      "no_person": "Συνδέστε πρώτα το έγγραφο με ένα πρόσωπο.",
      "not_found": "Ο έλεγχος δεν βρέθηκε.",
      "nothing_accepted": "Αποδεχτείτε ή διορθώστε πρώτα τουλάχιστον μία τιμή.",
      "policy_required": "Επιλέξτε το συμβόλαιο στο οποίο ανήκουν οι τιμές."
    },
    "financial": {
      "not_found": "Το στοιχείο δεν υπάρχει πλέον.",
      "rate_invalid": "Το επιτόκιο πρέπει να είναι από 0 έως 100%.",
      "type_required": "Επιλέξτε τύπο."
    },
    "production": {
      "duplicate_key": "Το καθολικό παραγωγής περιέχει διπλή εγγραφή."
    },
    "record": {
      "not_found": "Η εγγραφή δεν βρέθηκε."
    },
    "renewal": {
      "negative": "Το ασφάλιστρο ανανέωσης δεν μπορεί να είναι αρνητικό.",
      "not_found": "Η ανανέωση δεν βρέθηκε."
    },
    "tax": {
      "already_approved": "Οι κανόνες έχουν ήδη εγκριθεί.",
      "band_rate_invalid": "Κάθε συντελεστής κλίμακας πρέπει να είναι από 0% έως 100%.",
      "bands_required": "Προσθέστε τουλάχιστον μία φορολογική κλίμακα.",
      "ruleset_not_found": "Οι φορολογικοί κανόνες δεν βρέθηκαν.",
      "snapshot_not_found": "Ο αποθηκευμένος υπολογισμός δεν βρέθηκε.",
      "source_required": "Αναφέρετε την επίσημη πηγή των κανόνων.",
      "year_invalid": "Εισάγετε έγκυρο φορολογικό έτος."
    },
    "workspace": {
      "read_only": "Η συσκευή είναι μόνο για ανάγνωση μέχρι να συνδεθείτε ξανά στον συγχρονισμό.",
      "read_only_licence": "Η συνδρομή σας έληξε, γι’ αυτό το AVRASTRO είναι μόνο για ανάγνωση. Τα δεδομένα σας είναι ασφαλή — ανανεώστε από τον Λογαριασμό για να κάνετε αλλαγές.",
      "read_only_plan": "Αυτό το τμήμα του AVRASTRO δεν περιλαμβάνεται στο τρέχον πακέτο σας, γι’ αυτό οι εγγραφές του είναι μόνο για ανάγνωση. Δεν διαγράφηκε τίποτα."
    },
    "branding": {
      "scope_invalid": "Άγνωστο προφίλ ταυτότητας.",
      "not_found": "Το προφίλ ταυτότητας δεν υπάρχει πλέον.",
      "image_invalid": "Αποθηκεύονται μόνο εικόνες PNG, JPEG ή WebP έως περίπου 500 KB.",
      "email_invalid": "Ελέγξτε τη διεύθυνση e-mail.",
      "website_invalid": "Ελέγξτε τη διεύθυνση του ιστότοπου.",
      "accent_invalid": "Χρησιμοποιήστε χρώμα όπως #9A7427.",
      "mode_invalid": "Άγνωστος τρόπος ταυτότητας.",
      "signature_not_owner": "Αυτή η εικόνα υπογραφής ανήκει σε άλλο χρήστη και μόνο εκείνος μπορεί να την αλλάξει ή να τη χρησιμοποιήσει."
    },
    "checklist": {
      "name_required": "Δώστε όνομα στη λίστα.",
      "items_required": "Προσθέστε τουλάχιστον ένα στοιχείο.",
      "not_found": "Η λίστα δεν υπάρχει πλέον."
    },
    "group": {
      "not_found": "Το ομαδικό σχέδιο δεν βρέθηκε",
      "employer_required": "Συμπληρώστε τον εργοδότη",
      "category": "Άγνωστη κατηγορία",
      "status": "Άγνωστη κατάσταση",
      "employer_share": "Η συμμετοχή εργοδότη πρέπει να είναι από 0 έως 100%",
      "member_name_required": "Συμπληρώστε το όνομα του μέλους",
      "member_not_found": "Το μέλος δεν βρέθηκε",
      "class": "Άγνωστη κατηγορία μέλους",
      "leave_before_join": "Η αποχώρηση είναι πριν την ένταξη",
      "census_empty": "Το αρχείο δεν έχει γραμμές",
      "renewal_date_required": "Συμπληρώστε πρώτα την ημερομηνία ανανέωσης",
      "renewal_task_exists": "Υπάρχει ήδη υπενθύμιση για αυτή την ανανέωση"
    },
    "intake": {
      "revoked": "Ο πελάτης ανακάλεσε αυτή την κοινοποίηση",
      "no_contact": "Δεν υπάρχει όνομα, e-mail ή τηλέφωνο για νέα εγγραφή",
      "bad_time": "Η ώρα του ραντεβού δεν είναι έγκυρη",
      "kind": "Άγνωστος τύπος"
    },
    "payslip": {
      "no_gross": "Συμπληρώστε πρώτα τις μικτές αποδοχές."
    },
    "insured": {
      "not_found": "Το ασφαλισμένο αντικείμενο δεν υπάρχει πλέον.",
      "person_fixed": "Ένα ασφαλισμένο αντικείμενο μένει στον πελάτη του.",
      "kind": "Άγνωστο είδος αντικειμένου.",
      "status": "Άγνωστη κατάσταση αντικειμένου.",
      "year": "Το έτος δεν φαίνεται σωστό.",
      "year_built": "Το έτος κατασκευής δεν φαίνεται σωστό.",
      "amount": "Τα ποσά και τα εμβαδά πρέπει να είναι αριθμοί μηδέν ή μεγαλύτεροι.",
      "ncd": "Τα χρόνια χωρίς απαίτηση πρέπει να είναι ακέραιος από 0 έως 60.",
      "employees": "Οι υπάλληλοι πρέπει να είναι ακέραιος μηδέν ή μεγαλύτερος.",
      "date": "Μια ημερομηνία λήξης δεν είναι έγκυρη.",
      "policy": "Ένα συνδεδεμένο συμβόλαιο πρέπει να ανήκει στον ίδιο πελάτη.",
      "label_required": "Συμπληρώστε ονομασία, αριθμό εγγραφής, διεύθυνση ή δραστηριότητα."
    },
    "gi_renewal": {
      "not_general": "Δεν είναι συμβόλαιο γενικών ασφαλίσεων.",
      "stage": "Άγνωστο στάδιο ανανέωσης.",
      "no_date": "Το συμβόλαιο δεν έχει ημερομηνία ανανέωσης ή έναρξης.",
      "closed": "Η ανανέωση έχει ήδη αποφασιστεί.",
      "same_stage": "Η ανανέωση βρίσκεται ήδη σε αυτό το στάδιο."
    },
    "premium": {
      "not_found": "Αυτό το ληξιπρόθεσμο ασφάλιστρο δεν υπάρχει πλέον.",
      "closed": "Η εγγραφή έχει ήδη κλείσει (πληρώθηκε ή ακυρώθηκε).",
      "policy_fixed": "Ένα ληξιπρόθεσμο ασφάλιστρο μένει στο συμβόλαιό του.",
      "amount": "Το ποσό πρέπει να είναι αριθμός μεγαλύτερος από μηδέν.",
      "due_date": "Συμπληρώστε έγκυρη ημερομηνία οφειλής.",
      "future": "Η ημερομηνία οφειλής δεν μπορεί να είναι μελλοντική.",
      "duplicate": "Υπάρχει ήδη ανοιχτό ληξιπρόθεσμο ασφάλιστρο με αυτή την ημερομηνία για το συμβόλαιο.",
      "status": "Άγνωστη κατάσταση.",
      "mapping": "Επιλέξτε τις στήλες αριθμού συμβολαίου, ποσού και ημερομηνίας."
    },
    "schedule": {
      "product_required": "Συμπληρώστε το προϊόν ή τον κλάδο ασφάλισης.",
      "premium": "Συμπληρώστε το ασφάλιστρο (αριθμός μηδέν ή μεγαλύτερος).",
      "sum": "Το ασφαλισμένο κεφάλαιο πρέπει να είναι αριθμός μηδέν ή μεγαλύτερος.",
      "date": "Μια ημερομηνία δεν είναι έγκυρη.",
      "dates": "Η ημερομηνία λήξης είναι πριν από την έναρξη.",
      "frequency": "Άγνωστη συχνότητα πληρωμής.",
      "duplicate": "Υπάρχει ήδη συμβόλαιο με αυτόν τον αριθμό."
    },
    "nps": {
      "archived": "Το πρόσωπο είναι στο αρχείο.",
      "ref": "Η συνάντηση ή η αποζημίωση δεν βρέθηκε για αυτόν τον πελάτη.",
      "meeting_not_held": "Καταγράψτε πρώτα την έκβαση της συνάντησης.",
      "claim_not_closed": "Η αποζημίωση δεν έχει κλείσει ακόμα.",
      "duplicate": "Έχει ήδη ετοιμαστεί ερώτηση για αυτό.",
      "token": "Ο σύνδεσμος της ερώτησης δεν είναι έγκυρος.",
      "not_found": "Η ερώτηση δεν βρέθηκε.",
      "closed": "Η ερώτηση έχει ήδη απαντηθεί ή ανακληθεί.",
      "score": "Ο βαθμός πρέπει να είναι ακέραιος από 0 έως 10.",
      "not_promoter": "Μόνο το 9 ή το 10 οδηγεί σε αίτημα αξιολόγησης."
    },
    "kyc": {
      "document": "Επιλέξτε έγγραφο ταυτότητας από το θησαυροφυλάκιο αυτού του πελάτη.",
      "pep": "Απαντήστε στην ερώτηση για πολιτικά εκτεθειμένο πρόσωπο.",
      "risk": "Επιλέξτε επίπεδο κινδύνου.",
      "share": "Το ποσοστό δικαιούχου πρέπει να είναι από 0 έως 100%.",
      "share_total": "Τα ποσοστά των δικαιούχων ξεπερνούν το 100%.",
      "id_number": "Αριθμοί ταυτότητας, διαβατηρίου, φορολογικοί ή τραπεζικοί δεν μπαίνουν σε αυτά τα πεδία — μένουν στο έγγραφο στο θησαυροφυλάκιο.",
      "date": "Η ημερομηνία δεν είναι έγκυρη.",
      "future": "Η ημερομηνία ελέγχου δεν μπορεί να είναι μελλοντική."
    },
    "creport": {
      "kind": "Άγνωστος τύπος δήλωσης.",
      "id": "Η αναφορά της δήλωσης δεν είναι έγκυρη.",
      "accepted": "Αυτή η δήλωση έχει ήδη γίνει αποδεκτή.",
      "policy": "Το συμβόλαιο δεν ανήκει σε αυτόν τον πελάτη."
    },
    "voice": {
      "consent_required": "Δεν υπάρχει συναίνεση του πελάτη για ηχογράφηση αυτής της συνάντησης.",
      "nothing_kept": "Δεν έχει επιλεγεί τίποτα για αποθήκευση.",
      "meeting_not_found": "Η συνάντηση δεν βρέθηκε.",
      "dictation_confirm": "Επιβεβαιώστε ότι ηχογραφείτε μόνο τη δική σας φωνή."
    },
    "whatsapp": {
      "use": "Άγνωστος τύπος μηνύματος WhatsApp."
    },
    "setup": {
      "step": "Άγνωστο βήμα ρύθμισης.",
      "lines_required": "Επιλέξτε τουλάχιστον έναν κλάδο: ζωής ή γενικών.",
      "capacity": "Επιλέξτε ιδιότητα από τη λίστα.",
      "reg_no": "Ο αριθμός μητρώου είναι πολύ μεγάλος.",
      "time": "Η ώρα δεν είναι έγκυρη.",
      "hours_order": "Η ώρα λήξης πρέπει να είναι μετά την ώρα έναρξης.",
      "https": "Ο σύνδεσμος πρέπει να αρχίζει με https:// — δεν άλλαξε τίποτα.",
      "minutes": "Η διάρκεια πρέπει να είναι από 10 έως 240 λεπτά."
    },
    "client_import": {
      "stage": "Επιλέξτε πελάτες ή υποψήφιους.",
      "empty": "Δεν υπάρχει κανείς νέος για εισαγωγή.",
      "too_many": "Έως 5.000 γραμμές τη φορά — χωρίστε το αρχείο."
    },
    "sale_file": {
      "not_found": "Ο φάκελος πώλησης δεν βρέθηκε.",
      "person": "Ο φάκελος ανήκει σε άλλο πρόσωπο.",
      "line": "Επιλέξτε είδος πώλησης.",
      "advice": "Επιλέξτε αν δόθηκε συμβουλή.",
      "channel": "Επιλέξτε τρόπο πώλησης.",
      "policy": "Το συμβόλαιο δεν ανήκει σε αυτόν τον πελάτη.",
      "policy_has_file": "Αυτό το συμβόλαιο έχει ήδη φάκελο πώλησης.",
      "needs": "Η ανάλυση αναγκών δεν ανήκει σε αυτόν τον πελάτη.",
      "case": "Η αίτηση δεν ανήκει σε αυτόν τον πελάτη.",
      "date": "Η ημερομηνία πώλησης δεν είναι έγκυρη.",
      "future": "Η ημερομηνία πώλησης δεν μπορεί να είναι στο μέλλον.",
      "check_date": "Μια ημερομηνία ενημέρωσης δεν είναι έγκυρη ή είναι στο μέλλον.",
      "document": "Επιλέξτε έγγραφο από τα έγγραφα αυτού του πελάτη.",
      "risk_profile": "Το προφίλ κινδύνου δεν ανήκει σε αυτόν τον πελάτη."
    },
    "next_action": {
      "task_exists": "Η εργασία για αυτή την ενέργεια υπάρχει ήδη."
    },
    "lesson": {
      "slug": "Άγνωστο μάθημα.",
      "quiz": "Το αποτέλεσμα του κουίζ δεν είναι έγκυρο."
    },
    "call": {
      "outcome": "Επιλέξτε αποτέλεσμα κλήσης.",
      "no_target": "Η κλήση δεν αφορά κανέναν.",
      "do_not_call": "Αυτός ο αριθμός είναι «Να μην ξανακληθεί».",
      "day": "Η ημερομηνία της κλήσης δεν είναι έγκυρη.",
      "future": "Η κλήση δεν μπορεί να είναι στο μέλλον.",
      "hour": "Η ώρα της κλήσης δεν είναι έγκυρη.",
      "callback_date": "Ορίστε πότε θα ξανακαλέσετε.",
      "callback_past": "Η ημερομηνία δεν μπορεί να είναι πριν από την κλήση.",
      "meeting_time": "Ορίστε ημερομηνία και ώρα της συνάντησης.",
      "lawful_basis": "Επιλέξτε νομική βάση από τη λίστα."
    },
    "risk": {
      "incomplete": "Απαντήστε σε όλες τις ερωτήσεις.",
      "override_reason": "Γράψτε γιατί επιλέγετε άλλο προφίλ από το ενδεικτικό.",
      "source": "Άγνωστη πηγή προφίλ.",
      "date": "Η ημερομηνία δεν είναι έγκυρη.",
      "future": "Η ημερομηνία δεν μπορεί να είναι στο μέλλον.",
      "duplicate": "Αυτό το αποτέλεσμα έχει ήδη εισαχθεί.",
      "level": "Δεν βρέθηκε προφίλ κινδύνου.",
      "task_exists": "Υπάρχει ήδη εργασία ανασκόπησης."
    },
    "family": {
      "not_found": "Ο συγγενής δεν βρέθηκε.",
      "relation": "Επιλέξτε σχέση.",
      "self": "Ένα πρόσωπο δεν μπορεί να είναι συγγενής του εαυτού του.",
      "name_required": "Γράψτε όνομα ή επιλέξτε πρόσωπο.",
      "date": "Η ημερομηνία δεν είναι έγκυρη.",
      "birth_future": "Η ημερομηνία γέννησης δεν μπορεί να είναι στο μέλλον.",
      "pays": "Επιλέξτε ποιος πληρώνει.",
      "duplicate": "Αυτό το πρόσωπο είναι ήδη στον οικογενειακό χάρτη."
    },
    "summary": {
      "kind": "Άγνωστο είδος σύνοψης.",
      "lang": "Επιλέξτε ελληνικά, αγγλικά ή ρωσικά.",
      "not_found": "Η σύνοψη δεν βρέθηκε.",
      "shared": "Η σύνοψη έχει ήδη σταλεί· δημιουργήστε νέα.",
      "meeting": "Η συνάντηση δεν ανήκει σε αυτόν τον πελάτη.",
      "title": "Γράψτε τίτλο.",
      "empty": "Η σύνοψη είναι κενή."
    },
    "radar": {
      "task_exists": "Υπάρχει ήδη εργασία για αυτό."
    },
    "recommendation": {
      "approval_required": "Επιλέξτε πρώτα «Εγκρίνω» — μια προτεινόμενη καμπάνια δημιουργείται μόνο με την έγκρισή σας.",
      "unknown_theme": "Αυτό το θέμα καμπάνιας δεν υπάρχει πια.",
      "channel": "Επιλέξτε κανάλι για την καμπάνια.",
      "already_running": "Υπάρχει ήδη καμπάνια με αυτό το θέμα σε εξέλιξη."
    },
    "market_note": {
      "title_required": "Δώστε τίτλο στη σημείωση.",
      "source_required": "Μια σημείωση αγοράς χρειάζεται την πηγή της (δημοσίευση, φορέας ή ιστότοπος).",
      "date_invalid": "Δώστε την ημερομηνία δημοσίευσης (σήμερα ή νωρίτερα).",
      "url_invalid": "Ο σύνδεσμος πρέπει να αρχίζει με http:// ή https://.",
      "theme_required": "Επιλέξτε τουλάχιστον ένα θέμα καμπάνιας που αφορά η σημείωση."
    },
    "day_report": {
      "day": "Ο απολογισμός αποθηκεύεται για σήμερα ή προηγούμενη ημέρα.",
      "rating": "Η αυτοαξιολόγηση είναι ακέραιος από 1 έως 5.",
      "metric": "Άγνωστο μέγεθος στον απολογισμό.",
      "value": "Οι δικές σας καταχωρίσεις είναι ακέραιοι από 0 έως 9999.",
      "goals": "Οι στόχοι που επιτεύχθηκαν δεν μπορεί να είναι περισσότεροι από τους στόχους (έως 99)."
    },
    "catalog": {
      "name_required": "Γράψτε ένα όνομα.",
      "name_too_long": "Το όνομα είναι πολύ μεγάλο (έως 120 χαρακτήρες).",
      "duplicate": "Αυτό το όνομα υπάρχει ήδη στη λίστα.",
      "not_found": "Αυτή η καταχώριση του καταλόγου δεν υπάρχει πια.",
      "mismatch": "Η ασφαλιστική, η κατηγορία και το πρόγραμμα δεν ταιριάζουν μεταξύ τους.",
      "in_use": "Το χρησιμοποιούν συμβόλαια ή καταχωρίσεις κάτω από αυτό — απενεργοποιήστε το.",
      "move_insurer": "Μια καταχώριση δεν μπορεί να μεταφερθεί σε άλλη ασφαλιστική.",
      "category": "Άγνωστος τύπος συμβολαίου.",
      "branch": "Άγνωστος κλάδος.",
      "dates": "Το «διατίθεται έως» είναι πριν από το «διατίθεται από»."
    },
    "plan": {
      "time": "Συμπληρώστε ώρα έναρξης και λήξης.",
      "end_before_start": "Η λήξη πρέπει να είναι μετά την έναρξη.",
      "too_short": "Ένα μπλοκ διαρκεί τουλάχιστον 5 λεπτά.",
      "too_long": "Ένα μπλοκ διαρκεί το πολύ 12 ώρες.",
      "day": "Μη έγκυρη ημέρα.",
      "kind": "Άγνωστο είδος μπλοκ.",
      "title_required": "Δώστε τίτλο στο μπλοκ.",
      "overlaps_appointment": "Η ώρα επικαλύπτεται με ραντεβού — δεν άλλαξε τίποτα.",
      "appointment_fixed": "Τα ραντεβού δεν μετακινούνται από το πρόγραμμα — ανοίξτε το ραντεβού.",
      "not_found": "Το μπλοκ δεν βρέθηκε.",
      "block_closed": "Το μπλοκ έχει ήδη ολοκληρωθεί ή ακυρωθεί.",
      "task_planned": "Η εργασία είναι ήδη στο πρόγραμμα αυτής της ημέρας.",
      "after_midnight": "Το μπλοκ θα τελείωνε μετά τα μεσάνυχτα.",
      "same_day": "Διαλέξτε άλλη ημερομηνία από αυτή που ήδη σχεδιάζετε.",
      "nothing_to_move": "Δεν υπάρχουν δικά σας μπλοκ αυτή την ημέρα.",
      "nothing_to_copy": "Δεν υπάρχει τίποτα να αντιγραφεί (ή όλα πέφτουν πάνω σε κάτι).",
      "template_nothing": "Το πρότυπο δεν χωρά: όλα του τα μπλοκ πέφτουν πάνω σε κάτι.",
      "template_name": "Δώστε όνομα στο πρότυπο.",
      "template_empty": "Η ημέρα δεν έχει μπλοκ για πρότυπο.",
      "template_limit": "Έως 20 δικά σας πρότυπα.",
      "template_not_found": "Το πρότυπο δεν βρέθηκε.",
      "no_suggestions": "Δεν υπάρχουν προτάσεις."
    },
    "goals": {
      "day": "Μη έγκυρη ημέρα.",
      "not_found": "Δεν υπάρχουν ακόμη στόχοι για αυτή την ημέρα.",
      "type": "Άγνωστος στόχος.",
      "target": "Δώστε αριθμό από 0 έως το όριο του στόχου.",
      "market_text": "Γράψτε τη σημείωση αγοράς.",
      "market_source": "Προσθέστε από πού προέρχεται η σημείωση αγοράς.",
      "market_url": "Ο σύνδεσμος πρέπει να αρχίζει με http:// ή https://."
    },
    "taxf": {
      "year_invalid": "Μη έγκυρο φορολογικό έτος.",
      "year_not_found": "Ο φάκελος του έτους δεν βρέθηκε.",
      "email_invalid": "Ελέγξτε τη διεύθυνση e-mail.",
      "category_unknown": "Άγνωστη κατηγορία.",
      "category_label_required": "Δώστε όνομα στην κατηγορία.",
      "date_invalid": "Μη έγκυρη ημερομηνία.",
      "amount_invalid": "Μη έγκυρο ποσό.",
      "expected_not_found": "Το αναμενόμενο έγγραφο δεν βρέθηκε.",
      "document_not_in_folder": "Το αρχείο δεν ανήκει σε αυτόν τον φάκελο.",
      "item_not_found": "Το έγγραφο δεν βρέθηκε.",
      "item_other_year": "Το έγγραφο ανήκει σε άλλο έτος.",
      "title_required": "Δώστε τίτλο."
    }
  },
  "boot": {
    "volatile": "Η μόνιμη αποθήκευση δεν είναι διαθέσιμη σε αυτό το παράθυρο — οι αλλαγές κρατούνται μέχρι να το κλείσεις. Κάνε εξαγωγή backup για να τις κρατήσεις.",
    "opening": "Άνοιγμα χώρου εργασίας…",
    "failed": "Ο χώρος εργασίας δεν μπόρεσε να ανοίξει.",
    "recover": "Άνοιγμα εργαλείων ανάκτησης"
  },
  "demo": {
    "banner": "Δοκιμαστικός χώρος με φανταστικά πρόσωπα. Εισήγαγε τα δεδομένα σου από το «Δεδομένα & ασφάλεια».",
    "load": "Φόρτωση δοκιμαστικών δεδομένων",
    "clear": "Έναρξη χωρίς δεδομένα"
  },
  "briefing": {
    "title": "Ημερήσια ενημέρωση",
    "meetings": "{count, plural, one {Ένα ραντεβού σήμερα} other {# ραντεβού σήμερα}} — {count, plural, one {στις} other {το επόμενο στις}} {time} με {name} ({title}).",
    "no_meetings": "Κανένα ραντεβού σήμερα{count, plural, =0 {.} one { — καλή μέρα για # σημαντική κλήση.} other { — καλή μέρα για # σημαντικές κλήσεις.}}",
    "overdue": "{count, plural, one {Μία ενέργεια είναι εκπρόθεσμη} other {# ενέργειες είναι εκπρόθεσμες}}· η παλαιότερη είναι «{title}» με {name}.",
    "cases": "{count, plural, one {Μία αίτηση έχει κολλήσει} other {# αιτήσεις έχουν κολλήσει}}: {product} του/της {name} είναι στο στάδιο {stage} εδώ και {days} ημέρες{missing, plural, =0 {.} one { και λείπει # έγγραφο.} other { και λείπουν # έγγραφα.}}",
    "cases_moving": "{count, plural, one {Η ενεργή σου αίτηση κινείται.} other {Και οι # ενεργές αιτήσεις κινούνται.}}",
    "birthday": "{name}: γενέθλια σήμερα — κλείνει τα {age}.",
    "nameday": "{name}: γιορτάζει σήμερα ({feast}).",
    "reviews": "{count, plural, one {Ένας πελάτης χρειάζεται ετήσιο review} other {# πελάτες χρειάζονται ετήσιο review}}· το μεγαλύτερο χαρτοφυλάκιο είναι του/της {name} ({amount, number, currency}).",
    "gaps": "{count, plural, one {Μία οικογένεια έχει παιδιά χωρίς ασφάλεια ζωής} other {# οικογένειες έχουν παιδιά χωρίς ασφάλεια ζωής}} — ξεκίνα από {name}.",
    "start_flow": "Έναρξη Flow",
    "generated": "Γράφτηκε από το AVRASTRO με βάση τα δεδομένα σου · {time}",
    "promises": "{count, plural, one {Έχετε μία υπόσχεση προς εκπλήρωση} other {Έχετε # υποσχέσεις προς εκπλήρωση}} — «{title}» για {name}.",
    "decisions": "{count, plural, one {Ένας πελάτης αποφασίζει} other {# πελάτες αποφασίζουν}}· ο/η {name} σκέφτεται το «{title}» εδώ και {days} ημέρες.",
    "waiting": "{count, plural, one {Περιμένετε μία απάντηση πελάτη.} other {Περιμένετε # απαντήσεις πελατών.}}"
  },
  "flow": {
    "title": "Flow",
    "subtitle": "Μία σχέση τη φορά. Το AVRASTRO κρατά τη σειρά· εσύ αποφασίζεις.",
    "progress": "{done} από {total} ολοκληρώθηκαν",
    "start": "Έναρξη Flow",
    "resume": "Συνέχεια Flow",
    "done_title": "Το χαρτοφυλάκιό σου είναι σε τάξη",
    "done_body": "{count, plural, one {Ολοκλήρωσες # στοιχείο.} other {Ολοκλήρωσες # στοιχεία.}} Όλα τα υπόλοιπα είναι προγραμματισμένα.",
    "skip": "Παράλειψη",
    "snooze": "Αύριο",
    "note": "Σημείωση",
    "exit": "Έξοδος από Flow",
    "context": "Πλαίσιο",
    "last_contact": "Τελευταία επαφή",
    "portfolio": "Χαρτοφυλάκιο",
    "open_cases": "Ανοιχτές υποθέσεις",
    "keys": "Πλήκτρα",
    "logged": "Καταγράφηκε — επόμενη σχέση",
    "empty": "Τίποτα δεν σε χρειάζεται αυτή τη στιγμή.",
    "days_ago": "{days, plural, =0 {σήμερα} one {πριν # ημέρα} other {πριν # ημέρες}}",
    "keys_log": "καταγραφή συζήτησης",
    "keys_move": "προτεινόμενη κίνηση",
    "outcome": {
      "positive": "Μιλήσαμε — θετικά",
      "neutral": "Μιλήσαμε — ουδέτερα",
      "negative": "Δεν απάντησε / όχι τώρα"
    },
    "outcome_q": "Πώς πήγε;",
    "outcome_title": {
      "positive": "Κλήση — θετική: {reason}",
      "neutral": "Κλήση — ουδέτερη: {reason}",
      "negative": "Κλήση — χωρίς απάντηση: {reason}"
    }
  },
  "capture": {
    "title": "Γρήγορη καταγραφή",
    "placeholder": "Γράψε φυσικά: «ραντεβού με Άννα αύριο 10:30» ή «κλήση Γιώργο Παρασκευή 3μμ»",
    "understood": "Το AVRASTRO κατάλαβε",
    "create": "Δημιουργία: {kind}",
    "no_person": "Χωρίς συνδεδεμένο πρόσωπο",
    "choose_person": "Μήπως εννοείς",
    "hint": "Enter για δημιουργία · Tab για επιλογή προσώπου",
    "kind_note": "Σημείωση",
    "kind_case": "Αίτηση",
    "created": "Δημιουργήθηκε: {kind}",
    "needs_time": "Χρειάζεται ώρα — ανοίγει η φόρμα"
  },
  "coverage": {
    "title": "Ραντάρ κάλυψης",
    "subtitle": "Υπάρχουσα προστασία σε σχέση με ό,τι χρειάζεται αυτό το στάδιο ζωής",
    "area": {
      "life": "Ζωή",
      "health": "Υγεία",
      "income": "Εισόδημα",
      "savings": "Αποταμίευση & σύνταξη",
      "education": "Σπουδές",
      "property": "Περιουσία"
    },
    "need": {
      "0": "Δεν χρειάζεται",
      "1": "Καλό να υπάρχει",
      "2": "Σημαντικό",
      "3": "Απαραίτητο"
    },
    "held": {
      "0": "Χωρίς κάλυψη",
      "0.5": "Σε προσφορά",
      "1": "Καλύπτεται"
    },
    "reason": {
      "dependents": "Εξαρτώμενα παιδιά βασίζονται σε αυτό το εισόδημα",
      "partner": "Ο/η σύντροφος βασίζεται σε αυτό το εισόδημα",
      "debts": "Καλύπτει οφειλές και τελικά έξοδα",
      "none": "Δεν αφορά αυτό το στάδιο ζωής",
      "health": "Όλοι χρειάζονται ιατρική κάλυψη",
      "income": "Εργάσιμη ηλικία — το εισόδημα είναι το μεγαλύτερο περιουσιακό στοιχείο",
      "retiring": "Κοντά στη συνταξιοδότηση",
      "retirement": "Ορίζοντας αποταμίευσης για σύνταξη",
      "children_education": "Έρχονται οι σπουδές των παιδιών",
      "property": "Κατοικία και περιουσία",
      "needs_analysis": "Από την ανάλυση αναγκών"
    },
    "gaps": "{count, plural, =0 {Κανένα κενό} one {# κενό} other {# κενά}}",
    "score": "Κάλυψη {score}%",
    "opportunities": "Ευκαιρίες κάλυψης",
    "opportunities_hint": "Πελάτες με απαραίτητη ή σημαντική ανάγκη χωρίς ενεργή κάλυψη",
    "held_series": "Υπάρχει",
    "need_series": "Χρειάζεται"
  },
  "health": {
    "title": "Υγεία σχέσης",
    "book": "Υγεία χαρτοφυλακίου",
    "book_hint": "Σταθμισμένη με τα ασφάλιστρα σε {count} πελάτες",
    "band": {
      "strong": "Ισχυρή",
      "steady": "Σταθερή",
      "watch": "Προσοχή",
      "at_risk": "Σε κίνδυνο"
    },
    "factor": {
      "coverage": "Κάλυψη",
      "engagement": "Επαφή",
      "review": "Επανεξέταση",
      "open_items": "Εκκρεμότητες",
      "profile": "Προφίλ"
    },
    "detail": {
      "coverage": "{gaps, plural, =0 {Όλες οι αναγκαίες περιοχές καλύπτονται} one {# κενό κάλυψης} other {# κενά κάλυψης}}",
      "engagement": "Τελευταία επαφή {days, plural, =0 {σήμερα} one {πριν # ημέρα} other {πριν # ημέρες}}",
      "never": "Δεν έχει καταγραφεί επαφή",
      "open": "{overdue} εκπρόθεσμα · {stalled} στάσιμες · {missing} έγγραφα λείπουν",
      "profile": "{filled} από {total} βασικά στοιχεία"
    },
    "why": "Πώς προκύπτει η βαθμολογία",
    "book_empty": "Η υγεία χαρτοφυλακίου εμφανίζεται όταν έχετε πελάτες με συμβόλαια.",
    "column": "Υγεία"
  },
  "constellation": {
    "title": "Αστερισμός",
    "subtitle": "Το χαρτοφυλάκιό σου ως ζωντανός χάρτης — όσο πιο κοντά στο κέντρο, τόσο πιο σύντομα σε χρειάζεται. Το μέγεθος δείχνει το χαρτοφυλάκιο.",
    "legend_now": "Σε χρειάζεται τώρα",
    "legend_soon": "Σύντομα",
    "legend_calm": "Ήρεμα",
    "hint": "Πέρασε από πάνω για τον λόγο · κλικ για άνοιγμα",
    "size": "Μέγεθος = ετήσιο χαρτοφυλάκιο",
    "you": "Εσείς"
  },
  "prep": {
    "title": "Προετοιμασία ραντεβού",
    "open": "Προετοιμασία",
    "talking": "Θέματα συζήτησης",
    "family": "Οικογένεια",
    "holdings": "Καλύψεις",
    "open_items": "Εκκρεμότητες",
    "since": "Πελάτης από {date}",
    "point_gap": "Συζήτησε {area}: {reason}",
    "point_review": "Ετήσια αναθεώρηση: {state}",
    "point_case": "Ενημέρωση για {product} ({stage})",
    "point_moment": "Ανάφερε: {what}",
    "point_renewal": "{product}: ανανέωση στις {date}",
    "none": "Καμία εκκρεμότητα — αξιοποίησε τον χρόνο για να εμβαθύνεις τη σχέση.",
    "point_promise": "Υποσχεθήκαμε: {text}",
    "point_waiting": "Υποσχέθηκαν: {text}",
    "point_decision": "Εκκρεμής απόφαση: {title} ({days} ημέρες)"
  },
  "undo": {
    "action": "Αναίρεση",
    "done": "Αναιρέθηκε",
    "conflict": "Δεν γίνεται αναίρεση — η εγγραφή άλλαξε στο μεταξύ"
  },
  "comparator": {
    "title": "Σύγκριση συμβολαίων",
    "subtitle": "Σύγκρινε έως τρία πλάνα δίπλα-δίπλα — προστασία, κόστος και προβλεπόμενη αξία, χωρίς να μπερδεύονται",
    "new": "Νέα σύγκριση",
    "for": "Για",
    "plan": "Πλάνο {label}",
    "add_plan": "Προσθήκη πλάνου",
    "remove_plan": "Αφαίρεση",
    "insurer": "Ασφαλιστική",
    "product": "Προϊόν",
    "kind": "Τύπος",
    "kinds": {
      "protection": "Προστασία",
      "savings": "Αποταμίευση",
      "combined": "Προστασία + αποταμίευση"
    },
    "monthly": "Μηνιαίο ασφάλιστρο",
    "indexation": "Τιμαριθμοποίηση ασφαλίστρου %/έτος",
    "term": "Διάρκεια (έτη)",
    "cover": "Ασφαλισμένο ποσό / παροχή",
    "savings_share": "Ποσοστό ασφαλίστρου σε αποταμίευση %",
    "delay": "Μήνες χωρίς επένδυση",
    "y1": "Επιβάρυνση 1ου έτους %",
    "y2": "Επιβάρυνση 2ου έτους %",
    "fee": "Ετήσια χρέωση διαχείρισης %",
    "return": "Υποθετική απόδοση %",
    "guaranteed": "Εγγυημένο στη λήξη",
    "quotation": "Αρ. προσφοράς",
    "results": "Αποτελέσματα",
    "total_paid": "Συνολικό κόστος ασφαλίστρων",
    "saved": "Η σύγκριση αποθηκεύτηκε",
    "projected": "Προβλεπόμενη αξία",
    "guaranteed_value": "Εγγυημένη αξία",
    "protection_cost": "Κόστος προστασίας & επιβαρύνσεων",
    "net_cost": "Καθαρό κόστος μετά την προβλεπόμενη αξία",
    "per1000": "Ετήσιο ασφάλιστρο ανά 1.000 κάλυψης",
    "breakeven": "Η αξία ξεπερνά τα ασφάλιστρα",
    "breakeven_year": "στο {year}ο έτος",
    "never": "ποτέ",
    "charges_impact": "Χάνεται σε καθυστερήσεις, επιβαρύνσεις & χρεώσεις",
    "best": "Καλύτερο",
    "chart": "Προβλεπόμενη αξία έναντι πληρωμένων ασφαλίστρων",
    "chart_paid": "Πληρωμένα ασφάλιστρα",
    "year": "Έτος {year}",
    "warn": {
      "no_cover": "Δεν έχει δοθεί ασφαλισμένο ποσό",
      "no_term": "Δεν έχει δοθεί διάρκεια",
      "long_delay": "12+ μήνες χωρίς επένδυση",
      "high_charges": "Οι αρχικές επιβαρύνσεις απορροφούν το μεγαλύτερο μέρος των δύο πρώτων ετών",
      "fees_exceed_return": "Οι χρεώσεις ξεπερνούν την υποθετική απόδοση — το κεφάλαιο μειώνεται πραγματικά"
    },
    "decide": "Καταγραφή απόφασης",
    "decision": "Απόφαση",
    "decisions": {
      "A": "Πλάνο A",
      "B": "Πλάνο B",
      "C": "Πλάνο C",
      "later": "Θα αποφασίσει αργότερα",
      "none": "Κανένα"
    },
    "decided": "Απόφαση {date}: {decision}",
    "locked": "Η σύγκριση έχει αποφασιστεί και κλειδώσει. Άνοιξε αντίγραφο για αλλαγές.",
    "copy": "Άνοιγμα ως νέο προσχέδιο",
    "empty": "Δεν υπάρχουν συγκρίσεις ακόμη",
    "history": "Συγκρίσεις",
    "legacy": "Από το παλιό CRM",
    "followup": "Ημερομηνία follow-up",
    "draft": "Προσχέδιο",
    "chart_hint": "Συνεχής: προβλεπόμενη αξία · διακεκομμένη: καταβληθέντα ασφάλιστρα. Περάστε τον δείκτη για κάθε έτος.",
    "copied": "Άνοιξε νέο προσχέδιο από την κλειδωμένη σύγκριση",
    "decided_toast": "Η απόφαση καταγράφηκε και κλειδώθηκε",
    "disclaimer": "Οι προβλέψεις βασίζονται στην απόδοση και τις χρεώσεις που δώσατε· είναι ενδεικτικές, όχι εγγυημένες. Επισυνάπτετε πάντα την επίσημη προσφορά της εταιρείας.",
    "followup_hint": "Θα προστεθεί υπενθύμιση στην ατζέντα (προεπιλογή σε 7 ημέρες).",
    "lock_note": "Η καταγραφή της απόφασης παγώνει τα πλάνα, τα αποτελέσματα και την ετυμηγορία όπως είναι τώρα. Μπορείτε πάντα να ανοίξετε αντίγραφο.",
    "name": "Όνομα σύγκρισης",
    "need_person": "Επιλέξτε τον πελάτη για τον οποίο γίνεται η σύγκριση",
    "no_term": "Δώστε διάρκεια για να δείτε την προβολή",
    "plans": "πλάνα",
    "section_cost": "Κόστος",
    "section_protection": "Προστασία",
    "section_savings": "Αποταμίευση & αξία",
    "no_data": "Δώστε μηνιαίο ασφάλιστρο για να δείτε την προβολή"
  },
  "insights_v2": {
    "cohorts": "Χαρτοφυλάκιο ανά έτος έναρξης",
    "activity": "Δραστηριότητα — τελευταίες 12 εβδομάδες",
    "funnel": "Pipeline",
    "health_dist": "Υγεία σχέσεων",
    "opportunities": "Ευκαιρίες κάλυψης",
    "less": "Λιγότερη",
    "more": "Περισσότερη",
    "weekday": "{count} ολοκληρωμένες",
    "at_risk": "Χρειάζονται φροντίδα πρώτα",
    "funnel_hint": "Αιτήσεις που έφτασαν σε κάθε στάδιο (έκδοση = μετατροπή).",
    "policies": "{count, plural, one {# συμβόλαιο} other {# συμβόλαια}}"
  },
  "space": {
    "label": "Χώροι",
    "today": "Σήμερα",
    "people": "Άνθρωποι",
    "growth": "Ανάπτυξη",
    "advisory": "Συμβουλευτική",
    "cases": "Αιτήσεις",
    "intelligence": "Ανάλυση",
    "system": "Σύστημα"
  },
  "dates": {
    "plus3": "+3 ημέρες",
    "plus7": "+1 εβδομάδα",
    "day": "Ημέρα",
    "month": "Μήνας",
    "year": "Έτος",
    "ph_day": "ΗΗ",
    "ph_month": "ΜΜ",
    "ph_year": "ΕΕΕΕ",
    "clear": "Καθαρισμός ημερομηνίας",
    "year_hint": "↑ ↓ αλλάζουν το έτος · PgUp / PgDn ανά 10 έτη",
    "err_incomplete": "Συμπληρώστε ολόκληρη την ημερομηνία: ημέρα, μήνα και έτος (4 ψηφία).",
    "err_day": "Η ημέρα πρέπει να είναι από 1 έως 31.",
    "err_month": "Ο μήνας πρέπει να είναι από 1 έως 12.",
    "err_year": "Γράψτε έτος από {min} έως {max}.",
    "err_no_such_day": "Αυτή η ημερομηνία δεν υπάρχει: ο μήνας έχει {days} ημέρες.",
    "err_feb29": "Το {year} δεν είναι δίσεκτο έτος: ο Φεβρουάριος έχει 28 ημέρες.",
    "err_before": "Η ημερομηνία πρέπει να είναι από {date} και μετά.",
    "err_after": "Η ημερομηνία πρέπει να είναι έως {date}."
  },
  "rule": {
    "task_overdue": "Εκπρόθεσμες ενέργειες",
    "promise_overdue": "Υποσχέσεις σε πελάτες",
    "waiting_client": "Αναμονή για τον πελάτη",
    "appointment_today": "Συναντήσεις σήμερα",
    "case_stalled": "Αιτήσεις σε στασιμότητα",
    "case_missing": "Ελλείποντα έγγραφα αιτήσεων",
    "case_no_next": "Αιτήσεις χωρίς επόμενη ενέργεια",
    "decision_pending": "Εκκρεμείς αποφάσεις",
    "quote_expiring": "Προσφορές που λήγουν",
    "claim_followup": "Αποζημιώσεις προς παρακολούθηση",
    "service_open": "Ανοιχτά αιτήματα εξυπηρέτησης",
    "review_overdue": "Εκπρόθεσμες ανασκοπήσεις",
    "review_never": "Χωρίς ανασκόπηση",
    "review_due_soon": "Ανασκοπήσεις σύντομα",
    "renewal_soon": "Επέτειοι συμβολαίων",
    "protection_gap": "Κενά προστασίας",
    "needs_missing": "Λείπει ανάλυση αναγκών",
    "no_next_step": "Προσφορές χωρίς επόμενο βήμα",
    "silence": "Μεγάλη σιωπή",
    "hot": "Ζεστές ευκαιρίες",
    "prospect_followup": "Επανακλήσεις υποψηφίων",
    "referral_thanks": "Ευχαριστίες για συστάσεις",
    "birthday": "Γενέθλια",
    "nameday": "Ονομαστικές εορτές",
    "child_milestone": "Ορόσημα παιδιών",
    "data_quality": "Ελλιπή στοιχεία επικοινωνίας",
    "policy_lapsed": "Ακυρωμένα λόγω μη πληρωμής",
    "payment_late": "Καθυστερημένες πληρωμές",
    "life_event": "Γεγονότα ζωής",
    "loan_maturity": "Λήξεις δανείων",
    "education_milestone": "Ορόσημα σπουδών",
    "mortgage_gap": "Κενά κάλυψης στεγαστικού",
    "extraction_review": "Τιμές εγγράφων προς έλεγχο",
    "sync_conflict": "Συγκρούσεις συγχρονισμού",
    "insured_due": "Λήξεις MOT και άδειας κυκλοφορίας",
    "premium_overdue": "Ληξιπρόθεσμα ασφάλιστρα",
    "kyc_review": "Επανεξέταση φακέλου KYC/AML"
  },
  "hot": {
    "marked": "το σημειώσατε ως ζεστό",
    "recent_interest": "{count, plural, one {επικοινώνησε πρόσφατα} other {επικοινώνησε # φορές πρόσφατα}}",
    "many_interactions": "{count} επαφές αυτόν τον μήνα",
    "active_quote": "έχει ανοιχτή προσφορά",
    "pending_comparison": "αποφασίζει για μια σύγκριση",
    "open_opportunity": "έχει ανοιχτή ευκαιρία",
    "application_started": "ξεκίνησε αίτηση",
    "referrer": "σας έχει συστήσει πελάτες",
    "coverage_gap": "κενό σε {area}"
  },
  "journey": {
    "title": "Συμβουλευτική διαδρομή",
    "profile": "Προφίλ",
    "needs": "Ανάγκες",
    "proposal": "Πρόταση",
    "comparison": "Σύγκριση",
    "decision": "Απόφαση",
    "application": "Αίτηση",
    "policy": "Συμβόλαιο"
  },
  "needs": {
    "title": "Ανάλυση αναγκών",
    "subtitle": "Πρώτο προφίλ, ανάγκες, κίνδυνος και φόροι σε μία εγγραφή με εκδόσεις",
    "new": "Νέα ανάλυση αναγκών",
    "analysis": "Ανάλυση αναγκών",
    "start": "Έναρξη",
    "none": "Δεν υπάρχει",
    "none_person": "Δεν υπάρχει ακόμα ανάλυση αναγκών για {name}.",
    "last": "Τελευταία",
    "filter": {
      "all": "Όλοι",
      "missing": "Λείπει",
      "draft": "Πρόχειρη",
      "final": "Οριστική"
    },
    "status": {
      "draft": "Πρόχειρη",
      "final": "Οριστική"
    },
    "suggest": "Πρόταση",
    "suggested": "Συμπληρώθηκαν προτάσεις — ελέγξτε τις",
    "saved": "Η ανάλυση αναγκών αποθηκεύτηκε",
    "finalize": "Οριστικοποίηση",
    "finalized": "Η ανάλυση αναγκών οριστικοποιήθηκε",
    "finalized_at": "οριστικοποιήθηκε {date}",
    "revise": "Νέα έκδοση",
    "revised": "Άνοιξε νέα έκδοση",
    "locked": "Οριστική και κλειδωμένη — ανοίξτε νέα έκδοση για αλλαγές.",
    "need_person": "Επιλέξτε πρώτα πελάτη",
    "profile": "Πρώτο προφίλ",
    "risk": "Προφίλ κινδύνου",
    "risk_attitude": "Στάση απέναντι στον κίνδυνο",
    "vulnerability": "Ευαλωτότητα",
    "no_vulnerability": "Δεν προκύπτουν ενδείξεις ευαλωτότητας από το προφίλ.",
    "level": {
      "high": "Υψηλή",
      "medium": "Μέτρια",
      "low": "Χαμηλή"
    },
    "areas": "Ανάγκες",
    "areas_hint": "Προτεραιότητα, στόχος, υπάρχουσα κάλυψη και κενό — με το σκεπτικό σας και την επόμενη ενέργεια",
    "area": "Τομέας",
    "priority": "Προτεραιότητα",
    "target": "Στόχος",
    "existing": "Υπάρχει",
    "gap": "Κενό",
    "reasoning": "Σκεπτικό",
    "action": "Προτεινόμενη ενέργεια",
    "p": {
      "0": "—",
      "1": "Καλό",
      "2": "Σημαντικό",
      "3": "Απαραίτητο"
    },
    "create_actions": "Δημιουργία υπενθυμίσεων για σημαντικές ανάγκες με ενέργεια",
    "from_household": "{count} από το νοικοκυριό",
    "health_hint": "Μόνο γενικά — όχι ιατρικές λεπτομέρειες",
    "area_label": {
      "life": "Προστασία ζωής",
      "income": "Προστασία εισοδήματος (μηνιαία)",
      "critical_illness": "Σοβαρές ασθένειες",
      "health": "Ιατροφαρμακευτική",
      "accident": "Προσωπικό ατύχημα",
      "mortgage": "Στεγαστικό / δάνεια",
      "retirement": "Σύνταξη",
      "savings": "Αποταμίευση",
      "education": "Σπουδές",
      "property": "Περιουσία",
      "business": "Επιχείρηση"
    },
    "basis": {
      "life_dependants": "Εξαρτώμενα μέλη στηρίζονται στο εισόδημα — περίπου {years} χρόνια εισοδήματος συν δάνεια, μείον αποταμιεύσεις",
      "life_debts": "Καλύπτει δάνεια και τελικά έξοδα",
      "mortgage": "Υπόλοιπο στεγαστικού",
      "income": "Περίπου {pct}% του μηνιαίου εισοδήματος σε ανικανότητα",
      "critical_illness": "Περίπου {years} χρόνια εισοδήματος",
      "health": "Όλοι χρειάζονται ιατροφαρμακευτική κάλυψη",
      "accident": "Περίπου ένα χρόνο εισοδήματος",
      "retirement": "Συνταξιοδότηση στα {age}",
      "savings": "Αποθεματικό και στόχοι",
      "education": "{children, plural, =0 {Χωρίς παιδιά ακόμα} one {Σπουδές ενός παιδιού} other {Σπουδές # παιδιών}}",
      "property": "Σπίτι και περιουσία",
      "business": "Συνέχεια επιχείρησης"
    },
    "f": {
      "annualIncome": "Ετήσιο εισόδημα",
      "partnerIncome": "Εισόδημα συζύγου",
      "monthlyExpenses": "Μηνιαία έξοδα",
      "mortgage": "Υπόλοιπο στεγαστικού",
      "liabilities": "Άλλα δάνεια",
      "savings": "Αποταμιεύσεις",
      "dependants": "Εξαρτώμενα μέλη",
      "retirementAge": "Ηλικία σύνταξης",
      "smoker": "Καπνιστής",
      "employment": "Απασχόληση",
      "employer": "Εργοδότης",
      "businessOwner": "Ιδιοκτήτης επιχείρησης",
      "goals": "Στόχοι",
      "concerns": "Ανησυχίες",
      "existingCoverNotes": "Υπάρχουσα κάλυψη (άλλες εταιρείες)",
      "healthNotes": "Πλαίσιο υγείας"
    }
  },
  "risk": {
    "single_income": "Οικογένεια {dependants} ατόμων βασίζεται κυρίως σε ένα εισόδημα",
    "debt_exposure": "Τα δάνεια είναι {ratio}× το ετήσιο εισόδημα",
    "low_buffer": "Οι αποταμιεύσεις καλύπτουν {months} μήνες εξόδων",
    "smoker": "Καπνιστής — επηρεάζει τιμή και κίνδυνο υγείας",
    "business_owner": "Ιδιοκτήτης επιχείρησης — το εισόδημα εξαρτάται από την επιχείρηση",
    "title": "Προφίλ κινδύνου & καταλληλότητα",
    "level": {
      "conservative": "Συντηρητικό",
      "cautious": "Μετριοπαθές",
      "balanced": "Ισορροπημένο",
      "growth": "Αναπτυξιακό",
      "dynamic": "Δυναμικό"
    },
    "explain": {
      "conservative": "Προτεραιότητα η διατήρηση του κεφαλαίου· μικρή ανοχή σε διακυμάνσεις.",
      "cautious": "Κυρίως σταθερότητα, με λίγο χώρο για ανάπτυξη.",
      "balanced": "Ισορροπία ανάμεσα σε σταθερότητα και ανάπτυξη· αποδέχεται μέτριες διακυμάνσεις.",
      "growth": "Στόχος η ανάπτυξη σε βάθος χρόνου· αποδέχεται σημαντικές διακυμάνσεις.",
      "dynamic": "Μέγιστη έμφαση στην ανάπτυξη· αποδέχεται μεγάλες διακυμάνσεις για μεγάλο χρονικό ορίζοντα."
    },
    "source": {
      "website": "από το avrastro.com",
      "manual": "ερωτηματολόγιο συμβούλου"
    },
    "import": "Εισαγωγή από avrastro.com",
    "questionnaire": "Ερωτηματολόγιο κινδύνου",
    "date": "Ημερομηνία",
    "source_label": "Πηγή · έκδοση",
    "score": "Βαθμολογία",
    "goal": "Στόχος",
    "goal_ph": "π.χ. σύνταξη, σπουδές παιδιού",
    "goal_date": "Πότε χρειάζονται τα χρήματα",
    "goal_date_hint": "Χρησιμοποιείται για την ειδοποίηση όταν το προφίλ δεν ταιριάζει πια στον χρόνο που απομένει.",
    "time_to_goal": "Χρόνος ως τον στόχο",
    "years": "{count, plural, one {# έτος} other {# έτη}}",
    "none": "Δεν υπάρχει προφίλ κινδύνου. Συμπληρώστε το ερωτηματολόγιο ή εισαγάγετε το αποτέλεσμα που μοιράστηκε ο πελάτης από το avrastro.com.",
    "none_short": "Χωρίς προφίλ κινδύνου",
    "history": "{count, plural, one {# έκδοση} other {# εκδόσεις}}",
    "answers": "{count, plural, one {# απάντηση} other {# απαντήσεις}}",
    "disclaimer": "Βοήθημα για την αξιολόγηση καταλληλότητας του συμβούλου (IDD άρθρο 30)· δεν είναι σύσταση και δεν ονομάζει προϊόν. Η καταλληλότητα αξιολογείται από τον σύμβουλο.",
    "create_task": "Εργασία ανασκόπησης",
    "task_created": "Υπάρχει εργασία",
    "task_title": "Ανασκόπηση προφίλ κινδύνου: {name}",
    "new_version": "Νέα έκδοση",
    "mismatch": {
      "horizon_short": "Το προφίλ «{level}» δεν ταιριάζει πια σε {years} έτη ως τον στόχο (ταιριάζει έως «{fits}»).",
      "near_retirement": "Πλησιάζει η σύνταξη ({years} έτη) με προφίλ «{level}» (ταιριάζει έως «{fits}»).",
      "goal_passed": "Η ημερομηνία του στόχου πέρασε — αξίζει νέο προφίλ.",
      "stale": "Το προφίλ είναι παλιό — αξίζει ανασκόπηση."
    },
    "questionnaire_intro": "Οκτώ ερωτήσεις για χρονικό ορίζοντα, στόχο, αντίδραση σε πτώση, ικανότητα απώλειας, γνώσεις, εμπειρία, σταθερότητα εισοδήματος και αποθέματα. Το αποτέλεσμα είναι ενδεικτικό· αποφασίζετε εσείς.",
    "q": {
      "horizon": "Πότε θα χρειαστείτε το μεγαλύτερο μέρος αυτών των χρημάτων;",
      "objective": "Ποιος είναι ο κύριος στόχος;",
      "reaction": "Αν η αξία έπεφτε 15% μέσα σε έναν χρόνο, τι θα κάνατε;",
      "loss_capacity": "Τι μέρος των αποταμιεύσεων θα μπορούσατε να χάσετε χωρίς να αλλάξουν τα σχέδιά σας;",
      "knowledge": "Πώς θα περιγράφατε τις γνώσεις σας για επενδύσεις;",
      "experience": "Έχετε διατηρήσει επενδυτικά ταμεία, μετοχές ή επενδυτικά ασφαλιστικά προϊόντα;",
      "income": "Πόσο σταθερό είναι το εισόδημά σας;",
      "reserves": "Έχετε αποθεματικό για 3–6 μήνες εξόδων;"
    },
    "opt": {
      "horizon": {
        "o1": "Σε λιγότερο από 3 χρόνια",
        "o2": "Σε 3–7 χρόνια",
        "o3": "Σε 7–15 χρόνια",
        "o4": "Σε περισσότερα από 15 χρόνια"
      },
      "objective": {
        "o1": "Να μη χάσω κεφάλαιο",
        "o2": "Σταθερό εισόδημα",
        "o3": "Ισορροπημένη ανάπτυξη",
        "o4": "Ανάπτυξη σε βάθος χρόνου"
      },
      "reaction": {
        "o1": "Θα τα αποσύρω όλα",
        "o2": "Θα αποσύρω ένα μέρος",
        "o3": "Θα περιμένω",
        "o4": "Θα προσθέσω χρήματα"
      },
      "loss_capacity": {
        "o1": "Κανένα",
        "o2": "Έως 10%",
        "o3": "10–25%",
        "o4": "Πάνω από 25%"
      },
      "knowledge": {
        "o1": "Καμία",
        "o2": "Βασικές",
        "o3": "Καλές",
        "o4": "Επαγγελματικές"
      },
      "experience": {
        "o1": "Ποτέ",
        "o2": "Μία φορά",
        "o3": "Για μερικά χρόνια",
        "o4": "Τακτικά"
      },
      "income": {
        "o1": "Αβέβαιο",
        "o2": "Μεταβαλλόμενο",
        "o3": "Σταθερό",
        "o4": "Πολύ σταθερό, με αποθέματα"
      },
      "reserves": {
        "o1": "Όχι",
        "o2": "Εν μέρει",
        "o3": "Ναι",
        "o4": "Περισσότερο από αυτό"
      }
    },
    "indicative": "Ενδεικτικό προφίλ: {level} ({score}/{max})",
    "capped": {
      "horizon": "Περιορίστηκε σε «Μετριοπαθές» λόγω σύντομου χρονικού ορίζοντα.",
      "loss_capacity": "Περιορίστηκε σε «Μετριοπαθές»: δεν υπάρχει ικανότητα απώλειας.",
      "knowledge": "Περιορίστηκε σε «Ισορροπημένο»: χωρίς γνώσεις και εμπειρία."
    },
    "override": "Προφίλ που καταγράφεται",
    "override_hint": "Μπορείτε να επιλέξετε άλλο προφίλ από το ενδεικτικό· τότε γράψτε τον λόγο.",
    "keep_indicative": "Το ενδεικτικό",
    "override_reason": "Λόγος",
    "save": "Αποθήκευση νέας έκδοσης",
    "saved": "Το προφίλ κινδύνου αποθηκεύτηκε",
    "import_hint": "Όταν ο πελάτης μοιράζεται το αποτέλεσμα του ερωτηματολογίου κινδύνου από το avrastro.com, εισάγεται μόνο του όταν αποδεχτείτε το μοίρασμα στα Εισερχόμενα. Εδώ μπορείτε να επικολλήσετε το αποτέλεσμα (JSON) και χειροκίνητα.",
    "import_save": "Εισαγωγή",
    "import_unreadable": "Δεν βρέθηκε προφίλ ή βαθμολογία σε αυτό το κείμενο.",
    "from_score": "Το προφίλ προκύπτει από τη βαθμολογία (δεν ονομαζόταν στο αποτέλεσμα).",
    "in_sale_file": "Προφίλ κινδύνου για την καταλληλότητα",
    "pick": "Επιλέξτε έκδοση",
    "use_latest": "Το πιο πρόσφατο",
    "sale_file_hint": "Συμπληρώνεται στην καρτέλα πελάτη → «Προφίλ κινδύνου»."
  },
  "tax": {
    "title": "Εκτίμηση φόρου",
    "no_ruleset": "Δεν υπάρχουν ακόμα φορολογικοί κανόνες για την περιοχή {region}.",
    "provident": "Ταμείο προνοίας / έτος",
    "pension": "Συνταξιοδοτικό ταμείο / έτος",
    "medical": "Ιατρικό ταμείο / έτος",
    "housing": "Τόκοι στεγαστικού ή ενοίκιο",
    "household_income": "Εισόδημα νοικοκυριού",
    "si_actual": "Κοινωνικές ασφαλίσεις (πραγματικές)",
    "si_hint": "Αφήστε κενό για εκτίμηση",
    "cap": "Όριο εκπτώσεων (1/5 εισοδήματος)",
    "used": "Χρησιμοποιήθηκε",
    "capacity": "Διαθέσιμο περιθώριο",
    "life_relief": "Έκπτωση ασφαλίστρων ζωής",
    "saving": "Εκτιμώμενη φορολογική ελάφρυνση",
    "marginal": "Οριακός συντελεστής",
    "capacity_hint": "Έως {amount} επιπλέον εισφορές ζωής ή σύνταξης θα εξακολουθούσαν να εκπίπτουν — περίπου {saving} λιγότερος φόρος τον χρόνο.",
    "enter_income": "Συμπληρώστε το ετήσιο εισόδημα για να δείτε την εκτίμηση.",
    "disclaimer": "Εκτίμηση με τους κανόνες {id} (έλεγχος {date}). Δεν αποτελεί φορολογική συμβουλή — επιβεβαιώστε με τον λογιστή του πελάτη.",
    "note": {
      "si_estimated": "Οι κοινωνικές ασφαλίσεις υπολογίστηκαν με τον βασικό συντελεστή.",
      "life_no_sum_insured": "Συμβόλαιο ζωής χωρίς ασφαλισμένο ποσό — η έκπτωση υπολογίστηκε στο πλήρες ασφάλιστρο.",
      "cap_reached": "Οι εισφορές ήδη υπερβαίνουν το όριο εκπτώσεων.",
      "household_income_assumed": "Δεν δόθηκε εισόδημα νοικοκυριού — θεωρήθηκε ότι πληρείται το όριο για το επίδομα παιδιών.",
      "housing_over_threshold": "Το οικογενειακό εισόδημα υπερβαίνει το όριο — δεν ισχύει έκπτωση τόκων στέγασης/ενοικίου.",
      "provident_limited": "Οι εισφορές σε ταμείο συντάξεων και προνοίας περιορίζονται στο 10% των αποδοχών."
    }
  },
  "quotes": {
    "title": "Προσφορές",
    "subtitle": "Κάθε προσφορά μένει ορατή μέχρι να γίνει αποδεκτή, να απορριφθεί ή να λήξει",
    "new": "Νέα προσφορά",
    "edit": "Επεξεργασία προσφοράς",
    "saved": "Η προσφορά αποθηκεύτηκε",
    "empty": "Δεν υπάρχουν προσφορές.",
    "insurer": "Ασφαλιστική",
    "product": "Προϊόν",
    "number": "Αρ. προσφοράς",
    "premium": "Ασφάλιστρο",
    "expiry": "Ισχύει έως",
    "url": "Σύνδεσμος στο PDF",
    "followup": "Επικοινωνία στις",
    "valid_until": "ισχύει έως {date}"
  },
  "proposal": {
    "title": "Προτάσεις",
    "subtitle": "Προτάσεις προς τον πελάτη από ανάγκες, προσφορές και συγκρίσεις",
    "new": "Νέα πρόταση",
    "studio": "Proposal studio",
    "name": "Τίτλος πρότασης",
    "default_title": "Πρόταση προστασίας & αποταμίευσης",
    "empty": "Δεν έχουν εκδοθεί προτάσεις.",
    "recommendations": "Συστάσεις",
    "no_needs": "Δεν υπάρχει ανάλυση αναγκών — οι συστάσεις θα είναι κενές μέχρι να ολοκληρωθεί.",
    "close_gap": "Κάλυψη του κενού: {area}",
    "rationale": "Σκεπτικό",
    "rationale_hint": "Γιατί η σύσταση ταιριάζει στον πελάτη",
    "assumptions": "Παραδοχές",
    "default_assumptions": "Οι προβολές βασίζονται στις αποδόσεις και χρεώσεις της σύγκρισης. Ασφάλιστρα και παροχές σύμφωνα με την επίσημη προσφορά της ασφαλιστικής.",
    "preview": "Προεπισκόπηση",
    "issue": "Έκδοση & εκτύπωση",
    "issued": "Η πρόταση εκδόθηκε",
    "prepared_for": "Για τον/την {name} · {date}",
    "signatures": "Υπογραφή πελάτη · Υπογραφή συμβούλου",
    "version_note": "Η έκδοση δημιουργεί αριθμημένη έκδοση με ημερομηνία {date} στα έγγραφα και στο ιστορικό του πελάτη.",
    "section": {
      "situation": "Κατάσταση",
      "needs": "Ανάγκες",
      "recommendations": "Συστάσεις",
      "quotes": "Προσφορές",
      "comparison": "Σύγκριση",
      "tax": "Φορολογικά",
      "next_steps": "Επόμενα βήματα"
    }
  },
  "print": {
    "pdf_hint": "Για PDF: στο παράθυρο εκτύπωσης διαλέξτε «Αποθήκευση ως PDF» (Mac: κουμπί «PDF» κάτω αριστερά · Windows: εκτυπωτής «Microsoft Print to PDF»).",
    "notes_space": "Επιπλέον χώρος για σημειώσεις",
    "paper_letter": "Letter (ΗΠΑ)",
    "paper_a4": "A4",
    "paper": "Μέγεθος χαρτιού",
    "orientation_landscape": "Οριζόντια",
    "orientation_portrait": "Κατακόρυφα",
    "orientation": "Προσανατολισμός",
    "studio": "Print studio",
    "studio_hint": "Επιλέξτε τις ενότητες — μία υπηρεσία εκτύπωσης, με τα στοιχεία σας.",
    "sections": "Ενότητες",
    "section": {
      "identity": "Στοιχεία",
      "policies": "Συμβόλαια",
      "coverage": "Κάλυψη",
      "needs": "Ανάγκες",
      "comparisons": "Συγκρίσεις",
      "applications": "Αιτήσεις",
      "meetings": "Συναντήσεις",
      "notes": "Σημειώσεις",
      "review": "Ανασκόπηση",
      "next_actions": "Επόμενες ενέργειες",
      "protection": "Χάρτης προστασίας",
      "finances": "Εισοδήματα, δάνεια & στόχοι",
      "tax": "Φορολογικά",
      "renewals": "Ανανεώσεις",
      "life_events": "Γεγονότα ζωής",
      "review_changes": "Αλλαγές από το τελευταίο review"
    },
    "report": {
      "client_review": "Επανεξέταση πελάτη",
      "needs_analysis": "Ανάλυση αναγκών",
      "insurance_summary": "Σύνοψη ασφαλίσεων",
      "family_protection": "Οικογενειακή προστασία",
      "tax_planning": "Φορολογικός σχεδιασμός",
      "renewal_summary": "Σύνοψη ανανεώσεων",
      "meeting_summary": "Σύνοψη συνάντησης",
      "proposal_summary": "Σύνοψη πρότασης"
    },
    "prepared_for": "Ετοιμάστηκε για",
    "page": "Σελίδα",
    "of": "από",
    "confidential": "Εμπιστευτικό — για αποκλειστική χρήση του πελάτη που αναφέρεται παραπάνω.",
    "client_report": "Αναφορά πελάτη",
    "confidential_short": "Εμπιστευτικό",
    "plan_title": "Πρόγραμμα ημέρας",
    "plan_more": "ακόμη — βλ. «Πρόγραμμα»",
    "plan_in_crm": "στο CRM",
    "plan_due": "Κλήσεις και follow-up του CRM (χωρίς ώρα)",
    "plan_notes": "Σημειώσεις",
    "blank_title": "Πρόγραμμα ημέρας"
  },
  "pipeline": {
    "title": "Pipeline",
    "subtitle": "{open} ανοιχτές · {won} κερδήθηκαν φέτος · {value}",
    "new": "Νέα ευκαιρία",
    "opportunity": "Ευκαιρία",
    "stage": "Στάδιο",
    "expected": "Αναμενόμενο ετήσιο ασφάλιστρο",
    "target_close": "Στόχος κλεισίματος",
    "next_action_date": "Επόμενη ενέργεια στις",
    "advance": "Επόμενο",
    "moved": "Μεταφέρθηκε σε {stage}",
    "won": "Κερδήθηκε 🎉",
    "close_by": "κλείσιμο έως {date}",
    "why_hot": "Γιατί είναι ζεστή",
    "no_signals": "Δεν υπάρχουν ενδείξεις αυτή τη στιγμή.",
    "empty": "Δεν υπάρχουν ευκαιρίες.",
    "show_closed": "Εμφάνιση κλειστών",
    "hide_closed": "Απόκρυψη κλειστών"
  },
  "decisions": {
    "title": "Εκκρεμείς αποφάσεις",
    "subtitle": "Συγκρίσεις, προσφορές και ευκαιρίες που περιμένουν απάντηση του πελάτη",
    "none": "Δεν περιμένει τίποτα απόφαση.",
    "kind": {
      "comparison": "Σύγκριση",
      "quotation": "Προσφορά",
      "opportunity": "Ευκαιρία"
    },
    "waiting_days": "{days, plural, =0 {σήμερα} one {# ημέρα} other {# ημέρες}}",
    "no_deadline": "Χωρίς προθεσμία",
    "no_followup": "Χωρίς επικοινωνία",
    "reason": "Γιατί εκκρεμεί",
    "objections": "Αντιρρήσεις"
  },
  "decision": {
    "reason": {
      "draft": "Η σύγκριση είναι ακόμα πρόχειρη",
      "decide_later": "Ο πελάτης θα αποφασίσει αργότερα"
    }
  },
  "referrals": {
    "title": "Συστάσεις",
    "subtitle": "{total} συστάσεις · {converted} μετατράπηκαν",
    "new": "Νέα σύσταση",
    "saved": "Η σύσταση αποθηκεύτηκε",
    "empty": "Δεν υπάρχουν συστάσεις.",
    "referrer": "Σύσταση από",
    "name": "Πρόσωπο",
    "by": "από {name}",
    "convert": "Δημιουργία επαφής",
    "converted": "Η σύσταση έγινε επαφή",
    "thank": "Ευχαριστώ",
    "thanked": "ευχαριστήθηκε",
    "top": "Κορυφαίοι συστήνοντες",
    "given": "Συστάσεις που έδωσε",
    "referred_by": "Σύσταση από",
    "relationship": "Σχέση με αυτόν που σύστησε",
    "rel": {
      "family": "Οικογένεια",
      "friend": "Φίλος/η",
      "colleague": "Συνάδελφος",
      "neighbour": "Γείτονας",
      "business": "Επαγγελματική επαφή",
      "other": "Άλλο"
    },
    "log_attempt": "Καταγραφή επαφής",
    "attempt_saved": "Η επαφή καταγράφηκε",
    "attempts": "{count, plural, one {# προσπάθεια} other {# προσπάθειες}}",
    "meeting_on": "ραντεβού {date}",
    "next_on": "επόμενο {date}",
    "channel": "Κανάλι",
    "outcome": "Αποτέλεσμα",
    "out": {
      "reached": "Μιλήσαμε",
      "no_answer": "Δεν απάντησε",
      "callback": "Να καλέσω αργότερα",
      "meeting": "Κλείστηκε ραντεβού",
      "not_interested": "Δεν ενδιαφέρεται"
    },
    "appointment": "Ραντεβού",
    "next_step": "Επόμενη προσπάθεια",
    "next_step_hint": "Κενό: σε δύο ημέρες για «δεν απάντησε / αργότερα»",
    "funnel": "{given} συστάσεις · {met} ραντεβού · {won} νέοι",
    "to_thank": "ευχαριστήστε {count}",
    "to_thank_hint": "Συστάσεις που δεν έχουν ευχαριστηθεί"
  },
  "service": {
    "title": "Κέντρο εξυπηρέτησης",
    "subtitle": "Αιτήματα και αποζημιώσεις μετά την έκδοση — κατάσταση, επόμενη ενέργεια, χρόνος",
    "new": "Νέο αίτημα",
    "request": "Αίτημα",
    "next": "Επόμενη ενέργεια",
    "idle": "Ανοιχτό εδώ και",
    "open_only": "Μόνο ανοιχτά",
    "placeholder": "π.χ. αλλαγή δικαιούχου",
    "tab": {
      "requests": "Αιτήματα",
      "claims": "Αποζημιώσεις"
    },
    "type": {
      "beneficiary": "Αλλαγή δικαιούχου",
      "payment": "Πληρωμή / ασφάλιστρο",
      "address": "Αλλαγή διεύθυνσης",
      "certificate": "Πιστοποιητικό",
      "reinstatement": "Επαναφορά",
      "cancellation": "Ακύρωση",
      "cover_change": "Αλλαγή κάλυψης",
      "complaint": "Παράπονο"
    }
  },
  "claims": {
    "new": "Νέα αποζημίωση",
    "saved": "Η αποζημίωση αποθηκεύτηκε",
    "empty": "Δεν υπάρχουν αποζημιώσεις.",
    "type": "Είδος",
    "event_date": "Ημερομηνία συμβάντος",
    "reference": "Αρ. αποζημίωσης",
    "claimed": "Ζητήθηκε",
    "paid": "Πληρώθηκε",
    "note": "Το AVRASTRO σας βοηθά να εξυπηρετήσετε την αποζημίωση· την απόφαση την παίρνει η ασφαλιστική.",
    "kind": {
      "hospital": "Νοσηλεία",
      "outpatient": "Εξωνοσοκομειακά",
      "accident": "Ατύχημα",
      "critical_illness": "Σοβαρή ασθένεια",
      "death": "Θάνατος",
      "disability": "Ανικανότητα",
      "property": "Περιουσία",
      "motor": "Όχημα"
    }
  },
  "comms": {
    "title": "Επικοινωνίες",
    "log": "Καταγραφή επικοινωνίας",
    "logged": "Η επικοινωνία καταγράφηκε",
    "empty": "Δεν έχουν καταγραφεί επικοινωνίες.",
    "channel": "Κανάλι",
    "direction": "Κατεύθυνση",
    "subject": "Θέμα",
    "summary": "Σύνοψη",
    "followup": "Επόμενη επικοινωνία"
  },
  "meetings": {
    "title": "Συναντήσεις",
    "new": "Νέα συνάντηση",
    "edit": "Επεξεργασία συνάντησης",
    "saved": "Η συνάντηση αποθηκεύτηκε",
    "empty": "Δεν έχουν καταγραφεί συναντήσεις.",
    "untitled": "Συνάντηση",
    "purpose": "Σκοπός",
    "attendees": "Συμμετέχοντες",
    "agenda": "Ατζέντα",
    "held": "Έγινε",
    "record_outcome": "Καταγραφή αποτελέσματος",
    "assistant": "Βοηθός μετά τη συνάντηση",
    "notes": "Σημειώσεις συνάντησης",
    "notes_hint": "Γράψτε ελεύθερα, στα ελληνικά ή στα αγγλικά — ένα σημείο ανά γραμμή λειτουργεί καλύτερα",
    "analyse": "Εντοπισμός υποσχέσεων & βημάτων",
    "analyse_hint": "Το AVRASTRO διαβάζει τις σημειώσεις και προτείνει ποιος υποσχέθηκε τι και μέχρι πότε. Ελέγχετε τα πάντα πριν αποθηκευτούν.",
    "commitments": "Δεσμεύσεις",
    "no_commitments": "Δεν βρέθηκαν δεσμεύσεις — προσθέστε τις αν χρειάζεται.",
    "add_commitment": "Προσθήκη δέσμευσης",
    "keep": "Διατήρηση",
    "by": {
      "advisor": "Υποσχέθηκα",
      "client": "Υποσχέθηκε ο πελάτης"
    },
    "decisions": "Αποφάσεις",
    "objections": "Αντιρρήσεις",
    "opportunities": "Ευκαιρίες",
    "review_note": "Οι δεσμεύσεις με ημερομηνία γίνονται υπενθυμίσεις· οι υποσχέσεις του πελάτη παρακολουθούνται ως «αναμονή για τον πελάτη».",
    "save_outcome": "Αποθήκευση αποτελέσματος",
    "completed": "Η συνάντηση καταγράφηκε — δημιουργήθηκαν υπενθυμίσεις",
    "promises": "Υποσχέσεις",
    "no_promises": "Δεν υπάρχουν ανοιχτές υποσχέσεις."
  },
  "business": {
    "title": "Business center",
    "subtitle": "Στόχοι, παραγωγή, δραστηριότητα και εξυπηρέτηση — ξεχωριστά",
    "set_targets": "Ορισμός στόχων",
    "targets_saved": "Οι στόχοι αποθηκεύτηκαν",
    "no_target": "Χωρίς στόχο",
    "metric": {
      "annualPremium": "Νέο ετήσιο ασφάλιστρο",
      "policies": "Νέα συμβόλαια",
      "newClients": "Νέοι πελάτες",
      "meetings": "Συναντήσεις",
      "calls": "Κλήσεις",
      "reviews": "Ανασκοπήσεις",
      "referrals": "Συστάσεις"
    },
    "of_target": "από {target} · {pct}%",
    "on_pace": "εντός ρυθμού",
    "behind": "πίσω από τον ρυθμό",
    "pace": "Πού θα έπρεπε να είστε σήμερα",
    "production_by_month": "Παραγωγή ανά μήνα",
    "monthly_target": "Μηνιαίος στόχος",
    "pipeline": "Pipeline",
    "open_value": "Ανοιχτή αξία",
    "conversion": "Μετατροπή",
    "won_lost": "Κερδήθηκαν / χάθηκαν",
    "prospects_called": "Κλήσεις υποψηφίων",
    "service": "Εξυπηρέτηση",
    "service_opened": "Νέα αιτήματα",
    "service_closed": "Κλειστά αιτήματα",
    "claims_closed": "Κλειστές αποζημιώσεις",
    "claims_paid": "Πληρωμές αποζημιώσεων",
    "def": {
      "production": "Παραγωγή = ετήσιο ασφάλιστρο συμβολαίων με έναρξη φέτος (χωρίς προσφορές).",
      "activity": "Δραστηριότητα = ολοκληρωμένες κλήσεις και συναντήσεις, ανασκοπήσεις και συστάσεις φέτος.",
      "production_ledger": "Η παραγωγή προκύπτει από το καθολικό: νέες εργασίες, αυξήσεις και μειώσεις ασφαλίστρου, ανανεώσεις και αντιλογισμοί, καθεμία μία φορά."
    },
    "open_ledger": "Άνοιγμα καθολικού παραγωγής",
    "other_currencies": "άλλα νομίσματα: {list}"
  },
  "quality": {
    "title": "Ποιότητα δεδομένων",
    "subtitle": "{count, plural, =0 {Δεν βρέθηκαν ζητήματα} one {Βρέθηκε # ζήτημα} other {Βρέθηκαν # ζητήματα}} — με αιτία και προτεινόμενη διόρθωση",
    "clean": "Τα δεδομένα σας είναι καθαρά.",
    "never_deletes": "Ο έλεγχος ποιότητας δεν διαγράφει ποτέ τίποτα. Οι συγχωνεύσεις κρατούν στιγμιότυπο ασφαλείας και αναιρούνται.",
    "kind": {
      "duplicate_person": "Διπλοεγγραφές",
      "duplicate_prospect": "Διπλοί υποψήφιοι",
      "prospect_is_client": "Υποψήφιος είναι πελάτης",
      "missing_contact": "Χωρίς στοιχεία επικοινωνίας",
      "invalid_email": "Μη έγκυρο e-mail",
      "invalid_phone": "Μη έγκυρο τηλέφωνο",
      "missing_birthdate": "Χωρίς ημ. γέννησης",
      "broken_reference": "Σπασμένοι σύνδεσμοι",
      "client_without_policy": "Πελάτης χωρίς συμβόλαιο",
      "needs_outdated": "Παλιά ανάλυση αναγκών",
      "shared_contact": "Κοινά στοιχεία επικοινωνίας"
    },
    "issue": {
      "duplicate_person": "Ο/Η {a} και ο/η {b} μοιάζουν να είναι το ίδιο πρόσωπο",
      "duplicate_prospect": "Ο/Η {name} εμφανίζεται σε περισσότερες λίστες",
      "prospect_is_client": "Ο υποψήφιος {name} είναι ήδη πελάτης σας ({client})",
      "missing_contact": "Ο/Η {name} δεν έχει τηλέφωνο ή e-mail",
      "invalid_email": "{name}: το «{value}» δεν είναι έγκυρο e-mail",
      "invalid_phone": "{name}: το «{value}» δεν είναι έγκυρο τηλέφωνο",
      "missing_birthdate": "Ο/Η {name} δεν έχει ημερομηνία γέννησης",
      "broken_reference": "{table}.{field}: {problem}",
      "client_without_policy": "Ο/Η {name} είναι πελάτης χωρίς ενεργό συμβόλαιο",
      "needs_outdated": "Η ανάλυση αναγκών του/της {name} είναι {days} ημερών",
      "shared_contact": "Ο/Η {a} και ο/η {b} έχουν {basis, select, phone {το ίδιο τηλέφωνο} email {το ίδιο e-mail} other {κοινό στοιχείο επικοινωνίας}}"
    },
    "why": {
      "duplicate_person": "Ίδιο τηλέφωνο ή ίδιο όνομα και ημερομηνία γέννησης.",
      "duplicate_prospect": "Ο ίδιος αριθμός εισήχθη δύο φορές.",
      "prospect_is_client": "Αποφύγετε ψυχρές κλήσεις σε πελάτες σας.",
      "missing_contact": "Δεν μπορείτε να επικοινωνήσετε.",
      "invalid_email": "Τα μηνύματα θα επιστρέφονται.",
      "invalid_phone": "Κλήσεις και WhatsApp θα αποτυγχάνουν.",
      "missing_birthdate": "Χρειάζεται για ανασκοπήσεις, γενέθλια και τιμολόγηση.",
      "broken_reference": "Μια εγγραφή δείχνει σε κάτι που δεν υπάρχει πια.",
      "client_without_policy": "Σημειώστε ως πρώην πελάτη ή προσθέστε το συμβόλαιο.",
      "needs_outdated": "Η ζωή αλλάζει — επανεξετάστε τις ανάγκες.",
      "shared_contact": "Συνήθως μέλη οικογένειας — ελέγξτε ότι είναι διαφορετικά πρόσωπα."
    },
    "fix": {
      "merge": "Συγχώνευση…",
      "edit": "Επεξεργασία",
      "open": "Άνοιγμα",
      "review": "Έλεγχος",
      "compare": "Σύγκριση…"
    },
    "merge_title": "Συγχώνευση διπλοεγγραφών",
    "keep": "Διατήρηση",
    "merge_explain": "Ό,τι συνδέεται με {drop} μεταφέρεται σε {keep}· το {drop} αρχειοθετείται, δεν διαγράφεται.",
    "merge_confirm": "Συγχώνευση",
    "merged": "Οι εγγραφές συγχωνεύτηκαν",
    "fills": "Κενά πεδία συμπληρώνονται από τη διπλοεγγραφή: {list}",
    "merge_safety": "Κρατείται πρώτα στιγμιότυπο ασφαλείας· λειτουργεί και η αναίρεση.",
    "snapshot_label": "Πριν τη συγχώνευση {name}",
    "table": {
      "household_members": "Νοικοκυριό",
      "policies": "Συμβόλαια",
      "cases": "Αιτήσεις",
      "tasks": "Ενέργειες",
      "notes": "Σημειώσεις",
      "reviews": "Ανασκοπήσεις",
      "timeline": "Γεγονότα ιστορικού",
      "documents": "Έγγραφα",
      "service_cases": "Αιτήματα εξυπηρέτησης",
      "consents": "Συγκαταθέσεις",
      "legacy_records": "Εισαγμένες εγγραφές",
      "comparisons": "Συγκρίσεις",
      "needs_analyses": "Αναλύσεις αναγκών",
      "quotations": "Προσφορές",
      "opportunities": "Ευκαιρίες",
      "referrals": "Συστάσεις",
      "communications": "Επικοινωνίες",
      "meetings": "Συναντήσεις",
      "claims": "Αποζημιώσεις",
      "persons": "Πρόσωπα",
      "prospects": "Υποψήφιοι",
      "production_events": "Παραγωγή",
      "renewals": "Ανανεώσεις",
      "commission_entries": "Προμήθειες",
      "tax_snapshots": "Φορολογικοί υπολογισμοί",
      "financial_items": "Εισοδήματα, δάνεια & στόχοι",
      "life_events": "Γεγονότα ζωής",
      "campaign_activities": "Δραστηριότητα καμπάνιας",
      "automation_runs": "Εκτελέσεις αυτοματισμών",
      "extraction_drafts": "Έλεγχοι εγγράφων",
      "insured_items": "Ασφαλισμένα αντικείμενα",
      "premium_arrears": "Ληξιπρόθεσμα ασφάλιστρα",
      "nps_surveys": "Γνώμη πελατών",
      "kyc_files": "Φάκελοι KYC/AML",
      "sale_files": "Φάκελοι πώλησης (IDD)",
      "call_logs": "Κλήσεις προσέγγισης",
      "risk_profiles": "Προφίλ κινδύνου",
      "family_links": "Οικογενειακός χάρτης",
      "client_summaries": "Συνόψεις πελατών"
    },
    "field": {
      "primaryPhone": "τηλέφωνο",
      "primaryEmail": "e-mail",
      "birthDate": "ημ. γέννησης",
      "occupation": "επάγγελμα",
      "employer": "εργοδότης",
      "address": "διεύθυνση",
      "city": "πόλη",
      "maritalStatus": "οικογενειακή κατάσταση",
      "gender": "φύλο",
      "householdId": "νοικοκυριό",
      "source": "πηγή",
      "notes": "σημειώσεις",
      "displayName": "όνομα",
      "firstName": "όνομα",
      "lastName": "επώνυμο",
      "phones": "τηλέφωνα",
      "emails": "e-mails",
      "stage": "στάδιο",
      "clientSince": "πελάτης από",
      "referredByPersonId": "σύσταση από",
      "referredByName": "σύσταση από (όνομα)"
    },
    "compare_title": "Σύγκριση εγγραφών",
    "compare_hint": "Τίποτα δεν αλλάζει μέχρι να επιλέξετε. Η συγχώνευση κρατά αντίγραφο ασφαλείας· η επιλογή «χωριστά» απομνημονεύεται.",
    "shared_explain": "Μέλη οικογένειας συχνά μοιράζονται τηλέφωνο ή e-mail. Αν είναι διαφορετικά πρόσωπα, κρατήστε τα χωριστά.",
    "keep_separate": "Διατήρηση χωριστά",
    "kept_separate": "Διατηρήθηκαν χωριστά — το ζεύγος δεν θα επισημανθεί ξανά",
    "merge_these": "Συγχώνευση…",
    "linked": "Συνδεδεμένες εγγραφές",
    "linked_counts": "{policies, plural, one {# συμβόλαιο} other {# συμβόλαια}} · {tasks, plural, one {# εργασία} other {# εργασίες}} · {documents, plural, one {# έγγραφο} other {# έγγραφα}}",
    "same_household": "ίδιο νοικοκυριό",
    "conflicts": "Διαφορετικές τιμές — υπερισχύει η εγγραφή που διατηρείται:",
    "conflict_keeps": "κρατά «{keep}» (άλλη: «{drop}», παραμένει στο ιστορικό)",
    "moves_sensitive": "Μεταφέρονται επίσης {consents, plural, one {# εγγραφή συναίνεσης} other {# εγγραφές συναίνεσης}} και {documents, plural, one {# έγγραφο} other {# έγγραφα}}."
  },
  "compliance": {
    "title": "Συμμόρφωση & GDPR",
    "subtitle": "Συγκαταθέσεις, πρόσβαση, διόρθωση και διαγραφή · {count} πρόσωπα χωρίς καταγεγραμμένη συγκατάθεση marketing",
    "pick": "Επιλέξτε πρόσωπο για να δείτε συγκαταθέσεις και δικαιώματα.",
    "consents": "Συγκαταθέσεις",
    "record": "Καταγραφή συγκατάθεσης",
    "purpose": "Σκοπός",
    "granted": "Δόθηκε",
    "withdrawn": "Ανακλήθηκε",
    "not_recorded": "Δεν έχει καταγραφεί",
    "history": "Ιστορικό",
    "channel_hint": "Επιλέξτε κανάλι μόνο αν ο πελάτης περιόρισε τη συναίνεση σε αυτό· η προέλευση της συναίνεσης καταγράφεται στην Πηγή.",
    "rights": "Δικαιώματα υποκειμένου",
    "export": "Εξαγωγή όλων των δεδομένων (JSON)",
    "exported": "Τα προσωπικά δεδομένα εξήχθησαν",
    "rectify": "Διόρθωση στοιχείων",
    "erase": "Διαγραφή προσωπικών δεδομένων",
    "note": "Η διαγραφή ανωνυμοποιεί το πρόσωπο και αφαιρεί σημειώσεις, επικοινωνίες και έγγραφα· οι ασφαλιστικές εγγραφές διατηρούνται για κανονιστικούς λόγους.",
    "erase_title": "Διαγραφή προσωπικών δεδομένων · {name}",
    "erase_explain": "Το πρόσωπο ανωνυμοποιείται. Συμβόλαια, αιτήσεις, αποζημιώσεις και συγκαταθέσεις διατηρούνται χωρίς να το ταυτοποιούν.",
    "will_delete": "Θα διαγραφούν",
    "will_retain": "Θα διατηρηθούν (ανώνυμα)",
    "erase_word": "ΔΙΑΓΡΑΦΗ",
    "type_to_confirm": "Πληκτρολογήστε {word} για επιβεβαίωση",
    "erased": "Τα προσωπικά δεδομένα διαγράφηκαν",
    "snapshot_label": "Πριν τη διαγραφή {name}",
    "snapshot_kept": "Κρατήθηκε στιγμιότυπο ασφαλείας: {label}",
    "lawful_basis": "Νομική βάση",
    "source": "Πηγή",
    "source_hint": "π.χ. υπογεγραμμένο έντυπο, τηλεφώνημα, ιστοσελίδα",
    "scope": "Εύρος",
    "scope_hint": "π.χ. ενημερωτικά για συντάξεις, μόνο WhatsApp",
    "basis": {
      "consent": "Συναίνεση",
      "contract": "Σύμβαση",
      "legal_obligation": "Νομική υποχρέωση",
      "legitimate_interest": "Έννομο συμφέρον",
      "vital_interest": "Ζωτικό συμφέρον"
    },
    "any_channel": "Οποιοδήποτε κανάλι"
  },
  "consent": {
    "purpose": {
      "marketing": "Marketing",
      "advice": "Συμβουλευτική & εξυπηρέτηση",
      "health_data": "Επεξεργασία δεδομένων υγείας",
      "third_party": "Κοινοποίηση σε ασφαλιστικές",
      "newsletter": "Ενημερωτικό δελτίο",
      "client": "Σχέση πελάτη",
      "data_processing": "Επεξεργασία δεδομένων",
      "documents": "Αποθήκευση εγγράφων",
      "whatsapp": "Μηνύματα WhatsApp",
      "voice_recording": "Ηχογράφηση συναντήσεων για σύνοψη"
    }
  },
  "templates": {
    "title": "Πρότυπα μηνυμάτων",
    "subtitle": "Ένας πολύγλωσσος κατάλογος για κάθε μήνυμα προς πελάτες — τα πεδία συμπληρώνονται από τα δεδομένα σας",
    "template": "Πρότυπο",
    "compose": "Μήνυμα",
    "compose_template": "Μήνυμα από πρότυπο",
    "subject": "Θέμα",
    "body": "Κείμενο",
    "preview": "Προεπισκόπηση",
    "custom": "Προσαρμοσμένο",
    "default": "Προεπιλογή",
    "saved": "Το πρότυπο αποθηκεύτηκε",
    "reset": "Επαναφορά προεπιλογής",
    "missing": "Δεν υπάρχει ακόμα τιμή για: {list}",
    "key": {
      "appointment_confirm": "Επιβεβαίωση ραντεβού",
      "appointment_reminder": "Υπενθύμιση ραντεβού",
      "missed_call": "Αναπάντητη κλήση",
      "birthday": "Γενέθλια",
      "nameday": "Ονομαστική εορτή",
      "review_invite": "Πρόσκληση σε ανασκόπηση",
      "renewal": "Ανανέωση",
      "quote_followup": "Παρακολούθηση προσφοράς",
      "decision_followup": "Εκκρεμής απόφαση",
      "missing_documents": "Ελλείποντα έγγραφα",
      "underwriting_update": "Ενημέρωση ανάληψης κινδύνου",
      "meeting_followup": "Μετά τη συνάντηση",
      "referral_thanks": "Ευχαριστώ για τη σύσταση",
      "claim_update": "Ενημέρωση αποζημίωσης",
      "campaign": "Ελεύθερο μήνυμα",
      "followup_general": "Γενικό follow-up",
      "premium_reminder": "Υπενθύμιση ληξιπρόθεσμου ασφαλίστρου",
      "nps_invite": "Ερώτηση γνώμης (NPS)",
      "google_review": "Αίτημα αξιολόγησης Google",
      "review_request": "Ευχαριστώ + κριτική στο Google"
    },
    "print_letter": "Εκτύπωση ως επιστολή"
  },
  "ask": {
    "title": "Ρώτα το AVRASTRO",
    "subtitle": "Ερωτήσεις σε απλά ελληνικά ή αγγλικά, με απαντήσεις από τα δικά σας δεδομένα, σε αυτή τη συσκευή",
    "ask": "Ρώτα",
    "placeholder": "π.χ. Ποιοι πελάτες έχουν παιδιά κάτω των 10;",
    "privacy": "Οι απαντήσεις υπολογίζονται τοπικά από τις εγγραφές που βλέπετε. Τίποτα δεν αποστέλλεται σε υπηρεσία AI.",
    "empty": "Ρωτήστε για πελάτες, ανανεώσεις, παραγωγή ή καμπάνιες — κάθε απάντηση δείχνει τις εγγραφές πίσω της.",
    "lens": "Ρώτα το AVRASTRO: «{q}»",
    "voice": "Υπαγόρευση",
    "voice_note": "Η υπαγόρευση χρησιμοποιεί την υπηρεσία ομιλίας του browser· τίποτα δεν ηχογραφείται ή αποθηκεύεται",
    "voice_failed": "Η υπαγόρευση δεν είναι διαθέσιμη αυτή τη στιγμή",
    "segment_answer": "{segment}: {count, plural, one {# πρόσωπο} other {# πρόσωπα}}{incomplete, plural, =0 {} one { · # με ελλιπή στοιχεία} other { · # με ελλιπή στοιχεία}}",
    "renewals": "{count, plural, =0 {Καμία ανανέωση} one {# ανανέωση} other {# ανανεώσεις}} από {from} έως {to}",
    "production": "Παραγωγή — {period}: {total} ({count, plural, one {# κίνηση} other {# κινήσεις}})",
    "draft": "Ακολουθεί ένα προσχέδιο follow-up για έλεγχο πριν το στείλετε.",
    "campaign_draft": "Μια καμπάνια μπορεί να ξεκινήσει από αυτό το κοινό: {count, plural, one {# πρόσωπο} other {# πρόσωπα}}. Συναίνεση και εξαιρέσεις ελέγχονται πριν από κάθε επαφή.",
    "start_my_day": "Η μέρα σας είναι έτοιμη: προτεραιότητες, κλήσεις και follow-ups σε μία ουρά.",
    "unknown": "Δεν αναγνώρισα ακόμη την ερώτηση. Δοκιμάστε ένα από τα παραδείγματα ή αναφέρετε πελάτη, περίοδο ή ομάδα.",
    "ambiguous": "Ταιριάζουν περισσότερα πρόσωπα: {names}. Γίνετε πιο συγκεκριμένοι.",
    "which": "Εννοείτε: {names};",
    "open_draft": "Άνοιγμα προσχεδίου",
    "create_campaign": "Δημιουργία καμπάνιας",
    "sources": "Βάσει {count, plural, =0 {καμίας εγγραφής} one {# εγγραφής} other {# εγγραφών}} που βλέπετε",
    "example": {
      "review": "Ποιοι έχουν καθυστερημένο ετήσιο review;",
      "education": "Γονείς με παιδιά κάτω των 10 χωρίς πρόγραμμα σπουδών",
      "renewals": "Ανανεώσεις τις επόμενες 30 ημέρες",
      "life_medical": "Πελάτες με ασφάλεια ζωής αλλά χωρίς ιατροφαρμακευτικό",
      "draft": "Γράψε follow-up για την τελευταία μου συνάντηση",
      "campaign": "Ξεκίνα καμπάνια για στεγαστικά χωρίς ασφάλεια ζωής δανείου",
      "summary": "Σύνοψη για τη Μαρία",
      "prep": "Προετοιμασία συνάντησης με τον Ανδρέα",
      "opportunities": "Ποιες ευκαιρίες έχω;"
    },
    "client_summary": "{name}: {policies} ενεργά συμβόλαια ({annual} ετησίως), {cases} ανοιχτές αιτήσεις, {tasks} ανοιχτές εργασίες. Επανεξέταση: {review}. Κενά κάλυψης: {gaps}.",
    "meeting_prep": "Η προετοιμασία συνάντησης για {name} είναι έτοιμη: σημεία συζήτησης από τα στοιχεία, οικογένεια, καλύψεις και εκκρεμότητες.",
    "opportunities": "{count} κορυφαίες ευκαιρίες, η καθεμία με την αιτία και το επόμενο βήμα.",
    "open_client": "Άνοιγμα πελάτη"
  },
  "audit": {
    "title": "Αρχείο ελέγχου",
    "note": "Κάθε αλλαγή καταγράφεται με ποιος, πότε και τι. Ιατρικά και περιορισμένα έγγραφα καταγράφονται χωρίς το περιεχόμενό τους.",
    "synced": "από συγχρονισμό",
    "export": "Εξαγωγή CSV",
    "col": {
      "at": "Πότε (UTC)",
      "actor": "Ποιος",
      "action": "Ενέργεια",
      "summary": "Περίληψη",
      "entity": "Εγγραφή",
      "changes": "Αλλαγές (προηγούμενο → νέο)"
    }
  },
  "auto": {
    "title": "Αυτοματισμοί",
    "subtitle": "ΟΤΑΝ συμβεί κάτι, ΤΟΤΕ δημιουργείται εργασία — ποτέ μήνυμα, ποτέ αλλαγή στοιχείων πελάτη",
    "install": "Εγκατάσταση προτεινόμενων κανόνων",
    "installed": "Οι προτεινόμενοι κανόνες εγκαταστάθηκαν (ανενεργοί — ελέγξτε και ενεργοποιήστε)",
    "new": "Νέος κανόνας",
    "edit": "Επεξεργασία κανόνα",
    "empty": "Δεν υπάρχουν κανόνες. Εγκαταστήστε τους προτεινόμενους ή δημιουργήστε δικούς σας.",
    "enabled": "Ο κανόνας ενεργοποιήθηκε",
    "disabled": "Ο κανόνας απενεργοποιήθηκε",
    "enabled_label": "Ενεργός",
    "history": "Πρόσφατες εκτελέσεις",
    "last_run": "τελευταία εκτέλεση {date}",
    "make_runner": "Εκτέλεση αυτοματισμών σε αυτή τη συσκευή",
    "runner_here": "Αυτή η συσκευή εκτελεί τους ημερήσιους αυτοματισμούς.",
    "runner_other": "Άλλη συσκευή εκτελεί τους ημερήσιους αυτοματισμούς, ώστε οι εργασίες να μη δημιουργούνται δύο φορές.",
    "runner_none": "Καμία συσκευή δεν εκτελεί αυτοματισμούς καθημερινά — μπορείτε να τους εκτελείτε χειροκίνητα.",
    "nothing_enabled": "Τίποτα για εκτέλεση: κανένας ενεργός κανόνας δεν ταιριάζει σήμερα.",
    "preview_title": "Δοκιμαστική εκτέλεση (δεν δημιουργείται τίποτα)",
    "preview_note": "Η δοκιμαστική εκτέλεση δείχνει ακριβώς ποιες εργασίες θα δημιουργούσε μια πραγματική.",
    "test": "Δοκιμή",
    "run": "Εκτέλεση τώρα",
    "ran": "{count, plural, =0 {Καμία νέα εργασία} one {Δημιουργήθηκε # εργασία} other {Δημιουργήθηκαν # εργασίες}}",
    "safety": "Οι αυτοματισμοί δημιουργούν μόνο εργασίες. Κάθε περίπτωση εκτελείται μία φορά, μία εκτέλεση έχει όριο 200 εργασιών και κάθε αλλαγή κανόνα δημιουργεί νέα έκδοση.",
    "when": "ΟΤΑΝ {trigger}",
    "then": "ΤΟΤΕ εργασία «{kind}» σε {days, plural, =0 {0 ημέρες} one {# ημέρα} other {# ημέρες}}",
    "when_label": "Όταν",
    "days": "Ημέρες",
    "due_in": "Προθεσμία (ημέρες)",
    "task_kind": "Τύπος εργασίας",
    "task_title": "Τίτλος εργασίας",
    "would_create": "θα δημιουργούσε {count, plural, =0 {τίποτα} one {# εργασία} other {# εργασίες}}{done, plural, =0 {} other { · # ήδη έγιναν}}",
    "result": {
      "created": "δημιουργήθηκε εργασία"
    },
    "trigger": {
      "renewal_due": "μια ανανέωση λήγει σε {days, plural, =0 {0 ημέρες} one {# ημέρα} other {# ημέρες}}",
      "birthday": "ένας πελάτης έχει γενέθλια",
      "quote_pending": "μια προσφορά περιμένει απόφαση {days, plural, one {# ημέρα} other {# ημέρες}}",
      "review_overdue": "ένα ετήσιο review έχει καθυστερήσει",
      "policy_lapsed": "ένα συμβόλαιο ακυρώνεται λόγω μη πληρωμής",
      "life_event": "καταγράφεται γεγονός ζωής",
      "claim_action_due": "μια αποζημίωση χρειάζεται ενέργεια"
    }
  },
  "automation": {
    "default": {
      "renewal": "Προετοιμασία ανανεώσεων 30 ημέρες πριν",
      "birthday": "Κλήση γενεθλίων",
      "quote": "Follow-up προσφορών μετά από 5 ημέρες"
    },
    "task": {
      "renewal": "Προετοιμασία όρων ανανέωσης",
      "birthday": "Κλήση για ευχές γενεθλίων",
      "quote": "Follow-up για την εκκρεμή προσφορά"
    }
  },
  "campaigns": {
    "title": "Καμπάνιες",
    "subtitle": "Από μια έξυπνη ομάδα σε ελεγμένο κοινό, μήνυμα και πλάνο follow-up — εσείς ελέγχετε κάθε επαφή",
    "new": "Νέα καμπάνια",
    "empty": "Δεν υπάρχουν καμπάνιες. Ξεκινήστε από τη βιβλιοθήκη ή από μια ομάδα.",
    "campaign": "Καμπάνια",
    "audience": "Κοινό",
    "contacted": "Επαφές",
    "issued": "Εκδόσεις",
    "production": "Παραγωγή",
    "channel_label": "Κανάλι",
    "created": "Η καμπάνια δημιουργήθηκε",
    "prepare": "Έλεγχος & κλείδωμα κοινού",
    "prepared": "Το κοινό ελέγχθηκε και κλειδώθηκε",
    "launch": "Έναρξη (δημιουργία εργασιών)",
    "relaunch": "Δημιουργία εργασιών που λείπουν",
    "launched": "Η καμπάνια ξεκίνησε — οι εργασίες είναι στην ουρά σας",
    "complete": "Ολοκλήρωση καμπάνιας",
    "completed": "Η καμπάνια ολοκληρώθηκε",
    "audience_preview": "Προεπισκόπηση κοινού",
    "audience_frozen": "Κοινό κλειδωμένο στις {date}",
    "eligible": "Επιλέξιμοι",
    "excluded_note": "Εξαιρέθηκαν: {list}",
    "preview_hint": "Περιλαμβάνονται μόνο πρόσωπα με συναίνεση για το κανάλι και στοιχείο επικοινωνίας. Όσοι έχουν εξαιρεθεί δεν λαμβάνουν ποτέ επαφή.",
    "draft": "Προσχέδιο μηνύματος",
    "activity_saved": "Η δραστηριότητα καταγράφηκε",
    "message": "Μήνυμα",
    "kit": "Υλικό καμπάνιας: σενάριο κλήσης, σημεία συζήτησης, ακολουθία",
    "call_script": "Σενάριο κλήσης",
    "talking_points": "Σημεία συζήτησης",
    "sequence": "Ακολουθία",
    "step": "ημέρα {day}: {action}",
    "landing": "Κείμενο σελίδας",
    "social": "Ανάρτηση social",
    "use_theme": "Χρήση",
    "from_segment": "Δημιουργία καμπάνιας",
    "never_sends": "Το AVRASTRO δεν στέλνει ποτέ τίποτα μόνο του: ετοιμάζει προσχέδια και εργασίες και εσείς επιλέγετε τι θα σταλεί.",
    "verify_claims": "Ελέγξτε κάθε αριθμό και ισχυρισμό με το τρέχον υλικό της εταιρείας πριν τη χρήση.",
    "attribution": "Ένα συμβόλαιο αποδίδεται στην καμπάνια όταν εκδίδεται εντός του παραθύρου απόδοσης μετά την πρώτη επαφή.",
    "conversion": "μετατροπή {pct}",
    "no_conversion": "καμία μετατροπή ακόμη",
    "tab": {
      "campaigns": "Καμπάνιες",
      "library": "Βιβλιοθήκη",
      "segments": "Ομάδες",
      "newsletter": "Newsletter",
      "suggestions": "Προτάσεις"
    },
    "status": {
      "draft": "Προσχέδιο",
      "ready": "Έτοιμη",
      "active": "Ενεργή",
      "completed": "Ολοκληρωμένη",
      "archived": "Αρχειοθετημένη"
    },
    "kpi": {
      "audience": "Κοινό",
      "contacted": "Επαφές",
      "responded": "Απαντήσεις",
      "appointments": "Ραντεβού",
      "quotes": "Προσφορές",
      "applications": "Αιτήσεις",
      "issued": "Εκδόσεις"
    },
    "channel": {
      "whatsapp": "WhatsApp",
      "email": "E-mail",
      "sms": "SMS",
      "phone": "Τηλεφώνημα"
    },
    "activity": {
      "contacted": "Έγινε επαφή",
      "responded": "Απάντησε",
      "appointment": "Ραντεβού",
      "quote": "Προσφορά",
      "application": "Αίτηση",
      "issued": "Εκδόθηκε",
      "opted_out": "Δεν επιθυμεί επικοινωνία"
    },
    "objective": "Στόχος",
    "obj": {
      "appointments": "Κλείσιμο ραντεβού",
      "reviews": "Ετήσιες επανεξετάσεις",
      "new_business": "Νέες εργασίες",
      "cross_sell": "Ολοκλήρωση προστασίας (cross-sell)",
      "reactivation": "Επανενεργοποίηση",
      "referrals": "Συστάσεις",
      "retention": "Διατήρηση πελατών",
      "information": "Μόνο ενημέρωση"
    },
    "obj_hint": {
      "appointments": "Επιτυχία = ραντεβού που κλείστηκαν.",
      "reviews": "Επιτυχία = επανεξετάσεις που ολοκληρώθηκαν.",
      "new_business": "Επιτυχία = αιτήσεις και εκδοθέν ασφάλιστρο.",
      "cross_sell": "Επιτυχία = νέες καλύψεις σε υπάρχοντες πελάτες.",
      "reactivation": "Επιτυχία = πελάτες που επανενεργοποιήθηκαν.",
      "referrals": "Επιτυχία = συστάσεις που λήφθηκαν.",
      "retention": "Επιτυχία = ανανεώσεις που διατηρήθηκαν.",
      "information": "Χωρίς στόχο πωλήσεων — ενημέρωση πελατών."
    }
  },
  "campaign": {
    "step": {
      "message": "μήνυμα",
      "call": "κλήση",
      "followup": "follow-up"
    },
    "task": {
      "message": "Καμπάνια: αποστολή του έτοιμου μηνύματος",
      "call": "Καμπάνια: κλήση",
      "followup": "Καμπάνια: follow-up"
    }
  },
  "audience": {
    "reason": {
      "archived": "Αρχειοθετημένοι",
      "suppressed": "Χωρίς επικοινωνία",
      "consent_withdrawn": "Ανάκληση συναίνεσης",
      "no_consent": "Χωρίς συναίνεση marketing",
      "channel_not_consented": "Χωρίς συναίνεση για το κανάλι",
      "no_contact_detail": "Χωρίς τηλέφωνο ή e-mail"
    }
  },
  "segments": {
    "incomplete": "{count, plural, one {# με ελλιπή στοιχεία} other {# με ελλιπή στοιχεία}}",
    "incomplete_hint": "Αυτά τα πρόσωπα ίσως ανήκουν εδώ, αλλά ένα στοιχείο που λείπει (π.χ. ημερομηνία γέννησης) τα αποκλείει. Συμπληρώνοντάς το, περιλαμβάνονται.",
    "incomplete_short": "Ελλιπή στοιχεία",
    "refreshed": "ενημέρωση {date}",
    "population": "{count, plural, one {ελέγχθηκε # πρόσωπο} other {ελέγχθηκαν # πρόσωπα}}",
    "detail": {
      "age": "ηλικία",
      "amount": "ποσό",
      "balance": "υπόλοιπο",
      "birthDate": "ημ. γέννησης",
      "capacity": "υπόλοιπο έκπτωσης",
      "children": "παιδιά",
      "childrenWithoutBirthDate": "παιδιά χωρίς ημ. γέννησης",
      "currency": "νόμισμα",
      "date": "ημερομηνία",
      "days": "ημέρες",
      "dueDate": "λήξη",
      "income": "εισόδημα",
      "needsEvaluated": "αξιολόγηση αναγκών",
      "policies": "συμβόλαια",
      "product": "προϊόν",
      "state": "κατάσταση",
      "status": "κατάσταση",
      "type": "τύπος",
      "youngest": "μικρότερο παιδί",
      "annual": "Ετήσιο ασφάλιστρο",
      "stage": "Στάδιο",
      "item": "Αντικείμενο",
      "linkedPolicy": "Συνδεδεμένο συμβόλαιο",
      "vehicles": "Οχήματα",
      "family": "Μέλη οικογένειας",
      "employees": "Εργαζόμενοι"
    }
  },
  "segment": {
    "parents_children_under_10": "Γονείς με παιδιά κάτω των 10",
    "parents_children_0_12": "Γονείς με παιδιά 0–12 ετών",
    "no_medical_recorded": "Χωρίς καταγεγραμμένο ιατροφαρμακευτικό",
    "mortgage_no_credit_life": "Στεγαστικό χωρίς ασφάλεια ζωής δανείου",
    "life_no_savings": "Ασφάλεια ζωής χωρίς αποταμίευση",
    "over_40_no_retirement": "Άνω των 40 χωρίς συνταξιοδοτικό",
    "reviews_overdue": "Καθυστερημένα ετήσια reviews",
    "birthdays_this_month": "Γενέθλια αυτόν τον μήνα",
    "namedays_this_week": "Ονομαστικές εορτές αυτή την εβδομάδα",
    "tax_opportunity": "Αχρησιμοποίητη φοροαπαλλαγή για ασφάλιστρα ζωής",
    "lapsed_policies": "Ακυρωμένα λόγω μη πληρωμής",
    "gi_renewals_30": "Ανανεώσεις γενικών ασφαλίσεων σε 30 ημέρες",
    "life_no_medical": "Ασφάλεια ζωής χωρίς ιατροφαρμακευτικό",
    "parents_no_education": "Γονείς χωρίς πρόγραμμα σπουδών",
    "criteria": {
      "parents_children_under_10": "Πελάτες με τουλάχιστον ένα παιδί κάτω των 10 στο νοικοκυριό (απαιτείται ημ. γέννησης).",
      "parents_children_0_12": "Πελάτες με τουλάχιστον ένα παιδί 0–12 ετών στο νοικοκυριό.",
      "no_medical_recorded": "Ενεργοί πελάτες χωρίς ενεργό ιατροφαρμακευτικό συμβόλαιο.",
      "mortgage_no_credit_life": "Υπάρχει στεγαστικό αλλά όχι ενεργή ασφάλεια ζωής δανείου.",
      "life_no_savings": "Ενεργή ασφάλεια ζωής αλλά χωρίς πρόγραμμα αποταμίευσης ή επένδυσης.",
      "over_40_no_retirement": "Ηλικία 40+ χωρίς ενεργό συνταξιοδοτικό πρόγραμμα.",
      "reviews_overdue": "Το ετήσιο review έχει καθυστερήσει ή δεν έχει γίνει ποτέ.",
      "birthdays_this_month": "Τα γενέθλια πέφτουν τον τρέχοντα μήνα.",
      "namedays_this_week": "Η ονομαστική εορτή πέφτει τις επόμενες 7 ημέρες.",
      "tax_opportunity": "Αποθηκευμένος υπολογισμός δείχνει υπόλοιπο έκπτωσης για ασφάλιστρα ζωής (μόνο εγκεκριμένοι ή προσωρινοί κανόνες).",
      "lapsed_policies": "Τουλάχιστον ένα συμβόλαιο ακυρώθηκε λόγω μη πληρωμής.",
      "gi_renewals_30": "Ανανέωση γενικής ασφάλισης τις επόμενες 30 ημέρες.",
      "life_no_medical": "Ενεργή ασφάλεια ζωής αλλά όχι ενεργό ιατροφαρμακευτικό.",
      "parents_no_education": "Έχει παιδιά αλλά όχι πρόγραμμα σπουδών ή στόχο εκπαίδευσης.",
      "property_no_earthquake": "Ενεργή κατοικία στα ασφαλισμένα αντικείμενα χωρίς συνδεδεμένο ενεργό συμβόλαιο γενικού κλάδου. Αν υπάρχει συνδεδεμένο συμβόλαιο που δεν αναφέρει σεισμό, ο πελάτης εμφανίζεται στα ελλιπή (δεν έχει καταγραφεί η λεπτομέρεια κάλυψης). Κάλυψη σε άλλη εταιρεία δεν είναι γνωστή.",
      "family_vehicle_no_life": "Ενεργό όχημα, σύζυγος ή παιδιά στο νοικοκυριό και κανένα ενεργό συμβόλαιο ζωής ή προστασίας δανείου ως συμβαλλόμενος ή ασφαλισμένος.",
      "mortgage_no_protection": "Ενεργή κατοικία σημειωμένη με δάνειο και κανένα ενεργό συμβόλαιο προστασίας δανείου ή ζωής.",
      "business_no_liability": "Ενεργή επιχείρηση με προσωπικό και κανένα συνδεδεμένο ενεργό συμβόλαιο ευθύνης. Επιχειρήσεις χωρίς αριθμό εργαζομένων εμφανίζονται στα ελλιπή.",
      "gap_life_cover": "Πελάτες χωρίς καταγεγραμμένη ασφάλιση ζωής.",
      "gap_income_protection": "Πελάτες 18–64 χωρίς καταγεγραμμένη προστασία εισοδήματος.",
      "gap_beneficiaries": "Πελάτες με συμβόλαιο ζωής χωρίς ονομαστικούς δικαιούχους.",
      "gap_health": "Πελάτες χωρίς καταγεγραμμένο ιατροφαρμακευτικό σχέδιο.",
      "gap_retirement": "Πελάτες κάτω των 65 χωρίς καταγεγραμμένη αποταμίευση για σύνταξη."
    },
    "property_no_earthquake": "Κατοικία: δεν καταγράφεται κάλυψη σεισμού",
    "family_vehicle_no_life": "Οικογένεια με όχημα, χωρίς καταγεγραμμένη ασφάλεια ζωής",
    "mortgage_no_protection": "Κατοικία με δάνειο, χωρίς καταγεγραμμένη προστασία δανείου ή ζωής",
    "business_no_liability": "Επιχείρηση με προσωπικό, χωρίς συνδεδεμένο συμβόλαιο ευθύνης",
    "gap_life_cover": "Κενό: ασφάλιση ζωής",
    "gap_income_protection": "Κενό: προστασία εισοδήματος",
    "gap_beneficiaries": "Κενό: δικαιούχοι",
    "gap_health": "Κενό: ιατροφαρμακευτική κάλυψη",
    "gap_retirement": "Κενό: σύνταξη"
  },
  "commission": {
    "title": "Προμήθειες",
    "generate": "Υπολογισμός από την παραγωγή",
    "generated": "{count, plural, =0 {Καμία νέα γραμμή προμήθειας} one {Προστέθηκε # γραμμή προμήθειας} other {Προστέθηκαν # γραμμές προμήθειας}}",
    "rules": "Κανόνες",
    "rule": "Κανόνας προμήθειας",
    "rule_new": "Νέος κανόνας",
    "rule_hint": "Ο κανόνας ορίζει το αναμενόμενο ποσοστό ανά εταιρεία, κατηγορία και περίοδο. Το ποσοστό «παγώνει» σε κάθε γραμμή όταν υπολογίζεται.",
    "kind_label": "Είδος",
    "rate": "Ποσοστό (%)",
    "any": "οποιαδήποτε εταιρεία",
    "from": "Ισχύει από",
    "to": "Ισχύει έως",
    "source": "Πηγή",
    "source_ph": "π.χ. σύμβαση πρακτόρευσης 2026",
    "totals": "αναμενόμενες {expected} · εισπράχθηκαν {paid} · υπόλοιπο {outstanding}",
    "none": "καμία γραμμή προμήθειας",
    "mark_paid": "Σήμανση ως εισπραχθείσα",
    "disclaimer": "Οι αναμενόμενες προμήθειες είναι εκτίμηση βάσει των κανόνων σας· η κατάσταση της εταιρείας είναι η επίσημη πηγή.",
    "kind": {
      "new_business": "Νέα εργασία",
      "renewal": "Ανανέωση",
      "trail": "Επαναλαμβανόμενη",
      "bonus": "Bonus",
      "campaign_bonus": "Bonus καμπάνιας",
      "adjustment": "Διόρθωση"
    },
    "status": {
      "expected": "Αναμενόμενη",
      "pending": "Σε εκκρεμότητα",
      "paid": "Εισπράχθηκε",
      "cancelled": "Ακυρώθηκε"
    }
  },
  "custom": {
    "title": "Προσαρμοσμένα πεδία",
    "subtitle": "Προσθέστε τα στοιχεία που χρειάζεται το γραφείο σας, χωρίς αλλαγές στη βάση",
    "new": "Νέο πεδίο",
    "empty": "Δεν υπάρχουν προσαρμοσμένα πεδία.",
    "entity": "Αφορά",
    "key": "Κλειδί",
    "key_hint": "πεζά λατινικά, ψηφία και _ (δεν αλλάζει μετά τη χρήση)",
    "type_label": "Τύπος",
    "label_en": "Ετικέτα (Αγγλικά)",
    "label_el": "Ετικέτα (Ελληνικά)",
    "options": "Επιλογές",
    "options_hint": "χωρισμένες με κόμμα",
    "required": "υποχρεωτικό",
    "values": "{count, plural, =0 {χωρίς χρήση} one {# τιμή} other {# τιμές}}",
    "note": "Οι τιμές φυλάσσονται σε κάθε εγγραφή, περιλαμβάνονται σε αντίγραφα και εξαγωγές και δεν διαγράφονται όταν ένα πεδίο απενεργοποιηθεί.",
    "type": {
      "text": "Κείμενο",
      "number": "Αριθμός",
      "date": "Ημερομηνία",
      "choice": "Επιλογή",
      "bool": "Ναι / όχι"
    }
  },
  "day": {
    "greeting": {
      "morning": "Καλημέρα{name, select, none {} other {, {name}}}",
      "afternoon": "Καλό απόγευμα{name, select, none {} other {, {name}}}",
      "evening": "Καλησπέρα{name, select, none {} other {, {name}}}"
    },
    "tab": {
      "morning": "Έναρξη ημέρας",
      "queue": "Ουρά εργασιών",
      "evening": "Απολογισμός ημέρας"
    },
    "start": "Έναρξη ημέρας",
    "morning_line": "{count, plural, one {# πρόσωπο σας χρειάζεται σήμερα.} other {# πρόσωπα σας χρειάζονται σήμερα.}} Ξεκινήστε από την πρώτη κάρτα — τα υπόλοιπα περιμένουν.",
    "all_clear": "Τίποτα επείγον σήμερα. Καλή μέρα για reviews και νέες συζητήσεις.",
    "tiles_note": "Κάθε πλακίδιο ανοίγει τη λίστα πίσω του. Οι αριθμοί προέρχονται από τους ίδιους κανόνες με τη λίστα προσοχής.",
    "focus_mode": "Λειτουργία εστίασης",
    "record": "Καταγραφή",
    "recorded": "Το αποτέλεσμα καταγράφηκε και το επόμενο βήμα προγραμματίστηκε",
    "next_action": "Επόμενο βήμα μετά τη σημερινή επαφή",
    "completed": "Ολοκληρώθηκαν σήμερα",
    "none_completed": "Τίποτα δεν έχει ολοκληρωθεί ακόμη σήμερα.",
    "pending": "Σε εκκρεμότητα",
    "nothing_pending": "Δεν έμεινε τίποτα ανοιχτό για σήμερα. Μπράβο.",
    "move_all": "Μεταφορά όλων στην επόμενη εργάσιμη",
    "move_to": "Μεταφορά στις {date}",
    "moved": "{count, plural, one {Μεταφέρθηκε # εργασία} other {Μεταφέρθηκαν # εργασίες}} — οι αρχικές ημερομηνίες φυλάσσονται",
    "moved_one": "Η εργασία μεταφέρθηκε",
    "first_due": "αρχική λήξη {date}",
    "moved_times": "{count, plural, one {μεταφέρθηκε μία φορά} other {μεταφέρθηκε # φορές}}",
    "tile": {
      "followups": "Follow-ups",
      "birthdays": "Γενέθλια",
      "namedays": "Ονομαστικές εορτές",
      "child_birthdays": "Γενέθλια παιδιών αυτόν τον μήνα",
      "renewals": "Ανανεώσεις",
      "reviews": "Επανεξετάσεις",
      "quotes": "Προσφορές & αποφάσεις",
      "lapses": "Ακυρώσεις & καθυστερήσεις",
      "cases": "Αιτήσεις",
      "life_events": "Γεγονότα ζωής"
    }
  },
  "finances": {
    "title": "Εισοδήματα, δάνεια & στόχοι",
    "add": "Προσθήκη",
    "empty": "Δεν έχουν καταγραφεί εισοδήματα, δάνεια ή στόχοι.",
    "kind_label": "Είδος",
    "type_label": "Τύπος",
    "label": "Περιγραφή",
    "amount": "Ποσό",
    "instalment": "Δόση",
    "unknown_hint": "αφήστε κενό αν δεν είναι γνωστό — το άγνωστο δεν θεωρείται ποτέ μηδέν",
    "frequency": "Συχνότητα",
    "gross_net": "Μικτό ή καθαρό",
    "gross": "μικτό",
    "net": "καθαρό",
    "unknown": "άγνωστο",
    "balance": "Υπόλοιπο",
    "target": "Ποσό-στόχος",
    "by_date": "Έως",
    "rate": "Επιτόκιο (%)",
    "term": "Διάρκεια (μήνες)",
    "lender": "Δανειστής",
    "default_currency": "Προεπιλεγμένο νόμισμα",
    "from_document": "από έγγραφο",
    "year": "έτος",
    "kind": {
      "income": "Εισόδημα",
      "expense": "Δαπάνη",
      "liability": "Δάνειο",
      "goal": "Στόχος",
      "asset": "Περιουσιακό στοιχείο"
    },
    "type": {
      "salary": "Μισθός",
      "self_employment": "Ελεύθερο επάγγελμα",
      "rental": "Ενοίκια",
      "pension": "Σύνταξη",
      "other": "Άλλο",
      "living": "Έξοδα διαβίωσης",
      "rent": "Ενοίκιο",
      "income_tax": "Φόρος εισοδήματος",
      "education": "Σπουδές",
      "mortgage": "Στεγαστικό",
      "loan": "Δάνειο",
      "credit_card": "Πιστωτική κάρτα",
      "retirement": "Συνταξιοδότηση",
      "home": "Κατοικία",
      "emergency": "Αποθεματικό έκτακτης ανάγκης",
      "cash": "Μετρητά",
      "savings": "Αποταμιεύσεις",
      "investments": "Επενδύσεις",
      "property": "Ακίνητο"
    },
    "freq": {
      "monthly": "μηνιαία",
      "annual": "ετήσια",
      "one_off": "εφάπαξ"
    }
  },
  "fneeds": {
    "title": "Ανάγκες οικογένειας (κάλυψη ζωής)",
    "income": "Ετήσιο εισόδημα προς αναπλήρωση",
    "replacement": "Αναπλήρωση (%)",
    "years": "Έτη στήριξης",
    "debts": "Οφειλές προς εξόφληση",
    "final": "Τελικά έξοδα",
    "assets": "Ρευστά διαθέσιμα",
    "inflation": "Πληθωρισμός (%)",
    "return": "Απόδοση (%)",
    "capital": "Απαιτούμενο κεφάλαιο",
    "existing": "Μείον υπάρχουσα κάλυψη ζωής",
    "gap": "Κενό",
    "c": {
      "income": "Αναπλήρωση εισοδήματος",
      "debts": "Οφειλές",
      "education": "Σπουδές",
      "final": "Τελικά έξοδα",
      "emergency": "Αποθεματικό έκτακτης ανάγκης",
      "assets": "Μείον ρευστά διαθέσιμα"
    },
    "not_evaluated": "Δεν έχει αξιολογηθεί — λείπουν: {fields}. Τίποτα δεν θεωρείται δεδομένο.",
    "assumptions": "Μόνο ενδεικτικά. Πραγματικό επιτόκιο: {real}% ετησίως. Οι παραδοχές αλλάζουν και εμφανίζονται σε κάθε εκτύπωση.",
    "field": {
      "annualIncome": "ετήσιο εισόδημα",
      "years": "έτη στήριξης",
      "debts": "οφειλές"
    }
  },
  "lifeEvent": {
    "title": "Γεγονότα ζωής",
    "add": "Καταγραφή",
    "new": "Νέο γεγονός ζωής",
    "type": "Τι συνέβη;",
    "create_task": "Δημιουργία εργασίας follow-up",
    "saved": "Το γεγονός ζωής καταγράφηκε",
    "empty": "Δεν έχουν καταγραφεί γεγονότα ζωής.",
    "followup_created": "δημιουργήθηκε follow-up",
    "task": {
      "marriage": "Επανεξέταση κάλυψης μετά τον γάμο",
      "new_child": "Επανεξέταση οικογενειακής προστασίας για το νέο μωρό",
      "new_job": "Επανεξέταση προστασίας εισοδήματος μετά την αλλαγή εργασίας",
      "salary_increase": "Έλεγχος κάλυψης και αποταμίευσης μετά την αύξηση",
      "home_purchase": "Ασφάλιση κατοικίας και προστασία στεγαστικού",
      "mortgage": "Προστασία του νέου στεγαστικού",
      "new_loan": "Έλεγχος προστασίας για το νέο δάνειο",
      "business_start": "Κάλυψη επιχείρησης και βασικών προσώπων",
      "retirement_planning": "Συζήτηση για συνταξιοδοτικό σχεδιασμό",
      "divorce": "Επανεξέταση δικαιούχων και κάλυψης",
      "new_property": "Ασφάλιση του νέου ακινήτου",
      "other": "Follow-up για το γεγονός ζωής"
    }
  },
  "lock": {
    "title": "Το AVRASTRO είναι κλειδωμένο",
    "subtitle": "Τα δεδομένα σας σε αυτή τη συσκευή είναι κρυπτογραφημένα. Εισάγετε τη φράση πρόσβασης για να συνεχίσετε.",
    "unlock": "Ξεκλείδωμα",
    "unlocking": "Ξεκλείδωμα…",
    "recovery_key": "Κλειδί ανάκτησης",
    "use_recovery": "Χρήση κλειδιού ανάκτησης",
    "use_passphrase": "Χρήση φράσης πρόσβασης"
  },
  "meeting_mode": {
    "title": "Λειτουργία συνάντησης",
    "open": "Λειτουργία συνάντησης",
    "purpose": "Συνάντηση με πελάτη (λειτουργία συνάντησης)",
    "age": "{age} ετών",
    "add_goal": "Νέος στόχος",
    "not_evaluated": "Δεν έχει αξιολογηθεί ακόμη — θα συμπληρώσουμε μαζί τα στοιχεία που λείπουν.",
    "disclaimer": "Η σύνοψη είναι για συζήτηση. Δεν αποτελεί προσφορά ή συμβουλή μέχρι να συμφωνηθεί και να τεκμηριωθεί μια πρόταση.",
    "notes_ph": "Τι συμφωνήσαμε; Ποιο είναι το επόμενο βήμα;",
    "summary_title": "Σύνοψη συνάντησης — {name}",
    "print": "Εκτύπωση σύνοψης",
    "finish": "Ολοκλήρωση συνάντησης",
    "saved": "Η συνάντηση καταγράφηκε",
    "autosaved": "Αποθηκεύεται αυτόματα",
    "step": {
      "family": "Οικογένεια",
      "income": "Εισόδημα",
      "loans": "Δάνεια",
      "insurance": "Ασφαλίσεις",
      "goals": "Στόχοι",
      "analysis": "Προστασία",
      "discussion": "Συζήτηση",
      "summary": "Σύνοψη"
    }
  },
  "money": {
    "mixed_currencies": "πολλά νομίσματα — δεν αθροίζονται"
  },
  "quickadd": {
    "title": "Γρήγορη προσθήκη",
    "pick_person": "Για ποιον;",
    "note": "Σημείωση",
    "client": "Πελάτης",
    "lead": "Υποψήφιος",
    "policy": "Συμβόλαιο",
    "task": "Εργασία",
    "appointment": "Ραντεβού",
    "claim": "Αποζημίωση",
    "upload": "Έγγραφο",
    "card": "Επαγγελματική κάρτα"
  },
  "adjustment": {
    "type": {
      "increase": "Αύξηση",
      "decrease": "Μείωση",
      "reversal": "Αντιλογισμός",
      "renewal": "Ανανέωση",
      "correction": "Διόρθωση"
    },
    "source": {
      "renewal": "από ανανέωση",
      "extraction": "από έγγραφο"
    },
    "mode": {
      "new_instalment": "Νέα δόση ({freq})",
      "new_annual": "Νέο ετήσιο ασφάλιστρο",
      "delta_instalment": "Μεταβολή ανά δόση",
      "delta_annual": "Μεταβολή ανά έτος"
    }
  },
  "needTag": {
    "life_cover": "Κάλυψη ζωής",
    "savings": "Αποταμίευση",
    "education": "Σπουδές",
    "child_protection": "Προστασία παιδιών",
    "retirement": "Σύνταξη",
    "medical": "Ιατροφαρμακευτική",
    "accident": "Ατυχήματα",
    "income_protection": "Προστασία εισοδήματος",
    "critical_illness": "Σοβαρές ασθένειες",
    "mortgage_protection": "Προστασία στεγαστικού",
    "property": "Περιουσία",
    "motor": "Όχημα",
    "travel": "Ταξίδι",
    "liability": "Αστική ευθύνη",
    "business": "Επιχείρηση"
  },
  "production": {
    "title": "Παραγωγή",
    "subtitle": "Κάθε μεταβολή ασφαλίστρου πιστώνεται ακριβώς μία φορά — νέες εργασίες, αυξήσεις, μειώσεις, ανανεώσεις και αντιλογισμοί",
    "total": "Σύνολο",
    "life": "Ζωής",
    "general": "Γενικές",
    "events": "Κινήσεις",
    "previous": "αντίστοιχη προηγούμενη περίοδος",
    "vs_previous": "έναντι προηγούμενης περιόδου",
    "no_comparison": "χωρίς σύγκριση (η προηγούμενη περίοδος ήταν μηδέν)",
    "reconciled": "Συμφωνία",
    "reconciled_hint": "το καθολικό συμφωνεί με τα τρέχοντα ετήσια ασφάλιστρα",
    "by_type": "Ανά είδος",
    "no_contexts": "χωρίς cross-sale ή πιστώσεις καμπάνιας",
    "type_filter": "Φίλτρο ανά είδος",
    "all_types": "Όλα τα είδη",
    "all_branches": "Όλοι οι κλάδοι",
    "type_col": "Είδος",
    "amount": "Ετήσιο ποσό",
    "effective": "ισχύς",
    "single": "εφάπαξ",
    "empty": "Καμία παραγωγή σε αυτή την περίοδο.",
    "ledger_empty": "Το καθολικό είναι κενό. Δημιουργήστε το από τα υπάρχοντα συμβόλαια — δεν αλλάζει τίποτα, προστίθενται μόνο πιστώσεις.",
    "backfill": "Δημιουργία από τα υπάρχοντα συμβόλαια",
    "backfilled": "{count, plural, =0 {Τίποτα προς προσθήκη — το καθολικό είναι πλήρες} one {Προστέθηκε # εγγραφή} other {Προστέθηκαν # εγγραφές}}",
    "definition": "Παραγωγή = ετησιοποιημένο ασφάλιστρο που πιστώνεται την ημέρα καταχώρισης. Οι αυξήσεις πιστώνουν μόνο τη διαφορά· οι ακυρώσεις εντός του παραθύρου αντιλογίζουν τη νέα εργασία· τα εφάπαξ εμφανίζονται χωριστά.",
    "type": {
      "new_business": "Νέα εργασία",
      "increase": "Αύξηση",
      "decrease": "Μείωση",
      "renewal": "Ανανέωση",
      "replacement": "Αντικατάσταση",
      "reactivation": "Επαναφορά",
      "cancellation": "Ακύρωση",
      "reversal": "Αντιλογισμός"
    },
    "period": {
      "today": "Σήμερα",
      "week": "Εβδομάδα",
      "month": "Μήνας",
      "quarter": "Τρίμηνο",
      "year": "Έτος"
    },
    "context": {
      "upsell": "αναβάθμιση",
      "cross_sale": "cross-sale",
      "campaign": "καμπάνια"
    }
  },
  "protection": {
    "title": "Χάρτης προστασίας νοικοκυριού",
    "legend": "Η κατάσταση προκύπτει μόνο από αξιολόγηση αναγκών — ποτέ από εικασία",
    "area_label": "Τομέας",
    "family": "Οικογένεια",
    "required": "Απαιτούμενο",
    "covered": "Καλύπτεται",
    "gap": "Κενό",
    "unknown": "δεν έχει αξιολογηθεί",
    "basis_label": "Βάση",
    "cover_no_amount": "υπάρχει κάλυψη, άγνωστο ποσό",
    "cover_recorded": "υπάρχει κάλυψη",
    "presence": "υπάρχει (χωρίς ποσό)",
    "evaluate": "Αξιολόγηση αναγκών",
    "principle": "Μια κοινή παροχή μετρά μία φορά για την οικογένεια. Το «Προστατευμένο» απαιτεί ολοκληρωμένη ανάλυση αναγκών· όπου λείπουν στοιχεία εμφανίζεται «Δεν έχει αξιολογηθεί».",
    "topics": "Θέματα για συζήτηση",
    "topics_hint": "Προτάσεις από τα δεδομένα — αφορμές συζήτησης, όχι συστάσεις.",
    "mortgage_alerts": "Προστασία στεγαστικών",
    "mortgage_alert": "Στεγαστικό {balance}, κάλυψη ζωής {cover} — πιθανό κενό {gap}",
    "mortgage_alert_hint": "Υπόλοιπο στις {date} · δανειστής {lender}. Ελέγξτε το τρέχον υπόλοιπο πριν από οποιαδήποτε σύσταση.",
    "mortgage_line": "υπόλοιπο {balance} · κάλυψη {cover}",
    "no_alerts": "Δεν βρέθηκαν κενά προστασίας στεγαστικών.",
    "book_title": "Προστασία σε όλο το χαρτοφυλάκιο",
    "book_subtitle": "Κενά στεγαστικών και νοικοκυριά που χρειάζονται αξιολόγηση",
    "area": {
      "life": "Ζωή",
      "income": "Εισόδημα",
      "medical": "Υγεία",
      "critical_illness": "Σοβαρές ασθένειες",
      "accident": "Ατυχήματα",
      "mortgage": "Στεγαστικό",
      "loans": "Δάνεια",
      "emergency_fund": "Αποθεματικό",
      "retirement": "Σύνταξη",
      "education": "Σπουδές",
      "savings": "Αποταμίευση",
      "property": "Περιουσία",
      "motor": "Όχημα",
      "business": "Επιχείρηση"
    },
    "status": {
      "protected": "Προστατευμένο",
      "partial": "Μερικό",
      "not_evaluated": "Δεν έχει αξιολογηθεί",
      "gap": "Κενό",
      "not_needed": "Δεν χρειάζεται"
    },
    "basis": {
      "needs_analysis": "ανάλυση αναγκών",
      "liabilities": "καταγεγραμμένα δάνεια",
      "expenses": "καταγεγραμμένα έξοδα",
      "none": "καμία αξιολόγηση ακόμη"
    },
    "topic": {
      "child_education": "Σπουδές παιδιών",
      "mortgage_protection": "Προστασία στεγαστικού",
      "family_income_replacement": "Αναπλήρωση οικογενειακού εισοδήματος",
      "child_medical": "Ιατροφαρμακευτική κάλυψη παιδιών",
      "family_protection": "Προστασία οικογένειας",
      "retirement": "Σχεδιασμός σύνταξης",
      "medical": "Ιατροφαρμακευτική κάλυψη"
    },
    "topic_hint": {
      "child_education": "Υπάρχουν παιδιά, χωρίς καταγεγραμμένο πρόγραμμα ή στόχο σπουδών.",
      "mortgage_protection": "Υπάρχει στεγαστικό χωρίς ασφάλεια ζωής δανείου.",
      "family_income_replacement": "Υπάρχει κάλυψη ζωής· ελέγξτε ότι καλύπτει ακόμη τις ανάγκες της οικογένειας.",
      "child_medical": "Για παιδί της οικογένειας δεν έχει καταγραφεί ιατροφαρμακευτική κάλυψη — αξίζει να δείτε μαζί αν τη χρειάζονται.",
      "family_protection": "Παιδιά στην οικογένεια χωρίς καταγεγραμμένη κάλυψη ζωής — θέμα συζήτησης για το πώς θα τα έβγαζε πέρα η οικογένεια, όχι σύσταση.",
      "retirement": "Ηλικία 35+ χωρίς καταγεγραμμένο συνταξιοδοτικό.",
      "medical": "Δεν έχει καταγραφεί ιατροφαρμακευτικό πρόγραμμα."
    }
  },
  "renewals": {
    "title": "Ανανεώσεις",
    "subtitle": "Ανανεώσεις γενικών ασφαλίσεων κατά προτεραιότητα — ετοιμάστε όρους και καταγράψτε την απόφαση",
    "include_life": "Συμπερίληψη επετείων ζωής",
    "due": "Λήξη",
    "last": "Προηγούμενο ασφάλιστρο",
    "last_hint": "ετήσιο ποσό για την περίοδο που λήγει",
    "new": "Ασφάλιστρο ανανέωσης",
    "diff": "Μεταβολή",
    "awaiting": "αναμονή όρων",
    "terms": "Όροι",
    "change": "Μεταβολή έναντι προηγούμενου: {diff} ({pct})",
    "decide": {
      "renewed": "Ανανεώθηκε",
      "lapsed": "Δεν ανανεώθηκε",
      "declined": "Ο πελάτης αρνήθηκε"
    },
    "no_auto": "Τίποτα δεν ανανεώνεται αυτόματα — μια ανανέωση μετρά μόνο όταν την καταγράψετε.",
    "note": "Η καταγραφή «Ανανεώθηκε» ενημερώνει το ασφάλιστρο από την ημερομηνία ανανέωσης και πιστώνει την παραγωγή ανανέωσης μία φορά.",
    "empty": "Καμία ανανέωση σε αυτό το διάστημα.",
    "bucket": {
      "all": "Όλες",
      "expired": "Έληξαν",
      "today": "Σήμερα",
      "d7": "7 ημέρες",
      "d15": "15 ημέρες",
      "d30": "30 ημέρες"
    },
    "decided": {
      "renewed": "Η ανανέωση καταγράφηκε — ενημερώθηκε το ασφάλιστρο και πιστώθηκε η παραγωγή ανανέωσης",
      "lapsed": "Καταγράφηκε ως μη ανανεωμένο",
      "declined": "Καταγράφηκε: ο πελάτης αρνήθηκε την ανανέωση"
    },
    "mode": {
      "queue": "Κατά προτεραιότητα",
      "general": "Ανανεώσεις γενικού κλάδου"
    }
  },
  "retention": {
    "title": "Διατήρηση πελατών",
    "subtitle": "Ακυρώσεις, καθυστερήσεις πληρωμών, σιωπή και χαμένα reviews — σε ένα σημείο",
    "days": "{days, plural, one {# ημέρα} other {# ημέρες}}",
    "verified": "επιβεβαιωμένο από την εταιρεία",
    "advisor_note": "δική σας σημείωση, μη επιβεβαιωμένη",
    "kind": {
      "lapsed": "Ακυρωμένα λόγω μη πληρωμής",
      "late_payment": "Καθυστερημένες πληρωμές",
      "renewal_due": "Ανανεώσεις που πλησιάζουν",
      "no_contact": "Χωρίς επαφή για καιρό",
      "review_overdue": "Καθυστερημένα reviews"
    }
  },
  "security": {
    "title": "Ασφάλεια",
    "subtitle": "Κρυπτογράφηση σε αυτή τη συσκευή, αυτόματο κλείδωμα και αρχείο ελέγχου",
    "encryption": "Κρυπτογράφηση αποθηκευμένων δεδομένων",
    "on": "Η κρυπτογράφηση είναι ενεργή",
    "on_detail": "AES-256-GCM με κλειδί που προστατεύεται από τη φράση πρόσβασης (PBKDF2, {iterations} επαναλήψεις). Εγγραφές, αντίγραφα και αρχεία είναι κρυπτογραφημένα.",
    "off_intro": "Τα δεδομένα αποθηκεύονται σε αυτή τη συσκευή χωρίς φράση πρόσβασης. Όποιος έχει πρόσβαση σε αυτό το προφίλ browser μπορεί να τα διαβάσει.",
    "enable": "Ενεργοποίηση κρυπτογράφησης",
    "enable_hint": "Επιλέξτε μια μεγάλη φράση πρόσβασης που θα θυμάστε. Θα λάβετε και κλειδί ανάκτησης — φυλάξτε το σε ασφαλές σημείο.",
    "encrypting": "Κρυπτογράφηση…",
    "passphrase": "Φράση πρόσβασης",
    "passphrase_again": "Επανάληψη φράσης πρόσβασης",
    "new_passphrase": "Νέα φράση πρόσβασης",
    "current_or_recovery": "Τρέχουσα φράση πρόσβασης ή κλειδί ανάκτησης",
    "change": "Αλλαγή φράσης πρόσβασης",
    "changed": "Η φράση πρόσβασης άλλαξε",
    "lock_now": "Κλείδωμα τώρα",
    "autolock": "Αυτόματο κλείδωμα μετά από",
    "never": "Ποτέ",
    "minutes": "{count, plural, one {# λεπτό} other {# λεπτά}}",
    "recovery_title": "Το κλειδί ανάκτησης",
    "recovery_intro": "Αν ξεχάσετε τη φράση πρόσβασης, αυτό το κλειδί είναι ο μόνος τρόπος πρόσβασης. Το AVRASTRO δεν μπορεί να το ανακτήσει. Εκτυπώστε το ή φυλάξτε το σε διαχειριστή κωδικών.",
    "recovery_ack": "Έχω φυλάξει με ασφάλεια το κλειδί ανάκτησης",
    "recovery_done": "Τέλος — κλείδωμα και επανεκκίνηση",
    "fact": {
      "keys": "Τα κλειδιά δεν φεύγουν ποτέ από τη συσκευή και δεν αποστέλλονται σε server.",
      "recovery": "Αν χαθούν και η φράση πρόσβασης και το κλειδί ανάκτησης, τα δεδομένα της συσκευής δεν ανοίγουν.",
      "limits": "Η κρυπτογράφηση προστατεύει τα αποθηκευμένα δεδομένα. Όσο το AVRASTRO είναι ξεκλείδωτο, όποιος χρησιμοποιεί τον υπολογιστή τα βλέπει — κλειδώστε το όταν απομακρύνεστε."
    },
    "memory_note": "Η συνεδρία τρέχει μόνο στη μνήμη (η αποθήκευση του browser δεν είναι διαθέσιμη), οπότε δεν υπάρχει τίποτα προς κρυπτογράφηση στον δίσκο.",
    "desktop_note": "Η εφαρμογή desktop κρατά τα δεδομένα σε τοπική βάση· η πλήρης κρυπτογράφηση βάσης για desktop είναι στον προγραμματισμό. Μέχρι τότε χρησιμοποιήστε την κρυπτογράφηση δίσκου του λειτουργικού.",
    "strength": {
      "0": "Πολύ μικρή — τουλάχιστον 10 χαρακτήρες",
      "1": "Αποδεκτή — όσο μεγαλύτερη τόσο καλύτερα",
      "2": "Καλή",
      "3": "Ισχυρή"
    }
  },
  "sync": {
    "title": "Συγχρονισμός",
    "subtitle": "Εργαστείτε offline σε κάθε συσκευή· οι αλλαγές συγχωνεύονται με ασφάλεια όταν επανέλθει η σύνδεση",
    "unavailable": "Ο συγχρονισμός δεν είναι διαθέσιμος σε αυτή τη συνεδρία.",
    "now": "Συγχρονισμός τώρα",
    "running": "Συγχρονισμός…",
    "status": "Κατάσταση",
    "state": {
      "local": "Μόνο αυτή η συσκευή",
      "paired": "Συνδεδεμένο",
      "offline": "Εκτός σύνδεσης — οι αλλαγές φυλάσσονται"
    },
    "last": "τελευταίος συγχρονισμός {when}",
    "never": "χωρίς συγχρονισμό ακόμη",
    "pending": "Προς αποστολή",
    "pending_hint": "αποθηκευμένα εδώ, αποστέλλονται στον επόμενο συγχρονισμό",
    "conflicts": "Συγκρούσεις",
    "conflicts_hint": "το ίδιο πεδίο άλλαξε σε δύο συσκευές",
    "rejected": "Δεν έγιναν δεκτές",
    "rejected_hint": "ο server απέρριψε αυτές τις αλλαγές — φυλάσσονται για έλεγχο",
    "error": "Η τελευταία προσπάθεια απέτυχε: {error}",
    "reauth": "Νέα σύνδεση",
    "pairing": "Σύνδεση",
    "pair": "Σύνδεση με server συγχρονισμού",
    "pair_intro": "Συνδέστε τη συσκευή με τον server συγχρονισμού του γραφείου σας για κοινή εργασία μεταξύ συσκευών και συνεργατών. Μέχρι τότε όλα μένουν σε αυτή τη συσκευή.",
    "pair_hint": "Ο διαχειριστής σας δίνει τη διεύθυνση του server, το ID χώρου εργασίας και τα στοιχεία σύνδεσης.",
    "paired": "Η συσκευή συνδέθηκε — ξεκίνησε ο πρώτος συγχρονισμός",
    "unpair": "Αποσύνδεση",
    "server": "Server",
    "https": "απαιτείται https:// (http:// μόνο για αυτόν τον υπολογιστή)",
    "workspace": "Χώρος εργασίας",
    "workspace_id": "ID χώρου εργασίας",
    "account": "Λογαριασμός",
    "password": "Κωδικός",
    "password_note": "Ο κωδικός αποστέλλεται μόνο στον server συγχρονισμού σας και δεν αποθηκεύεται στη συσκευή.",
    "device": "Συσκευή",
    "lease": "Πρόσβαση offline έως",
    "encryption": "Κρυπτογράφηση στη συσκευή",
    "encrypted": "ενεργή",
    "not_encrypted": "ανενεργή — ενεργοποίηση",
    "security_note": "Τα δεδομένα μεταφέρονται μέσω HTTPS. Ο server εφαρμόζει τον ρόλο και τον χώρο εργασίας σας· οι διαγραμμένες εγγραφές κρατούνται ως σημάδια διαγραφής ώστε να μην επανέρχονται κατά λάθος.",
    "inbox": "Εισερχόμενα συγκρούσεων",
    "no_conflicts": "Καμία σύγκρουση. Αλλαγές σε διαφορετικά πεδία συγχωνεύονται αυτόματα.",
    "review": "Έλεγχος",
    "conflict_hint": "τίποτα δεν αντικαθίσταται μέχρι να αποφασίσετε",
    "field": "Πεδίο",
    "local": "Αυτή η συσκευή",
    "cloud": "Άλλη συσκευή",
    "critical": "κρίσιμο",
    "keep": "Διατήρηση",
    "keep_edited": "Διατήρηση της επεξεργασμένης εγγραφής",
    "keep_delete": "Να παραμείνει διαγραμμένη",
    "keep_cloud": "Διατήρηση της εκδοχής της άλλης συσκευής",
    "accept_delete": "Αποδοχή της διαγραφής",
    "apply": "Εφαρμογή",
    "resolved": "Η σύγκρουση επιλύθηκε",
    "retry": "Επανάληψη",
    "requeued": "Σε αναμονή για τον επόμενο συγχρονισμό",
    "discard": "Απόρριψη",
    "discarded": "Η αλλαγή απορρίφθηκε",
    "device_data": "Δεδομένα σε αυτή τη συσκευή",
    "records": "Εγγραφές",
    "files": "Αρχεία",
    "storage": "Χώρος σε χρήση",
    "clear_device": "Αφαίρεση δεδομένων από τη συσκευή…",
    "clear_intro": "Αφαιρείται μόνο το τοπικό αντίγραφο. Τα δεδομένα στον server και σε άλλες συσκευές δεν επηρεάζονται.",
    "clear_pending": "{count, plural, one {# αλλαγή δεν έχει} other {# αλλαγές δεν έχουν}} αποσταλεί ακόμη και θα χαθούν. Συγχρονίστε πρώτα.",
    "clear_word": "ΑΦΑΙΡΕΣΗ",
    "clear_type": "Πληκτρολογήστε {word} για επιβεβαίωση",
    "pack_export": "Εξαγωγή πακέτου συγχρονισμού",
    "pack_exported": "{count, plural, one {Εξήχθη # αλλαγή} other {Εξήχθησαν # αλλαγές}}",
    "pack_import": "Εισαγωγή πακέτου συγχρονισμού",
    "pack_invalid": "Το αρχείο δεν είναι πακέτο συγχρονισμού AVRASTRO.",
    "pack_note": "Χωρίς server; Μεταφέρετε αλλαγές μεταξύ συσκευών με αρχείο (USB, κοινόχρηστος φάκελος). Ισχύουν οι ίδιοι κανόνες συγχώνευσης και συγκρούσεων.",
    "pack_from": "Από συσκευή",
    "pack_ops": "Αλλαγές",
    "pack_apply": "Άμεση εφαρμογή",
    "pack_merge": "Συγχώνευση",
    "pack_skip": "Υπάρχουν ήδη",
    "pack_preview_note": "Λαμβάνεται αντίγραφο ασφαλείας πριν εφαρμοστεί οτιδήποτε.",
    "pack_imported": "Εφαρμόστηκαν {applied}, συγχωνεύτηκαν {merged}, συγκρούσεις {conflicts}",
    "pack_mark_delivered": "Σήμανση ως παραδοθέν",
    "pack_delivered": "Το πακέτο σημειώθηκε ως παραδοθέν",
    "badge": {
      "locked": "Μόνο ανάγνωση — συνδεθείτε για συγχρονισμό",
      "conflict": "{count, plural, one {# σύγκρουση προς επίλυση} other {# συγκρούσεις προς επίλυση}}",
      "running": "Συγχρονισμός…",
      "offline": "Εκτός σύνδεσης — οι αλλαγές αποθηκεύονται στη συσκευή",
      "pending": "{count, plural, one {# αλλαγή προς αποστολή} other {# αλλαγές προς αποστολή}}",
      "ok": "Ενημερωμένο",
      "update": "Χρειάζεται ενημέρωση για να συνεχιστεί ο συγχρονισμός"
    },
    "readonly": {
      "lease_expired": "Η πρόσβαση offline έληξε. Μπορείτε να διαβάζετε τα πάντα, αλλά συνδεθείτε ξανά για αλλαγές.",
      "device_revoked": "Η συσκευή αποσυνδέθηκε από διαχειριστή. Τα δεδομένα είναι μόνο για ανάγνωση εδώ.",
      "licence_expired": "Η συνδρομή σας έληξε. Μπορείτε να διαβάζετε και να εξάγετε τα πάντα· ανανεώστε για να κάνετε ξανά αλλαγές.",
      "licence_required": "Αυτό το αντίγραφο του AVRASTRO χρειάζεται λογαριασμό. Συνδεθείτε για να κάνετε αλλαγές — τα δεδομένα σας παραμένουν ανέγγιχτα."
    },
    "role": {
      "admin": "Διαχειριστής",
      "advisor": "Σύμβουλος",
      "manager": "Υπεύθυνος (μόνο ανάγνωση)",
      "assistant": "Βοηθός"
    },
    "reason": {
      "deleted_locally": "Διαγράφηκε εδώ, άλλαξε σε άλλη συσκευή",
      "deleted_remotely": "Άλλαξε εδώ, διαγράφηκε σε άλλη συσκευή",
      "edited_both": "Άλλαξε και στις δύο συσκευές",
      "critical_field": "Κρίσιμο πεδίο (ασφάλιστρο, κατάσταση, συναίνεση…) άλλαξε και στις δύο συσκευές"
    },
    "err": {
      "invalid_credentials": "Λάθος e-mail ή κωδικός.",
      "revoked": "Η συσκευή έχει αποσυνδεθεί από διαχειριστή.",
      "expired": "Η συνεδρία έληξε. Συνδεθείτε ξανά.",
      "no_token": "Δεν έχετε συνδεθεί.",
      "permission": "Ο ρόλος σας δεν το επιτρέπει.",
      "not_found": "Ο χώρος εργασίας δεν βρέθηκε σε αυτόν τον server.",
      "https_required": "Η διεύθυνση του server πρέπει να ξεκινά με https://.",
      "network": "Ο server δεν είναι προσβάσιμος. Ελέγξτε τη διεύθυνση και τη σύνδεσή σας.",
      "device": "Η συσκευή δεν μπόρεσε να καταχωριστεί."
    }
  },
  "taxc": {
    "title": "Φορολογικό κέντρο",
    "subtitle": "Φορολογικοί κανόνες με εκδόσεις και πηγές· μόνο ενδεικτικά — ποτέ φορολογική συμβουλή",
    "year": "Φορολογικό έτος",
    "unavailable": "Δεν υπάρχουν διαθέσιμοι κανόνες για το {year}",
    "source": "Πηγή: {source} · έλεγχος {date}",
    "approved_by": "έγκριση από {who}",
    "rulesets": "Εκδόσεις κανόνων",
    "rules_note": "Οι κανόνες δεν μαντεύονται: ένα έτος χωρίς εγκεκριμένους ή προσωρινούς κανόνες δεν δίνει αποτέλεσμα. Οι παλαιότεροι υπολογισμοί κρατούν την έκδοση κανόνων που χρησιμοποίησαν.",
    "built_in": "ενσωματωμένο",
    "approve": "Έγκριση",
    "approved": "Οι κανόνες εγκρίθηκαν",
    "ruleset_new": "Νέα έκδοση κανόνων",
    "ruleset_hint": "Εισαγάγετε τους κανόνες όπως δημοσιεύθηκαν από τη φορολογική αρχή και αναφέρετε την πηγή. Οι κανόνες σε προσχέδιο δεν χρησιμοποιούνται σε υπολογισμούς.",
    "ruleset_id": "ID κανόνων",
    "ruleset_saved": "Η έκδοση κανόνων αποθηκεύτηκε",
    "source_label": "Επίσημη πηγή",
    "source_ph": "π.χ. εγκύκλιος Τμήματος Φορολογίας, URL",
    "verified": "Ελέγχθηκε στις",
    "status_label": "Κατάσταση",
    "bands": "Φορολογικές κλίμακες",
    "band_add": "Προσθήκη κλίμακας",
    "up_to": "έως (κενό = χωρίς όριο)",
    "params": "Παράμετροι",
    "pick_person": "Επιλέξτε πρόσωπο για υπολογισμό.",
    "gross": "Ακαθάριστο ετήσιο εισόδημα",
    "si": "Κοινωνικές ασφαλίσεις",
    "medical": "Εισφορές ΓεΣΥ",
    "provident": "Ταμείο προνοίας",
    "pension": "Συνταξιοδοτικό ταμείο",
    "children": "Παιδιά",
    "life_policies": "{count, plural, =0 {Χωρίς ασφάλειες ζωής} one {Περιλαμβάνεται # ασφάλεια ζωής} other {Περιλαμβάνονται # ασφάλειες ζωής}}",
    "opportunity": "Έκπτωση ασφαλίστρων ζωής",
    "o": {
      "gross": "Ακαθάριστο εισόδημα",
      "limit": "Όριο έκπτωσης",
      "eligible": "Ήδη σε χρήση",
      "remaining": "Υπόλοιπο έκπτωσης"
    },
    "illustration": "Ενδεικτικά: η αξιοποίηση του υπολοίπου θα μπορούσε να μειώσει τον φόρο κατά περίπου {saving} (οριακός συντελεστής {rate}).",
    "disclaimer": "Ενδεικτικός υπολογισμός βάσει των κανόνων που εμφανίζονται· δεν αποτελεί φορολογική συμβουλή. Επιβεβαιώστε με τον λογιστή του πελάτη.",
    "save_snapshot": "Αποθήκευση υπολογισμού",
    "snapshot_saved": "Ο υπολογισμός αποθηκεύτηκε με την έκδοση κανόνων του",
    "snapshots": "Αποθηκευμένοι υπολογισμοί",
    "rules_changed": "με νεότερους κανόνες: {amount}",
    "status": {
      "approved": "Εγκεκριμένο",
      "provisional": "Προσωρινό",
      "draft": "Προσχέδιο",
      "retired": "Αποσυρμένο"
    },
    "reason": {
      "no_rules_for_year": "Δεν υπάρχουν φορολογικοί κανόνες για αυτό το έτος. Προσθέστε τους από επίσημη πηγή — δεν χρησιμοποιείται ποτέ το προηγούμενο έτος.",
      "not_approved": "Οι κανόνες για το έτος είναι ακόμη προσχέδιο. Εγκρίνετέ τους για να χρησιμοποιηθούν.",
      "no_engine": "Οι φορολογικοί υπολογισμοί δεν είναι ακόμη διαθέσιμοι για αυτή τη χώρα.",
      "expired": "Οι κανόνες για αυτό το έτος έχουν αποσυρθεί.",
      "income_unknown": "Εισαγάγετε το ακαθάριστο εισόδημα — δεν θεωρείται ποτέ δεδομένο."
    },
    "savings_title": "Ευκαιρίες φοροαπαλλαγής στο χαρτοφυλάκιο",
    "savings_sub": "Η πιο πρόσφατη μισθοδοσία ή φορολογικός υπολογισμός ανά πελάτη, με περιθώριο για εκπιπτόμενα ασφάλιστρα.",
    "savings_empty": "Καμία ακόμη — αναλύστε τη μισθοδοσία ενός πελάτη για να βρείτε.",
    "savings_col_client": "Πελάτης",
    "savings_col_room": "Περιθώριο / έτος",
    "savings_col_saving": "Όφελος φόρου",
    "savings_col_from": "Από",
    "from_payslip": "μισθοδοσία",
    "from_calculator": "υπολογισμό",
    "follow_up": "Εργασία",
    "follow_up_open": "υπάρχει εργασία",
    "follow_up_made": "Η εργασία δημιουργήθηκε",
    "own_folder": "Για τα δικά σας φορολογικά ως σύμβουλος (άδεια, ασφάλιση ευθύνης, κοινωνικές ασφαλίσεις, βεβαιώσεις):"
  },
  "vault": {
    "title": "Έγγραφα",
    "subtitle": "Κάθε έγγραφο με το πρόσωπο, την κατηγορία και τις εκδόσεις του — ανάγνωση τοπικά, έλεγχος από εσάς",
    "upload": "Ανέβασμα εγγράφου",
    "choose_file": "Επιλογή αρχείου",
    "scan": "Φωτογραφία",
    "category": "Κατηγορία",
    "all_categories": "Όλες οι κατηγορίες",
    "restricted": "Περιορισμένης πρόσβασης (ιατρικό ή ευαίσθητο)",
    "version_of": "Νέα έκδοση του",
    "new_document": "— νέο έγγραφο —",
    "store": "Αποθήκευση",
    "stored": "Το έγγραφο αποθηκεύτηκε",
    "upload_note": "Αρχεία έως 20 MB αποθηκεύονται σε αυτή τη συσκευή (και στον server συγχρονισμού αν είναι συνδεδεμένος). Το κείμενο διαβάζεται τοπικά· τίποτα δεν στέλνεται σε υπηρεσία AI.",
    "too_large": "Το αρχείο είναι μεγαλύτερο από {mb} MB.",
    "duplicate": "Το ίδιο αρχείο υπάρχει ήδη ως «{title}». Αν πρόκειται για ενημέρωση, επιλέξτε το στο «Νέα έκδοση του».",
    "file_missing": "Το αρχείο δεν είναι διαθέσιμο σε αυτή τη συσκευή.",
    "open": "Άνοιγμα",
    "download": "Λήψη",
    "versions": "{count, plural, one {# έκδοση} other {# εκδόσεις}}",
    "drafts": "{count, plural, one {# έγγραφο περιμένει έλεγχο} other {# έγγραφα περιμένουν έλεγχο}}",
    "nothing_found": "Κανένα έγγραφο δεν ταιριάζει.",
    "footer": "Το άνοιγμα ή η λήψη εγγράφου καταγράφεται στο αρχείο ελέγχου.",
    "tab_note": "Αποθηκευμένα αρχεία, εκδόσεις και τιμές που διαβάστηκαν",
    "review": "Έλεγχος τιμών",
    "review_intro": "Αποδεχτείτε, διορθώστε ή απορρίψτε κάθε τιμή. Τίποτα δεν γράφεται στην εγγραφή μέχρι την εφαρμογή.",
    "field": "Πεδίο",
    "extracted": "Από το έγγραφο",
    "existing": "Στο AVRASTRO τώρα",
    "destination": "Προορισμός",
    "page": "σελ. {page}",
    "confidence": "Βεβαιότητα",
    "alternatives": "Άλλες τιμές που βρέθηκαν: {list}",
    "not_found": "δεν βρέθηκε",
    "correct": "Σωστή τιμή",
    "accept": "Αποδοχή",
    "rejectf": "Απόρριψη",
    "add_manual": "Προσθήκη τιμής χειροκίνητα:",
    "add": "Προσθήκη",
    "target_policy": "Συμβόλαιο",
    "apply": "Εφαρμογή αποδεκτών τιμών",
    "applied": "Οι τιμές εφαρμόστηκαν με σύνδεση στο έγγραφο",
    "reject_all": "Απόρριψη όλων",
    "rejected": "Ο έλεγχος έκλεισε — δεν άλλαξε τίποτα",
    "never_auto": "Οι τιμές από έγγραφα δεν εφαρμόζονται ποτέ αυτόματα. Ασφάλιστρο από έγγραφο καταγράφεται ως διόρθωση, ποτέ ως πώληση.",
    "stage": {
      "idle": "Αποθήκευση",
      "reading": "Ανάγνωση…",
      "hashing": "Έλεγχος…",
      "storing": "Αποθήκευση…",
      "extracting": "Ανάγνωση κειμένου…",
      "done": "Ολοκληρώθηκε",
      "error": "Απέτυχε"
    },
    "show": {
      "all": "Όλα",
      "files": "Με αρχείο"
    },
    "doctype": {
      "payslip": "Μισθοδοσία",
      "income_statement": "Βεβαίωση αποδοχών",
      "tax_certificate": "Φορολογική βεβαίωση",
      "tax_assessment": "Εκκαθαριστικό φόρου",
      "loan_statement": "Κατάσταση δανείου",
      "mortgage_statement": "Κατάσταση στεγαστικού",
      "policy_schedule": "Πίνακας συμβολαίου",
      "quotation": "Προσφορά",
      "bank_document": "Τραπεζικό έγγραφο",
      "pension_statement": "Κατάσταση συνταξιοδοτικού",
      "other": "Άλλο έγγραφο"
    },
    "method": {
      "pdf_text": "Κείμενο PDF",
      "text": "Αρχείο κειμένου",
      "manual": "Χειροκίνητη καταχώριση",
      "ocr_unavailable": "Δεν διαβάστηκε κείμενο"
    },
    "error": {
      "pdf_encrypted": "Το PDF προστατεύεται με κωδικό.",
      "no_text_layer": "Το PDF είναι σάρωση χωρίς κείμενο — εισαγάγετε τις τιμές χειροκίνητα.",
      "ocr_not_configured": "Οι φωτογραφίες αποθηκεύονται αλλά δεν διαβάζονται: δεν υπάρχει συνδεδεμένη υπηρεσία OCR. Εισαγάγετε τις τιμές χειροκίνητα.",
      "read_failed": "Το αρχείο δεν διαβάστηκε."
    },
    "decision": {
      "pending": "προς έλεγχο",
      "accepted": "αποδεκτό",
      "rejected": "απορρίφθηκε"
    },
    "fkey": {
      "name": "Όνομα",
      "employer": "Εργοδότης",
      "period": "Περίοδος",
      "gross_monthly": "Μικτές μηνιαίες αποδοχές",
      "net_monthly": "Καθαρές μηνιαίες αποδοχές",
      "gross_annual": "Μικτό ετήσιο εισόδημα",
      "net_annual": "Καθαρό ετήσιο εισόδημα",
      "tax_amount": "Φόρος",
      "loan_amount": "Ποσό δανείου",
      "loan_balance": "Ανεξόφλητο υπόλοιπο",
      "loan_instalment": "Δόση",
      "loan_rate": "Επιτόκιο",
      "loan_term_months": "Διάρκεια (μήνες)",
      "lender": "Δανειστής",
      "policy_number": "Αριθμός συμβολαίου",
      "insurer": "Ασφαλιστική εταιρεία",
      "policy_premium": "Ασφάλιστρο",
      "premium_frequency": "Συχνότητα πληρωμής",
      "sum_assured": "Ασφαλισμένο κεφάλαιο",
      "policy_expiry": "Ημερομηνία λήξης"
    },
    "dest": {
      "identity_check": "μόνο έλεγχος ταυτότητας",
      "persons_employer": "πρόσωπο · εργοδότης",
      "info": "μόνο πληροφορία",
      "financial_items_income": "εισόδημα",
      "financial_items_expense": "έξοδα",
      "financial_items_liability": "δάνεια",
      "policies": "συμβόλαιο"
    }
  },
  "onboard": {
    "welcome": "Καλώς ήρθατε στο AVRASTRO",
    "welcome_sub": "Ο χώρος εργασίας σας ως σύμβουλος — ιδιωτικός, σε αυτή τη συσκευή, έτοιμος σε ένα λεπτό.",
    "setup": "Ρύθμιση του γραφείου μου",
    "setup_sub": "Αγορά, προφίλ, λογότυπο και στόχοι — περίπου δύο λεπτά, κάθε βήμα προαιρετικό.",
    "import_sub": "Μεταφέρετε πελάτες, συμβόλαια και εργασίες από προηγούμενο VÉRO CRM.",
    "demo_sub": "Περιηγηθείτε πρώτα με φανταστικούς πελάτες. Μπορείτε να τους διαγράψετε αργότερα.",
    "account": "Σύνδεση ή δημιουργία λογαριασμού",
    "account_sub": "Συγχρονισμός συσκευών, αντίγραφα στο cloud και ομαδική εργασία.",
    "account_sub_server": "Για συγχρονισμό, αντίγραφα στο cloud και ομάδες — θα χρειαστείτε τη διεύθυνση διακομιστή του παρόχου σας.",
    "private": "Όλα μένουν σε αυτή τη συσκευή μέχρι να επιλέξετε να συνδέσετε λογαριασμό.",
    "progress": "Πρόοδος ρύθμισης",
    "step": {
      "market": "Αγορά",
      "profile": "Προφίλ",
      "brand": "Ταυτότητα",
      "goals": "Στόχοι",
      "done": "Έτοιμο"
    },
    "market_title": "Πού εργάζεστε;",
    "market_sub": "Η αγορά ορίζει νόμισμα, πεδία αδειοδότησης, εορτολόγιο και λίστες ελέγχου. Η γλώσσα είναι ξεχωριστή — την επιλέξατε στην πρώτη οθόνη.",
    "market_note": "Μπορείτε να αλλάξετε την αγορά οποτεδήποτε από τις Ρυθμίσεις.",
    "currency": "Νόμισμα",
    "time_zone": "Ζώνη ώρας",
    "profile_title": "Πώς σας βλέπουν οι πελάτες",
    "profile_sub": "Χρησιμοποιείται σε προτάσεις, επανεξετάσεις, επιστολές και μηνύματα. Τίποτα δεν επινοείται — τα κενά πεδία απλώς δεν εμφανίζονται.",
    "profile_note": "Περισσότερα στοιχεία (φωτογραφία, υπογραφή, κανονιστικό κείμενο) στο Σύστημα → Ταυτότητα.",
    "brand_title": "Το λογότυπό σας σε κάθε έγγραφο",
    "brand_sub": "Τα έγγραφα φέρουν διπλή ταυτότητα: προηγείται το λογότυπο του γραφείου σας, το AVRASTRO εμφανίζεται διακριτικά. PNG, JPG, WebP ή SVG — προσαρμόζεται αυτόματα.",
    "no_logo": "Χωρίς λογότυπο ακόμη",
    "goals_title": "Στόχοι και υπενθυμίσεις",
    "goals_sub": "Οι στόχοι τροφοδοτούν τις μπάρες ρυθμού στην Επιχείρηση· οι υπενθυμίσεις δημιουργούν εργασίες — το AVRASTRO δεν στέλνει ποτέ τίποτα μόνο του.",
    "goal_premium": "Στόχος νέων ετήσιων ασφαλίστρων ({currency})",
    "goal_clients": "Νέοι πελάτες φέτος",
    "goal_meetings": "Συναντήσεις φέτος",
    "reminders": "Ετοίμαζε τις καθημερινές μου υπενθυμίσεις σε αυτή τη συσκευή (επαναλήψεις, ανανεώσεις, γενέθλια, επανεξετάσεις)",
    "reminders_note": "Εγκαθιστά τους βασικούς αυτοματισμούς· μπορείτε να τους ελέγξετε ή να τους απενεργοποιήσετε στο Σύστημα → Αυτοματισμοί.",
    "done_title": "Όλα έτοιμα",
    "done_sub": "Ξεκινήστε από το Σήμερα: σας δείχνει ποιος χρειάζεται προσοχή και τι να κάνετε μετά.",
    "logo_ready": "Το λογότυπο είναι έτοιμο για τα έγγραφα",
    "reminders_on": "Καθημερινές υπενθυμίσεις σε αυτή τη συσκευή",
    "start_tour": "Ξενάγηση (1 λεπτό)",
    "go_today": "Μετάβαση στο Σήμερα",
    "skip": "Παράλειψη",
    "signed_in_as": "Συνδεθήκατε ως {name} · {workspace}. Το προφίλ σας στο avrastro.com συμπληρώνει τη ρύθμιση — αλλάξτε ό,τι θέλετε."
  },
  "tour": {
    "title": "Ξενάγηση",
    "show": "Εμφάνιση ξενάγησης",
    "step": "{n} από {total}",
    "skip": "Τέλος ξενάγησης",
    "finish": "Τέλος",
    "today": {
      "title": "Σήμερα",
      "body": "Ποιος σας χρειάζεται τώρα: προτεραιότητες, επαναλήψεις, ανανεώσεις και γενέθλια — με την αιτία και την καλύτερη επόμενη ενέργεια."
    },
    "people": {
      "title": "Πρόσωπα",
      "body": "Κάθε πελάτης, οικογένεια και συμβόλαιο, με πλήρη εικόνα 360°, έγγραφα και επανεξετάσεις."
    },
    "growth": {
      "title": "Ανάπτυξη",
      "body": "Υποψήφιοι, pipeline, συστάσεις και καμπάνιες — από πού έρχονται οι νέες εργασίες."
    },
    "cases": {
      "title": "Υποθέσεις",
      "body": "Αιτήσεις από την πρόταση ως την έκδοση, με λίστες εγγράφων και κατάσταση ανάληψης κινδύνου."
    },
    "lens": {
      "title": "Φακός",
      "body": "Πατήστε Ctrl/⌘ K οπουδήποτε για να βρείτε οποιονδήποτε ή να κάνετε οτιδήποτε πληκτρολογώντας."
    },
    "flow": {
      "title": "Ροή",
      "body": "Δουλέψτε τη μέρα σας ένα θέμα τη φορά, χωρίς να ψάχνετε σε οθόνες."
    },
    "system": {
      "title": "Σύστημα",
      "body": "Δεδομένα και αντίγραφα, ταυτότητα, λογαριασμός και ρυθμίσεις. Τα δεδομένα σας μένουν δικά σας — εξάγετέ τα οποτεδήποτε."
    }
  },
  "outlook": {
    "title": "Ημερολόγιο Outlook",
    "intro": "Συνδέστε το ημερολόγιο του Outlook (Microsoft 365): τα ραντεβού του CRM εμφανίζονται στο Outlook και στο κινητό σας, και ό,τι έχετε κλείσει στο Outlook κλείνει τις ίδιες ώρες στα online ραντεβού της ιστοσελίδας.",
    "connect": "Σύνδεση με Outlook",
    "check": "Έλεγχος σύνδεσης",
    "opened": "Ολοκληρώστε τη σύνδεση στη σελίδα της Microsoft που άνοιξε, και μετά πατήστε «Έλεγχος σύνδεσης».",
    "account": "Λογαριασμός",
    "last": "Τελευταίος συγχρονισμός",
    "events": "{n} ραντεβού στο Outlook",
    "sync": "Συγχρονισμός τώρα",
    "synced": "Έγινε συγχρονισμός: {n} ραντεβού στο Outlook.",
    "err": "Ο συγχρονισμός δεν ολοκληρώθηκε ({e}).",
    "reconnect": "Η Microsoft ζητά νέα σύνδεση (π.χ. άλλαξε ο κωδικός ή ανακλήθηκε η άδεια). Πατήστε «Σύνδεση με Outlook».",
    "disconnect": "Αποσύνδεση",
    "disconnect_confirm": "Να σταματήσει η σύνδεση με το Outlook; Τα ραντεβού που είναι ήδη στο Outlook μένουν εκεί.",
    "note": "Το Outlook είναι αντίγραφο: οι αλλαγές γίνονται στο CRM και περνούν στο Outlook σε λίγα λεπτά. Η σύνδεση γίνεται στη σελίδα της Microsoft· ο κωδικός σας δεν περνά από το AVRASTRO.",
    "mail": {
      "title": "E-mail με πελάτες στο χρονολόγιό τους",
      "intro": "Προαιρετικό: τα e-mail ανάμεσα στο Outlook σας και σε πελάτη του CRM (με βάση τη διεύθυνση e-mail του πελάτη) εμφανίζονται στο χρονολόγιο του πελάτη — θέμα, ημερομηνία, κατεύθυνση και σύνδεσμος για άνοιγμα στο Outlook. Άλλα e-mail δεν κρατιούνται ποτέ. Η Microsoft θα σας ζητήσει να επιτρέψετε «Ανάγνωση της αλληλογραφίας σας».",
      "connect": "Εμφάνιση e-mail πελατών",
      "on": "Ενεργό — τελευταίος έλεγχος {when}. Ελέγχεται κάθε 10 λεπτά όσο είναι συνδεδεμένο.",
      "sync": "Έλεγχος τώρα",
      "synced": "Έλεγχος: {n} νέα e-mail με πελάτες.",
      "off": "Διακοπή",
      "off_confirm": "Να σταματήσει η ανάγνωση των e-mail του Outlook; Όσα e-mail είναι ήδη στα χρονολόγια πελατών μένουν· το ημερολόγιο μένει συνδεδεμένο.",
      "note": "Το κείμενο των e-mail δεν κρατιέται, εκτός αν επιλέξετε «κράτησε το κείμενο των e-mail» στο χρονολόγιο ενός πελάτη (μόνο για εκείνον). Δύο άτομα με την ίδια διεύθυνση δεν αντιστοιχίζονται.",
      "keep_text": "Κράτησε το κείμενο των e-mail του Outlook με αυτόν τον πελάτη (από εδώ και πέρα)",
      "sent": "Στάλθηκε · Outlook",
      "received": "Ελήφθη · Outlook",
      "open": "Άνοιγμα στο Outlook",
      "in_untitled": "E-mail από τον πελάτη (χωρίς θέμα)",
      "out_untitled": "E-mail προς τον πελάτη (χωρίς θέμα)"
    }
  },
  "account": {
    "signin_email": "E-mail σύνδεσης",
    "change_email": "Αλλαγή e-mail",
    "email_current": "Τωρινό e-mail",
    "email_new": "Νέο e-mail",
    "email_send_code": "Αποστολή κωδικού",
    "email_code_sent": "Στείλαμε κωδικό 6 ψηφίων στο {email}. Πληκτρολογήστε τον εδώ (ισχύει 15 λεπτά).",
    "email_code": "Κωδικός από το e-mail",
    "email_confirm": "Επιβεβαίωση",
    "email_changed": "Το e-mail σύνδεσης είναι πλέον {email}.",
    "email_change_note": "Ο κωδικός πρόσβασης, τα δεδομένα, οι χώροι εργασίας και οι συσκευές σας μένουν ίδια. Το παλιό e-mail θα λάβει ειδοποίηση για την αλλαγή.",
    "title": "Λογαριασμός & συνδρομή",
    "subtitle_out": "Προαιρετικά: ο λογαριασμός προσθέτει συγχρονισμό συσκευών, κρυπτογραφημένα αντίγραφα στο cloud και ομάδες. Το AVRASTRO λειτουργεί πλήρως και χωρίς αυτόν.",
    "subtitle_in": "Προφίλ, συνδρομή, ασφάλεια, συσκευές και αντίγραφα στο cloud.",
    "unavailable": "Οι λογαριασμοί δεν είναι διαθέσιμοι σε αυτή την έκδοση.",
    "tab": {
      "signin": "Σύνδεση",
      "register": "Νέος λογαριασμός",
      "reset": "Ξέχασα τον κωδικό"
    },
    "server": "Διακομιστής",
    "server_hint": "Η διεύθυνση της υπηρεσίας λογαριασμών AVRASTRO (https).",
    "change_server": "αλλαγή",
    "session_ended": "Αποσυνδεθήκατε σε αυτή τη συσκευή. Τα δεδομένα σας είναι εδώ — συνδεθείτε ξανά για να συνεχίσει ο συγχρονισμός.",
    "why_title": "Τι προσθέτει ένας λογαριασμός",
    "why": {
      "sync": "Συγχρονισμός υπολογιστή, tablet και κινητού — οι διενέξεις εμφανίζονται σε εσάς, ποτέ δεν αντικαθίστανται σιωπηλά.",
      "backup": "Αντίγραφα στο cloud κρυπτογραφημένα στη συσκευή σας με δικό σας κωδικό αντιγράφου.",
      "team": "Γραφεία: θέσεις, ρόλοι, προσκλήσεις και ημερολόγιο δραστηριότητας.",
      "devices": "Δείτε και αποσυνδέστε τις συσκευές σας· προαιρετική σύνδεση δύο βημάτων.",
      "local": "Τα δεδομένα πελατών μένουν στον κρυπτογραφημένο χώρο κάθε συσκευής. Χωρίς λογαριασμό τίποτα δεν φεύγει."
    },
    "privacy_note": "Οι συγχρονισμένες εγγραφές προστατεύονται κατά τη μεταφορά και στον διακομιστή· τα αντίγραφα στο cloud είναι κρυπτογραφημένα από άκρο σε άκρο.",
    "email_label": "E-mail",
    "password": "Κωδικός πρόσβασης",
    "password_repeat": "Επανάληψη κωδικού",
    "current_password": "Τρέχων κωδικός",
    "new_password": "Νέος κωδικός",
    "pw_rule": "Τουλάχιστον 10 χαρακτήρες· μια μικρή φράση είναι ιδανική.",
    "pw_ok": "Αρκετά ισχυρός",
    "pw_mismatch": "Οι κωδικοί διαφέρουν",
    "password_note": "Ο κωδικός σας δεν αποθηκεύεται ποτέ στη συσκευή — μόνο μια ανακλήσιμη συνεδρία.",
    "sign_in": "Σύνδεση",
    "sign_out": "Αποσύνδεση",
    "working": "Παρακαλώ περιμένετε…",
    "mfa_code": "Κωδικός εφαρμογής ταυτοποίησης",
    "mfa_code_hint": "Ο 6ψήφιος κωδικός της εφαρμογής ταυτοποίησης ή ένας από τους κωδικούς ανάκτησης.",
    "choose_workspace": "Το e-mail σας ανήκει σε περισσότερους χώρους εργασίας. Επιλέξτε:",
    "switch_sync": "Η συσκευή συγχρονίζεται με {server}. Με τη σύνδεση ο συγχρονισμός θα μεταφερθεί στον λογαριασμό AVRASTRO. Συνέχεια;",
    "signed_in": "Συνδεθήκατε · {workspace}",
    "signed_out": "Αποσυνδεθήκατε. Όλα όσα υπάρχουν στη συσκευή παραμένουν.",
    "created": "Ο λογαριασμός δημιουργήθηκε · {workspace}",
    "create": "Δημιουργία λογαριασμού",
    "trial_note": "Δωρεάν δοκιμή {days} ημερών. Χωρίς στοιχεία πληρωμής για να ξεκινήσετε.",
    "code_needed": "Σε αυτή την υπηρεσία απαιτείται κωδικός ενεργοποίησης ή πρόσκλησης.",
    "invite_only": "Οι νέοι λογαριασμοί σε αυτή την υπηρεσία δημιουργούνται μόνο με πρόσκληση.",
    "reg": {
      "you": "Εσείς",
      "practice": "Το γραφείο σας",
      "prefs": "Προτιμήσεις"
    },
    "first_name": "Όνομα",
    "last_name": "Επώνυμο",
    "mobile": "Κινητό",
    "branch": "Υποκατάστημα",
    "office_phone": "Τηλέφωνο γραφείου",
    "code": "Κωδικός ενεργοποίησης ή πρόσκλησης",
    "code_hint": "Προαιρετικό. Από το γραφείο σας ή από το AVRASTRO.",
    "accept_terms": "Αποδέχομαι τους Όρους Χρήσης *",
    "accept_privacy": "Διάβασα τη Δήλωση Απορρήτου και συμφωνώ με την επεξεργασία των δεδομένων του λογαριασμού μου (ΓΚΠΔ) *",
    "accept_marketing": "Θέλω να λαμβάνω περιστασιακά νέα του προϊόντος (προαιρετικό)",
    "reg_note": "Τα πεδία αδειοδότησης ακολουθούν την αγορά που επιλέγετε. Με τη δημιουργία λογαριασμού δεν αποστέλλονται δεδομένα πελατών.",
    "send_reset": "Αποστολή κωδικού επαναφοράς",
    "reset_sent": "Αν η διεύθυνση έχει λογαριασμό, στάλθηκε κωδικός επαναφοράς (ισχύει μία ώρα). Πληκτρολογήστε τον μαζί με τον νέο κωδικό.",
    "reset_code": "Κωδικός επαναφοράς",
    "set_password": "Ορισμός νέου κωδικού",
    "reset_done": "Ο κωδικός άλλαξε. Όλες οι συσκευές αποσυνδέθηκαν — συνδεθείτε με τον νέο κωδικό.",
    "email_verified": "επιβεβαιωμένο",
    "email_unverified": "μη επιβεβαιωμένο",
    "verify_resend": "Αποστολή e-mail επιβεβαίωσης",
    "verify_sent": "Το e-mail επιβεβαίωσης στάλθηκε",
    "verified": "Το e-mail επιβεβαιώθηκε",
    "checked": "τελευταίος έλεγχος {when}",
    "billing_success": "Ευχαριστούμε — η συνδρομή σας ενεργοποιείται.",
    "subscription": "Συνδρομή",
    "plan": "Πρόγραμμα",
    "status": "Κατάσταση",
    "cancels": "λήγει στο τέλος της περιόδου",
    "trial_end": "Λήξη δοκιμής",
    "period_end": "Εξοφλημένο έως",
    "limits": "Όρια",
    "limits_value": "{seats} θέση(εις) · {devices} συσκευές η καθεμία",
    "licence": "Άδεια σε αυτή τη συσκευή",
    "valid_until": "έως {date}",
    "unmanaged": "Ο χώρος εργασίας δεν έχει συνδρομή (ιδιόκτητος συγχρονισμός). Δεν ισχύουν όρια.",
    "redeem": "Εξαργύρωση κωδικού",
    "code_applied": "Ο κωδικός εφαρμόστηκε",
    "manage_billing": "Τιμολόγια & πληρωμή",
    "price_unset": "Τιμή κατόπιν αιτήματος",
    "free": "Δωρεάν",
    "current_plan": "Τρέχον πρόγραμμα",
    "choose_plan": "Επιλογή",
    "billing_off": "Η ηλεκτρονική πληρωμή δεν έχει ρυθμιστεί σε αυτή την υπηρεσία· επικοινωνήστε με τον πάροχο για αλλαγή προγράμματος.",
    "renew": "Ανανέωση",
    "readonly_safe": "Τίποτα δεν διαγράφηκε — μπορείτε ακόμη να διαβάζετε και να εξάγετε τα πάντα.",
    "profile": "Προφίλ",
    "profile_note": "Το προφίλ συμπληρώνει και την ταυτότητα των εγγράφων όπου είναι κενή. Λογότυπα, φωτογραφία και υπογραφή βρίσκονται στην Ταυτότητα.",
    "edit_branding": "Ταυτότητα εγγράφων",
    "security": "Ασφάλεια",
    "change_password": "Αλλαγή κωδικού",
    "change_password_note": "Οι άλλες συσκευές σας θα αποσυνδεθούν.",
    "password_changed": "Ο κωδικός άλλαξε",
    "mfa": "Σύνδεση δύο βημάτων",
    "mfa_on": "ενεργή",
    "mfa_off": "Η σύνδεση δύο βημάτων απενεργοποιήθηκε",
    "mfa_enable": "Ενεργοποίηση σύνδεσης δύο βημάτων",
    "mfa_disable": "Απενεργοποίηση",
    "mfa_steps": "Προσθέστε αυτό το κλειδί σε εφαρμογή ταυτοποίησης (π.χ. Google Authenticator, Microsoft Authenticator, 1Password) και πληκτρολογήστε τον 6ψήφιο κωδικό που εμφανίζει.",
    "mfa_open_app": "Άνοιγμα σε εφαρμογή ταυτοποίησης σε αυτή τη συσκευή",
    "mfa_confirm": "Επιβεβαίωση και ενεργοποίηση",
    "mfa_recovery": "Η σύνδεση δύο βημάτων ενεργοποιήθηκε. Φυλάξτε αυτούς τους κωδικούς ανάκτησης σε ασφαλές μέρος — ο καθένας λειτουργεί μία φορά αν χάσετε το κινητό. Εμφανίζονται μόνο τώρα.",
    "mfa_save_codes": "Αποθήκευση κωδικών",
    "mfa_code_or_recovery": "Κωδικός εφαρμογής ή ανάκτησης",
    "device_lock": "Κλείδωμα & κρυπτογράφηση συσκευής",
    "security_note": "Οι κωδικοί αποθηκεύονται κατακερματισμένοι (scrypt) στον διακομιστή· οι συνεδρίες ανακαλούνται ανά συσκευή.",
    "devices": "Συσκευές",
    "device_unnamed": "Συσκευή",
    "this_device": "αυτή η συσκευή",
    "signed_out_device": "αποσυνδεδεμένη",
    "last_seen": "τελευταία φορά {when}",
    "revoke": "Αποσύνδεση",
    "revoke_confirm": "Αποσύνδεση της «{device}»; Θα κρατήσει τα δεδομένα μόνο για ανάγνωση μέχρι να συνδεθεί ξανά κάποιος.",
    "device_revoked": "Η συσκευή αποσυνδέθηκε",
    "devices_note": "Χάσατε μια συσκευή; Αποσυνδέστε την εδώ και αλλάξτε τον κωδικό σας.",
    "cloud_backup": "Αντίγραφο στο cloud (κρυπτογράφηση από άκρο σε άκρο)",
    "cloud_backup_desc": "Ένα πλήρες αντίγραφο κρυπτογραφείται σε αυτή τη συσκευή με κωδικό αντιγράφου πριν ανέβει. Ο διακομιστής δεν μπορεί να το διαβάσει.",
    "cloud_backup_note": "Χωρίς τον κωδικό αντιγράφου κανείς — ούτε το AVRASTRO — δεν μπορεί να το επαναφέρει. Φυλάξτε τον. Διατηρούνται τα 30 πιο πρόσφατα αντίγραφα.",
    "backup_password": "Κωδικός αντιγράφου",
    "backup_password_hint": "Τουλάχιστον 10 χαρακτήρες· μπορεί να διαφέρει από τον κωδικό σύνδεσης.",
    "backup_now": "Κρυπτογράφηση και αντίγραφο τώρα",
    "backup_done": "Το κρυπτογραφημένο αντίγραφο ανέβηκε",
    "backup_restore": "Επαναφορά…",
    "backup_restore_next": "Πληκτρολογήστε τον κωδικό αντιγράφου και πατήστε Ανάλυση: θα δείτε προεπισκόπηση πριν αλλάξει οτιδήποτε.",
    "backup_delete_confirm": "Διαγραφή αυτού του αντιγράφου από το cloud; Τα δεδομένα της συσκευής δεν επηρεάζονται.",
    "backup_role": "Τα αντίγραφα στο cloud είναι διαθέσιμα σε διαχειριστές και συμβούλους.",
    "backup_plan": "Το αντίγραφο στο cloud δεν περιλαμβάνεται στο πρόγραμμά σας.",
    "backup_stale": "Το τελευταίο αντίγραφο στο cloud είναι παλαιότερο της εβδομάδας.",
    "backup_none": "Δεν υπάρχει ακόμη αντίγραφο στο cloud.",
    "privacy": "Απόρρητο (ΓΚΠΔ)",
    "privacy_desc": "Λάβετε όσα τηρεί η υπηρεσία για τον λογαριασμό σας, εξάγετε το πελατολόγιο ή διαγράψτε τον λογαριασμό.",
    "export": "Λήψη δεδομένων λογαριασμού",
    "export_clients": "Εξαγωγή δεδομένων πελατών",
    "delete": "Διαγραφή λογαριασμού",
    "delete_intro": "Διαγράφει τον λογαριασμό σας στην υπηρεσία. Αν είστε το τελευταίο μέλος ενός χώρου εργασίας, διαγράφεται και το αντίγραφό του στον διακομιστή (συγχρονισμένες εγγραφές και αντίγραφα στο cloud). Τα δεδομένα αυτής της συσκευής δεν αγγίζονται. Γραφεία: μεταβιβάστε πρώτα τον ρόλο διαχειριστή.",
    "delete_type": "Πληκτρολογήστε DELETE για επιβεβαίωση",
    "deleted": "Ο λογαριασμός διαγράφηκε. Τα δεδομένα της συσκευής παραμένουν.",
    "badge": {
      "trial": "Δοκιμή · {days} ημ.",
      "active": "Συνδρομή ενεργή",
      "grace": "Ανανέωση · {days} ημ.",
      "expired": "Μόνο ανάγνωση",
      "invalid": "Έλεγχος άδειας",
      "none": "Σύνδεση"
    },
    "readonly": {
      "licence_expired": "Η συνδρομή σας έληξε — το AVRASTRO είναι μόνο για ανάγνωση σε αυτή τη συσκευή.",
      "licence_required": "Συνδεθείτε στον λογαριασμό AVRASTRO για να κάνετε αλλαγές."
    },
    "sub_status": {
      "trialing": "Δοκιμή",
      "active": "Ενεργή",
      "past_due": "Εκκρεμεί πληρωμή",
      "canceled": "Ακυρωμένη",
      "expired": "Έληξε"
    },
    "licence_state": {
      "none": "Δεν απαιτείται",
      "trialing": "Δοκιμή",
      "active": "Έγκυρη",
      "grace": "Περίοδος χάριτος — ανανεώστε σύντομα",
      "expired": "Έληξε (μόνο ανάγνωση)",
      "invalid": "Δεν επαληθεύτηκε"
    },
    "interval": {
      "month": "μήνα",
      "year": "έτος",
      "trial": "δοκιμή",
      "custom": "κατά περίπτωση"
    },
    "feature": {
      "sync": "Συγχρονισμός",
      "cloud_backup": "Αντίγραφα cloud",
      "campaigns": "Καμπάνιες",
      "tax_center": "Φορολογικό κέντρο",
      "team": "Ομάδα",
      "branding_agency": "Ταυτότητα γραφείου",
      "sso": "Ενιαία σύνδεση",
      "audit_export": "Εξαγωγή ελέγχου",
      "api": "API",
      "website_inbox": "Εισερχόμενα ιστότοπου",
      "client_portal": "Πύλη πελάτη",
      "ai_drafts": "Προσχέδια AI",
      "automations": "Αυτοματισμοί",
      "analytics": "Αναλύσεις",
      "group_plans": "Ομαδικά σχέδια"
    },
    "err": {
      "email_same": "Είναι το ίδιο e-mail με το τωρινό.",
      "code_expired": "Ο κωδικός έληξε ή δόθηκε λάθος πολλές φορές. Ζητήστε νέο κωδικό.",
      "generic": "Κάτι πήγε στραβά ({code}). Δοκιμάστε ξανά.",
      "network": "Η υπηρεσία λογαριασμών δεν είναι προσβάσιμη. Ελέγξτε τη σύνδεση — το AVRASTRO συνεχίζει να λειτουργεί offline.",
      "https_required": "Χρησιμοποιήστε ασφαλή διεύθυνση https://.",
      "no_server": "Πληκτρολογήστε πρώτα τη διεύθυνση του διακομιστή.",
      "key_mismatch": "Το κλειδί άδειας του διακομιστή δεν ταιριάζει με αυτό που εμπιστεύεται η εφαρμογή. Για την ασφάλειά σας δεν έγινε σύνδεση.",
      "invalid_credentials": "Λάθος e-mail ή κωδικός.",
      "mfa_required": "Πληκτρολογήστε τον κωδικό της εφαρμογής ταυτοποίησης.",
      "mfa_invalid": "Ο κωδικός δεν είναι έγκυρος. Ελέγξτε την ώρα του κινητού και δοκιμάστε ξανά.",
      "rate_limited": "Πάρα πολλές προσπάθειες. Περιμένετε λίγα λεπτά.",
      "email_taken": "Αυτό το e-mail έχει ήδη λογαριασμό — συνδεθείτε.",
      "email_invalid": "Ελέγξτε τη διεύθυνση e-mail.",
      "name_required": "Απαιτούνται όνομα και επώνυμο.",
      "password_too_short": "Χρησιμοποιήστε τουλάχιστον 10 χαρακτήρες.",
      "password_too_common": "Ο κωδικός είναι πολύ συνηθισμένος.",
      "password_contains_email": "Μη χρησιμοποιείτε το όνομα του e-mail στον κωδικό.",
      "consent_required": "Αποδεχτείτε τους Όρους και τη Δήλωση Απορρήτου.",
      "code_invalid": "Ο κωδικός δεν είναι έγκυρος ή έχει ήδη χρησιμοποιηθεί.",
      "code_required": "Απαιτείται κωδικός ενεργοποίησης ή πρόσκλησης.",
      "registration_closed": "Οι νέοι λογαριασμοί γίνονται μόνο με πρόσκληση.",
      "invitation_other_email": "Η πρόσκληση στάλθηκε σε άλλη διεύθυνση e-mail.",
      "seat_limit": "Όλες οι θέσεις του προγράμματος είναι κατειλημμένες.",
      "device_limit": "Συμπληρώθηκε το όριο συσκευών του προγράμματος. Αποσυνδέστε μια παλιά συσκευή από Λογαριασμός → Συσκευές (από άλλη συσκευή) ή ρωτήστε τον διαχειριστή.",
      "licence_expired": "Η συνδρομή έληξε — ανανεώστε για να κάνετε αλλαγές.",
      "plan_feature": "Το πρόγραμμά σας δεν το περιλαμβάνει.",
      "token_invalid": "Ο κωδικός δεν είναι έγκυρος ή έληξε. Ζητήστε νέο.",
      "revoked": "Η συνεδρία έληξε. Συνδεθείτε ξανά.",
      "expired": "Η συνεδρία έληξε. Συνδεθείτε ξανά.",
      "no_token": "Παρακαλώ συνδεθείτε.",
      "signed_out": "Παρακαλώ συνδεθείτε.",
      "permission": "Ο ρόλος σας δεν το επιτρέπει.",
      "not_found": "Δεν βρέθηκε — ίσως έχει αφαιρεθεί.",
      "plaintext_refused": "Μόνο κρυπτογραφημένα αντίγραφα μπορούν να ανέβουν.",
      "too_large": "Πολύ μεγάλο για την υπηρεσία.",
      "billing_not_configured": "Η ηλεκτρονική πληρωμή δεν έχει ρυθμιστεί σε αυτή την υπηρεσία.",
      "plan_not_on_sale": "Αυτό το πρόγραμμα δεν διατίθεται ακόμη online.",
      "no_billing_customer": "Δεν υπάρχει ακόμη λογαριασμός χρέωσης.",
      "transfer_ownership": "Ορίστε πρώτα άλλο μέλος ως διαχειριστή.",
      "cancel_subscription_first": "Ακυρώστε πρώτα την ενεργή συνδρομή (Τιμολόγια & πληρωμή).",
      "confirm_required": "Πληκτρολογήστε DELETE για επιβεβαίωση.",
      "last_admin": "Ένας χώρος εργασίας χρειάζεται τουλάχιστον έναν διαχειριστή.",
      "already_member": "Είστε ήδη μέλος αυτού του χώρου εργασίας.",
      "mfa_already_enabled": "Η σύνδεση δύο βημάτων είναι ήδη ενεργή.",
      "mfa_not_pending": "Ξεκινήστε ξανά τη ρύθμιση.",
      "mfa_not_enabled": "Η σύνδεση δύο βημάτων είναι ανενεργή.",
      "licence_expiry": "Χρησιμοποιήστε έγκυρη ημερομηνία λήξης άδειας.",
      "server_error": "Πρόβλημα στην υπηρεσία. Δοκιμάστε αργότερα.",
      "website_session_ended": "Η σύνδεσή σας στο avrastro.com έληξε. Συνεχίστε με το avrastro.com για να συγχρονίσετε ξανά — τα δεδομένα σε αυτή τη συσκευή είναι ασφαλή.",
      "workspace_mismatch": "Αυτή η συσκευή περιέχει δεδομένα άλλου χώρου εργασίας ({workspace}). Δεν ανεβαίνουν ποτέ σε διαφορετικό λογαριασμό. Χρησιμοποιήστε άλλο προφίλ φυλλομετρητή ή υπολογιστή, ή κάντε εξαγωγή και καθαρισμό αυτής της συσκευής πρώτα (Δεδομένα & ασφάλεια).",
      "website_web_only": "Η σύνδεση μέσω ιστότοπου από εδώ λειτουργεί στην εφαρμογή web. Στην εφαρμογή υπολογιστή χρησιμοποιήστε τον κωδικό που εμφανίζεται.",
      "already_linked": "Αυτός ο χώρος εργασίας είναι ήδη συνδεδεμένος με λογαριασμό στο avrastro.com.",
      "storage_limit": "Ο χώρος αντιγράφων ασφαλείας του πακέτου σας γέμισε. Διαγράψτε παλαιότερα αντίγραφα παρακάτω ή προσθέστε χώρο από το Advisor Hub.",
      "push_endpoint": "Η υπηρεσία ειδοποιήσεων αυτού του browser δεν υποστηρίζεται.",
      "push_key": "Ο browser έστειλε ελλιπές κλειδί ειδοποιήσεων. Δοκιμάστε ξανά.",
      "push_limit": "Φτάσατε το όριο των 10 συσκευών με ειδοποιήσεις. Κλείστε πρώτα μία.",
      "push_not_configured": "Οι ειδοποιήσεις δεν είναι διαθέσιμες σε αυτόν τον server.",
      "passkey_unknown": "Αυτό το passkey δεν είναι καταχωρισμένο σε λογαριασμό AVRASTRO (ίσως αφαιρέθηκε).",
      "passkey_challenge": "Το αίτημα passkey έληξε. Δοκιμάστε ξανά.",
      "passkey_expired": "Το αίτημα passkey έληξε. Δοκιμάστε ξανά.",
      "passkey_signature": "Το passkey δεν επαληθεύτηκε.",
      "passkey_sign_count": "Αυτό το passkey φαίνεται αντιγραμμένο σε άλλη συσκευή και απορρίφθηκε. Συνδεθείτε με κωδικό και προσθέστε το ξανά.",
      "passkey_origin": "Αυτό το passkey ανήκει σε άλλον ιστότοπο.",
      "passkey_rp_id": "Αυτό το passkey ανήκει σε άλλον ιστότοπο.",
      "passkey_user_verification": "Η συσκευή δεν επιβεβαίωσε ότι είστε εσείς (Face ID, δακτυλικό ή PIN συσκευής).",
      "passkey_exists": "Αυτό το passkey έχει ήδη προστεθεί.",
      "passkey_limit": "Φτάσατε το όριο των 20 passkeys. Αφαιρέστε πρώτα ένα.",
      "passkeys_not_configured": "Τα passkeys δεν είναι διαθέσιμα σε αυτόν τον server."
    },
    "licence_offline": "επαληθεύεται στη συσκευή, λειτουργεί offline",
    "website": {
      "title": "Ένας λογαριασμός με το {site}",
      "sub_web": "Συνδεθείτε μία φορά στο {site} — το CRM ανοίγει με τον ίδιο λογαριασμό. Χωρίς δεύτερο κωδικό.",
      "sub_desktop": "Συνεχίστε στο {site} από τον φυλλομετρητή και επιβεβαιώστε τον κωδικό που βλέπετε εδώ. Δεν πληκτρολογείτε κωδικό πρόσβασης στην εφαρμογή.",
      "continue": "Συνέχεια με {site}",
      "code_intro": "Ο φυλλομετρητής ανοίγει το {site}. Συνδεθείτε εκεί και πληκτρολογήστε αυτόν τον κωδικό όταν σας ζητηθεί:",
      "open": "Άνοιγμα {site}",
      "waiting": "Αναμονή επιβεβαίωσης… Ο κωδικός ισχύει 10 λεπτά. Δεν άνοιξε; Μεταβείτε στο",
      "manage_plan": "Πακέτο & χρεώσεις στο {site}",
      "manage_plan_note": "Αναβαθμίσεις, πρόσθετα, τιμολόγια και ακύρωση γίνονται από το Advisor Hub.",
      "link_title": "Χρησιμοποιήστε και τον λογαριασμό σας στο {site}",
      "link_sub": "Συνδέστε αυτόν τον χώρο εργασίας με τον λογαριασμό συμβούλου σας στο {site}: ανοίγετε το CRM από το Advisor Hub και διαχειρίζεστε εκεί το πακέτο σας. Γίνεται μία φορά· ο κωδικός σας εξακολουθεί να λειτουργεί.",
      "link": "Σύνδεση με {site}",
      "already_linked": "Αυτός ο χώρος εργασίας είναι ήδη συνδεδεμένος με λογαριασμό στο {site}."
    },
    "store_note": "Ό,τι περιλαμβάνει η συνδρομή του χώρου εργασίας σας εμφανίζεται εδώ αυτόματα μόλις συνδεθείτε.",
    "invite_code": "Κωδικός πρόσκλησης",
    "read_legal": "Διαβάστε:"
  },
  "team": {
    "subtitle": "Θέσεις, ρόλοι, προσκλήσεις και δραστηριότητα του γραφείου σας.",
    "sign_in_first": "Συνδεθείτε σε λογαριασμό για να διαχειριστείτε ομάδα.",
    "admin_only": "Μόνο διαχειριστές και υπεύθυνοι βλέπουν την ομάδα.",
    "seats": "Θέσεις σε χρήση",
    "seats_hint": "Ενεργά μέλη του προγράμματος",
    "invitations": "Ανοιχτές προσκλήσεις",
    "invitations_hint": "Κωδικοί που δεν χρησιμοποιήθηκαν",
    "members": "Μέλη",
    "member": "Μέλος",
    "role": "Ρόλος",
    "active": "Ενεργό",
    "disabled": "Απενεργοποιημένο",
    "disable": "Απενεργοποίηση",
    "enable": "Ενεργοποίηση",
    "disable_confirm": "Απενεργοποίηση του/της {name}; Όλες οι συσκευές αποσυνδέονται· οι κοινές εγγραφές παραμένουν.",
    "roles_note": "Διαχειριστής: τα πάντα, μαζί με ομάδα και χρέωση. Σύμβουλος: το δικό του πελατολόγιο. Υπεύθυνος: εποπτεία μόνο για ανάγνωση. Βοηθός: χωρίς ευαίσθητα έγγραφα.",
    "invite": "Πρόσκληση συνεργάτη",
    "invite_email": "E-mail",
    "invite_email_hint": "Προαιρετικό: αφήστε κενό για κωδικό που θα δώσετε εσείς.",
    "valid_days": "Ισχύς (ημέρες)",
    "invite_create": "Δημιουργία πρόσκλησης",
    "code_once": "Κωδικός πρόσκλησης (εμφανίζεται μία φορά):",
    "code_mailed": "Στάλθηκε επίσης στο {email}.",
    "open_invitation": "Ανοιχτή πρόσκληση",
    "until": "έως {date}",
    "revoke": "Ανάκληση",
    "activity": "Δραστηριότητα",
    "no_activity": "Καμία δραστηριότητα ακόμη.",
    "action": {
      "sign_in": "συνδέθηκε",
      "account_created": "δημιούργησε τον λογαριασμό",
      "account_joined": "μπήκε στην ομάδα",
      "account_deleted": "διέγραψε τον λογαριασμό του",
      "profile_updated": "ενημέρωσε το προφίλ",
      "password_changed": "άλλαξε κωδικό",
      "password_reset": "επανέφερε τον κωδικό",
      "mfa_enabled": "ενεργοποίησε σύνδεση δύο βημάτων",
      "mfa_disabled": "απενεργοποίησε σύνδεση δύο βημάτων",
      "device_revoked": "αποσύνδεσε συσκευή",
      "code_redeemed": "εξαργύρωσε κωδικό",
      "invitation_created": "δημιούργησε πρόσκληση",
      "invitation_revoked": "ανακάλεσε πρόσκληση",
      "member_updated": "άλλαξε μέλος",
      "backup_uploaded": "δημιούργησε αντίγραφο στο cloud",
      "backup_downloaded": "κατέβασε αντίγραφο από το cloud",
      "backup_deleted": "διέγραψε αντίγραφο από το cloud",
      "push_refused": "ο συγχρονισμός απορρίφθηκε (συνδρομή)",
      "push_denied": "η αλλαγή απορρίφθηκε (δικαίωμα)",
      "file_upload": "ανέβασε αρχείο εγγράφου",
      "file_download": "άνοιξε αρχείο εγγράφου",
      "file_denied": "δεν του επιτράπηκε αρχείο εγγράφου"
    },
    "activity_export": "Εξαγωγή ιστορικού (CSV)",
    "activity_export_locked": "Η εξαγωγή του ιστορικού ενεργειών για συμμόρφωση περιλαμβάνεται στα πακέτα Team και Enterprise.",
    "activity_export_unavailable": "Η εξαγωγή του ιστορικού ενεργειών δεν περιλαμβάνεται στη συνδρομή αυτού του χώρου εργασίας."
  },
  "branding": {
    "title": "Ταυτότητα",
    "subtitle": "Το λογότυπο, η ταυτότητα και η υπογραφή σας σε κάθε πρόταση, επανεξέταση, επιστολή και αναφορά — με διπλή ταυτότητα μαζί με το AVRASTRO εξ ορισμού.",
    "open": "Λογότυπα, φωτογραφία & υπογραφή",
    "incomplete": "Προσθέστε όνομα, τηλέφωνο ή e-mail και αριθμό άδειας ώστε τα έγγραφα να έχουν πλήρη ταυτότητα.",
    "save": "Αποθήκευση ταυτότητας",
    "saved": "Η ταυτότητα αποθηκεύτηκε",
    "sec": {
      "identity": "Σύμβουλος",
      "licence": "Αδειοδότηση",
      "contact": "Επικοινωνία",
      "logos": "Γραφείο & λογότυπα",
      "signature": "Υπογραφή",
      "documents": "Στα έγγραφα"
    },
    "advisor_name": "Όνομα συμβούλου",
    "job_title": "Τίτλος",
    "job_title_ph": "π.χ. Ανώτερος Ασφαλιστικός Σύμβουλος",
    "photo": "Φωτογραφία",
    "country": "Αγορά",
    "licence_number": "Αριθμός άδειας",
    "licence_authority": "Αρχή αδειοδότησης",
    "authority_hint": "Προτεινόμενη για την αγορά — επιβεβαιώστε με τον εποπτικό φορέα.",
    "licence_expiry": "Λήξη άδειας",
    "licence_short": "Άδεια",
    "registration": "Αριθμός μητρώου επιχείρησης",
    "regulatory": "Κανονιστική δήλωση",
    "regulatory_hint": "Εμφανίζεται στο υποσέλιδο των εγγράφων, π.χ. «Εγγεγραμμένος ασφαλιστικός διαμεσολαβητής, άδεια …».",
    "field": {
      "licenceNumber": "Αριθμός άδειας",
      "licenceAuthority": "Αρχή αδειοδότησης",
      "licenceExpiry": "Λήξη άδειας"
    },
    "agency_name": "Γραφείο / εταιρεία",
    "agency_logo": "Λογότυπο γραφείου",
    "advisor_logo": "Δικό σας λογότυπο (προαιρετικό)",
    "advisor_logo_hint": "Εμφανίζεται δίπλα στο λογότυπο του γραφείου όταν διαφέρει.",
    "agency_admin_only": "Μόνο διαχειριστής μπορεί να αλλάξει το προφίλ του γραφείου.",
    "logo_hint": "PNG, JPG, WebP ή SVG έως 10 MB. Προσαρμόζεται, περικόπτεται και διατηρεί τις αναλογίες του αυτόματα — φαρδιά, τετράγωνα ή ψηλά λογότυπα ταιριάζουν όλα.",
    "upload": "Μεταφόρτωση",
    "replace": "Αντικατάσταση",
    "remove": "Αφαίρεση",
    "upload_logo": "Μεταφόρτωση λογοτύπου",
    "replace_logo": "Αντικατάσταση λογοτύπου",
    "remove_logo": "Αφαίρεση λογοτύπου",
    "processing": "Προετοιμασία…",
    "empty": {
      "logo": "Χωρίς λογότυπο",
      "photo": "Χωρίς φωτογραφία",
      "signature": "Χωρίς υπογραφή"
    },
    "image_error": {
      "too_large": "Η εικόνα ξεπερνά τα 10 MB.",
      "unsupported": "Χρησιμοποιήστε PNG, JPG, WebP, SVG ή GIF.",
      "unreadable": "Η εικόνα δεν διαβάστηκε.",
      "too_big_after": "Η εικόνα είναι πολύ λεπτομερής για αποθήκευση· δοκιμάστε απλούστερη ή μικρότερη εκδοχή."
    },
    "signature": "Εικόνα υπογραφής (όχι ηλεκτρονική υπογραφή)",
    "signature_hint": "Ανεβάστε σάρωση (το λευκό φόντο γίνεται διαφανές) ή σχεδιάστε την.",
    "draw": "Σχεδίαση",
    "draw_title": "Σχεδιάστε την υπογραφή σας",
    "draw_hint": "Με ποντίκι, γραφίδα ή δάχτυλο.",
    "clear": "Καθαρισμός",
    "use_signature": "Χρήση υπογραφής",
    "sign_off": "Κλείσιμο μηνυμάτων",
    "sign_off_hint": "Χρησιμοποιείται στο τέλος μηνυμάτων και επιστολών.",
    "mode": "Τρόπος ταυτότητας",
    "mode_opt": {
      "co": "Διπλή ταυτότητα",
      "advisor": "Πρώτα η δική μου",
      "vero": "Μόνο AVRASTRO"
    },
    "mode_hint": {
      "co": "Προηγούνται τα λογότυπά σας· το λογότυπο AVRASTRO εμφανίζεται δίπλα στον τίτλο και στο υποσέλιδο.",
      "advisor": "Μόνο τα λογότυπά σας στην κεφαλίδα· το «Με το AVRASTRO» μένει μικρό στο υποσέλιδο.",
      "vero": "Το λογότυπο AVRASTRO στην κεφαλίδα αντί για το δικό σας (το όνομα και τα στοιχεία σας παραμένουν)."
    },
    "show_photo": "Εμφάνιση φωτογραφίας",
    "show_signature": "Υπογραφή σε προτάσεις και επιστολές",
    "show_regulatory": "Εμφάνιση κανονιστικής δήλωσης",
    "accent": "Χρώμα έμφασης",
    "preview": "Προεπισκόπηση",
    "preview_note": "Το πραγματικό πρότυπο σε A4 — ακριβώς ό,τι εκτυπώνεται και περιέχουν τα PDF.",
    "powered": "Με το AVRASTRO",
    "prepared_with": "Με το",
    "sample": {
      "proposal": "Πρόταση",
      "review": "Ετήσια επανεξέταση",
      "letter": "Επιστολή",
      "proposal_title": "Πρόταση προστασίας",
      "review_title": "Ετήσια επανεξέταση",
      "letter_title": "Επιστολή",
      "client": "Κα Μαρία Παράδειγμα<br>Οδός Παραδείγματος 1, 1000 Πόλη",
      "letter_body": "Αγαπητή κα Παράδειγμα,<br><br>σας ευχαριστώ για τη συνάντησή μας. Όπως συμφωνήσαμε, επισυνάπτω τη σύνοψη της κάλυψής σας και τα επόμενα βήματα.",
      "situation": "Τετραμελής οικογένεια· ένα εισόδημα· στεγαστικό έως το 2041. Προτεραιότητα: προστασία εισοδήματος και ασφάλεια ζωής για το στεγαστικό.",
      "next": "Επόμενη επανεξέταση σε 12 μήνες."
    },
    "signature_note": "Εικόνα της χειρόγραφης υπογραφής σας, που τυπώνεται μόνο στα έγγραφα όπου επιλέγετε «Με την υπογραφή μου». Δεν είναι ηλεκτρονική ούτε εγκεκριμένη ηλεκτρονική υπογραφή — για έγγραφα που υπογράφει ηλεκτρονικά ο πελάτης χρησιμοποιήστε την Ηλεκτρονική υπογραφή. Μόνο εσείς τη βλέπετε, την εισάγετε, την αντικαθιστάτε ή τη διαγράφετε.",
    "signature_alt": "Εικόνα υπογραφής",
    "delete_signature": "Διαγραφή υπογραφής",
    "signature_replace_confirm": "Να αντικατασταθεί η εικόνα υπογραφής σας με τη νέα;",
    "signature_delete_confirm": "Διαγραφή της εικόνας υπογραφής σας; Αφαιρείται από το προφίλ σας σε κάθε συγχρονισμένη συσκευή και δεν μπορεί πλέον να εισαχθεί σε έγγραφα.",
    "signature_saved": "Η εικόνα υπογραφής αποθηκεύτηκε",
    "signature_replaced": "Η εικόνα υπογραφής αντικαταστάθηκε",
    "signature_deleted": "Η εικόνα υπογραφής διαγράφηκε"
  },
  "radar": {
    "title": "Ραντάρ ευκαιριών",
    "subtitle": "{count} ευκαιρίες στο χαρτοφυλάκιό σας — η καθεμία με την αιτία και το επόμενο βήμα.",
    "book": "χαρτοφυλάκιο {amount}",
    "empty": "Δεν υπάρχει πρόταση αυτή τη στιγμή.",
    "more": "Εμφάνιση {count} ακόμη",
    "note": "Μόνο προτάσεις: κάθε ενέργεια ανοίγει την κανονική φόρμα· τίποτα δεν στέλνεται ή δημιουργείται μόνο του. Όσοι είναι στη λίστα «χωρίς επικοινωνία» εξαιρούνται.",
    "kind": {
      "coverage_gap": "Κενά κάλυψης",
      "life_event": "Γεγονότα ζωής",
      "renewal_window": "Στιγμές ανανέωσης",
      "review_due": "Επανεξετάσεις",
      "decision_open": "Ανοιχτές αποφάσεις",
      "lapsed": "Επανενεργοποίηση",
      "dormant": "Πελάτες χωρίς επαφή",
      "referral_ask": "Ζητήστε συστάσεις",
      "family_uncovered": "Οικογένεια χωρίς κάλυψη",
      "tax_saving": "Φορολογικό όφελος",
      "premium_overdue": "Ληξιπρόθεσμα ασφάλιστρα",
      "cross_sell": "Ζωή ↔ γενικός κλάδος"
    },
    "why": {
      "coverage_gap": "Χρειάζεται κάλυψη {areas} που δεν υπάρχει.",
      "life_event": "{event} στις {date} — συνήθως χρειάζεται έλεγχος της προστασίας.",
      "renewal_window": "Το {product} ανανεώνεται σε {days} ημέρες — ιδανική στιγμή για συνολικό έλεγχο.",
      "review_overdue": "Η ετήσια επανεξέταση καθυστερεί {days} ημέρες.",
      "review_never": "Έχει συμβόλαια αλλά δεν έγινε ποτέ επανεξέταση.",
      "decision_open": "Το «{title}» περιμένει απόφαση εδώ και {days} ημέρες.",
      "lapsed": "Το {product} ακυρώθηκε τον τελευταίο χρόνο — αξίζει κλήση επανενεργοποίησης.",
      "dormant": "Καμία επαφή εδώ και {days} ημέρες.",
      "referral_ask": "Ισχυρή σχέση (υγεία {score}) και καμία σύσταση τον τελευταίο χρόνο.",
      "referral_after_review": "Πρόσφατη επανεξέταση με ικανοποίηση — καλή στιγμή να ζητήσετε σύσταση.",
      "family_uncovered": "Ο/Η {name} στο ίδιο νοικοκυριό δεν έχει δική του/της κάλυψη.",
      "tax_saving": "Μπορεί να εκπέσει ακόμη περίπου €{capacity} τον χρόνο σε ασφάλιστρα ({year}) — περίπου €{saving} λιγότερος φόρος.",
      "premium_overdue": "{product}: ένα ασφάλιστρο δεν έχει εισπραχθεί ({days} ημέρες) — ένα τηλεφώνημα κρατά την κάλυψη σε ισχύ.",
      "premium_lapse_risk": "{product}: ασφάλιστρο ληξιπρόθεσμο εδώ και {days} ημέρες — κίνδυνος ακύρωσης.",
      "cs_property_no_earthquake": "{item}: δεν υπάρχει συνδεδεμένο συμβόλαιο κατοικίας στο CRM — μια ερώτηση για κάλυψη σεισμού ίσως είναι χρήσιμη.",
      "cs_family_vehicle_no_life": "Οικογένεια με όχημα ({item}) χωρίς καταγεγραμμένη ασφάλεια ζωής — ίσως μια συζήτηση για την προστασία της οικογένειας.",
      "cs_mortgage_no_protection": "Το {item} έχει δάνειο και δεν καταγράφεται προστασία δανείου ή ζωής — ένας σύντομος έλεγχος ίσως βοηθήσει.",
      "cs_business_no_liability": "Η επιχείρηση {item} έχει προσωπικό χωρίς συνδεδεμένο συμβόλαιο ευθύνης — μια ερώτηση για ευθύνη εργοδότη ίσως είναι χρήσιμη."
    },
    "action": {
      "call": "Κλήση",
      "followup": "Επανάληψη",
      "appointment": "Ραντεβού",
      "proposal": "Ανάλυση & πρόταση",
      "campaign": "Καμπάνια",
      "message": "Πρόχειρο μηνύματος"
    }
  },
  "growth_a": {
    "title": "Αναλυτικά ανάπτυξης",
    "subtitle": "{from} – {to}: από πού έρχονται οι νέες εργασίες και πώς μετατρέπονται.",
    "period": {
      "month": "Αυτός ο μήνας",
      "quarter": "Τρίμηνο",
      "year": "Φέτος",
      "last12": "Τελευταίοι 12 μήνες"
    },
    "new_contacts": "Νέες επαφές",
    "new_clients": "Νέοι πελάτες",
    "conversion": "Μετατροπή",
    "conversion_hint": "νέες επαφές που έγιναν πελάτες",
    "issue_rate": "Ποσοστό έκδοσης",
    "issue_rate_hint": "εκδόθηκαν ÷ (εκδόθηκαν + απορρίφθηκαν/αποσύρθηκαν)",
    "avg_case": "Μέσο μέγεθος υπόθεσης",
    "avg_case_hint": "ασφάλιστρο εκδοθεισών αιτήσεων",
    "avg_policy": "Μέσο νέο συμβόλαιο",
    "avg_policy_hint": "ετήσιο ασφάλιστρο",
    "days_to_issue": "Ημέρες έως έκδοση",
    "pipeline": "Αξία pipeline",
    "pipeline_hint": "ανοιχτές ευκαιρίες, αναμενόμενο ασφάλιστρο",
    "weighted": "Σταθμισμένο pipeline",
    "weighted_hint": "ανά στάδιο: 10 · 25 · 50 · 75 %",
    "commission": "Προμήθεια",
    "commission_paid": "εισπράχθηκαν {amount}",
    "sources": "Πηγές νέων επαφών",
    "source_tip": "{contacts} επαφές · {clients} πελάτες · μετατροπή {conversion}",
    "sources_note": "Μπάρα: ετήσιο ασφάλιστρο πελατών από την πηγή (επαφές όταν δεν υπάρχουν ακόμη). Ποσοστό: μετατροπή.",
    "no_contacts": "Καμία νέα επαφή σε αυτή την περίοδο.",
    "cases": "Αιτήσεις",
    "started": "Ξεκίνησαν",
    "issued": "Εκδόθηκαν",
    "declined": "Απορρίφθηκαν / αποσύρθηκαν",
    "open_cases": "Ανοιχτές τώρα",
    "open_opps": "Ανοιχτές ευκαιρίες",
    "new_policies": "Νέα συμβόλαια",
    "referrals": "Συστάσεις",
    "ref_given": "Λήφθηκαν",
    "ref_converted": "Έγιναν επαφές",
    "ref_business": "Εργασίες από συστάσεις",
    "definitions": "Προκύπτουν από τις εγγραφές σας για την περίοδο· τίποτα δεν εκτιμάται. Εργασίες = ενεργό ετήσιο ασφάλιστρο σήμερα.",
    "source": {
      "referral": "Σύσταση",
      "website": "Ιστότοπος",
      "unknown": "Χωρίς καταγραφή",
      "campaign": "Καμπάνια",
      "social": "Μέσα κοινωνικής δικτύωσης",
      "event": "Εκδήλωση",
      "cold_call": "Τηλέφωνα στην τύχη",
      "walk_in": "Επίσκεψη στο γραφείο",
      "legacy": "Εισαγωγή",
      "friends_family": "Φιλικά & οικογενειακά πρόσωπα",
      "professional_network": "Επαγγελματικές γνωριμίες",
      "portfolio_transfer": "Μεταφορά χαρτοφυλακίου",
      "met_in_person": "Γνωριμία"
    }
  },
  "req": {
    "details": "Λεπτομέρειες",
    "status": "Κατάσταση",
    "waiting_on": "Αναμονή από",
    "requested_at": "Ζητήθηκε",
    "received_at": "Παραλήφθηκε",
    "expires_at": "Ισχύει έως",
    "expires_hint": "π.χ. ταυτότητα ή ιατρική έκθεση",
    "document": "Συνδεδεμένο έγγραφο",
    "label": "Περιγραφή",
    "complete": "Όλα τα απαιτούμενα έγγραφα παραλήφθηκαν",
    "status_opt": {
      "required": "Απαιτείται",
      "requested": "Ζητήθηκε",
      "received": "Παραλήφθηκε",
      "waived": "Δεν χρειάζεται",
      "expired": "Έληξε"
    },
    "waiting_opt": {
      "client": "Πελάτη",
      "insurer": "Ασφαλιστική",
      "advisor": "Εμένα"
    },
    "state": {
      "missing": "Λείπει",
      "requested": "Ζητήθηκε",
      "waiting_client": "Αναμονή πελάτη",
      "waiting_insurer": "Αναμονή ασφαλιστικής",
      "received": "Παραλήφθηκε",
      "waived": "Δεν χρειάζεται",
      "expired": "Έληξε"
    },
    "sum": {
      "received": "{count} παραλήφθηκαν",
      "missing": "{count} λείπουν",
      "waiting_client": "{count} αναμονή πελάτη",
      "waiting_insurer": "{count} αναμονή ασφαλιστικής",
      "expired": "{count} έληξαν"
    }
  },
  "checklist": {
    "title": "Λίστα εγγράφων",
    "manage": "Λίστες εγγράφων",
    "new": "Νέα λίστα",
    "intro": "Λίστες ανά ασφαλιστική και/ή κατηγορία προϊόντος. Όταν ξεκινά μια αίτηση προτείνεται η πιο συγκεκριμένη: ασφαλιστική + κατηγορία › ασφαλιστική › κατηγορία.",
    "name": "Όνομα",
    "insurer_hint": "Κενό για οποιαδήποτε ασφαλιστική",
    "category_hint": "Κενό για οποιοδήποτε προϊόν",
    "any": "Οποιαδήποτε ασφαλιστική και προϊόν",
    "items": "{count} στοιχεία",
    "add_item": "Προσθήκη στοιχείου",
    "mandatory": "Απαιτείται για ολοκλήρωση",
    "mandatory_short": "Απαιτείται",
    "optional": "προαιρετικό",
    "active": "Ενεργή",
    "inactive": "ανενεργή",
    "choose": "Προσθήκη λίστας…",
    "apply": "Προσθήκη",
    "applied": "Η λίστα προστέθηκε (μόνο όσα έλειπαν)",
    "fits": "ταιριάζει",
    "none_yet": "Δεν υπάρχουν ακόμη λίστες ασφαλιστικών.",
    "suggested": "Προτείνεται: {name}",
    "auto_named": "Αυτόματα: {name}",
    "auto_market": "Αυτόματα (προεπιλογή αγοράς)",
    "market_default": "Προεπιλογή αγοράς"
  },
  "referral": {
    "task_title": "Επικοινωνία με σύσταση"
  },
  "web": {
    "refresh": "Ανανέωση",
    "loading": "Φόρτωση…",
    "connect": "Σύνδεση λογαριασμού",
    "see_plans": "Δείτε τα πακέτα",
    "reason": {
      "signed_out": "Συνδέστε τον λογαριασμό σας στο avrastro.com για να λαμβάνετε όσα σας στέλνουν πελάτες μέσω του ιστότοπου.",
      "offline": "Είστε εκτός σύνδεσης. Αυτή η σελίδα χρειάζεται internet· ό,τι έχετε ήδη αποδεχθεί βρίσκεται στο CRM και λειτουργεί χωρίς σύνδεση.",
      "plan": "Το τρέχον πακέτο σας δεν το περιλαμβάνει. Αναβαθμίστε από το Advisor Hub."
    },
    "err": {
      "plan_feature": "Το τρέχον πακέτο σας δεν το περιλαμβάνει.",
      "licence_expired": "Η συνδρομή έληξε — ο χώρος είναι μόνο για ανάγνωση. Ανανεώστε από το Advisor Hub.",
      "portal_not_allowed": "Ο πελάτης δεν έχει επιτρέψει (ή δεν επιτρέπει πλέον) δημοσίευση στην πύλη του.",
      "title_required": "Προσθέστε τίτλο.",
      "not_found": "Δεν είναι πλέον διαθέσιμο.",
      "ai_not_configured": "Τα προσχέδια AI δεν έχουν ρυθμιστεί σε αυτόν τον διακομιστή.",
      "ai_allowance_used": "Εξαντλήθηκαν τα προσχέδια AI του μήνα. Προσθέστε περισσότερα από το Advisor Hub ή περιμένετε τον επόμενο μήνα.",
      "ai_unavailable": "Η υπηρεσία AI δεν απάντησε. Δοκιμάστε ξανά.",
      "ai_empty": "Η υπηρεσία AI δεν επέστρεψε κείμενο. Δοκιμάστε ξανά.",
      "input_required": "Γράψτε τις σημειώσεις για το προσχέδιο.",
      "network": "Δεν υπάρχει σύνδεση με την υπηρεσία AVRASTRO. Δοκιμάστε ξανά.",
      "permission": "Ο ρόλος σας δεν επιτρέπει αυτή την ενέργεια.",
      "website_unreachable": "Το avrastro.com δεν απάντησε. Δοκιμάστε ξανά σε λίγο· τίποτα δεν άλλαξε.",
      "website_error": "Το avrastro.com δεν ολοκλήρωσε την ενέργεια. Δοκιμάστε ξανά ή επιβεβαιώστε το ραντεβού από το Advisor Hub.",
      "website_not_linked": "Ο λογαριασμός σας στο avrastro.com δεν είναι συνδεδεμένος με αυτό το CRM.",
      "booking_state": "Το ραντεβού έχει ήδη αλλάξει στο avrastro.com (επιβεβαιώθηκε, απορρίφθηκε ή ακυρώθηκε). Ανανεώστε τη λίστα.",
      "action": "Μη έγκυρη ενέργεια."
    },
    "inbox": {
      "title": "Εισερχόμενα ιστότοπου",
      "subtitle": "Κοινοποιήσεις, αιτήματα ραντεβού και μηνύματα από το avrastro.com. Τίποτα δεν μπαίνει στο CRM χωρίς την αποδοχή σας.",
      "tab": {
        "open": "Προς έλεγχο",
        "all": "Όλα"
      },
      "empty": "Τίποτα προς έλεγχο. Νέες κοινοποιήσεις, ραντεβού και μηνύματα από το avrastro.com εμφανίζονται εδώ.",
      "empty_all": "Δεν υπάρχουν ακόμη εγγραφές.",
      "kind": {
        "share": "Κοινοποιημένες αναφορές",
        "booking": "Αίτημα ραντεβού",
        "lead": "Μήνυμα"
      },
      "status": {
        "accepted": "Αποδεκτό",
        "declined": "Απορρίφθηκε",
        "archived": "Αρχειοθετήθηκε",
        "revoked": "Ανακλήθηκε από τον πελάτη",
        "expired": "Η κοινοποίηση έληξε"
      },
      "mode": {
        "office": "στο γραφείο",
        "online": "online",
        "phone": "τηλεφωνικά",
        "cafe": "σε καφέ",
        "client_place": "στον χώρο του πελάτη",
        "video": "βιντεοκλήση"
      },
      "booking": {
        "requested": "ζητήθηκε",
        "confirmed": "επιβεβαιώθηκε",
        "declined": "απορρίφθηκε",
        "cancelled": "ακυρώθηκε",
        "cancelled_by_client": "ακυρώθηκε από τον πελάτη",
        "completed": "ολοκληρώθηκε"
      },
      "received": "παραλήφθηκε {when}",
      "share_line": "{n, plural, one {# αναφορά} other {# αναφορές}} έως {until}",
      "portal_allowed": "επιτρέπεται η πύλη πελάτη",
      "show_results": "Εμφάνιση αποτελεσμάτων",
      "matches": "Ταιριάζει με {name} στο CRM σας.",
      "accept_link": "Αποδοχή στον/στην {name}",
      "accept_new": "Αποδοχή ως νέος υποψήφιος",
      "accept_lead": "Αποδοχή ως νέα επαφή",
      "other_person": "Άλλο πρόσωπο…",
      "existing_person": "Σύνδεση με υπάρχον πρόσωπο",
      "link": "Σύνδεση",
      "decline": "Απόρριψη",
      "decline_confirm": "Απόρριψη; Το AVRASTRO δεν ειδοποιεί τον αποστολέα· τίποτα δεν προστίθεται στο CRM.",
      "declined": "Απορρίφθηκε.",
      "accepted": "Ο/Η {name} είναι πλέον στο CRM σας.",
      "open_person": "Άνοιγμα στο CRM",
      "booking_changed": "Ο πελάτης άλλαξε αυτό το ραντεβού στο avrastro.com.",
      "cancel_appointment": "Ακύρωση στην ατζέντα",
      "cancelled_on_site": "Ακυρώθηκε στο avrastro.com",
      "appointment_cancelled": "Το ραντεβού ακυρώθηκε στην ατζέντα σας.",
      "withdrawal_revoked": "Ανακλήθηκε από τον πελάτη στο avrastro.com",
      "withdrawal_expired": "Έληξε η περίοδος κοινοποίησης στο avrastro.com",
      "withdrawals": "{n, plural, one {Καταγράφηκε # ανάκληση} other {Καταγράφηκαν # ανακλήσεις}} στο ιστορικό συγκαταθέσεων.",
      "note_share": "Κοινοποίηση μέσω avrastro.com: {purpose}",
      "task_share": "Έλεγχος όσων κοινοποίησε ο/η {name}",
      "task_booking": "Αίτημα ραντεβού από το avrastro.com{topic}",
      "via_site": "μέσω {site}",
      "note_lead": "Μήνυμα από το avrastro.com{topic}",
      "task_lead": "Απάντηση στον/στην {name}",
      "scope": "Κοινοποίηση avrastro.com {ref}: {n} αναφορά(ές)· στοιχεία: {fields}· πύλη πελάτη: {portal}· έως {until}",
      "privacy": "Το περιεχόμενο που κοινοποιείται φυλάσσεται στην υπηρεσία AVRASTRO μόνο όσο το επιτρέπει ο πελάτης. Όσα αποδέχεστε γίνονται εγγραφές του CRM υπό τον έλεγχό σας. Ενημέρωση",
      "task_callback": "Κλήση στον/στην {name}{topic}",
      "callback": "Αίτημα κλήσης",
      "best_time": {
        "morning": "πρωί",
        "midday": "μεσημέρι",
        "afternoon": "απόγευμα"
      },
      "shared_policies": "Συμβόλαια από τον φάκελο του πελάτη",
      "policy_renews": "Ανανέωση",
      "policy_sum": "Ασφαλισμένο ποσό",
      "policy_premium": "Ασφάλιστρο",
      "opinion_file": "Προσφορά για δεύτερη γνώμη",
      "opinion_open": "Άνοιγμα αρχείου (avrastro.com)",
      "opinion_closed": "το αρχείο δεν είναι πια διαθέσιμο",
      "opinion_until": "διαθέσιμο έως {date}"
    },
    "portal": {
      "title": "Πύλη πελάτη",
      "subtitle": "Ό,τι δημοσιεύετε στην ιδιωτική σελίδα των πελατών στο avrastro.com. Μόνο για όσους το επέτρεψαν· εσείς αποφασίζετε τι βλέπουν.",
      "empty": "Κανένας πελάτης δεν έχει επιτρέψει ακόμη δημοσιεύσεις. Ο πελάτης το επιτρέπει όταν σας κοινοποιεί αναφορές στο avrastro.com.",
      "allowed_until": "Επιτρέπεται έως {date}",
      "publish": "Δημοσίευση",
      "publish_to": "Δημοσίευση στον/στην {name}",
      "withdraw": "Απόσυρση",
      "withdraw_confirm": "Απόσυρση; Ο πελάτης δεν θα το βλέπει πλέον.",
      "withdrawn": "Αποσύρθηκε",
      "read": "Διαβάστηκε {date}",
      "unread": "Δεν διαβάστηκε ακόμη",
      "published": "Δημοσιεύθηκε στην πύλη του πελάτη.",
      "kind": {
        "summary": "Σύνοψη ασφαλίσεων",
        "review": "Σύνοψη ανασκόπησης",
        "document_request": "Απαιτούμενα έγγραφα",
        "appointment": "Ραντεβού",
        "note": "Σημείωση"
      },
      "kind_label": "Τύπος",
      "title_label": "Τίτλος",
      "body_label": "Μήνυμα",
      "body_hint": "Γραμμένο για τον πελάτη. Οι εσωτερικές σημειώσεις δεν δημοσιεύονται ποτέ.",
      "sections": "Γραμμές (ετικέτα · τιμή)",
      "prefill": "Συμπλήρωση από τα συμβόλαια",
      "prefill_title": "Οι τρέχουσες ασφαλίσεις σας",
      "add_line": "Προσθήκη γραμμής",
      "line_label": "Ετικέτα",
      "line_value": "Τιμή",
      "year": "έτος",
      "renews": "ανανέωση {date}",
      "note": "Δημοσιεύθηκε στην πύλη πελάτη: {title}",
      "publish_note": "Ο πελάτης το βλέπει στην ιδιωτική του σελίδα στο avrastro.com και δεν λαμβάνει άλλα δεδομένα από το CRM σας. Μπορείτε να το αποσύρετε οποτεδήποτε.",
      "privacy": "Τα στοιχεία της πύλης φυλάσσονται κρυπτογραφημένα στην υπηρεσία AVRASTRO και εμφανίζονται μόνο στον συνδεδεμένο πελάτη, όσο σας το επιτρέπει."
    },
    "drafts": {
      "title": "Προσχέδια AI",
      "subtitle": "Προσχέδια μηνυμάτων, συνόψεων, σημειώσεων συνάντησης και ατζέντας ανασκόπησης — τα ελέγχετε και τα διορθώνετε πριν τη χρήση.",
      "kind": {
        "message": "Μήνυμα προς πελάτη",
        "summary": "Σύνοψη πελάτη",
        "meeting": "Σημειώσεις συνάντησης → ενέργειες",
        "review": "Ατζέντα ετήσιας ανασκόπησης"
      },
      "kind_label": "Τι να γραφτεί",
      "input": "Οι σημειώσεις σας",
      "input_hint": "Μόνο γεγονότα. Αποφύγετε αριθμούς ταυτότητας και στοιχεία υγείας αν δεν χρειάζονται.",
      "run": "Προσχέδιο",
      "working": "Γράφεται…",
      "usage": "{used} από {allowance} προσχέδια αυτόν τον μήνα",
      "not_configured": "Τα προσχέδια AI δεν έχουν ρυθμιστεί ακόμη σε αυτόν τον διακομιστή (ο ιδιοκτήτης προσθέτει κλειδί API).",
      "privacy": "Οι σημειώσεις σας αποστέλλονται στον πάροχο AI μόνο για αυτό το προσχέδιο· το AVRASTRO δεν τις αποθηκεύει, ούτε το προσχέδιο, στον διακομιστή.",
      "result": "Προσχέδιο",
      "empty": "Το προσχέδιο εμφανίζεται εδώ.",
      "review": "Ελέγξτε κάθε στοιχείο, ποσό και δέσμευση πριν την αποστολή — το AI μπορεί να κάνει λάθη. Τίποτα δεν αποστέλλεται αυτόματα.",
      "copy": "Αντιγραφή",
      "copied": "Αντιγράφηκε.",
      "save_note": "Αποθήκευση ως σημείωση"
    },
    "booking": {
      "who_title": "Επιβεβαιωμένο ραντεβού από το avrastro.com",
      "confirm_title": "Επιβεβαίωση ραντεβού",
      "question": "Είναι ήδη πελάτης σας ή κάποιος νέος; Διαλέξτε, για να μπει το ραντεβού στην ατζέντα και να ανοίξει η καρτέλα του για προετοιμασία.",
      "confirm_question": "Είναι ήδη πελάτης σας ή κάποιος νέος; Με την επιλογή σας το ραντεβού επιβεβαιώνεται στο avrastro.com, ο πελάτης λαμβάνει την πλήρη επιβεβαίωση και το ραντεβού μπαίνει στην ατζέντα σας.",
      "found_email": "Βρέθηκε στο CRM σας: {name} (ίδιο email).",
      "found_phone": "Βρέθηκε στο CRM σας: {name} (ίδιο τηλέφωνο).",
      "not_found": "Δεν βρέθηκε κανείς στο CRM σας με αυτό το email ή τηλέφωνο.",
      "is_match": "Ναι, είναι ο/η {name}",
      "existing": "Υπάρχων πελάτης — διαλέγω από τη λίστα",
      "new_prospect": "Νέος/νέα — υποψήφιος πελάτης",
      "later": "Αργότερα",
      "note": "Μένει στα «Εισερχόμενα ιστότοπου» μέχρι να επιλέξετε.",
      "confirm_note": "Ο πελάτης λαμβάνει email με ημέρα, ώρα, διεύθυνση, χάρτη, τι να φέρει και τα στοιχεία επικοινωνίας σας.",
      "done": "Το ραντεβού μπήκε στην ατζέντα σας.",
      "done_confirmed": "Επιβεβαιώθηκε· ο πελάτης ενημερώθηκε και το ραντεβού μπήκε στην ατζέντα σας.",
      "task_confirmed": "Ραντεβού (avrastro.com){topic}",
      "confirm": "Επιβεβαίωση ραντεβού",
      "decline": "Απόρριψη αιτήματος",
      "decline_confirm": "Να απορριφθεί το αίτημα; Ο πελάτης θα λάβει email ότι η ώρα δεν είναι διαθέσιμη και μπορεί να διαλέξει άλλη.",
      "declined": "Το αίτημα απορρίφθηκε και ο πελάτης ενημερώθηκε.",
      "confirmed_hint": "Επιβεβαιώθηκε στο avrastro.com — συνδέστε το με πελάτη για να μπει στην ατζέντα."
    }
  },
  "groups": {
    "title": "Ομαδικά σχέδια",
    "subtitle": "Σχέδια εργοδοτών — ομαδικά ιατροφαρμακευτικά, ζωής, ταμεία προνοίας και ατυχημάτων — με το μητρώο μελών.",
    "new": "Νέο ομαδικό σχέδιο",
    "empty": "Δεν υπάρχουν ακόμη ομαδικά σχέδια. Προσθέστε σχέδιο εργοδότη για να έχετε μητρώο, ασφάλιστρο και ανανέωση σε ένα σημείο.",
    "not_found": "Αυτό το ομαδικό σχέδιο δεν υπάρχει πλέον.",
    "scheme": "Σχέδιο",
    "category": "Κατηγορία",
    "members": "Μέλη",
    "annual": "Ετήσιο ασφάλιστρο",
    "renewal": "Ανανέωση",
    "in_days": "σε {days} ημ.",
    "overdue": "εκπρόθεσμη",
    "cat": {
      "life": "Ομαδική ζωής",
      "medical": "Ομαδική ιατροφαρμακευτική",
      "pension": "Συνταξιοδοτικό / ταμείο προνοίας",
      "accident": "Ομαδική ατυχημάτων",
      "mixed": "Μικτό",
      "other": "Άλλο"
    },
    "status": {
      "quote": "Προσφορά",
      "active": "Ενεργό",
      "renewing": "Σε ανανέωση",
      "ended": "Έληξε"
    },
    "filter": {
      "active": "Ενεργά",
      "pending": "Εντάσσονται",
      "left": "Αποχώρησαν",
      "all": "Όλα"
    },
    "field": {
      "displayName": "Ονοματεπώνυμο",
      "firstName": "Όνομα",
      "lastName": "Επώνυμο",
      "birthDate": "Ημ. γέννησης",
      "email": "E-mail",
      "phone": "Τηλέφωνο",
      "employeeNo": "Αρ. μητρώου",
      "class": "Κατηγορία",
      "joinDate": "Ένταξη",
      "leaveDate": "Αποχώρηση",
      "dependants": "Εξαρτώμενοι"
    },
    "export": "Εξαγωγή μητρώου",
    "import": "Εισαγωγή μητρώου",
    "add_member": "Προσθήκη μέλους",
    "active": "Ενεργά μέλη",
    "pending": "Εντάσσονται",
    "dependants": "Εξαρτώμενοι",
    "avg_age": "Μέση ηλικία",
    "split": "Ο εργοδότης πληρώνει {employer} ({share}%), τα μέλη {members}.",
    "changes_soon": "Επόμενες 30 ημέρες: {joining} εντάσσονται, {leaving} αποχωρούν.",
    "missing_birth": "{n, plural, one {# μέλος δεν έχει} other {# μέλη δεν έχουν}} ημερομηνία γέννησης — οι ασφαλιστές συνήθως τη ζητούν.",
    "classes": "Κατηγορίες",
    "class_line": "{n, plural, one {# μέλος} other {# μέλη}}",
    "no_members": "Δεν υπάρχουν ακόμη μέλη.",
    "contact": "Υπεύθυνος επικοινωνίας",
    "renewal_task_create": "Δημιουργία υπενθύμισης ανανέωσης",
    "renewal_task": "Ανανέωση ομαδικού: {name}",
    "renewal_task_done": "Δημιουργήθηκε υπενθύμιση ανανέωσης.",
    "not_clients": "Δεν είναι ακόμη ατομικοί πελάτες ({n})",
    "not_clients_note": "Κάθε μέλος είναι πιθανή συζήτηση συμβουλευτικής (ατομική κάλυψη, οικογένεια, αποταμίευση). Δεν τους αποστέλλεται τίποτα.",
    "all_clients": "Όλα τα ενεργά μέλη είναι ήδη πελάτες.",
    "make_prospect": "Προσθήκη ως υποψήφιος",
    "prospect_created": "Ο/Η {name} προστέθηκε ως υποψήφιος.",
    "left_on": "αποχώρησε {date}",
    "mark_left": "Σήμανση αποχώρησης",
    "left": "Καταγράφηκε η αποχώρηση — το ιστορικό διατηρείται.",
    "employer": "Εργοδότης",
    "scheme_name": "Όνομα σχεδίου",
    "carrier": "Ασφαλιστική",
    "policy_number": "Αρ. συμβολαίου",
    "start": "Έναρξη",
    "premium_model": "Ασφάλιστρο",
    "per_member": "Ανά μέλος ανά έτος",
    "total": "Συνολικό ανά έτος",
    "premium_per_member": "€ ανά μέλος / έτος",
    "total_premium": "Σύνολο € / έτος",
    "employer_share": "Συμμετοχή εργοδότη",
    "vat": "Αρ. ΦΠΑ / ΑΦΤ εργοδότη",
    "add_class": "Προσθήκη κατηγορίας",
    "class_name": "Κατηγορία (π.χ. Διεύθυνση)",
    "benefits": "Παροχές (π.χ. Σχέδιο Α, παγκόσμια κάλυψη)",
    "individual": "Ατομική εγγραφή πελάτη",
    "individual_hint": "Σύνδεση του μέλους με τη δική του εγγραφή στο CRM (προαιρετικό).",
    "import_title": "Εισαγωγή μητρώου — {name}",
    "import_intro": "Χρησιμοποιήστε το αρχείο του εργοδότη ή της ασφαλιστικής (CSV ή Excel) ή επικολλήστε τις γραμμές. Θα δείτε το αποτέλεσμα κάθε γραμμής πριν αποθηκευτεί οτιδήποτε.",
    "import_file": "Επιλογή αρχείου",
    "import_paste": "…ή επικολλήστε γραμμές εδώ (με γραμμή επικεφαλίδων)",
    "import_unreadable": "Το αρχείο δεν διαβάζεται. Αποθηκεύστε το ως CSV ή .xlsx και δοκιμάστε ξανά.",
    "import_leavers": "Όσα μέλη λείπουν από το αρχείο αποχώρησαν",
    "import_summary": "{add} νέα · {update} ενημερώσεις · {skip} παραλείπονται",
    "import_new_classes": "νέες κατηγορίες: {names}",
    "import_leaving": "{n} αποχωρούν",
    "import_apply": "Εισαγωγή {add} νέων, ενημέρωση {update}",
    "import_done": "Το μητρώο εισήχθη: {add} νέα, {update} ενημερώσεις.",
    "import_again": "Άλλο αρχείο",
    "import_action": {
      "add": "Νέο",
      "update": "Ενημέρωση",
      "skip": "Παράλειψη"
    },
    "problem": {
      "name_missing": "χωρίς όνομα",
      "birthDate_invalid": "μη έγκυρη ημ. γέννησης",
      "joinDate_invalid": "μη έγκυρη ημ. ένταξης",
      "leaveDate_invalid": "μη έγκυρη ημ. αποχώρησης",
      "dependants_invalid": "οι εξαρτώμενοι δεν είναι αριθμός",
      "duplicate_in_file": "διπλή γραμμή στο αρχείο"
    },
    "locked": "Τα ομαδικά σχέδια περιλαμβάνονται στα Professional και Team. Τα υπάρχοντα σχέδιά σας παραμένουν διαθέσιμα για ανάγνωση και εξαγωγή."
  },
  "save": {
    "short_saved": "Αποθηκεύτηκε",
    "short_volatile": "Δεν αποθηκεύεται",
    "short_error": "Σφάλμα αποθήκευσης",
    "short_offline": "Χωρίς σύνδεση",
    "auto": "Κάθε αλλαγή αποθηκεύεται αυτόματα σε αυτή τη συσκευή καθώς δουλεύετε.",
    "saved_at": "Αποθηκεύτηκε σε αυτή τη συσκευή {time}",
    "volatile": "Δεν αποθηκεύεται: ο browser δεν επέτρεψε τοπική αποθήκευση, άρα τίποτα δεν θα μείνει μετά το κλείσιμο. Χρησιμοποιήστε Chrome ή Edge σε κανονικό (όχι ιδιωτικό) παράθυρο.",
    "error": "Η τελευταία αλλαγή δεν αποθηκεύτηκε στη συσκευή. Κάντε εξαγωγή αντιγράφου και ελέγξτε τον ελεύθερο χώρο.",
    "offline": "Χωρίς internet: ό,τι είναι σε αυτή τη συσκευή δουλεύει κανονικά· οι online λειτουργίες περιμένουν τη σύνδεση.",
    "backup_never": "Δεν έχει γίνει ακόμη αρχείο αντιγράφου ασφαλείας σε αυτή τη συσκευή.",
    "backup_due": "Τελευταίο αρχείο αντιγράφου πριν από {days} ημέρες."
  },
  "protect": {
    "title": "Πού βρίσκονται τα δεδομένα σας και πώς προστατεύονται",
    "personal_edition": "Προσωπική offline έκδοση",
    "volatile": "Δεν αποθηκεύεται — λειτουργεί μόνο στη μνήμη. Μην κλείσετε τίποτα πριν κάνετε εξαγωγή αντιγράφου, και ανοίξτε το AVRASTRO σε Chrome ή Edge σε κανονικό παράθυρο.",
    "native": "Αποθηκεύεται στο αρχείο βάσης δεδομένων της εφαρμογής σε αυτόν τον υπολογιστή, καθώς δουλεύετε.",
    "browser": "Αποθηκεύεται στον χώρο αυτού του browser σε αυτόν τον υπολογιστή, καθώς δουλεύετε. Άλλος browser ή άλλος υπολογιστής δεν το βλέπει — μεταφέρεται με αρχείο αντιγράφου.",
    "persisted": "Ο browser το κρατά μόνιμα (δεν το σβήνει για να ελευθερώσει χώρο).",
    "not_persisted": "Ο browser μπορεί να το σβήσει αν ο δίσκος γεμίσει πολύ — κρατάτε αρχεία αντιγράφων.",
    "encrypted": "Κρυπτογραφημένο σε αυτή τη συσκευή με τη φράση σας (AES-256-GCM). Το AVRASTRO τη ζητά σε κάθε άνοιγμα.",
    "not_encrypted": "Δεν είναι κρυπτογραφημένο από το AVRASTRO: όποιος χρησιμοποιεί αυτόν τον λογαριασμό υπολογιστή μπορεί να το ανοίξει. Χρησιμοποιήστε κρυπτογράφηση δίσκου και φράση πρόσβασης.",
    "turn_on": "Ενεργοποίηση κρυπτογράφησης",
    "snapshots": "Αυτόματα αντίγραφα επαναφοράς: ένα κάθε 12 ώρες όταν υπάρχει αλλαγή, κρατιούνται τα 7 πιο πρόσφατα σε αυτή τη συσκευή.",
    "last_auto": "Τελευταίο: {time}.",
    "backup_never": "Δεν έχει γίνει ακόμη αρχείο αντιγράφου ασφαλείας σε αυτή τη συσκευή.",
    "backup_age": "Τελευταίο αρχείο αντιγράφου: πριν από {days} ημέρες.",
    "backup_why": "Το αρχείο αντιγράφου είναι το αντίγραφό σας έξω από τον browser — κρατάτε ένα κάθε εβδομάδα σε USB ή σε φάκελο cloud.",
    "online": "Με σύνδεση.",
    "offline": "Χωρίς σύνδεση.",
    "network_needed": "Χωρίς internet όλα εδώ λειτουργούν· σύνδεση χρειάζονται μόνο η είσοδος στον λογαριασμό, ο συγχρονισμός, τα εισερχόμενα ιστότοπου, το client portal και τα προσχέδια AI."
  },
  "register": {
    "title": "Λίστα πελατών",
    "subtitle": "Όλοι οι πελάτες σας, με το πότε έγιναν πελάτες και από πού ήρθαν. Εκτυπώστε, εξάγετε ή συμπληρώστε ό,τι λείπει.",
    "who": "Ποιοι",
    "who_clients": "Πελάτες",
    "who_with_former": "Πελάτες και πρώην πελάτες",
    "who_all": "Όλοι, και οι υποψήφιοι",
    "source_all": "Όλες οι πηγές",
    "from": "Πελάτης από: από",
    "to": "έως",
    "sort": "Ταξινόμηση",
    "sort_name": "Όνομα",
    "sort_since": "Πελάτης από",
    "sort_source": "Πηγή",
    "group": "Ομαδοποίηση ανά πηγή",
    "contact": "Τηλέφωνο και e-mail",
    "portfolio": "Συμβόλαια και ασφάλιστρα",
    "count": "{count, plural, one {# πελάτης} other {# πελάτες}}",
    "by_source": "Ανά πηγή",
    "by_year": "Νέοι πελάτες ανά έτος",
    "col_no": "Α/Α",
    "col_name": "Πελάτης",
    "col_phone": "Τηλέφωνο",
    "col_email": "E-mail",
    "col_since": "Πελάτης από",
    "col_source": "Πηγή",
    "col_referred": "Σύσταση από",
    "col_policies": "Ενεργά συμβόλαια",
    "col_premium": "Ετήσιο ασφάλιστρο",
    "col_year": "Έτος",
    "col_clients": "Πελάτες",
    "col_share": "Ποσοστό",
    "col_stage": "Στάδιο",
    "print": "Εκτύπωση",
    "csv": "Εξαγωγή CSV (Excel)",
    "fill": "Συμπλήρωση πηγής και ημερομηνίας",
    "fill_done": "Τέλος",
    "missing": "{source} χωρίς καταγεγραμμένη πηγή · {since} χωρίς καταγεγραμμένη ημερομηνία «Πελάτης από»",
    "note_first_policy": "¹ ημερομηνία πρώτου συμβολαίου — δεν έχει καταχωριστεί «Πελάτης από»",
    "note_added": "² ημερομηνία καταχώρισης στο AVRASTRO — δεν έχει καταχωριστεί «Πελάτης από»",
    "empty": "Κανένας πελάτης με αυτά τα φίλτρα.",
    "saved": "Αποθηκεύτηκε",
    "filters": "Φίλτρα: {list}",
    "total": "Σύνολο",
    "exported": "Η λίστα πελατών εξήχθη",
    "basis": "Βάση ημερομηνίας"
  },
  "payslip": {
    "title": "Μισθοδοσία → φόρος",
    "open": "Μισθοδοσία → φόρος",
    "intro": "Ανεβάστε μία ή περισσότερες μισθοδοσίες (PDF). Διαβάζονται σε αυτόν τον υπολογιστή — τίποτα δεν αποστέλλεται. Ελέγχετε κάθε ποσό πριν αποθηκευτεί οτιδήποτε.",
    "choose": "Επιλογή PDF μισθοδοσίας",
    "stored": "Μισθοδοσίες που υπάρχουν ήδη στα έγγραφα του πελάτη",
    "read": "Ανάγνωση μισθοδοσιών",
    "reading": "Ανάγνωση…",
    "add_more": "Προσθήκη μισθοδοσιών",
    "manual": "Χειροκίνητη καταχώριση",
    "person_first": "Διαλέξτε πρώτα πελάτη.",
    "period": "Περίοδος",
    "employer": "Εργοδότης",
    "unknown_period": "δεν βρέθηκε περίοδος",
    "k": {
      "gross": "Μικτές αποδοχές",
      "basic": "Βασικός μισθός",
      "allowances": "Επιδόματα & πρόσθετα",
      "thirteenth": "13ος μισθός",
      "si": "Κοινωνικές Ασφαλίσεις",
      "ghs": "ΓεΣΥ",
      "provident": "Ταμείο Προνοίας",
      "pension": "Ταμείο Συντάξεων",
      "medical": "Ιατροφαρμακευτικό ταμείο",
      "union": "Συντεχνία / επαγγελματικός σύνδεσμος",
      "tax": "Φόρος εισοδήματος που παρακρατήθηκε",
      "otherDeductions": "Άλλες κρατήσεις",
      "deductionsTotal": "Σύνολο κρατήσεων",
      "net": "Καθαρές αποδοχές"
    },
    "from_line": "Από τη γραμμή: «{line}»",
    "derived": "υπολογίστηκε από τις αποδοχές",
    "not_found": "δεν βρέθηκε",
    "alternatives": "Βρέθηκαν επίσης: {list}",
    "check_ok": "Αθροίζει σωστά: μικτές − κρατήσεις = καθαρές.",
    "check_diff": "Δεν αθροίζει — διαφορά {amount}. Ελέγξτε τα ποσά.",
    "check_unknown": "Δεν βρέθηκαν καθαρές αποδοχές — ελέγξτε τα ποσά.",
    "warn": {
      "no_text": "Το PDF είναι σκαναρισμένο (εικόνα) και δεν έχει κείμενο για ανάγνωση. Πληκτρολογήστε τα ποσά από τη μισθοδοσία.",
      "no_gross": "Δεν βρέθηκαν μικτές αποδοχές.",
      "no_si": "Δεν βρέθηκαν Κοινωνικές Ασφαλίσεις.",
      "no_period": "Δεν βρέθηκε η περίοδος μισθοδοσίας.",
      "net_mismatch": "Μικτές − κρατήσεις δεν ισούται με τις καθαρές.",
      "unidentified_deductions": "Κάποιες κρατήσεις του συνόλου δεν αναγνωρίστηκαν· μετρούν ως «άλλες κρατήσεις»."
    },
    "error": {
      "not_pdf": "Δεν είναι αρχείο PDF.",
      "password": "Το PDF έχει κωδικό. Ανοίξτε το, αποθηκεύστε αντίγραφο χωρίς κωδικό και δοκιμάστε ξανά.",
      "damaged": "Το PDF δεν μπόρεσε να διαβαστεί."
    },
    "year_settings": "Το έτος",
    "salaries": "Μισθοί τον χρόνο",
    "salaries_hint": "Διαλέξτε 13 αν ο πελάτης παίρνει 13ο μισθό.",
    "tax_year": "Φορολογικό έτος",
    "children": "Παιδιά",
    "household_income": "Εισόδημα νοικοκυριού (προαιρετικό)",
    "life_policies": "Ασφαλίσεις ζωής που μετρούν",
    "no_life": "Δεν υπάρχει ενεργή ασφάλεια ζωής στο AVRASTRO.",
    "result": "Αποτέλεσμα",
    "annual_gross": "Ετήσιες μικτές",
    "contributions": "Εκπιπτόμενες εισφορές σήμερα",
    "cap": "Όριο (1/5 του εισοδήματος)",
    "capacity": "Περιθώριο για εκπιπτόμενα ασφάλιστρα",
    "per_month": "≈ {amount} τον μήνα",
    "tax_estimate": "Εκτιμώμενος φόρος εισοδήματος {year}",
    "effective": "πραγματικός συντελεστής {rate}",
    "withheld": "Παρακρατείται στις μισθοδοσίες (ετησίως)",
    "withheld_diff_over": "Παρακρατούνται περίπου {amount} περισσότερα από την εκτίμηση — πιθανή επιστροφή μετά τη φορολογική δήλωση.",
    "withheld_diff_under": "Παρακρατούνται περίπου {amount} λιγότερα από την εκτίμηση — πιθανός φόρος προς πληρωμή μετά τη δήλωση.",
    "withheld_ok": "Η παρακράτηση συμφωνεί με την εκτίμηση.",
    "saving": "Αν αξιοποιηθεί όλο το περιθώριο (≈ {monthly}/μήνα σε εκπιπτόμενα ασφάλιστρα), η εξοικονόμηση φόρου είναι περίπου {saving} τον χρόνο με οριακό συντελεστή {rate}.",
    "no_capacity": "Οι εκπιπτόμενες εισφορές φτάνουν ήδη το όριο — δεν υπάρχει επιπλέον φορολογικό όφελος από ασφάλιστρα.",
    "unavailable": "Δεν υπάρχουν φορολογικοί κανόνες για το {year}: {reason}",
    "save": "Αποθήκευση στον πελάτη",
    "saved": "Η ανάλυση μισθοδοσίας αποθηκεύτηκε",
    "follow_up": "Δημιουργία εργασίας για πρόταση φοροαπαλλαγής",
    "follow_up_title": "Πρόταση φοροαπαλλαγής: έως {amount}/έτος εκπιπτόμενα ασφάλιστρα",
    "print": "Εκτύπωση",
    "share": "Αποστολή στον πελάτη",
    "store_note": "Οι μισθοδοσίες αποθηκεύονται στα έγγραφα του πελάτη ως περιορισμένης πρόσβασης (οι βοηθοί δεν τις βλέπουν).",
    "doc_title": "Μισθοδοσία {period}",
    "print_title": "Ανάλυση μισθοδοσίας και φόρου",
    "disclaimer": "Εκτίμηση για συμβουλευτική συζήτηση, με βάση τις μισθοδοσίες και τους φορολογικούς κανόνες που αναφέρονται — δεν αποτελεί φορολογική συμβουλή. Ο τελικός φόρος προκύπτει από τη φορολογική δήλωση.",
    "months_used": "{count, plural, one {# μισθοδοσία} other {# μισθοδοσίες}}",
    "annual_basis": "τυπικός μήνας × {n}",
    "col_file": "Μισθοδοσία",
    "payslips": "Μισθοδοσίες",
    "ask_client": "Ζητήστε μισθοδοσίες από τον πελάτη",
    "change": {
      "salary_increase": "Αύξηση μισθού {pct}% από την προηγούμενη μισθοδοσία ({from} → {to}). Με την αποθήκευση καταγράφεται γεγονός ζωής «αύξηση μισθού» και επανεξέταση κάλυψης.",
      "new_job": "Νέος εργοδότης από την προηγούμενη μισθοδοσία. Με την αποθήκευση καταγράφεται γεγονός ζωής «νέα εργασία» και επανεξέταση κάλυψης."
    }
  },
  "share": {
    "open": "Αποστολή στον πελάτη",
    "title": "Αποστολή στον/στην {name}",
    "what": "Τι θα σταλεί",
    "message": "Μήνυμα",
    "to": "Προς:",
    "preview": "Προεπισκόπηση",
    "chars": "χαρακτήρες",
    "privacy": "Περιέχει προσωπικά και οικονομικά στοιχεία — ελέγξτε τον παραλήπτη πριν το στείλετε.",
    "nothing": "δεν υπάρχει ακόμη κάτι",
    "how": "Το AVRASTRO ανοίγει τη δική σας εφαρμογή με έτοιμο μήνυμα· εσείς πατάτε αποστολή. Κάθε αποστολή καταγράφεται στο ιστορικό του πελάτη.",
    "copied": "Αντιγράφηκε — επικολλήστε το σε όποια εφαρμογή θέλετε.",
    "ics": "Αρχείο ημερολογίου",
    "subject": "Πληροφορίες για {name}",
    "log_subject": "Αποστολή μέσω {channel}",
    "intro_default": "Καλησπέρα {name}, όπως συζητήσαμε, σας στέλνω τα στοιχεία για τις ασφαλίσεις σας:",
    "item": {
      "summary": "Σύντομη σύνοψη",
      "policies": "Συμβόλαια και ασφάλιστρα",
      "protection": "Εικόνα προστασίας",
      "tax": "Αποτέλεσμα φόρου (μισθοδοσία)",
      "documents": "Έγγραφα που χρειάζομαι",
      "appointment": "Επόμενο ραντεβού",
      "renewals": "Επερχόμενες ανανεώσεις",
      "request": "Ζήτηση εγγράφων"
    },
    "s": {
      "summary": "Σύνοψη",
      "policies": "Τα συμβόλαιά σας",
      "protection": "Η προστασία σας",
      "tax": "Εκτίμηση φόρου {year}",
      "documents": "Παρακαλώ στείλτε μου",
      "appointment": "Το επόμενο ραντεβού μας",
      "renewals": "Έρχονται για ανανέωση",
      "request": "Για να ετοιμάσω τον φάκελό σας, στείλτε μου"
    },
    "ch": {
      "whatsapp": "WhatsApp",
      "viber": "Viber",
      "email": "E-mail",
      "sms": "SMS",
      "system": "Κοινοποίηση…",
      "copy": "Αντιγραφή κειμένου",
      "pdf": "PDF / εκτύπωση"
    },
    "summary_line": "{count, plural, =0 {Κανένα ενεργό συμβόλαιο} one {# ενεργό συμβόλαιο} other {# ενεργά συμβόλαια}} · σύνολο {total} τον χρόνο",
    "no": "αρ.",
    "year": "έτος",
    "renews": "ανανέωση",
    "tax_income": "Ετήσιο μικτό εισόδημα: {amount}",
    "tax_estimate": "Εκτιμώμενος φόρος εισοδήματος: {amount}",
    "tax_capacity": "Μπορείτε να αξιοποιήσετε ακόμη {amount} τον χρόνο (≈ {monthly}/μήνα) σε εκπιπτόμενα ασφάλιστρα — περίπου {saving} λιγότερος φόρος τον χρόνο.",
    "tax_full": "Οι εκπιπτόμενες εισφορές σας φτάνουν ήδη το ετήσιο όριο.",
    "tax_note": "Πρόκειται για εκτίμηση, όχι φορολογική συμβουλή· ο τελικός φόρος προκύπτει από τη φορολογική δήλωση.",
    "req": {
      "payslips": "Τις 3 τελευταίες μισθοδοσίες σας (PDF ή φωτογραφία)",
      "tax_return": "Την τελευταία φορολογική δήλωση / βεβαίωση",
      "id": "Αντίγραφο ταυτότητας ή διαβατηρίου",
      "policy_schedules": "Τους πίνακες ασφάλισης των συμβολαίων που ήδη έχετε",
      "medical": "Πρόσφατη ιατρική έκθεση, αν τη ζητήσει η εταιρεία",
      "vehicle": "Άδεια κυκλοφορίας οχήματος και άδεια οδήγησης",
      "property": "Τίτλο ή εκτίμηση ακινήτου και στοιχεία δανείου",
      "loan": "Σύμβαση δανείου ή στεγαστικού (ποσό, διάρκεια, τράπεζα)",
      "bank": "IBAN για την πάγια εντολή των ασφαλίστρων"
    },
    "intro_request": "Γεια σας {name}, για να δω πόσο φόρο μπορείτε να εξοικονομήσετε, μπορείτε να μου στείλετε τα παρακάτω; Μια φωτογραφία ή PDF εδώ αρκεί."
  },
  "gate": {
    "title": "Είσοδος στο AVRASTRO CRM",
    "sub": "Το CRM για ασφαλιστικούς συμβούλους: πελάτες, συμβόλαια, ανανεώσεις και εργασίες, ίδια σε υπολογιστή, tablet και κινητό.",
    "fact": {
      "sync": "Ένας λογαριασμός συγχρονίζει όλες τις συσκευές σας.",
      "backup": "Κρυπτογραφημένα αντίγραφα στο cloud, με δικό σας κωδικό.",
      "team": "Γραφεία με ρόλους, προσκλήσεις και ημερολόγιο δραστηριότητας."
    },
    "legal": "Νομικά κείμενα",
    "terms_page": "Όροι χρήσης",
    "privacy_page": "Απόρρητο",
    "reset_title": "Νέος κωδικός πρόσβασης",
    "session_ended": "Η συνεδρία σας έληξε. Συνδεθείτε ξανά· τα δεδομένα σας είναι ασφαλή.",
    "unavailable": "Η υπηρεσία λογαριασμών δεν είναι διαθέσιμη αυτή τη στιγμή. Ανανεώστε τη σελίδα σε λίγο.",
    "no_account": "Δεν έχετε λογαριασμό;",
    "have_account": "Έχετε ήδη λογαριασμό;",
    "show": "Εμφάνιση",
    "hide": "Απόκρυψη",
    "show_password": "Εμφάνιση κωδικού",
    "hide_password": "Απόκρυψη κωδικού",
    "optional": "(προαιρετικό)",
    "forgot": "Ξεχάσατε τον κωδικό;",
    "or": "ή",
    "reg_closed_title": "Οι νέες εγγραφές θα ανοίξουν σύντομα",
    "reg_closed_body": "Προς το παρόν νέος λογαριασμός δημιουργείται μόνο με πρόσκληση από γραφείο που χρησιμοποιεί ήδη το AVRASTRO CRM. Αν έχετε κωδικό πρόσκλησης, πληκτρολογήστε τον παρακάτω.",
    "reg_code_title": "Χρειάζεστε κωδικό",
    "reg_code_body": "Νέος λογαριασμός δημιουργείται με κωδικό ενεργοποίησης από το AVRASTRO ή με πρόσκληση από το γραφείο σας.",
    "invite_code": "Κωδικός πρόσκλησης",
    "code_label": "Κωδικός ενεργοποίησης ή πρόσκλησης",
    "code_set": "Κωδικός: {code}",
    "change": "Αλλαγή",
    "have_code": "Έχω κωδικό ενεργοποίησης ή πρόσκλησης",
    "accept": "Αποδέχομαι τους {terms} και έχω διαβάσει την {privacy}.",
    "terms_link": "Όρους Χρήσης",
    "privacy_link": "Πολιτική Απορρήτου",
    "reg_after": "Θα σας στείλουμε e-mail για να επιβεβαιώσετε τη διεύθυνσή σας. Τα υπόλοιπα στοιχεία του γραφείου σας τα συμπληρώνετε όποτε θέλετε από τον Λογαριασμό.",
    "reset_intro": "Πληκτρολογήστε το e-mail του λογαριασμού σας. Θα σας στείλουμε κωδικό επαναφοράς που ισχύει μία ώρα.",
    "reset_from_link": "Ορίστε τον νέο σας κωδικό. Όλες οι συσκευές σας θα αποσυνδεθούν και θα συνδεθείτε ξανά με τον νέο κωδικό.",
    "back_signin": "Πίσω στη σύνδεση",
    "reset_done": "Ο κωδικός άλλαξε. Συνδεθείτε με τον νέο σας κωδικό.",
    "preparing": "Ετοιμάζουμε τον χώρο εργασίας σας…",
    "err": {
      "network": "Δεν ήταν δυνατή η σύνδεση με το AVRASTRO. Ελέγξτε τη σύνδεσή σας στο διαδίκτυο και δοκιμάστε ξανά.",
      "registration_closed": "Οι εγγραφές είναι προς το παρόν κλειστές. Χρειάζεστε έγκυρο κωδικό πρόσκλησης.",
      "workspace_mismatch": "Αυτός ο φυλλομετρητής κρατά δεδομένα άλλου χώρου εργασίας ({workspace}), που δεν ανεβαίνουν ποτέ σε άλλον λογαριασμό. Συνδεθείτε με εκείνον τον λογαριασμό ή χρησιμοποιήστε άλλο προφίλ φυλλομετρητή."
    }
  },
  "insured": {
    "new": "Νέο αντικείμενο",
    "empty": "Δεν υπάρχουν ασφαλισμένα αντικείμενα. Προσθέστε οχήματα, κατοικία ή επιχείρηση του πελάτη για να έχετε αξίες, οδηγούς και ημερομηνίες σε ένα σημείο.",
    "note": "Οι αξίες είναι όπως τις δήλωσε ο πελάτης. Ο έλεγχος αξίας ανοικοδόμησης είναι ενδεικτικός — δεν αποτελεί συμβουλή ούτε εκτίμηση.",
    "filter": {
      "active": "Ενεργά",
      "all": "Όλα (και πωλημένα / αρχειοθετημένα)"
    },
    "kind": {
      "vehicle": "Όχημα",
      "property": "Ακίνητο",
      "business": "Επιχείρηση",
      "other": "Άλλο"
    },
    "status": {
      "active": "Ενεργό",
      "sold": "Πωλήθηκε",
      "archived": "Αρχειοθετημένο"
    },
    "field": {
      "kind": "Είδος",
      "label": "Ονομασία",
      "regNo": "Αρ. εγγραφής",
      "make": "Μάρκα",
      "model": "Μοντέλο",
      "make_model": "Μάρκα / μοντέλο",
      "year": "Έτος",
      "value": "Αξία",
      "drivers": "Οδηγοί",
      "ncdYears": "Χρόνια χωρίς απαίτηση",
      "motDue": "Λήξη MOT",
      "roadTaxDue": "Λήξη άδειας κυκλοφορίας",
      "address": "Διεύθυνση",
      "areaSqm": "Εμβαδόν (m²)",
      "yearBuilt": "Έτος κατασκευής",
      "rebuildValue": "Αξία ανοικοδόμησης",
      "contentsValue": "Αξία περιεχομένου",
      "mortgaged": "Με υποθήκη",
      "activity": "Δραστηριότητα",
      "employees": "Υπάλληλοι",
      "policies": "Συνδεδεμένα συμβόλαια"
    },
    "label_hint": "Προαιρετικό — αλλιώς χρησιμοποιείται ο αριθμός εγγραφής, η διεύθυνση ή η δραστηριότητα.",
    "ncd_hint": "Χρόνια χωρίς απαίτηση (έκπτωση μη απαίτησης)",
    "drivers_hint": "Ονόματα, χωρισμένα με κόμμα",
    "task_note": "Δημιουργείται υπενθύμιση 14 ημέρες πριν από τη λήξη του MOT και της άδειας κυκλοφορίας.",
    "mark_sold": "Σήμανση ως πωλημένο",
    "archive": "Αρχειοθέτηση",
    "reactivate": "Ξανά ενεργό",
    "done": {
      "sold": "Σημειώθηκε ως πωλημένο — παραμένει στο ιστορικό",
      "archived": "Αρχειοθετήθηκε — παραμένει στο ιστορικό"
    },
    "due": {
      "mot": "Τεχνικός έλεγχος (MOT)",
      "road_tax": "Άδεια κυκλοφορίας"
    },
    "due_line": "{what} για {label}: {date} (σε {days} ημ.)",
    "task": {
      "mot": "Λήξη MOT: {label}",
      "road_tax": "Λήξη άδειας κυκλοφορίας: {label}"
    },
    "hint": {
      "missing": "Ενδεικτικό: δεν έχει καταγραφεί αξία ανοικοδόμησης για το ακίνητο.",
      "missing_with_estimate": "Ενδεικτικό: δεν έχει καταγραφεί αξία ανοικοδόμησης. Με {cost} ανά m², το εμβαδόν αντιστοιχεί περίπου σε {estimate}.",
      "below": "Ενδεικτικό: εμβαδόν × {cost} ανά m² ≈ {estimate}, υψηλότερο από την καταγεγραμμένη αξία ανοικοδόμησης ({rebuild}). Αξίζει να ελεγχθεί με τον πελάτη και την ασφαλιστική."
    }
  },
  "gi_renewals": {
    "intro": "Ανανεώσεις γενικών ασφαλίσεων ως ροή εργασίας. Οι υπενθυμίσεις δημιουργούνται {days} ημέρες πριν από τη λήξη (Ρυθμίσεις).",
    "create_tasks": "Δημιουργία υπενθυμίσεων ({count})",
    "tasks_done": "{count, plural, one {Δημιουργήθηκε # υπενθύμιση ανανέωσης} other {Δημιουργήθηκαν # υπενθυμίσεις ανανέωσης}}",
    "task_title": "Ανανέωση σε {days} ημέρες: {product}",
    "empty": "Καμία ανανέωση γενικών ασφαλίσεων τις επόμενες εβδομάδες.",
    "note": "Γενικός κλάδος = συμβόλαια με κλάδο «γενικός» ή κατηγορία οχήματος, κατοικίας, ταξιδιού, αστικής ευθύνης ή επιχείρησης. Τίποτα δεν ανανεώνεται αυτόματα.",
    "lost_note": "Καταγράφεται ως μη ανανεωμένο· το συμβόλαιο και το ιστορικό του διατηρούνται.",
    "in_days": "σε {days} ημ. · {date}",
    "expired": "έληξε {date}",
    "stage_label": "Στάδιο",
    "stage": {
      "new": "Προς έναρξη",
      "requested_quotes": "Ζητήθηκαν προσφορές",
      "compared": "Συγκρίθηκαν",
      "sent_to_client": "Στάλθηκε στον πελάτη",
      "approved": "Εγκρίθηκε",
      "renewed": "Ανανεώθηκε",
      "lost": "Χάθηκε"
    },
    "moved": {
      "requested_quotes": "Καταγράφηκε: ζητήθηκαν προσφορές",
      "compared": "Καταγράφηκε: συγκρίθηκαν προσφορές",
      "sent_to_client": "Καταγράφηκε: στάλθηκε στον πελάτη",
      "approved": "Καταγράφηκε: εγκρίθηκε από τον πελάτη",
      "renewed": "Η ανανέωση καταγράφηκε — ενημερώθηκε το ασφάλιστρο και πιστώθηκε η παραγωγή ανανέωσης",
      "lost": "Καταγράφηκε ως χαμένη"
    }
  },
  "premiums": {
    "title": "Ληξιπρόθεσμα ασφάλιστρα",
    "panel_title": "Ληξιπρόθεσμα ασφάλιστρα (ανοιχτά)",
    "record": "Καταγραφή ληξιπρόθεσμου ασφαλίστρου",
    "form_intro": "Ασφάλιστρο που η εταιρεία δεν μπόρεσε να εισπράξει (αποτυχημένη χρέωση, απλήρωτη δόση). Δημιουργείται υπενθύμιση για εσάς· τίποτα δεν στέλνεται στον πελάτη.",
    "amount": "Ποσό",
    "due_date": "Ημερομηνία οφειλής",
    "note_ph": "π.χ. η τράπεζα επέστρεψε τη χρέωση",
    "none": "Δεν έχουν καταγραφεί ληξιπρόθεσμα ασφάλιστρα για αυτό το συμβόλαιο.",
    "none_open": "Κανένα ανοιχτό ληξιπρόθεσμο ασφάλιστρο.",
    "note": "Όταν ένα ποσό μένει ανοιχτό πάνω από {days} ημέρες, το συμβόλαιο δείχνει «κίνδυνος ακύρωσης» (αλλάζει στις Ρυθμίσεις). Οι υπενθυμίσεις ανοίγουν ως πρόχειρα — τίποτα δεν στέλνεται μόνο του.",
    "risk_hint": "Εμφανίζεται όταν ένα ληξιπρόθεσμο ασφάλιστρο μένει ανοιχτό πάνω από {days} ημέρες",
    "lapse_risk": "Κίνδυνος ακύρωσης",
    "overdue_chip": "Ληξιπρόθεσμο ασφάλιστρο",
    "open_days": "{count, plural, one {ανοιχτό # ημέρα} other {ανοιχτό # ημέρες}}",
    "reminder": "Πρόχειρο υπενθύμισης",
    "mark_paid": "Πληρώθηκε",
    "mark_lapsed": "Ακυρώθηκε",
    "recorded": "Καταγράφηκε το ληξιπρόθεσμο ασφάλιστρο — προστέθηκε υπενθύμιση",
    "paid_done": "Σημειώθηκε ως πληρωμένο — παραμένει στο ιστορικό",
    "lapsed_done": "Σημειώθηκε ως ακυρωμένο — παραμένει στο ιστορικό",
    "task_title": "Ληξιπρόθεσμο ασφάλιστρο: {product} ({number})",
    "status": {
      "open": "Ανοιχτό",
      "paid": "Πληρώθηκε",
      "lapsed": "Ακυρώθηκε"
    },
    "source": {
      "manual": "Καταχώριση από εσάς",
      "import": "Λίστα ασφαλιστικής"
    },
    "import": "Εισαγωγή λίστας ασφαλιστικής",
    "import_title": "Εισαγωγή λίστας ληξιπρόθεσμων της ασφαλιστικής",
    "import_intro": "Επιλέξτε το αρχείο CSV ή Excel που έστειλε η ασφαλιστική (ή επικολλήστε το). Εσείς επιλέγετε ποια στήλη είναι ο αριθμός συμβολαίου, το ποσό και η ημερομηνία. Οι γραμμές ταιριάζουν μόνο με ακριβή αριθμό συμβολαίου· ό,τι άλλο εμφανίζεται ως χωρίς αντιστοίχιση, ποτέ με εικασία.",
    "import_file": "Επιλογή αρχείου",
    "import_paste": "…ή επικολλήστε εδώ τις γραμμές (με τη γραμμή επικεφαλίδων)",
    "import_unreadable": "Το αρχείο δεν διαβάστηκε. Αποθηκεύστε το ως CSV ή .xlsx και δοκιμάστε ξανά.",
    "import_summary": "{matched} με αντιστοίχιση · {unmatched} χωρίς αντιστοίχιση · {duplicates} ήδη καταγεγραμμένα",
    "import_apply": "Καταγραφή {count, plural, one {# εγγραφής} other {# εγγραφών}}",
    "import_done": "{count, plural, one {Καταγράφηκε # ληξιπρόθεσμο ασφάλιστρο} other {Καταγράφηκαν # ληξιπρόθεσμα ασφάλιστρα}}, το καθένα με υπενθύμιση",
    "import_again": "Άλλο αρχείο",
    "map_all": "Επιλέξτε τις τρεις στήλες: αριθμός συμβολαίου, ποσό και ημερομηνία.",
    "field": {
      "policyNumber": "Αριθμός συμβολαίου",
      "amount": "Ποσό",
      "dueDate": "Ημερομηνία οφειλής"
    },
    "duplicate": "Ήδη καταγεγραμμένο",
    "new_item": "Νέο",
    "unmatched": "Γραμμές χωρίς αντιστοίχιση",
    "unmatched_note": "Οι γραμμές χωρίς αντιστοίχιση δεν καταγράφονται. Ελέγξτε τον αριθμό συμβολαίου στο CRM (ή προσθέστε το συμβόλαιο) και κάντε ξανά εισαγωγή.",
    "reason": {
      "no_number": "Χωρίς αριθμό συμβολαίου",
      "no_policy": "Δεν υπάρχει συμβόλαιο με αυτόν τον αριθμό",
      "ambiguous": "Τον αριθμό έχουν περισσότερα συμβόλαια",
      "amount": "Το ποσό δεν διαβάζεται",
      "date": "Η ημερομηνία δεν διαβάζεται",
      "future": "Μελλοντική ημερομηνία"
    }
  },
  "schedule": {
    "title": "Νέο συμβόλαιο από PDF πίνακα ασφάλισης",
    "intro": "Επιλέξτε τον πίνακα ασφάλισης της εταιρείας. Διαβάζεται σε αυτή τη συσκευή· ελέγξτε και διορθώστε κάθε τιμή — τίποτα δεν αποθηκεύεται πριν πατήσετε Αποθήκευση. Αριθμοί ταυτότητας και τραπεζικά στοιχεία δεν διαβάζονται ποτέ.",
    "choose": "Επιλογή PDF",
    "reading": "Ανάγνωση…",
    "from_line": "Από: «{line}» (σελ. {page})",
    "not_found": "Δεν βρέθηκε στον πίνακα — συμπληρώστε το αν το γνωρίζετε",
    "alternatives": "βρέθηκε επίσης: {list}",
    "premium_is": "Το παραπάνω ασφάλιστρο είναι",
    "basis": {
      "instalment": "η δόση για τη συχνότητα",
      "annual": "το ετήσιο ποσό"
    },
    "keep_pdf": "Φύλαξη του PDF στα έγγραφα του πελάτη, συνδεδεμένο με το συμβόλαιο",
    "duplicate_warn": "Υπάρχει ήδη συμβόλαιο με αυτόν τον αριθμό ({product}). Επιλέξτε για να αποθηκευτεί κι άλλο.",
    "note": "Οι τιμές που διαβάζονται από έγγραφο είναι προτάσεις: ισχύουν ο πίνακας και τα στοιχεία της εταιρείας.",
    "save": "Αποθήκευση συμβολαίου",
    "saved": "Το συμβόλαιο αποθηκεύτηκε από τον πίνακα",
    "doc_title": "Πίνακας ασφάλισης {number}",
    "vault_hint": "Μοιάζει με πίνακα ασφάλισης — δημιουργήστε το συμβόλαιο από αυτόν, ελέγχοντας πρώτα τις τιμές.",
    "k": {
      "insurer": "Ασφαλιστική εταιρεία",
      "policyNumber": "Αριθμός συμβολαίου",
      "insuredName": "Ασφαλισμένος",
      "product": "Προϊόν / κλάδος",
      "startDate": "Ημερομηνία έναρξης",
      "endDate": "Ημερομηνία λήξης",
      "renewalDate": "Ημερομηνία ανανέωσης",
      "premium": "Ασφάλιστρο",
      "frequency": "Συχνότητα πληρωμής",
      "sumInsured": "Ασφαλισμένο κεφάλαιο"
    },
    "warn": {
      "no_text": "Δεν βρέθηκε κείμενο (σαρωμένη εικόνα). Συμπληρώστε τις τιμές χειροκίνητα.",
      "no_number": "Δεν βρέθηκε αριθμός συμβολαίου — ελέγξτε τον πίνακα.",
      "no_premium": "Δεν βρέθηκε ασφάλιστρο — συμπληρώστε το (χρειάζεται για αποθήκευση).",
      "dates": "Η λήξη είναι πριν από την έναρξη — ελέγξτε και τις δύο.",
      "insurer_from_heading": "Η εταιρεία βρέθηκε από την επικεφαλίδα της σελίδας — επιβεβαιώστε την.",
      "holder_as_insured": "Δεν υπάρχει πεδίο «ασφαλισμένος»: εμφανίζεται ο αντισυμβαλλόμενος — αλλάξτε το αν ο ασφαλισμένος είναι άλλος."
    }
  },
  "recon": {
    "title": "Συμφωνία κατάστασης προμηθειών",
    "open": "Συμφωνία κατάστασης",
    "intro": "Φορτώστε την κατάσταση προμηθειών της εταιρείας (CSV ή Excel, ή επικόλληση) και επιλέξτε τις στήλες. Συγκρίνεται με τις προμήθειες που αναμένει το CRM από την παραγωγή σας· τίποτα δεν αλλάζει πριν αποδεχτείτε μια γραμμή.",
    "file": "Επιλογή αρχείου κατάστασης",
    "paste": "…ή επικολλήστε εδώ τις γραμμές (με τη γραμμή επικεφαλίδων)",
    "unreadable": "Το αρχείο δεν διαβάστηκε. Αποθηκεύστε το ως CSV ή .xlsx και δοκιμάστε ξανά.",
    "map_all": "Επιλέξτε τις τρεις στήλες: αριθμός συμβολαίου, ποσό και περίοδος.",
    "again": "Άλλη κατάσταση",
    "ref": "Αναφορά κατάστασης",
    "ref_hint": "Αποθηκεύεται σε κάθε αποδεκτή γραμμή, π.χ. «Eurolife 09/2026»",
    "insurer": "Ασφαλιστική (προαιρετικά)",
    "insurer_hint": "Ως ελλείπουσες εμφανίζονται μόνο τα συμβόλαια αυτής της εταιρείας",
    "field": {
      "policyNumber": "Αριθμός συμβολαίου",
      "amount": "Ποσό προμήθειας",
      "period": "Περίοδος"
    },
    "status": {
      "matched": "Συμφωνούν",
      "different": "Διαφορετικό ποσό",
      "missing": "Λείπουν (αναμενόμενες, δεν πληρώθηκαν)",
      "unexpected": "Απρόσμενες (πληρώθηκαν, δεν αναμένονταν)"
    },
    "reason": {
      "no_policy": "δεν υπάρχει συμβόλαιο με αυτόν τον αριθμό",
      "ambiguous": "τον αριθμό έχουν περισσότερα συμβόλαια",
      "no_entry": "δεν αναμένεται προμήθεια για την περίοδο"
    },
    "problem": {
      "no_number": "Χωρίς αριθμό συμβολαίου",
      "amount": "Το ποσό δεν διαβάζεται",
      "period": "Η περίοδος δεν διαβάζεται"
    },
    "invalid": "Γραμμές που δεν διαβάστηκαν",
    "col": {
      "expected": "Αναμενόμενη",
      "paid": "Πληρωμένη",
      "difference": "Διαφορά"
    },
    "summary": "Περίοδοι {periods}: αναμενόμενες {expected} · στην κατάσταση {paid} · διαφορά {difference}",
    "accept": "Αποδοχή γραμμής",
    "accept_n": "Αποδοχή {count, plural, one {# γραμμής} other {# γραμμών}}",
    "accepted": "αποδεκτή",
    "accepted_done": "{count, plural, one {Καταχωρίστηκε # γραμμή κατάστασης} other {Καταχωρίστηκαν # γραμμές κατάστασης}}",
    "paid_date": "Ημερομηνία πληρωμής",
    "export": "Εξαγωγή CSV",
    "print": "Εκτύπωση",
    "note": "Η αποδοχή καταχωρίζει το ποσό της κατάστασης ως πληρωμένο στην αναμενόμενη γραμμή (το αναμενόμενο ποσό μένει, ώστε να φαίνεται η διαφορά)· γραμμή χωρίς αναμενόμενη προμήθεια καταχωρίζεται ως πληρωμένη προσαρμογή. Οι ελλείπουσες μένουν ανοιχτές."
  },
  "morning": {
    "title": "Πρωινό e-mail «Η μέρα μου»",
    "intro": "Κάθε εργάσιμη μέρα η πλατφόρμα σάς στέλνει με e-mail τη μέρα σας σε μια ματιά: ραντεβού, κλήσεις και follow-up για σήμερα ή εκπρόθεσμα, ανανεώσεις των επόμενων 30 ημερών, γενέθλια και ανοιχτές καθυστερήσεις ασφαλίστρων — με σύνδεσμο για το «Ημερήσιο φύλλο» της ημέρας.",
    "enabled": "Να μου στέλνεται το πρωινό e-mail τις εργάσιμες",
    "time": "Ώρα",
    "time_hint": "Ώρα Κύπρου (προεπιλογή 07:30)",
    "to": "Αποστολή στο",
    "to_hint": "Κενό = το e-mail του λογαριασμού σας ({email})",
    "to_invalid": "Η διεύθυνση e-mail δεν φαίνεται σωστή — δεν άλλαξε τίποτα.",
    "lang": "Γλώσσα του e-mail",
    "skip_holidays": "Όχι τις αργίες της Κύπρου",
    "next": "Επόμενο e-mail: {date} στις {time}",
    "no_next": "Δεν υπάρχει εργάσιμη μέρα τις επόμενες δύο εβδομάδες.",
    "off": "Απενεργοποιημένο — δεν στέλνεται τίποτα.",
    "privacy": "Το e-mail έχει μόνο αριθμούς, μικρά ονόματα και ώρες — όχι επώνυμα, τηλέφωνα, ποσά, συμβόλαια, στοιχεία υγείας ή οικονομικά. Το «Ημερήσιο φύλλο» ανοίγει στην εφαρμογή αφού συνδεθείτε. Η πλατφόρμα το συντάσσει από τα δεδομένα που συγχρονίζουν οι συσκευές σας· αν μια συσκευή δεν συγχρόνισε από χθες, φαίνεται η χθεσινή εικόνα.",
    "need_account": "Το πρωινό e-mail το στέλνει η πλατφόρμα AVRASTRO: συνδεθείτε στον λογαριασμό σας (Σύστημα → Λογαριασμός) και κρατήστε τον συγχρονισμό ανοιχτό.",
    "test": "Στείλε μου δοκιμαστικό τώρα",
    "test_sent": "Το δοκιμαστικό e-mail στάλθηκε στο {to}",
    "test_failed": "Το δοκιμαστικό e-mail δεν στάλθηκε ({code}). Βεβαιωθείτε ότι αυτή η συσκευή συγχρόνισε τη ρύθμιση."
  },
  "nps": {
    "title": "Γνώμη πελάτη",
    "subtitle": "Μία ερώτηση, 0–10. Την ετοιμάζει το CRM, τη στέλνετε εσείς.",
    "ask": "Ζητήστε τη γνώμη του",
    "need_account": "Τη σελίδα της ερώτησης τη δείχνει η πλατφόρμα AVRASTRO: συνδεθείτε πρώτα στον λογαριασμό σας (Σύστημα → Λογαριασμός).",
    "prepared": "Η ερώτηση ετοιμάστηκε — δείτε το μήνυμα και στείλτε το εσείς",
    "prepared_chip": "Ζητήθηκε γνώμη",
    "answered_chip": "Γνώμη {score}/10",
    "resend": "Μήνυμα",
    "withdraw": "Ανάκληση",
    "withdrawn": "Η ερώτηση ανακλήθηκε — ο σύνδεσμος παύει να λειτουργεί",
    "empty": "Δεν έχει ζητηθεί γνώμη ακόμα. Μετά από συνάντηση ή κλειστή αποζημίωση, το «Ζητήστε τη γνώμη του» ετοιμάζει ένα σύντομο μήνυμα με τον σύνδεσμο.",
    "status": {
      "prepared": "Ζητήθηκε — αναμένεται απάντηση",
      "answered": "Απαντήθηκε",
      "withdrawn": "Ανακλήθηκε"
    },
    "trigger": {
      "meeting": "μετά από συνάντηση",
      "claim": "μετά από αποζημίωση",
      "manual": "από εσάς"
    },
    "category": {
      "promoter": "Υποστηρικτής (9–10)",
      "passive": "Ουδέτερος (7–8)",
      "detractor": "Επικριτής (0–6)"
    },
    "review": "Ζητήστε αξιολόγηση Google",
    "review_again": "Αξιολόγηση Google (ξανά)",
    "review_no_link": "Ορίστε τον σύνδεσμο αξιολόγησης Google στις Ρυθμίσεις",
    "callback": "Εργασία επανάκλησης",
    "callback_title": "Επανάκληση — γνώμη {score}/10",
    "chart_title": "Γνώμη πελατών (NPS)",
    "score_12m": "NPS, τελευταίοι 12 μήνες",
    "answers": "Απαντήσεις",
    "response_rate": "απάντησε το {pct}%",
    "no_answers": "χωρίς απαντήσεις",
    "chart_alt": "NPS ανά μήνα: {list}",
    "chart_note": "NPS = % των 9–10 μείον % των 0–6. Οι στήλες πάνω από τη μέση είναι θετικές· οι μήνες χωρίς απαντήσεις δείχνουν —.",
    "review_url": "Σύνδεσμος αξιολόγησης Google",
    "review_url_hint": "Από το Google Business Profile → «Ζητήστε κριτικές». Χρησιμοποιείται ως «Αφήστε κριτική» στα πρότυπα μηνυμάτων (review.link) και στο προσχέδιο μετά από 9 ή 10.",
    "review_url_invalid": "Ο σύνδεσμος πρέπει να αρχίζει με https:// — δεν άλλαξε τίποτα."
  },
  "card": {
    "title": "Νέα επαφή από επαγγελματική κάρτα",
    "photo": "Φωτογραφίστε ή επιλέξτε την κάρτα",
    "photo_alt": "Η επαγγελματική κάρτα",
    "reading": "Ανάγνωση της κάρτας…",
    "read_device": "Διαβάστηκε σε αυτή τη συσκευή — ελέγξτε κάθε πεδίο.",
    "read_platform": "Διαβάστηκε από την υπηρεσία αναγνώρισης κειμένου — ελέγξτε κάθε πεδίο.",
    "read_failed": "Η κάρτα δεν διαβάστηκε. Επικολλήστε ή πληκτρολογήστε το κείμενό της παρακάτω.",
    "no_ocr": "Αυτός ο browser δεν διαβάζει κείμενο από φωτογραφίες. Επικολλήστε ή πληκτρολογήστε το κείμενο της κάρτας παρακάτω (στο κινητό: παρατεταμένο πάτημα στη φωτογραφία → «Αντιγραφή κειμένου»).",
    "too_large": "Η φωτογραφία είναι μεγαλύτερη από 5 MB — επιλέξτε μικρότερη.",
    "text": "Κείμενο της κάρτας",
    "text_hint": "Καλύτερα ένα στοιχείο ανά γραμμή.",
    "read": "Συμπλήρωση των πεδίων",
    "review": "Έλεγχος πριν την αποθήκευση",
    "empty": "Φωτογραφίστε την κάρτα ή επικολλήστε το κείμενό της: τα πεδία εμφανίζονται εδώ για έλεγχο.",
    "rest": "Δεν χρησιμοποιήθηκαν: {lines}",
    "source_note": "Αποθηκεύεται ως νέα επαφή (lead), πηγή «Γνωριμία». Το τηλέφωνο γραφείου, η ιστοσελίδα και η διεύθυνση μπαίνουν στις σημειώσεις.",
    "privacy": "Δεν αποθηκεύεται τίποτα πριν πατήσετε Αποθήκευση. Η φωτογραφία μένει σε αυτή τη συσκευή· μόνο αν η πλατφόρμα σας έχει ενεργή υπηρεσία αναγνώρισης κειμένου στέλνεται εκεί για ανάγνωση, και δεν φυλάσσεται.",
    "note_from": "Από επαγγελματική κάρτα ({date})",
    "field": {
      "firstName": "Όνομα",
      "lastName": "Επώνυμο",
      "mobile": "Κινητό",
      "phone": "Τηλέφωνο γραφείου",
      "email": "E-mail",
      "company": "Εταιρεία",
      "jobTitle": "Θέση",
      "website": "Ιστοσελίδα",
      "address": "Διεύθυνση"
    }
  },
  "kyc": {
    "title": "Φάκελος KYC / AML",
    "subtitle": "Λίστα «γνωρίζω τον πελάτη μου» για ασφαλίσεις ζωής",
    "saved": "Ο φάκελος KYC αποθηκεύτηκε",
    "task_title": "Επανεξέταση KYC/AML: {name}",
    "status": {
      "complete": "Πλήρης",
      "incomplete": "Ελλιπής",
      "none": "Δεν ξεκίνησε"
    },
    "missing": "Λείπουν: {list}",
    "miss": {
      "id_document": "έγγραφο ταυτότητας στο θησαυροφυλάκιο",
      "id_expired": "έληξε το έγγραφο ταυτότητας",
      "beneficiaries": "δικαιούχοι",
      "pep": "απάντηση PEP",
      "source_of_funds": "προέλευση χρημάτων",
      "checked": "ημερομηνία ελέγχου",
      "next_review": "ημερομηνία επόμενης επανεξέτασης",
      "review_overdue": "πέρασε η ημερομηνία επανεξέτασης"
    },
    "review_on": "Επόμενη επανεξέταση: {date} (σε {days} ημέρες)",
    "review_overdue": "Η επανεξέταση έληγε στις {date} (πριν από {days} ημέρες)",
    "amlr_before": "Ο Κανονισμός (ΕΕ) 2024/1624 για την καταπολέμηση της νομιμοποίησης εσόδων από παράνομες δραστηριότητες εφαρμόζεται από {date} (σε {days} ημέρες). Μέχρι τότε ισχύουν ο κυπριακός νόμος περί παρεμπόδισης και καταπολέμησης της νομιμοποίησης εσόδων και τα έντυπα της ασφαλιστικής εταιρείας.",
    "amlr_after": "Ο Κανονισμός (ΕΕ) 2024/1624 για την καταπολέμηση της νομιμοποίησης εσόδων εφαρμόζεται από {date}.",
    "id_document": "Έγγραφο ταυτότητας (στο θησαυροφυλάκιο)",
    "id_document_hint": "Ανεβάστε την ταυτότητα ή το διαβατήριο στο θησαυροφυλάκιο (κατηγορία «Ταυτότητα») και επιλέξτε το εδώ. Ο αριθμός του μένει μόνο στο έγγραφο.",
    "id_none": "— κανένα στον φάκελο —",
    "upload_id": "Ανέβασμα στο θησαυροφυλάκιο",
    "id_expiry": "Ισχύει έως",
    "risk": "Κίνδυνος",
    "risk_level": {
      "low": "Χαμηλός",
      "standard": "Κανονικός",
      "high": "Υψηλός"
    },
    "pep": "Πολιτικά εκτεθειμένο πρόσωπο (ή στενό μέλος οικογένειας / συνεργάτης);",
    "pep_hint": "Δημόσιο αξίωμα τώρα ή τους τελευταίους 12 μήνες, ή στενό μέλος οικογένειας ή συνεργάτης τέτοιου προσώπου.",
    "pep_answer": {
      "no": "Όχι",
      "yes": "Ναι",
      "unknown": "Δεν ρωτήθηκε ακόμα"
    },
    "pep_note": "Ποιο αξίωμα / ποια σχέση",
    "funds": "Προέλευση χρημάτων",
    "fund": {
      "salary": "Μισθός",
      "business": "Εισόδημα επιχείρησης",
      "savings": "Αποταμιεύσεις",
      "inheritance": "Κληρονομιά",
      "property_sale": "Πώληση ακινήτου",
      "investments": "Επενδύσεις",
      "pension": "Σύνταξη",
      "gift": "Δωρεά",
      "other": "Άλλο"
    },
    "funds_note": "Λεπτομέρειες (προαιρετικό)",
    "beneficiaries": "Δικαιούχοι",
    "ben_name": "Όνομα",
    "ben_relationship": "Σχέση",
    "ben_add": "Προσθήκη δικαιούχου",
    "checked_at": "Ελέγχθηκε στις",
    "next_review": "Επόμενη επανεξέταση",
    "next_review_hint": "Κενό = από την ημερομηνία ελέγχου: υψηλός κίνδυνος 1 χρόνος, κανονικός 3 χρόνια, χαμηλός 5 χρόνια.",
    "no_id_numbers": "Ένα πεδίο μοιάζει να περιέχει αριθμό ταυτότητας, διαβατηρίου, φορολογικό ή τραπεζικό. Αφαιρέστε τον — τέτοιοι αριθμοί μένουν στο έγγραφο στο θησαυροφυλάκιο.",
    "privacy": "Κρατήστε μόνο ό,τι ζητά η λίστα. Αριθμοί ταυτότητας δεν πληκτρολογούνται εδώ· το ίδιο το έγγραφο είναι στο κρυπτογραφημένο θησαυροφυλάκιο και η πρόσβαση σε έγγραφα περιορισμένης πρόσβασης καταγράφεται."
  },
  "creport": {
    "title": "Ζημιές και αλλαγές από πελάτες",
    "subtitle": "Δηλώσεις των πελατών σας μέσω της πύλης στην ιστοσελίδα",
    "empty": "Δεν υπάρχουν δηλώσεις ακόμα. Οι πελάτες που επιτρέπουν την πύλη μπορούν να δηλώσουν ζημιά ή να ζητήσουν αλλαγή από τη σελίδα τους στην ιστοσελίδα.",
    "unavailable": "Οι δηλώσεις δεν φορτώθηκαν (εκτός σύνδεσης ή η ιστοσελίδα δεν είναι συνδεδεμένη).",
    "new": "Νέα",
    "accept": "Αποδοχή στο CRM",
    "accepted": "Η δήλωση έγινε αποδεκτή — δημιουργήθηκε αποζημίωση / αίτημα με follow-up για σήμερα",
    "decline": "Απόρριψη",
    "declined": "Απορρίφθηκε — ο πελάτης βλέπει ότι θα επικοινωνήσετε μαζί του",
    "declined_chip": "Απορρίφθηκε",
    "matched": "Ταίριαξε με e-mail ή τηλέφωνο: {name}",
    "event_date": "Ημερομηνία συμβάντος",
    "policy_ref": "Αριθμός συμβολαίου που δόθηκε",
    "files": "{count, plural, one {# αρχείο} other {# αρχεία}}",
    "file_failed": "Το αρχείο {name} δεν αποθηκεύτηκε — ανοίξτε ξανά τη δήλωση αργότερα.",
    "docs_asked": "Ο πελάτης είδε",
    "task_title": "Δήλωση πελάτη: {title}",
    "insurer_note": "Η επίσημη δήλωση ζημιάς ή το αίτημα αλλαγής προς την ασφαλιστική γίνεται όπως ζητά η ίδια η εταιρεία (το δικό της έντυπο, πύλη ή e-mail, με τα πρωτότυπα έγγραφα, μέσα στις προθεσμίες του συμβολαίου). Το ίδιο ενημερώνεται και ο πελάτης.",
    "kind": {
      "car_accident": "Τροχαίο ατύχημα",
      "home_damage": "Ζημιά στο σπίτι",
      "hospital": "Νοσηλεία",
      "death": "Θάνατος συγγενή",
      "theft": "Κλοπή",
      "change": "Αίτημα αλλαγής"
    },
    "stage": {
      "sent": "Στάλθηκε",
      "received": "Παραλήφθηκε",
      "documents_needed": "Χρειάζονται έγγραφα",
      "in_progress": "Σε εξέλιξη",
      "with_insurer": "Στην ασφαλιστική",
      "approved": "Εγκρίθηκε",
      "paid": "Πληρώθηκε",
      "declined": "Απορρίφθηκε από την ασφαλιστική",
      "closed": "Ολοκληρώθηκε"
    },
    "doc": {
      "accident_form": "Δήλωση ατυχήματος",
      "photos_damage": "Φωτογραφίες ζημιάς",
      "photos_scene": "Φωτογραφίες σημείου",
      "driving_licence": "Δίπλωμα οδηγού",
      "police_report": "Αναφορά Αστυνομίας",
      "repair_estimate": "Εκτίμηση επισκευής",
      "other_party": "Στοιχεία άλλου μέρους",
      "description": "Περιγραφή",
      "invoices": "Τιμολόγια / αποδείξεις",
      "police_report_if_any": "Αναφορά Αστυνομίας (αν υπάρχει)",
      "discharge_summary": "Εξιτήριο",
      "hospital_invoices": "Λογαριασμοί νοσοκομείου",
      "medical_reports": "Ιατρικές εκθέσεις",
      "claim_form_insurer": "Έντυπο απαίτησης ασφαλιστικής",
      "death_certificate": "Πιστοποιητικό θανάτου",
      "policy_document": "Ασφαλιστήριο",
      "beneficiary_id": "Ταυτότητα δικαιούχου",
      "medical_cause": "Ιατρική βεβαίωση αιτίας",
      "bank_details_beneficiary": "Τραπεζικά στοιχεία δικαιούχου",
      "list_of_items": "Λίστα κλαπέντων",
      "proof_of_ownership": "Απόδειξη κυριότητας",
      "request_details": "Τι να αλλάξει",
      "supporting_document": "Σχετικό έγγραφο"
    }
  },
  "passkey": {
    "title": "Passkeys (Face ID, Touch ID, δακτυλικό αποτύπωμα)",
    "intro": "Συνδεθείτε με το πρόσωπο ή το δακτυλικό σας αποτύπωμα αντί για κωδικό. Τα βιομετρικά μένουν στη συσκευή σας· το AVRASTRO ελέγχει μόνο μια υπογραφή. Το passkey μετρά και ως δεύτερο βήμα.",
    "add": "Προσθήκη passkey σε αυτή τη συσκευή",
    "added": "Το passkey προστέθηκε. Την επόμενη φορά επιλέξτε «Σύνδεση με passkey».",
    "removed": "Το passkey αφαιρέθηκε.",
    "remove": "Αφαίρεση",
    "remove_confirm": "Να αφαιρεθεί το passkey «{name}»; Η συσκευή αυτή θα συνδέεται ξανά με κωδικό.",
    "unnamed": "Passkey",
    "created": "προστέθηκε {date}",
    "last_used": "τελευταία χρήση {date}",
    "none": "Δεν υπάρχουν ακόμη passkeys.",
    "unsupported": "Ανοίξτε το AVRASTRO στον browser (app.avrastro.com) στο κινητό ή στον υπολογιστή σας για να προσθέσετε ένα.",
    "sign_in": "Σύνδεση με passkey",
    "cancelled": "Το passkey δεν χρησιμοποιήθηκε (ακυρώθηκε ή δεν υπάρχει σε αυτή τη συσκευή)."
  },
  "push": {
    "help": {
      "retry": "Ακόμη τίποτα: «Απενεργοποίηση» στη συσκευή, ανανέωση σελίδας, «Ενεργοποίηση» ξανά και «Δοκιμή». Το ιστορικό δείχνει αν η ειδοποίηση στάλθηκε.",
      "closed": "Με κλειστό browser: Chrome / Edge τις δείχνουν όταν ο browser τρέχει στο παρασκήνιο· στο κινητό έρχονται και με κλειστή την εφαρμογή.",
      "private": "Ιδιωτικό παράθυρο ή αποκλεισμένα δεδομένα ιστότοπων: οι ειδοποιήσεις δεν λειτουργούν εκεί.",
      "ios": "iPhone / iPad: μόνο από την εικόνα του AVRASTRO στην Αρχική οθόνη (Safari → Κοινοποίηση → Προσθήκη στην Αρχική οθόνη), iOS 16.4 ή νεότερο.",
      "focus": "Λειτουργία «Μην ενοχλείτε» / «Συγκέντρωση» κρύβει τις ειδοποιήσεις — ελέγξτε τη.",
      "os": "Σύστημα: Mac → Ρυθμίσεις συστήματος → Γνωστοποιήσεις → (ο browser σας) → Να επιτρέπονται. Windows → Ρυθμίσεις → Σύστημα → Ειδοποιήσεις → (ο browser σας) ενεργό.",
      "allow": "Browser: εικονίδιο κλειδαριάς δίπλα στη διεύθυνση → Ειδοποιήσεις → Να επιτρέπεται. Μετά ανανεώστε τη σελίδα.",
      "title": "Δεν έρχονται ειδοποιήσεις; Έλεγχος βήμα προς βήμα"
    },
    "status": {
      "queued": "σε αναμονή (ώρες ησυχίας)",
      "failed": "απέτυχε",
      "sent": "στάλθηκε"
    },
    "history_empty": "Δεν έχει σταλεί καμία ειδοποίηση ακόμη.",
    "history": "Ιστορικό ειδοποιήσεων",
    "time_zone": "Ώρα συσκευής: {tz}",
    "quiet_hint": "Τις ώρες ησυχίας δεν εμφανίζεται τίποτα· ό,τι έρθει από το site εμφανίζεται μόλις τελειώσουν.",
    "quiet_to": "έως",
    "quiet_from": "από",
    "quiet": "Ώρες ησυχίας",
    "failing": "{n} αποτυχίες παράδοσης",
    "error": {
      "unsupported": "Αυτός ο browser δεν υποστηρίζει ειδοποιήσεις. Χρησιμοποιήστε Chrome, Edge, Firefox ή Safari.",
      "subscribe_timeout": "Η υπηρεσία ειδοποιήσεων του browser δεν απάντησε. Ελέγξτε τη σύνδεση και δοκιμάστε ξανά σε λίγο.",
      "subscribe_failed": "Η υπηρεσία ειδοποιήσεων του browser (Google, Apple, Mozilla ή Microsoft) δεν δέχτηκε την εγγραφή. Ελέγξτε τη σύνδεση και ότι οι ειδοποιήσεις του browser επιτρέπονται στο λειτουργικό σύστημα, και δοκιμάστε ξανά.",
      "sw_timeout": "Η λειτουργία παρασκηνίου του AVRASTRO δεν ξεκίνησε εγκαίρως. Ανανεώστε τη σελίδα (μία φορά) και πατήστε ξανά «Ενεργοποίηση».",
      "sw_failed": "Ο browser δεν επέτρεψε στο AVRASTRO να εγκαταστήσει τη λειτουργία παρασκηνίου (service worker) που χρειάζονται οι ειδοποιήσεις. Σε ιδιωτικό παράθυρο ή με αποκλεισμένα cookies αυτό απαγορεύεται — ανοίξτε το app.avrastro.com σε κανονικό παράθυρο.",
      "dismissed": "Το παράθυρο άδειας έκλεισε χωρίς απάντηση. Πατήστε ξανά «Ενεργοποίηση» και επιλέξτε «Να επιτρέπεται».",
      "denied": "Ο browser δεν επέτρεψε ειδοποιήσεις για το AVRASTRO. Επιτρέψτε τες από το εικονίδιο κλειδαριάς δίπλα στη διεύθυνση (Ρυθμίσεις ιστότοπου → Ειδοποιήσεις → Να επιτρέπεται) και δοκιμάστε ξανά."
    },
    "not_configured_here": "Ο διακομιστής AVRASTRO στον οποίο είστε συνδεδεμένοι δεν στέλνει ειδοποιήσεις (δεν έχει ρυθμιστεί). Στο app.avrastro.com λειτουργούν.",
    "state": {
      "desktop": "Εφαρμογή υπολογιστή",
      "server": "Μη διαθέσιμες σε αυτόν τον διακομιστή",
      "blocked": "Δεν είναι δυνατές εδώ",
      "off": "Όχι ενεργές σε αυτή τη συσκευή",
      "on": "Ενεργές σε αυτή τη συσκευή"
    },
    "turning_on": "Ενεργοποίηση…",
    "on_no_test": "Οι ειδοποιήσεις ενεργοποιήθηκαν, αλλά η δοκιμαστική δεν παραδόθηκε ακόμη. Πατήστε «Δοκιμή» σε λίγο.",
    "title": "Ειδοποιήσεις σε αυτή τη συσκευή",
    "intro": "Ειδοποίηση στο κινητό ή στον υπολογιστή όταν φτάνει ραντεβού ή μήνυμα από το site, και πριν από τα ραντεβού σας. Κλειστές μέχρι να τις ανοίξετε εδώ· κάθε συσκευή έχει τις δικές της επιλογές.",
    "on": "Άνοιγμα ειδοποιήσεων σε αυτή τη συσκευή",
    "on_done": "Οι ειδοποιήσεις άνοιξαν. Στάλθηκε δοκιμαστική ειδοποίηση σε αυτή τη συσκευή.",
    "off": "Κλείσιμο",
    "off_confirm": "Να σταματήσουν οι ειδοποιήσεις στο «{device}»;",
    "device": "Συσκευή",
    "denied": "Ο browser δεν επέτρεψε ειδοποιήσεις. Μπορείτε να τις επιτρέψετε από τις ρυθμίσεις ιστότοπου του browser και να δοκιμάσετε ξανά.",
    "test": "Δοκιμή",
    "test_sent": "Η δοκιμαστική ειδοποίηση στάλθηκε.",
    "test_failed": "Η δοκιμαστική ειδοποίηση δεν παραδόθηκε. Κλείστε και ανοίξτε ξανά τις ειδοποιήσεις σε εκείνη τη συσκευή.",
    "last_ok": "τελευταία παράδοση {when}",
    "minutes_before": "Υπενθύμιση",
    "minutes": "{n} λεπτά πριν",
    "pref": {
      "renewals": "Ανανεώσεις συμβολαίων",
      "tasks": "Εργασίες / follow-ups της ημέρας",
      "bookings": "Ραντεβού από το site",
      "messages": "Μηνύματα από το site",
      "appointments": "Πριν από τα ραντεβού",
      "details": "Λεπτομέρειες στην κλειδωμένη οθόνη"
    },
    "support": {
      "insecure": "Οι ειδοποιήσεις χρειάζονται ασφαλή σύνδεση (https). Ανοίξτε το AVRASTRO στο https://app.avrastro.com.",
      "desktop_app": "Η εφαρμογή υπολογιστή δεν λαμβάνει ειδοποιήσεις μέσω διαδικτύου (Web Push). Δείχνει δικές της ειδοποιήσεις του συστήματος όσο είναι ανοιχτή — ενεργοποιήστε τις στις Ρυθμίσεις. Για ειδοποιήσεις και όταν είναι κλειστή, ενεργοποιήστε τις στο app.avrastro.com σε έναν browser ή στο κινητό.",
      "unsupported": "Αυτή η εφαρμογή ή ο browser δεν δέχεται ειδοποιήσεις. Χρησιμοποιήστε το AVRASTRO σε Chrome, Edge, Firefox ή Safari στο app.avrastro.com.",
      "ios_home_screen": "Σε iPhone και iPad: ανοίξτε το app.avrastro.com στο Safari, Κοινοποίηση → «Προσθήκη στην οθόνη Αφετηρίας», ανοίξτε το AVRASTRO από την οθόνη Αφετηρίας και μετά ανοίξτε τις ειδοποιήσεις εδώ.",
      "denied": "Οι ειδοποιήσεις είναι μπλοκαρισμένες για το AVRASTRO σε αυτόν τον browser. Επιτρέψτε τις από τις ρυθμίσεις ιστότοπου και ανανεώστε τη σελίδα."
    },
    "note": "Από προεπιλογή η κλειδωμένη οθόνη δείχνει μόνο «Νέο αίτημα ραντεβού» ή «Ραντεβού σε 30 λεπτά» — χωρίς ονόματα πελατών. Η ειδοποίηση ταξιδεύει κρυπτογραφημένη μέσω της υπηρεσίας ειδοποιήσεων του browser σας (Apple, Google, Mozilla ή Microsoft)."
  },
  "esign": {
    "send": "Αποστολή για υπογραφή",
    "send_title": "Αποστολή για υπογραφή — {name}",
    "kind_label": "Έγγραφο",
    "kind": {
      "needs": "Δήλωση αναγκών",
      "consent": "Συναίνεση GDPR",
      "proposal": "Σύνοψη πρότασης",
      "other": "Άλλο έγγραφο"
    },
    "lang": "Γλώσσα του εγγράφου",
    "title_label": "Τίτλος",
    "extra_text": "Επιπλέον κείμενο (προαιρετικό)",
    "extra_hint": "Τυπώνεται στο τέλος του εγγράφου, πριν από την υπογραφή.",
    "email": "E-mail του πελάτη",
    "email_hint": "Εδώ πηγαίνουν ο σύνδεσμος και ο εξαψήφιος κωδικός επιβεβαίωσης.",
    "days": "Ο σύνδεσμος ισχύει",
    "days_n": "{n, plural, one {# ημέρα} other {# ημέρες}}",
    "legal": "Απλή ηλεκτρονική υπογραφή (eIDAS, Κανονισμός (ΕΕ) 910/2014, άρθρο 3 σημείο 10): ο πελάτης διαβάζει το PDF, επιβεβαιώνει με κωδικό που στέλνεται στο e-mail του και υπογράφει με το δάχτυλο ή το ποντίκι· προστίθεται σελίδα ελέγχου (ώρα, hash IP, πρόγραμμα περιήγησης, τρόπος κωδικού, SHA-256 του εγγράφου). Όπου ασφαλιστική εταιρεία απαιτεί δικό της έντυπο ή δική της υπογραφή, ισχύει εκείνο.",
    "sent_title": "Στάλθηκε για υπογραφή",
    "sent_emailed": "Ο σύνδεσμος στάλθηκε στο {email}. Μπορείτε να τον στείλετε και εσείς (π.χ. με WhatsApp):",
    "sent_link": "Στείλτε αυτόν τον σύνδεσμο στον πελάτη:",
    "list_title": "Ηλεκτρονικές υπογραφές",
    "none": "Δεν έχει σταλεί ακόμη τίποτα για υπογραφή.",
    "status": {
      "sent": "στάλθηκε",
      "opened": "άνοιξε",
      "signed": "υπογράφηκε",
      "cancelled": "ακυρώθηκε",
      "expired": "έληξε"
    },
    "sent_on": "στάλθηκε {date}",
    "signed_on": "υπογράφηκε {date}",
    "until": "ισχύει έως {date}",
    "collect": "Προσθήκη στα έγγραφα",
    "cancel": "Ακύρωση",
    "collected": "{n, plural, one {Ένα υπογεγραμμένο έγγραφο προστέθηκε} other {# υπογεγραμμένα έγγραφα προστέθηκαν}} στα έγγραφα του πελάτη.",
    "err": {
      "esign_no_channel": "Προσθέστε το e-mail του πελάτη: εκεί στέλνεται ο κωδικός επιβεβαίωσης.",
      "esign_missing": "Χρειάζονται τίτλος και όνομα πελάτη.",
      "esign_empty": "Το έγγραφο δεν έχει περιεχόμενο.",
      "esign_not_configured": "Οι ηλεκτρονικές υπογραφές δεν είναι διαθέσιμες σε αυτόν τον server.",
      "email_invalid": "Η διεύθυνση e-mail δεν φαίνεται σωστή."
    },
    "doc": {
      "client": "Πελάτης",
      "name": "Ονοματεπώνυμο",
      "needs": "Δήλωση αναγκών",
      "no_needs": "Δεν έχει καταγραφεί ακόμη ανάλυση αναγκών.",
      "analysis_date": "Ανάλυση αναγκών",
      "consent": "Συναίνεση για επεξεργασία προσωπικών δεδομένων (GDPR)",
      "proposal": "Σύνοψη πρότασης",
      "no_quotes": "Δεν έχουν καταγραφεί ακόμη προσφορές."
    },
    "needs": {
      "declaration": "Βεβαιώνω ότι οι παραπάνω πληροφορίες για την κατάστασή μου και τις ανάγκες μου είναι ακριβείς και πλήρεις, όσο γνωρίζω, και ότι συζητήθηκαν με τον σύμβουλό μου."
    },
    "proposal": {
      "declaration": "Βεβαιώνω ότι έλαβα και κατάλαβα αυτή τη σύνοψη της πρότασης. Δεν είναι ασφαλιστήριο συμβόλαιο: ισχύουν τα έγγραφα, οι όροι και η αποδοχή της ασφαλιστικής εταιρείας."
    },
    "consent": {
      "controller": "Υπεύθυνος επεξεργασίας: ο ασφαλιστικός μου σύμβουλος που αναφέρεται στην αρχή του εγγράφου, ο οποίος τηρεί φάκελο πελάτη στο AVRASTRO CRM.",
      "purposes": "Σκοποί: συμβουλή και διαμεσολάβηση στην ασφάλιση, ετοιμασία προσφορών και αιτήσεων, εξυπηρέτηση και επανεξέταση των συμβολαίων μου, και επικοινωνία για αυτά.",
      "data": "Δεδομένα: στοιχεία ταυτότητας και επικοινωνίας, οικογενειακές και οικονομικές πληροφορίες που δίνω, και — μόνο όπου χρειάζεται για αίτηση — πληροφορίες υγείας, για τις οποίες αυτή είναι η ρητή συναίνεσή μου (ΓΚΠΔ άρθρο 9 παρ. 2 στοιχ. α).",
      "recipients": "Αποδέκτες: οι ασφαλιστικές εταιρείες στις οποίες επιλέγω να κάνω αίτηση και οι πάροχοι υπηρεσιών που χρησιμοποιεί ο σύμβουλος για το CRM, με σύμβαση και σύμφωνα με το ευρωπαϊκό δίκαιο προστασίας δεδομένων.",
      "retention": "Διατήρηση: όσο είμαι πελάτης και μετά μόνο όσο απαιτεί ο νόμος.",
      "rights": "Τα δικαιώματά μου: πρόσβαση, διόρθωση, διαγραφή, περιορισμός, φορητότητα και αντίρρηση, και καταγγελία στον Επίτροπο Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (Κύπρος).",
      "withdraw": "Μπορώ να ανακαλέσω αυτή τη συναίνεση οποτεδήποτε, ενημερώνοντας τον σύμβουλό μου· η ανάκληση δεν επηρεάζει την επεξεργασία που έγινε ήδη.",
      "declaration": "Διάβασα τα παραπάνω και δίνω τη συναίνεσή μου."
    }
  },
  "vcall": {
    "location": "AVRASTRO Video",
    "mode": "Συνάντηση",
    "mode_physical": "Με φυσική παρουσία",
    "mode_video": "Βιντεοκλήση",
    "create_room": "Δημιουργία αίθουσας AVRASTRO Video (προστατευμένος σύνδεσμος για αυτό το ραντεβού, με αίθουσα αναμονής)",
    "addon_needed": "Το AVRASTRO Video είναι πρόσθετο που δεν είναι ενεργό στη συνδρομή σας. Μπορείτε να βάλετε τον δικό σας σύνδεσμο βίντεο στο «Τόπος».",
    "own_link": "Βάλτε τον σύνδεσμο βίντεο (Zoom, Teams, Meet…) στο «Τόπος».",
    "guest_link": "Σύνδεσμος για τον πελάτη",
    "link_note": "Ανοίγει 15 λεπτά πριν από την ώρα ({from})· ο πελάτης περιμένει μέχρι να τον δεχτείτε. Δεν καταγράφεται.",
    "key_link": "Κλειδί κρυπτογράφησης (εμπιστευτική κλήση)",
    "key_note": "Ο σύνδεσμος του πελάτη δεν περιέχει το κλειδί — ούτε το e-mail, το ημερολόγιο ή η ιστοσελίδα. Στείλτε αυτόν τον σύνδεσμο-κλειδί χωριστά (SMS, τηλέφωνο), ποτέ στο ίδιο μήνυμα.",
    "open_panel": "Βιντεοκλήση",
    "panel_title": "Βιντεοκλήση",
    "guest_waiting": "Ο/Η {name} είναι στην αίθουσα αναμονής",
    "privacy_note": "Η κλήση τρέχει σε δικό της παράθυρο. Τίποτα από το CRM δεν μοιράζεται, εκτός αν επιλέξετε «Κοινή προβολή» ή μοιραστείτε μόνοι σας ένα παράθυρο.",
    "open_call": "Άνοιγμα παραθύρου κλήσης",
    "open_here": "Άνοιγμα σε αυτό το πλαίσιο",
    "call_frame": "Βιντεοκλήση",
    "lobby": "Αίθουσα αναμονής",
    "lobby_empty": "Δεν περιμένει κανείς.",
    "admit": "Αποδοχή",
    "deny": "Απόρριψη",
    "in_call": "Στην κλήση: {names}",
    "lock": "Κλείδωμα αίθουσας",
    "unlock": "Ξεκλείδωμα αίθουσας",
    "end_all": "Τέλος για όλους",
    "revoke": "Νέος σύνδεσμος (ο παλιός σταματά να ισχύει)",
    "shared_title": "Κοινή προβολή",
    "shared_note": "Ο πελάτης βλέπει μόνο αυτή την ασφαλή σύνοψη ενός βήματος της Συνάντησης — χωρίς προμήθειες, ιδιωτικές σημειώσεις ή άλλους πελάτες.",
    "shared_step": "Βήμα Συνάντησης",
    "shared_preview": "Τι βλέπει ο πελάτης",
    "share_on": "Προβολή στον πελάτη",
    "share_off": "Διακοπή προβολής",
    "shared_on": "Ο πελάτης βλέπει τώρα την Κοινή προβολή.",
    "shared_off": "Η Κοινή προβολή κρύφτηκε.",
    "chat_title": "Σύνδεσμοι στα μηνύματα της κλήσης",
    "chat_esign_btn": "Αποστολή για υπογραφή",
    "chat_esign": "Έγγραφο για υπογραφή",
    "chat_portal_btn": "Σύνδεσμος client portal",
    "chat_portal": "Τα έγγραφά σας στο client portal",
    "chat_posted": "Ο σύνδεσμος στάλθηκε στα μηνύματα της κλήσης.",
    "notes_title": "Σημειώσεις και επόμενα βήματα",
    "notes_ph": "Σημειώσεις της συνάντησης (ιδιωτικές, δεν εμφανίζονται ποτέ στον πελάτη)",
    "notes_private": "Αποθηκεύονται στη συνάντηση αυτού του πελάτη, συνδεδεμένη με το ραντεβού.",
    "follow_ph": "Επόμενο βήμα",
    "follow_by": "Ποιος",
    "by_advisor": "Εγώ",
    "by_client": "Πελάτης",
    "follow_add": "Προσθήκη επόμενου βήματος",
    "notes_save": "Αποθήκευση σημειώσεων",
    "meeting_finish": "Ολοκλήρωση συνάντησης",
    "meeting_purpose": "Συνάντηση με βίντεο",
    "notes_saved": "Οι σημειώσεις αποθηκεύτηκαν στη συνάντηση.",
    "meeting_saved": "Η συνάντηση αποθηκεύτηκε· τα επόμενα βήματα είναι στην ατζέντα.",
    "usage": "Αυτόν τον μήνα: {minutes} από {limit} λεπτά συμμετεχόντων (δίκαιη χρήση)",
    "usage_warn": "πάνω από 80% — χωρίς επιπλέον χρέωση",
    "no_recording": "Το AVRASTRO Video δεν καταγράφει, δεν απομαγνητοφωνεί και δεν συνοψίζει κλήσεις.",
    "ics_note": "Βιντεοκλήση AVRASTRO — ανοίγει στον browser:",
    "call_notes": "Σημειώσεις από το παράθυρο κλήσης",
    "call_notes_saved": "Αποθηκεύτηκαν στη συνάντηση αυτού του πελάτη (ο πελάτης δεν βλέπει ποτέ τις σημειώσεις).",
    "elsewhere_h": "Ανοίξτε την κλήση στο Safari ή στο Chrome",
    "elsewhere_p": "Αυτό το παράθυρο δεν μπορεί να χρησιμοποιήσει κάμερα και μικρόφωνο (π.χ. browser ενσωματωμένος σε άλλη εφαρμογή). Αντιγράψτε τον σύνδεσμο οικοδεσπότη και ανοίξτε τον στο Safari ή στο Chrome.",
    "elsewhere_open": "Άνοιγμα στον browser",
    "elsewhere_once": "Ο σύνδεσμος οικοδεσπότη ισχύει μία φορά, για 2 λεπτά. Αν έληξε, πατήστε ξανά «Άνοιγμα παραθύρου κλήσης».",
    "feedback_title": "Αξιολόγηση πελάτη",
    "feedback_stars": "{n} από 5 αστέρια",
    "status": {
      "scheduled": "προγραμματισμένη",
      "open": "ανοιχτή",
      "expired": "ο σύνδεσμος έληξε",
      "ended": "ολοκληρώθηκε",
      "cancelled": "ακυρώθηκε"
    },
    "err": {
      "generic": "Η υπηρεσία βίντεο απάντησε: {code}",
      "video_not_entitled": "Το AVRASTRO Video δεν περιλαμβάνεται στη συνδρομή σας (πρόσθετο).",
      "video_not_configured": "Το AVRASTRO Video δεν έχει ρυθμιστεί ακόμη σε αυτόν τον server.",
      "video_too_early": "Η κλήση ανοίγει μία ώρα πριν από το ραντεβού.",
      "video_not_open": "Η κλήση δεν είναι ανοιχτή (ολοκληρώθηκε ή έληξε).",
      "video_room_full": "Η κλήση είναι γεμάτη (έως 4 άτομα).",
      "video_guest_state": "Το άτομο δεν περιμένει πια.",
      "video_link_origin": "Μπορούν να σταλούν μόνο σύνδεσμοι υπογραφής και client portal.",
      "network": "Δεν υπάρχει σύνδεση με την πλατφόρμα AVRASTRO.",
      "rate_limited": "Πολλές προσπάθειες — περιμένετε ένα λεπτό."
    },
    "alert_waiting_title": "{names} σας περιμένει στη βιντεοκλήση",
    "alert_soon_title": "Βιντεοκλήση σε {minutes} λεπτά",
    "alert_join": "Μπείτε τώρα",
    "alert_waiting_tab": "Σας περιμένουν",
    "alert_enable_notifications": "Ειδοποιήσεις και όταν είστε σε άλλη καρτέλα: Ενεργοποίηση",
    "popup_blocked": "Ο browser μπλόκαρε το νέο παράθυρο — πατήστε «Άνοιγμα παραθύρου κλήσης» στο πλαίσιο."
  },
  "newsletter": {
    "audience": "Κοινό: Συνδρομητές newsletter",
    "audience_name": "Συνδρομητές newsletter",
    "need_account": "Συνδεθείτε στον λογαριασμό AVRASTRO (Σύστημα → Λογαριασμός) για να δείτε τους συνδρομητές και να στείλετε.",
    "unavailable": "Οι συνδρομητές δεν είναι διαθέσιμοι τώρα ({code}).",
    "active": "Επιβεβαιωμένοι συνδρομητές",
    "langs": "Γλώσσα",
    "list": {
      "monthly": "Μηνιαίο newsletter",
      "alerts": "Ειδοποιήσεις αλλαγών"
    },
    "privacy_note": "Μόνο όσοι επιβεβαίωσαν την εγγραφή τους στο avrastro.com (διπλή επιβεβαίωση). Οι διευθύνσεις μένουν κρυπτογραφημένες στην πλατφόρμα· εδώ βλέπετε μόνο αριθμούς. Κάθε e-mail έχει σύνδεσμο διαγραφής με ένα κλικ.",
    "new": {
      "monthly": "Νέο μηνιαίο newsletter",
      "alerts": "Νέα ειδοποίηση αλλαγής"
    },
    "new_title": {
      "monthly": "Newsletter μήνα",
      "alerts": "Ειδοποίηση αλλαγής"
    },
    "body_start_el": "Γεια σας {name},\n\n",
    "body_start_en": "Hello {name},\n\n",
    "drafts": "Προσχέδια ειδοποιήσεων για έγκριση",
    "drafts_hint": "Ετοιμάστηκαν επειδή ενημερώθηκε ένας οδηγός στο avrastro.com. Δεν στέλνονται ποτέ αυτόματα: ανοίξτε, ελέγξτε και στείλτε, ή απορρίψτε.",
    "open_draft": "Άνοιγμα για έλεγχο",
    "dismiss": "Απόρριψη",
    "dismissed": "Το προσχέδιο απορρίφθηκε.",
    "empty": "Δεν υπάρχει ακόμη newsletter. Ξεκινήστε ένα από τα κουμπιά παραπάνω.",
    "language": "Γλώσσα κειμένου",
    "body": "Κείμενο",
    "body_hint": "Το {name} γίνεται το μικρό όνομα του συνδρομητή (ή παραλείπεται). Κάθε συνδρομητής λαμβάνει τη γλώσσα που διάλεξε.",
    "footer_note": "Στο τέλος κάθε e-mail μπαίνει αυτόματα: ότι το AVRASTRO δεν είναι ασφαλιστική εταιρεία και ο προσωπικός σύνδεσμος διαγραφής.",
    "problem": {
      "subject_el": "λείπει το ελληνικό θέμα",
      "subject_en": "λείπει το αγγλικό θέμα",
      "body_el": "το ελληνικό κείμενο είναι πολύ σύντομο",
      "body_en": "το αγγλικό κείμενο είναι πολύ σύντομο",
      "asks_for_data": "το κείμενο ζητά προσωπικά στοιχεία — αφαιρέστε το"
    },
    "send_test": "Δοκιμή σε εμένα",
    "send_list": "Αποστολή στους συνδρομητές",
    "test_first": "Στείλτε πρώτα μια δοκιμή στον εαυτό σας.",
    "confirm_send": "Να σταλεί τώρα σε {n} συνδρομητές; Δεν αναιρείται.",
    "test_sent": "Η δοκιμή στάλθηκε στο {to}.",
    "sent": "Στάλθηκε σε {n} συνδρομητές ({failed} απέτυχαν).",
    "send_failed": "Η αποστολή δεν έγινε ({code}).",
    "history": "Αποστολές",
    "test": "δοκιμή",
    "sent_line": "{n} απεστάλησαν · {failed} απέτυχαν"
  },
  "whatsapp": {
    "title": "WhatsApp Business",
    "intro": "Υπενθυμίσεις ραντεβού, ευχές γενεθλίων και ειδοποιήσεις ανανέωσης από τον αριθμό σας WhatsApp Business, με τα πρότυπα που ενέκρινε η Meta. Μόνο σε πελάτες που έδωσαν συναίνεση για WhatsApp, μόνο όταν πατήσετε «Αποστολή στο WhatsApp» ή ανοίξετε τη συγκεκριμένη αυτόματη αποστολή.",
    "need_account": "Συνδεθείτε στον λογαριασμό σας AVRASTRO για να συνδέσετε αριθμό WhatsApp.",
    "admin_only": "Μόνο ο διαχειριστής του γραφείου συνδέει τον αριθμό WhatsApp.",
    "connected": "Συνδεδεμένο: {number} ({name}).",
    "webhook": "Webhook της Meta (callback URL): {url} · verify token: {token} · πεδίο: messages",
    "disconnect": "Αποσύνδεση του αριθμού",
    "phone_id": "Phone number ID",
    "phone_id_hint": "Meta → WhatsApp → API setup",
    "app_secret": "App secret",
    "app_secret_hint": "Εφαρμογή Meta → Settings → Basic",
    "token": "Μόνιμο access token",
    "token_hint": "Token χρήστη συστήματος με whatsapp_business_messaging· στέλνεται μία φορά στην πλατφόρμα και φυλάσσεται εκεί κρυπτογραφημένο, ποτέ στο CRM.",
    "connect": "Σύνδεση του αριθμού",
    "connected_ok": "Ο αριθμός WhatsApp συνδέθηκε.",
    "connect_failed": "Δεν συνδέθηκε ({code}). Ελέγξτε το token, το phone number ID και το app secret.",
    "enabled": "Χρήση WhatsApp Business για πελάτες με συναίνεση WhatsApp",
    "lang": "Γλώσσα",
    "auto": "Αυτόματη αποστολή",
    "bad_name": "Το όνομα προτύπου έχει μόνο πεζά λατινικά, ψηφία και _ (όπως στη Meta).",
    "reminder_hours": "Αυτόματη υπενθύμιση: ώρες πριν από το ραντεβού",
    "renewal_days": "Αυτόματη ειδοποίηση ανανέωσης: ημέρες πριν",
    "privacy": "Από το CRM φεύγουν μόνο οι παράμετροι του προτύπου (μικρό όνομα, ημερομηνία, ώρα, όνομα προϊόντος) — ποτέ ποσά, αριθμοί συμβολαίων ή στοιχεία υγείας. Τα αυτόματα μηνύματα φεύγουν 09:00–20:00, μία φορά ανά πελάτη και περίσταση. Η Meta χρεώνει ανά συνομιλία.",
    "send": "Αποστολή στο WhatsApp",
    "send_title": "Αποστολή στο WhatsApp",
    "what": "Μήνυμα",
    "which_appointment": "Ραντεβού",
    "preview": "Πρότυπο {template} με: {params}",
    "send_note": "Στέλνεται από τον αριθμό σας WhatsApp Business με το εγκεκριμένο πρότυπο· η παράδοση φαίνεται στο χρονολόγιο του πελάτη.",
    "sent": "Στάλθηκε στο WhatsApp.",
    "send_failed": "Το WhatsApp δεν δέχτηκε το μήνυμα — δείτε το χρονολόγιο του πελάτη.",
    "send_error": "Δεν στάλθηκε ({code}).",
    "use": {
      "appointment_reminder": "Υπενθύμιση ραντεβού",
      "birthday": "Ευχές γενεθλίων",
      "renewal_notice": "Ειδοποίηση ανανέωσης"
    },
    "params": {
      "appointment_reminder": "Εγκεκριμένο πρότυπο με (1) μικρό όνομα, (2) ημερομηνία, (3) ώρα",
      "birthday": "Εγκεκριμένο πρότυπο με (1) μικρό όνομα",
      "renewal_notice": "Εγκεκριμένο πρότυπο με (1) μικρό όνομα, (2) προϊόν, (3) ημερομηνία ανανέωσης"
    },
    "block": {
      "off": "Το WhatsApp Business είναι κλειστό (Ρυθμίσεις).",
      "no_template": "Δεν έχει οριστεί εγκεκριμένο πρότυπο για αυτό το μήνυμα (Ρυθμίσεις).",
      "no_consent": "Δεν έχει καταγραφεί συναίνεση WhatsApp για αυτόν τον πελάτη (Συμμόρφωση → συναίνεση «WhatsApp»).",
      "consent_withdrawn": "Ο πελάτης ανακάλεσε τη συναίνεση για WhatsApp.",
      "no_number": "Δεν υπάρχει κινητό για αυτόν τον πελάτη.",
      "archived": "Ο πελάτης είναι αρχειοθετημένος.",
      "do_not_contact": "Ο πελάτης ζήτησε να μην επικοινωνούμε.",
      "not_found": "Επιλέξτε επόμενο ραντεβού με ώρα."
    },
    "consent_record": "Ο πελάτης συμφωνεί σε μηνύματα WhatsApp — καταγραφή συναίνεσης",
    "not_synced": "(Η πλατφόρμα ελέγχει τα συγχρονισμένα δεδομένα — αν το αλλάξατε μόλις τώρα, περιμένετε τον συγχρονισμό και δοκιμάστε ξανά.)"
  },
  "voice": {
    "open": "Σύνοψη συνάντησης από φωνή",
    "title": "Σύνοψη συνάντησης από φωνή",
    "intro": "Ηχογραφήστε τη συνάντηση στην εφαρμογή· παίρνετε πρόχειρη σύνοψη και προτεινόμενες εργασίες για έλεγχο και διόρθωση. Τίποτα δεν αποθηκεύεται πριν πατήσετε «Αποθήκευση». Ο ήχος στέλνεται μία φορά για απομαγνητοφώνηση και διαγράφεται αμέσως· δεν κρατιέται ποτέ στο CRM.",
    "consent_missing": "Δεν υπάρχει συναίνεση για ηχογράφηση συναντήσεων στην καρτέλα του πελάτη. Ρωτήστε τον· αν συμφωνεί, καταγράψτε την εδώ.",
    "consent_withdrawn": "Ο πελάτης ανακάλεσε τη συναίνεση για ηχογράφηση. Μην ηχογραφήσετε.",
    "consent_record": "Ο πελάτης συμφωνεί — καταγραφή συναίνεσης",
    "consent_note": "Συναίνεση για ηχογράφηση συναντήσεων με σκοπό γραπτή σύνοψη (ο ήχος διαγράφεται μετά την απομαγνητοφώνηση).",
    "consent_on_file": "Υπάρχει συναίνεση για ηχογράφηση ({date}).",
    "confirm_now": "Ρώτησα τον πελάτη τώρα και συμφωνεί με αυτή την ηχογράφηση.",
    "record_intro": "Τοποθετήστε τη συσκευή ανάμεσά σας. Έως {max} λεπτά.",
    "start": "Έναρξη ηχογράφησης",
    "stop": "Τέλος και σύνοψη",
    "recording": "Ηχογράφηση",
    "privacy": "Ο ήχος πηγαίνει μία φορά στην υπηρεσία απομαγνητοφώνησης μέσω της πλατφόρμας AVRASTRO και διαγράφεται αμέσως μετά. Στοιχεία υγείας και άλλα ευαίσθητα σημειώνονται και μένουν εκτός, εκτός αν τα κρατήσετε εσείς.",
    "mic_denied": "Το μικρόφωνο δεν είναι διαθέσιμο — επιτρέψτε το στον browser και δοκιμάστε ξανά.",
    "working": "Απομαγνητοφώνηση και σύνοψη… χρειάζεται έως ένα λεπτό.",
    "failed": "Δεν έγινε σύνοψη ({code}). Δεν αποθηκεύτηκε τίποτα.",
    "review_intro": "Ελέγξτε και διορθώστε. Αποθηκεύονται μόνο οι γραμμές και οι εργασίες με ✓.",
    "meeting": "Αποθήκευση στη συνάντηση",
    "new_meeting": "Νέα συνάντηση (σήμερα)",
    "summary": "Σύνοψη",
    "decisions": "Αποφάσεις",
    "tasks": "Προτεινόμενες εργασίες",
    "keep": "Κράτησε",
    "in_days": "σε ημέρες",
    "sensitive": "Ευαίσθητο: {kinds}",
    "sensitive_hint": "Μένει εκτός αν το τσεκάρετε. Κρατήστε μόνο ό,τι χρειάζεται για την ασφαλιστική ανάγκη.",
    "kind": {
      "health": "υγεία",
      "beliefs": "πεποιθήσεις",
      "origin": "καταγωγή",
      "sexual": "ιδιωτική ζωή",
      "criminal": "ποινικό μητρώο",
      "identifier": "αρ. ταυτότητας / τράπεζας"
    },
    "review_note": "Το προσχέδιο προέρχεται από AI και μπορεί να έχει λάθη· γίνεται δικό σας όταν το αποθηκεύσετε.",
    "save": "Αποθήκευση",
    "discard": "Απόρριψη",
    "saved": "Η σύνοψη της συνάντησης αποθηκεύτηκε.",
    "timeline": "Σύνοψη συνάντησης (από φωνή)",
    "off": "Η σύνοψη συνάντησης από φωνή δεν είναι ενεργή για αυτό το γραφείο (η πλατφόρμα χρειάζεται υπηρεσία απομαγνητοφώνησης — δείτε τα βήματα του ιδιοκτήτη). Δεν ηχογραφήθηκε τίποτα.",
    "need_account": "Συνδεθείτε στον λογαριασμό σας AVRASTRO για να χρησιμοποιήσετε τη σύνοψη συνάντησης.",
    "dictation_open": "Φωνητικές σημειώσεις μετά τη συνάντηση",
    "mode": "Τι ηχογραφείτε",
    "mode_meeting": "Τη συνάντηση (με συγκατάθεση)",
    "mode_dictation": "Τις δικές μου σημειώσεις",
    "dictation_intro": "Μετά τη συνάντηση, πείτε με δικά σας λόγια τι ειπώθηκε. Η φωνή σας γίνεται σημειώσεις συνάντησης, εργασίες και πρόχειρη ανάλυση αναγκών — όλα τα ελέγχετε πριν αποθηκευτούν. Λειτουργεί όταν έχει ρυθμιστεί η υπηρεσία μεταγραφής (TRANSCRIBE) στην πλατφόρμα.",
    "dictation_confirm": "Ηχογραφώ μόνο τη δική μου φωνή — όχι τον πελάτη.",
    "needs": "Ανάγκες για πρόχειρη ανάλυση αναγκών",
    "needs_note": "Όσες κρατήσετε γίνονται πρόχειρη (όχι τελική) ανάλυση αναγκών, που συμπληρώνετε εσείς."
  },
  "help": {
    "title": "Κέντρο βοήθειας",
    "subtitle": "Οδηγοί για κάθε οθόνη, συντομεύσεις και τι νέο υπάρχει.",
    "panel_title": "Βοήθεια για αυτή την οθόνη",
    "open": "Βοήθεια",
    "this_screen": "Βοήθεια για αυτή την οθόνη",
    "open_centre": "Κέντρο βοήθειας",
    "search": "Αναζήτηση στη βοήθεια…",
    "no_results": "Δεν βρέθηκε άρθρο για «{q}».",
    "no_context": "Δεν υπάρχει ακόμη άρθρο ειδικά για αυτή την οθόνη. Δείτε τα βασικά:",
    "topics": "Θέματα βοήθειας",
    "welcome_title": "Πώς μπορούμε να βοηθήσουμε;",
    "welcome_sub": "Ξεκινήστε από ένα από αυτά ή αναζητήστε με μια λέξη.",
    "press_question": "Συμβουλή: πατήστε «?» σε οποιαδήποτε οθόνη για βοήθεια ειδικά για αυτή.",
    "lesson_link": "Μάθημα: {title}",
    "keys": "Πλήκτρα",
    "action": "Ενέργεια",
    "where": "Πού",
    "version": "Έκδοση {v}",
    "tab": {
      "articles": "Άρθρα",
      "shortcuts": "Συντομεύσεις",
      "new": "Τι νέο υπάρχει",
      "ask": "Ρωτήστε το AVRASTRO"
    },
    "group": {
      "start": "Ξεκίνημα",
      "clients": "Πελάτες & ραντεβού",
      "sales": "Πωλήσεις & συμμόρφωση",
      "service": "Εξυπηρέτηση & ανανεώσεις",
      "growth": "Ανάπτυξη & παραγωγή",
      "safety": "Δεδομένα & ασφάλεια",
      "settings": "Ρυθμίσεις"
    }
  },
  "lessons": {
    "title": "Μαθήματα",
    "subtitle": "{count} σύντομα μαθήματα με βήματα, βίντεο και κουίζ — με τον δικό σας ρυθμό.",
    "progress": "{done} από {total} μαθήματα ολοκληρώθηκαν",
    "continue": "Συνέχεια: {title}",
    "start": "Ξεκινήστε: {title}",
    "minutes": "{n} λεπτά",
    "level": {
      "basic": "Βασικό",
      "daily": "Καθημερινή δουλειά",
      "advanced": "Προχωρημένο"
    },
    "done": "Ολοκληρώθηκε",
    "quiz_score": "Κουίζ {correct}/{of}",
    "video_soon": "Το βίντεο έρχεται σύντομα",
    "video_soon_sub": "Στο μεταξύ, ακολουθήστε τα βήματα παρακάτω — είναι τα ίδια με το βίντεο.",
    "watch_in": "Δείτε το στα {lang}",
    "lang": {
      "el": "Ελληνικά",
      "en": "Αγγλικά",
      "ru": "Ρωσικά"
    },
    "of": "Μάθημα {n} από {total}",
    "all": "Όλα τα μαθήματα",
    "goal": "Τι θα μάθετε",
    "steps": "Βήματα",
    "practice": "Δοκιμάστε το: {screen}",
    "mark_done": "Σημείωση ως ολοκληρωμένο",
    "mark_undone": "Αναίρεση ολοκλήρωσης",
    "marked_done": "Το μάθημα ολοκληρώθηκε",
    "marked_undone": "Το μάθημα σημειώθηκε ως μη ολοκληρωμένο",
    "read_more": "Διαβάστε επίσης",
    "nav": "Πλοήγηση μαθημάτων",
    "prev": "Προηγούμενο",
    "next": "Επόμενο",
    "quiz": "Σύντομο κουίζ",
    "right": "Σωστά!",
    "wrong": "Όχι ακριβώς.",
    "check": "Έλεγχος απαντήσεων",
    "retry": "Ξανά"
  },
  "setup": {
    "step": {
      "profile": {
        "title": "Προφίλ & εγγραφή ICCS",
        "sub": "Ο αριθμός μητρώου σας, η ιδιότητα και οι κλάδοι για τους οποίους είστε εγγεγραμμένοι."
      },
      "office": {
        "title": "Γραφείο & διαθεσιμότητα",
        "sub": "Πού και πότε συναντάτε πελάτες."
      },
      "clients": {
        "title": "Εισαγωγή πελατών",
        "sub": "Φέρτε τους πελάτες σας από Excel/CSV ή από το παλιό VÉRO."
      },
      "connect": {
        "title": "Ημερολόγιο & e-mail",
        "sub": "Τα ραντεβού σας στο Outlook και τα e-mail με πελάτες στο ιστορικό τους."
      },
      "bookings": {
        "title": "Κρατήσεις στο avrastro.com",
        "sub": "Οι πελάτες κλείνουν ραντεβού online· εσείς εγκρίνετε."
      },
      "modules": {
        "title": "Ποια εργαλεία θα βλέπετε",
        "sub": "Κρύψτε ό,τι δεν χρειάζεστε — τα δεδομένα δεν αλλάζουν."
      },
      "safety": {
        "title": "Αντίγραφα & ασφάλεια",
        "sub": "Ένα αντίγραφο εκτός συσκευής, κρυπτογράφηση και ασφαλής σύνδεση."
      }
    },
    "title": "Ρύθμιση του AVRASTRO",
    "subtitle": "Επτά σύντομα βήματα· κάθε βήμα παραλείπεται και συνεχίζεται όποτε θέλετε.",
    "help": "Πώς λειτουργεί",
    "steps_label": "Βήματα ρύθμισης",
    "progress": "Πρόοδος {percent}%",
    "progress_aria": "Η ρύθμιση έχει ολοκληρωθεί κατά {percent}%",
    "step_of": "Βήμα {n} από {total}",
    "card_title": "Ας ετοιμάσουμε το γραφείο σας",
    "card_sub": "{done} από {total} βήματα έτοιμα{skipped, plural, =0 {} one { · # παραλείφθηκε} other { · # παραλείφθηκαν}}",
    "start": "Έναρξη ρύθμισης",
    "continue": "Συνέχεια ρύθμισης",
    "snooze": "Απόκρυψη για μια εβδομάδα",
    "snoozed": "Η λίστα θα επιστρέψει σε μια εβδομάδα — ή ανοίξτε τον Οδηγό ρύθμισης όποτε θέλετε.",
    "back": "Πίσω",
    "skip": "Παράλειψη για τώρα",
    "unskip": "Επαναφορά βήματος",
    "mark_done": "Έγινε",
    "save_next": "Αποθήκευση και συνέχεια",
    "next": "Συνέχεια",
    "cancel": "Άκυρο",
    "saved": "Αποθηκεύτηκε",
    "choose": "— επιλέξτε —",
    "status": {
      "done": "Έγινε",
      "skipped": "Παραλείφθηκε",
      "todo": "Εκκρεμεί"
    },
    "finish": {
      "title": "Λίστα ξεκινήματος",
      "sub": "{done} από {total} βήματα έτοιμα. Τα υπόλοιπα μένουν στην οθόνη «Τώρα» μέχρι να τα κάνετε ή να τα παραλείψετε.",
      "done_title": "Είστε έτοιμοι!",
      "done_sub": "Η ρύθμιση ολοκληρώθηκε. Τα μαθήματα σας δείχνουν την καθημερινή δουλειά βήμα-βήμα."
    },
    "to_today": "Στην οθόνη «Τώρα»",
    "reg_no": "Αριθμός μητρώου ICCS",
    "reg_no_hint": "Όπως εμφανίζεται στο μητρώο διαμεσολαβητών της Υπηρεσίας Ελέγχου Ασφαλιστικών Εταιρειών· μπαίνει στα έγγραφα προς πελάτες.",
    "capacity": "Ιδιότητα",
    "capacity_hint": "Η ιδιότητα με την οποία είστε εγγεγραμμένοι.",
    "capacity_opt": {
      "tied_agent": "Αποκλειστικός (συνδεδεμένος) ασφαλιστικός πράκτορας",
      "agent": "Ασφαλιστικός πράκτορας (περισσότερων ασφαλιστικών)",
      "broker": "Ασφαλιστικός μεσίτης",
      "advisor_rep": "Ασφαλιστικός σύμβουλος διαμεσολαβητή",
      "ancillary": "Παρεπόμενος ασφαλιστικός διαμεσολαβητής"
    },
    "lines": "Κλάδοι",
    "line": {
      "life": "Ασφαλίσεις ζωής",
      "general": "Γενικές ασφαλίσεις",
      "life_sub": "Ζωής, υγείας, αποταμίευσης, σύνταξης — με φάκελο KYC/AML και φορολογικό κέντρο.",
      "general_sub": "Οχήματα, κατοικία, ταξίδι, επιχείρηση — με ασφαλισμένα αντικείμενα και στάδια ανανέωσης."
    },
    "insurers": "Ασφαλιστικές με τις οποίες συνεργάζεστε",
    "insurers_hint": "Χωρίστε με κόμμα.",
    "profile_note": "Τα στοιχεία μπαίνουν στις προτάσεις, στις επιστολές και στο προφίλ σας· αλλάζουν οποτεδήποτε από τις Ρυθμίσεις. Το AVRASTRO δεν είναι ασφαλιστική εταιρεία.",
    "https_hint": "Σύνδεσμος που αρχίζει με https://",
    "office_phone": "Τηλέφωνο γραφείου",
    "days": "Ημέρες εργασίας",
    "from": "Από",
    "to": "Έως",
    "meeting_minutes": "Συνήθης διάρκεια συνάντησης",
    "minutes": "{n} λεπτά",
    "modes": "Πού συναντάτε πελάτες",
    "mode": {
      "office": "Στο γραφείο",
      "online": "Online",
      "phone": "Τηλεφωνικά",
      "client_place": "Στον χώρο του πελάτη",
      "cafe": "Σε καφετέρια"
    },
    "office_note": "Η διάρκεια γίνεται η προεπιλογή για νέα ραντεβού· τις ώρες κρατήσεων στο avrastro.com τις ορίζετε στο Advisor Hub.",
    "clients_now": "{count, plural, =0 {Δεν έχετε ακόμη πελάτες στο AVRASTRO.} one {Έχετε # πελάτη ή υποψήφιο στο AVRASTRO.} other {Έχετε # πελάτες και υποψήφιους στο AVRASTRO.}}",
    "clients_demo": "(Είναι δοκιμαστικά πρόσωπα — φέρτε τους δικούς σας.)",
    "clients_excel": "Από Excel ή CSV",
    "clients_excel_sub": "Λίστα πελατών με έλεγχο διπλών πριν αποθηκευτεί οτιδήποτε.",
    "clients_vero": "Από το παλιό VÉRO CRM",
    "clients_vero_sub": "Αντίγραφο ασφαλείας (.json/.ICRM) με συμβόλαια, εργασίες και έγγραφα.",
    "clients_one_sub": "Ένα-ένα, με προειδοποίηση για διπλό τηλέφωνο ή e-mail.",
    "clients_card_sub": "Φωτογραφία επαγγελματικής κάρτας από τη Γρήγορη προσθήκη («+»).",
    "connect_done": "Το Outlook είναι συνδεδεμένο.",
    "connect_ready": "Μπορείτε να συνδέσετε το Outlook από τον Λογαριασμό σας.",
    "connect_sign_in": "Η σύνδεση ημερολογίου και e-mail χρειάζεται λογαριασμό AVRASTRO. Χωρίς λογαριασμό, κάθε ραντεβού ανοίγει ως αρχείο .ics στο ημερολόγιό σας.",
    "connect_outlook_sub": "Τα ραντεβού του CRM στο Outlook και στο κινητό· οι κρατημένες ώρες σας κλείνουν τις ώρες κρατήσεων.",
    "connect_mail": "E-mail με πελάτες",
    "connect_mail_sub": "Τα e-mail με πελάτες του CRM εμφανίζονται στο ιστορικό τους (προαιρετικό).",
    "connect_ics": "Χωρίς σύνδεση (.ics)",
    "connect_ics_sub": "Από την Ατζέντα, κάθε ραντεβού ανοίγει στο ημερολόγιο του τηλεφώνου σας.",
    "connect_note": "Το AVRASTRO δεν στέλνει ποτέ μηνύματα μόνο του· ανοίγει προσχέδια στις δικές σας εφαρμογές.",
    "bookings_1": "Στο avrastro.com → Advisor Hub → Διαθεσιμότητα ορίστε ημέρες και ώρες.",
    "bookings_2": "Με «Προεπισκόπηση» βλέπετε τη σελίδα κρατήσεων· αντιγράψτε τη διεύθυνσή της εδώ.",
    "bookings_3": "Κάθε αίτημα έρχεται στα Εισερχόμενα ιστότοπου· μπαίνει στην ατζέντα μόνο όταν το επιβεβαιώσετε.",
    "open_availability": "Άνοιγμα Διαθεσιμότητας στο avrastro.com",
    "booking_url": "Ο σύνδεσμος κρατήσεών σας",
    "copy": "Αντιγραφή",
    "copied": "Αντιγράφηκε",
    "copy_failed": "Η αντιγραφή δεν έγινε — επιλέξτε τον σύνδεσμο και αντιγράψτε τον.",
    "bookings_note": "Βάλτε τον σύνδεσμο στην υπογραφή του e-mail, στα κοινωνικά δίκτυα ή στο site σας.",
    "modules_both": "Είστε εγγεγραμμένοι για ζωής και γενικών: φαίνονται όλα τα εργαλεία.",
    "modules_life": "Μόνο ζωής: τα εργαλεία γενικών (ασφαλισμένα αντικείμενα, στάδια ανανέωσης γενικών) είναι κρυμμένα.",
    "modules_general": "Μόνο γενικών: τα εργαλεία ζωής (KYC/AML, Προστασία, Φορολογικό κέντρο) είναι κρυμμένα.",
    "change_lines": "Αλλαγή κλάδων",
    "modules_note": "Η απόκρυψη αλλάζει μόνο τι βλέπετε· τα δεδομένα μένουν και μια κρυμμένη οθόνη ανοίγει πάντα από τον Φακό.",
    "safety_no_backup": "Δεν έχει γίνει ακόμη αρχείο αντιγράφου ασφαλείας σε αυτή τη συσκευή.",
    "safety_backup_age": "{days, plural, =0 {Τελευταίο αντίγραφο: σήμερα.} one {Τελευταίο αντίγραφο: πριν από # ημέρα.} other {Τελευταίο αντίγραφο: πριν από # ημέρες.}}",
    "safety_encrypted": "Τα δεδομένα σε αυτή τη συσκευή είναι κρυπτογραφημένα.",
    "safety_not_encrypted": "Τα δεδομένα δεν είναι κρυπτογραφημένα από το AVRASTRO.",
    "safety_account": "Ενεργοποιήστε σύνδεση δύο βημάτων ή passkey στον λογαριασμό σας.",
    "practice_title": "Κλάδοι, εγγραφή και εργαλεία",
    "hidden_tools": "Κρυμμένα εργαλεία",
    "none_hidden": "Κανένα",
    "choose_tools": "Επιλογή εργαλείων"
  },
  "cimport": {
    "field": {
      "displayName": "Ονοματεπώνυμο",
      "firstName": "Όνομα",
      "lastName": "Επώνυμο",
      "phone": "Τηλέφωνο",
      "email": "E-mail",
      "birthDate": "Ημ. γέννησης",
      "address": "Διεύθυνση",
      "city": "Πόλη",
      "occupation": "Επάγγελμα",
      "clientSince": "Πελάτης από",
      "notes": "Σημειώσεις"
    },
    "title": "Εισαγωγή πελατών από Excel ή CSV",
    "intro": "Επιλέξτε αρχείο .xlsx ή .csv ή επικολλήστε γραμμές με τη γραμμή επικεφαλίδων. Ελέγξτε την αντιστοίχιση στηλών και την προεπισκόπηση — τίποτα δεν αποθηκεύεται πριν πατήσετε «Εισαγωγή».",
    "choose": "Επιλογή αρχείου",
    "paste": "…ή επικολλήστε εδώ τις γραμμές (με τη γραμμή επικεφαλίδων)",
    "unreadable": "Το αρχείο δεν διαβάστηκε. Αποθηκεύστε το ως .xlsx ή CSV και δοκιμάστε ξανά.",
    "header_row": "Η πρώτη γραμμή είναι επικεφαλίδες",
    "column": "Στήλη {n}",
    "ignore": "— αγνόηση —",
    "kind": {
      "new": "Νέος",
      "existing": "Υπάρχει ήδη",
      "repeat": "Επανάληψη στο αρχείο",
      "invalid": "Χωρίς όνομα"
    },
    "col": {
      "status": "Κατάσταση",
      "notes": "Παρατηρήσεις"
    },
    "add_anyway": "Προσθήκη του/της {name} παρ’ όλα αυτά",
    "match": {
      "phone": "Ίδιο τηλέφωνο με {name}",
      "email": "Ίδιο e-mail με {name}",
      "name": "Ίδιο όνομα με {name}"
    },
    "problem": {
      "birth_date": "ημ. γέννησης αγνοείται",
      "client_since": "«πελάτης από» αγνοείται",
      "email": "e-mail μη έγκυρο"
    },
    "more_rows": "…και {count} ακόμη γραμμές.",
    "as": "Εισαγωγή ως",
    "stage": {
      "client": "Πελάτες",
      "prospect": "Υποψήφιοι"
    },
    "safety": "Όσοι υπάρχουν ήδη δεν αλλάζουν. Όλη η εισαγωγή αναιρείται με Ctrl+Z.",
    "run": "{count, plural, =0 {Εισαγωγή} one {Εισαγωγή # προσώπου} other {Εισαγωγή # προσώπων}}",
    "done": "{count, plural, one {Εισήχθη # πρόσωπο} other {Εισήχθησαν # πρόσωπα}}",
    "card_title": "Εισαγωγή πελατών (Excel/CSV)",
    "card_sub": "Λίστα πελατών από άλλο πρόγραμμα ή υπολογιστικό φύλλο, με έλεγχο διπλών.",
    "open": "Εισαγωγή πελατών"
  },
  "salefile": {
    "check": {
      "identity_disclosed": "Στοιχεία & αριθμός μητρώου διαμεσολαβητή",
      "advice_disclosed": "Αν παρέχεται συμβουλή",
      "complaints_info": "Καταγγελίες & εξωδικαστική επίλυση",
      "capacity_disclosed": "Ιδιότητα & ασφαλιστικές που εκπροσωπείτε",
      "remuneration_disclosed": "Είδος αμοιβής",
      "demands_needs": "Απαιτήσεις και ανάγκες",
      "recommendation": "Εξατομικευμένη σύσταση",
      "product_info": "Έντυπο πληροφοριών προϊόντος",
      "kid": "Έγγραφο βασικών πληροφοριών (KID)",
      "costs_disclosed": "Κόστη και επιβαρύνσεις",
      "suitability": "Αξιολόγηση καταλληλότητας",
      "suitability_report": "Δήλωση καταλληλότητας",
      "kyc": "Φάκελος KYC/AML πλήρης",
      "privacy_notice": "Ενημέρωση για προσωπικά δεδομένα (GDPR)",
      "durable_medium": "Σε χαρτί ή σταθερό μέσο",
      "signed": "Υπογεγραμμένη πρόταση / αίτηση"
    },
    "check_hint": {
      "identity_disclosed": "Όνομα, διεύθυνση, εγγραφή στο ICCS και πώς ελέγχεται (IDD άρθρο 18).",
      "advice_disclosed": "Ενημέρωση αν δίνετε συμβουλή για τα προϊόντα (IDD άρθρο 18).",
      "complaints_info": "Διαδικασία παραπόνων και Χρηματοοικονομικός Επίτροπος (IDD άρθρο 18).",
      "capacity_disclosed": "Αν ενεργείτε για λογαριασμό του πελάτη ή ασφαλιστικής(-ών) και ποιων (IDD άρθρο 19).",
      "remuneration_disclosed": "Αμοιβή από τον πελάτη, προμήθεια ή άλλο, ή συνδυασμός (IDD άρθρο 19).",
      "demands_needs": "Καταγράφονται στο πεδίο παραπάνω· το προϊόν συνάδει με αυτές (IDD άρθρο 20).",
      "recommendation": "Γιατί το προϊόν καλύπτει καλύτερα τις ανάγκες (IDD άρθρο 20).",
      "product_info": "IPID για γενικές ασφαλίσεις (IDD άρθρο 20(5)) ή οι προσυμβατικές πληροφορίες της ασφαλιστικής για ζωής.",
      "kid": "Για επενδυτικά ασφαλιστικά προϊόντα (κανονισμός PRIIPs).",
      "costs_disclosed": "Όλα τα κόστη και οι σχετικές επιβαρύνσεις (IDD άρθρο 29).",
      "suitability": "Γνώσεις & εμπειρία, οικονομική κατάσταση και ικανότητα ζημιών, στόχοι και ανοχή κινδύνου (IDD άρθρο 30).",
      "suitability_report": "Δίνεται στον πελάτη πριν από τη σύμβαση (IDD άρθρο 30).",
      "kyc": "Από την καρτέλα KYC/AML του πελάτη.",
      "privacy_notice": "Ενημέρωση επεξεργασίας και, όπου χρειάζεται, συγκατάθεση.",
      "durable_medium": "Οι πληροφορίες δόθηκαν σε χαρτί ή σταθερό μέσο και ο πελάτης κράτησε αντίγραφο (IDD άρθρο 23).",
      "signed": "Η πρόταση ασφάλισης υπογράφηκε από τον πελάτη."
    },
    "title": "Φάκελοι πώλησης (IDD)",
    "subtitle": "Απαιτήσεις και ανάγκες, σύσταση και ενημερώσεις προς τον πελάτη — ένας φάκελος ανά πώληση.",
    "how": "Τι χρειάζεται",
    "new": "Νέος φάκελος πώλησης",
    "stat": {
      "without": "Συμβόλαια 12 μηνών χωρίς φάκελο",
      "open": "Φάκελοι σε εξέλιξη",
      "complete": "Ολοκληρωμένοι φάκελοι"
    },
    "without_title": "Συμβόλαια χωρίς φάκελο",
    "without_sub": "Ενεργά συμβόλαια που ξεκίνησαν τους τελευταίους 12 μήνες.",
    "open_file": "Άνοιγμα φακέλου",
    "without_empty": "Κάθε πρόσφατο συμβόλαιο έχει φάκελο πώλησης.",
    "open_title": "Σε εξέλιξη",
    "open_sub": "Τι λείπει από κάθε φάκελο.",
    "progress": "Συμπληρωμένο κατά {percent}%",
    "missing": "Λείπει: {list}",
    "open_empty": "Δεν υπάρχει φάκελος σε εκκρεμότητα.",
    "done_title": "Ολοκληρωμένοι φάκελοι",
    "hide": "Απόκρυψη",
    "view": "Προβολή",
    "done_empty": "Δεν υπάρχει ακόμη ολοκληρωμένος φάκελος.",
    "disclaimer": "Βοήθημα για τον δικό σας φάκελο σύμφωνα με την Οδηγία (ΕΕ) 2016/97 (IDD) και τον Ν. 38(Ι)/2016 όπως τροποποιήθηκε — όχι νομική συμβουλή. Προηγούνται οι κανόνες της ασφαλιστικής σας και οι οδηγίες της Υπηρεσίας Ελέγχου Ασφαλιστικών Εταιρειών. Οι φάκελοι δεν διαγράφονται.",
    "edit_title": "Φάκελος πώλησης — {name}",
    "save": "Αποθήκευση φακέλου",
    "saved": "Ο φάκελος πώλησης αποθηκεύτηκε",
    "complete": "Ο φάκελος είναι πλήρης",
    "client": "Πελάτης",
    "policy": "Συμβόλαιο",
    "no_policy": "— χωρίς συμβόλαιο ακόμη —",
    "sale_date": "Ημερομηνία πώλησης",
    "product": "Προϊόν",
    "insurer": "Ασφαλιστική",
    "line_label": "Είδος πώλησης",
    "line": {
      "life": "Ζωής",
      "general": "Γενικών",
      "ibip": "Επενδυτικό ασφαλιστικό (IBIP)"
    },
    "line_hint": {
      "life": "Ζωής, υγείας, προστασίας εισοδήματος — με φάκελο KYC/AML.",
      "general": "Οχήματος, κατοικίας, ταξιδιού, επιχείρησης — με έντυπο IPID.",
      "ibip": "Αποταμιευτικά/επενδυτικά (π.χ. unit-linked): και αξιολόγηση καταλληλότητας, κόστη και KID."
    },
    "advice_label": "Συμβουλή",
    "advice": {
      "advised": "Με συμβουλή",
      "non_advised": "Χωρίς συμβουλή"
    },
    "channel_label": "Τρόπος",
    "channel": {
      "face_to_face": "Δια ζώσης",
      "distance": "Από απόσταση"
    },
    "needs": "Ανάλυση αναγκών",
    "demands": "Απαιτήσεις και ανάγκες του πελάτη",
    "demands_hint": "Τι ζήτησε και τι χρειάζεται ο πελάτης, με δικά σας λόγια (τουλάχιστον μία πρόταση).",
    "recommendation": "Σύσταση",
    "recommendation_hint": "Γιατί το προτεινόμενο προϊόν καλύπτει καλύτερα αυτές τις ανάγκες.",
    "checklist": "Τι δόθηκε στον πελάτη και πότε",
    "open_kyc": "Άνοιγμα KYC/AML",
    "auto_ok": "Συμπληρώθηκε",
    "auto_todo": "Συμπληρώστε το πεδίο",
    "given_on": "Ημερομηνία: {item}",
    "today": "Σήμερα",
    "document_for": "Έγγραφο: {item}",
    "no_document": "— χωρίς έγγραφο —",
    "notes": "Σημειώσεις"
  },
  "nba": {
    "kind": {
      "settle_arrears": "Πρώτα το ληξιπρόθεσμο ασφάλιστρο",
      "call_detractor": "Τηλεφωνήστε πριν από κάθε πρόταση",
      "resolve_service": "Κλείστε πρώτα το ανοιχτό θέμα",
      "request_terms": "Ζητήστε όρους ανανέωσης",
      "send_terms": "Στείλτε τη σύγκριση στον πελάτη",
      "follow_up_terms": "Πάρτε τηλέφωνο για την απόφαση",
      "confirm_renewal": "Καταγράψτε την ανανέωση",
      "explain_increase": "Εξηγήστε την αύξηση",
      "check_sum_insured": "Ελέγξτε την αξία ανοικοδόμησης",
      "renew_kyc": "Ενημερώστε τον φάκελο KYC",
      "review_cover": "Κλείστε ραντεβού επανεξέτασης",
      "confirm_contact": "Πάρτε ένα τηλέφωνο",
      "prepare_renewal": "Προετοιμάστε την ανανέωση"
    },
    "why": {
      "settle_arrears": "Ανοιχτό ποσό {amount} εδώ και {days} ημέρες — η κάλυψη κινδυνεύει πριν την ανανέωση.",
      "call_detractor": "Ο πελάτης βαθμολόγησε την εξυπηρέτηση {score}/10 φέτος — ακούστε τον πρώτα.",
      "resolve_service": "{count, plural, one {Μία ανοιχτή αποζημίωση ή αίτημα} other {# ανοιχτές αποζημιώσεις ή αιτήματα}} — μια ανανέωση δεν συζητιέται καλά όσο εκκρεμεί.",
      "request_terms": "Δεν έχει ξεκινήσει ακόμη — ζητήστε όρους από τις ασφαλιστικές.",
      "send_terms": "Οι όροι συγκρίθηκαν — στείλτε τους στον πελάτη.",
      "follow_up_terms": "Οι όροι στάλθηκαν πριν από {days} ημέρες χωρίς απάντηση.",
      "confirm_renewal": "Ο πελάτης ενέκρινε — καταγράψτε «Ανανεώθηκε» για να ενημερωθεί το ασφάλιστρο.",
      "explain_increase": "Το νέο ασφάλιστρο είναι {pct}% υψηλότερο — εξηγήστε το ή δείτε εναλλακτικές.",
      "check_sum_insured": "Για «{item}» η αξία λείπει ή φαίνεται χαμηλή — ενδεικτικός έλεγχος υποασφάλισης.",
      "renew_kyc": "Ο φάκελος KYC/AML είναι ελλιπής ή λήγει — ενημερώστε τον στη συνάντηση της επετείου.",
      "review_cover": "Καμία επανεξέταση τους τελευταίους 12 μήνες — η επέτειος είναι η ευκαιρία.",
      "confirm_contact": "Καμία καταγεγραμμένη επαφή τους τελευταίους 6 μήνες.",
      "prepare_renewal": "Όλα σε τάξη — ετοιμάστε μια σύντομη ενημέρωση για τον πελάτη."
    },
    "also": {
      "settle_arrears": "ληξιπρόθεσμο",
      "call_detractor": "χαμηλή βαθμολογία",
      "resolve_service": "ανοιχτό θέμα",
      "request_terms": "όροι",
      "send_terms": "αποστολή όρων",
      "follow_up_terms": "αναμονή απάντησης",
      "confirm_renewal": "εγκρίθηκε",
      "explain_increase": "αύξηση ασφαλίστρου",
      "check_sum_insured": "πιθανή υποασφάλιση",
      "renew_kyc": "KYC",
      "review_cover": "επανεξέταση",
      "confirm_contact": "χωρίς επαφή",
      "prepare_renewal": "ανανέωση"
    },
    "title": "Επόμενη καλύτερη ενέργεια",
    "subtitle": "Για κάθε ανανέωση των επόμενων 60 ημερών, η κίνηση που αξίζει τώρα.",
    "in_days": "λήξη σε {days} ημ. · {date}",
    "expired": "έληξε πριν από {days} ημ. · {date}",
    "task_title": "{action}: {product}",
    "task_done": "Η εργασία μπήκε στην ατζέντα για σήμερα",
    "task_exists": "Στην ατζέντα",
    "create_task": "Δημιουργία εργασίας",
    "empty": "Καμία ανανέωση τις επόμενες 60 ημέρες.",
    "more": "Εμφάνιση {count} ακόμη"
  },
  "call": {
    "outcome": {
      "no_answer": "Δεν απάντησε",
      "busy": "Κατειλημμένο",
      "wrong_number": "Λάθος αριθμός",
      "not_interested": "Δεν ενδιαφέρεται",
      "callback": "Να καλέσω αργότερα",
      "interested": "Ενδιαφέρεται",
      "meeting": "Κλείστηκε συνάντηση",
      "do_not_call": "Να μην ξανακληθεί"
    }
  },
  "calls": {
    "title": "Τηλεφωνική προσέγγιση",
    "subtitle": "Λίστες τηλεφώνων, γρήγορη οθόνη κλήσεων και τα αποτελέσματά σας — ποιος απάντησε, ποιος θέλει να του ξανατηλεφωνήσετε, πού κλείσατε συνάντηση.",
    "how": "Πώς λειτουργεί",
    "new_list": "Νέα λίστα κλήσεων",
    "edit_list": "Ρυθμίσεις λίστας",
    "goal_today": "Κλήσεις σήμερα",
    "goal_week": "Συναντήσεις αυτή την εβδομάδα",
    "streak": "{count, plural, one {# μέρα στη σειρά} other {# μέρες στη σειρά}}",
    "best": "ρεκόρ {count}",
    "goals_edit": "Στόχοι",
    "goal_dials": "Κλήσεις την ημέρα",
    "goal_meetings": "Συναντήσεις την εβδομάδα",
    "max_attempts": "Μέγιστες προσπάθειες ανά αριθμό",
    "max_attempts_hint": "Μετά από τόσες κλήσεις χωρίς απάντηση, ο αριθμός δεν ξαναμπαίνει στη σειρά.",
    "no_lists": "Δεν υπάρχει ακόμη λίστα. Δημιουργήστε μία, επικολλήστε αριθμούς ή εισαγάγετε αρχείο Excel/CSV.",
    "numbers": "Αριθμοί",
    "to_call": "Για κλήση σήμερα",
    "dials": "Κλήσεις",
    "meetings": "Συναντήσεις",
    "dnc_short": "Χωρίς κλήσεις",
    "start": "Ξεκινήστε κλήσεις",
    "import": "Εισαγωγή αριθμών",
    "open_list": "Η λίστα",
    "overdue_title": "{count, plural, one {# επανάκληση περιμένει} other {# επανακλήσεις περιμένουν}}",
    "overdue_sub": "Είχατε πει «θα σας ξανακαλέσω» και η μέρα πέρασε.",
    "call_now": "Κλήση τώρα",
    "privacy_title": "Ιδιωτικότητα:",
    "privacy_note": "Για κάθε λίστα σημειώστε τη νομική βάση (συγκατάθεση ή έννομο συμφέρον) και από πού προήλθαν οι αριθμοί. Όποιος ζητήσει να μην τον ξανακαλέσετε σημειώνεται «Να μην ξανακληθεί» και δεν εμφανίζεται πουθενά ξανά για κλήση.",
    "privacy_settings": "Ρυθμίσεις",
    "settings_title": "Τηλεφωνική προσέγγιση",
    "legal_title": "Ελέγξτε τους ισχύοντες κανόνες:",
    "legal_note": "Οι κανόνες για τις μη ζητηθείσες κλήσεις προώθησης και για τα δεδομένα που κρατάτε αλλάζουν. Το AVRASTRO δεν κρίνει τι επιτρέπεται: πριν καλέσετε μια λίστα, ελέγξτε τους κανόνες που ισχύουν σήμερα στην Κύπρο (για παράδειγμα τις οδηγίες του Γραφείου Επιτρόπου Προστασίας Δεδομένων Προσωπικού Χαρακτήρα) και τις οδηγίες της εταιρείας σας. Καταγράψτε από πού προήλθε κάθε λίστα και σεβαστείτε κάθε αίτημα «να μη με ξανακαλέσετε».",
    "list_name": "Όνομα λίστας",
    "list_name_hint": "π.χ. «Λίστα Α Οκτώβριος»",
    "lawful_basis": "Νομική βάση",
    "lawful_basis_hint": "Σε ποια βάση κρατάτε και καλείτε αυτούς τους αριθμούς.",
    "basis": {
      "consent": "Συγκατάθεση",
      "legitimate_interest": "Έννομο συμφέρον",
      "existing_relationship": "Υφιστάμενη σχέση",
      "unknown": "Δεν είναι γνωστή"
    },
    "basis_missing": "χωρίς νομική βάση",
    "consent_source": "Πηγή αριθμών / συγκατάθεσης",
    "consent_source_hint": "π.χ. «Φόρμα επισκεπτών έκθεσης 2026»",
    "scripts": "Εναρκτήριες φράσεις A / B",
    "scripts_hint": "Δοκιμάστε δύο τρόπους να ξεκινάτε· η «Βελτίωσή μου» δείχνει ποιος κλείνει περισσότερες συναντήσεις.",
    "variant": "Παραλλαγή {v}",
    "script_title": "Σύντομος τίτλος",
    "script_opening": "Τι λέτε στην αρχή",
    "script_notes": "Σημειώσεις: ερωτήσεις, απαντήσεις σε αντιρρήσεις",
    "save_and_import": "Αποθήκευση και εισαγωγή αριθμών",
    "import_dnc": "{count, plural, one {# αριθμός είναι «Να μην ξανακληθεί» και δεν προστίθεται} other {# αριθμοί είναι «Να μην ξανακληθούν» και δεν προστίθενται}}",
    "legend_dnc": "Να μην ξανακληθεί",
    "session": "Κλήσεις",
    "made_session": "{count, plural, one {# κλήση} other {# κλήσεις}}",
    "booked_session": "{count, plural, one {# συνάντηση} other {# συναντήσεις}}",
    "today_of": "Σήμερα {n} / {goal}",
    "left": "Απομένουν {count}",
    "variant_mode": "Εναρκτήρια φράση",
    "alternate": "A/B εναλλάξ",
    "end_session": "Τέλος",
    "done_title": "Δεν απομένει κανείς για σήμερα",
    "done_sub": "Σε αυτή τη συνεδρία: {made} κλήσεις, {booked} συναντήσεις.",
    "reason": {
      "callback_due": "Επανάκληση για σήμερα",
      "followup_due": "Συνέχεια — ενδιαφέρεται",
      "new": "Νέος αριθμός",
      "retry": "Νέα προσπάθεια"
    },
    "attempts": "{count, plural, one {# προσπάθεια} other {# προσπάθειες}}",
    "timer_start": "Έναρξη χρόνου",
    "timer_stop": "Τέλος συνομιλίας",
    "notes": "Σημειώσεις",
    "history": "{count, plural, one {# προηγούμενη κλήση} other {# προηγούμενες κλήσεις}}",
    "held_on": "Βάση: {basis} · Πηγή: {source}",
    "opening_line": "Εναρκτήρια φράση {v}",
    "no_script": "Δεν έχετε γράψει εναρκτήρια φράση για αυτή την παραλλαγή.",
    "add_script": "Προσθήκη",
    "outcome": "Αποτέλεσμα",
    "when_meeting": "Πότε είναι η συνάντηση;",
    "when_callback": "Πότε να ξανακαλέσετε;",
    "today": "Σήμερα",
    "tomorrow": "Αύριο",
    "date": "Ημερομηνία",
    "time": "Ώρα",
    "where": "Πού",
    "duration": "Διάρκεια",
    "minutes": "{count} λεπτά",
    "book_meeting": "Κλείσιμο συνάντησης",
    "save_callback": "Αποθήκευση επανάκλησης",
    "keys_hint": "Πλήκτρα 1–8 για γρήγορο αποτέλεσμα · Esc για έξοδο",
    "skip": "Παράλειψη",
    "saved": "{name}: αποθηκεύτηκε",
    "saved_callback": "{name}: η επανάκληση μπήκε στις εργασίες",
    "saved_meeting": "{name}: η συνάντηση μπήκε στην ατζέντα",
    "task_callback": "Επανάκληση: {name}",
    "task_followup": "Συνέχεια: {name} (ενδιαφέρεται)",
    "task_meeting": "Συνάντηση με {name} (από τηλεφωνική προσέγγιση)",
    "dnc_title": "«Να μην ξανακληθεί»: {name}",
    "dnc_body": "Ο αριθμός δεν θα εμφανίζεται πια για κλήση σε καμία λίστα, δεν θα προστίθεται ξανά από εισαγωγές και θα εξαιρείται από εκστρατείες με τηλέφωνο. Οι ανοιχτές επανακλήσεις ακυρώνονται.",
    "dnc_yes": "Να μην ξανακληθεί",
    "dnc_on": "Να μην ξανακληθεί",
    "dnc_mark": "Σήμανση «Να μην ξανακληθεί»",
    "dnc_clear": "Άρση «Να μην ξανακληθεί»",
    "dnc_on_done": "Σημειώθηκε «Να μην ξανακληθεί»",
    "dnc_off_done": "Η σήμανση «Να μην ξανακληθεί» αφαιρέθηκε"
  },
  "callstats": {
    "title": "Η βελτίωσή μου",
    "subtitle": "Πόσα τηλέφωνα παίρνετε, πόσοι απαντούν και σε τι ποσοστό κλείνετε συνάντηση — ανά μέρα, εβδομάδα, μήνα, λίστα και εναρκτήρια φράση.",
    "pdf": "PDF",
    "list": "Λίστα",
    "all_lists": "Όλες οι λίστες",
    "variant": "Εναρκτήρια φράση",
    "all_variants": "Όλες οι φράσεις",
    "period": {
      "week": "Εβδομάδα",
      "30d": "30 ημέρες",
      "month": "Μήνας",
      "90d": "90 ημέρες",
      "year": "Έτος"
    },
    "per": {
      "day": "ανά ημέρα",
      "week": "ανά εβδομάδα",
      "month": "ανά μήνα"
    },
    "kpi": {
      "dials": "Κλήσεις",
      "connect": "Απάντησαν",
      "conversations": "Συζητήσεις",
      "meetings": "Συναντήσεις",
      "meeting_rate": "Συνάντηση ανά κλήση",
      "meeting_per_conv": "Συνάντηση ανά συζήτηση",
      "held_noshow": "Έγιναν / δεν ήρθαν",
      "show_rate": "Ήρθαν στη συνάντηση",
      "sales": "Πωλήσεις",
      "dials_per_meeting": "Κλήσεις ανά συνάντηση",
      "avg_duration": "Μέση διάρκεια συνομιλίας",
      "sales_premium": "Ετήσιο ασφάλιστρο πωλήσεων"
    },
    "insights": "Τι δείχνουν τα δεδομένα σας",
    "insights_note": "Υπολογίζονται μόνο από τις δικές σας κλήσεις· όταν τα δεδομένα είναι λίγα, δεν βγάζουμε συμπέρασμα.",
    "tone": {
      "good": "Καλό",
      "watch": "Προσοχή",
      "info": "Πληροφορία"
    },
    "insight": {
      "best_window": "Κλείνετε περισσότερες συναντήσεις μεταξύ {window}: {rate}% των κλήσεων, έναντι {overall}% συνολικά.",
      "best_weekday": "Η καλύτερη μέρα σας είναι η {weekday}: {rate}% συναντήσεις ανά κλήση, έναντι {overall}% συνολικά.",
      "variant_ratio": "Η φράση {win} κλείνει {ratio}× περισσότερες συναντήσεις από την {lose} ({winRate}% έναντι {loseRate}%).",
      "variant_only": "Μόνο η φράση {win} έφερε συναντήσεις ({meetings}) — η {lose} καμία μέχρι τώρα.",
      "variant_even": "Οι δύο φράσεις φέρνουν παρόμοια αποτελέσματα (A {a}%, B {b}%).",
      "variant_more_data": "Για σύγκριση A/B χρειάζονται τουλάχιστον {need} κλήσεις ανά φράση (τώρα A {a}, B {b}).",
      "callbacks_overdue": "Πολλά «να καλέσω αργότερα» δεν έγιναν ποτέ — {count} καθυστερούν.",
      "connect_low_window": "Απαντά μόνο το {rate}% των κλήσεων· μεταξύ {window} απαντά το {best}%.",
      "connect_low": "Απαντά μόνο το {rate}% των κλήσεων· δοκιμάστε άλλες ώρες ή μέρες.",
      "no_shows": "{noShow} από {total} συναντήσεις δεν έγιναν (δεν ήρθαν)· μια υπενθύμιση την προηγουμένη ίσως βοηθήσει.",
      "meetings_unconfirmed": "{count} συναντήσεις πέρασαν χωρίς να σημειώσετε αν έγιναν.",
      "trend_up": "Αυτή την εβδομάδα κλείνετε συνάντηση στο {now}% των κλήσεων, από {before}% τις προηγούμενες τέσσερις.",
      "trend_down": "Αυτή την εβδομάδα το ποσοστό συναντήσεων έπεσε στο {now}% από {before}% τις προηγούμενες τέσσερις.",
      "dials_per_meeting": "Χρειάζεστε κατά μέσο όρο {dials} κλήσεις για μία συνάντηση.",
      "streak": "Πετυχαίνετε τον ημερήσιο στόχο {days} μέρες στη σειρά.",
      "sales": "Από τις κλήσεις έγιναν {sales} πωλήσεις μετά από {meetings} συναντήσεις.",
      "no_data": "Δεν υπάρχουν ακόμη κλήσεις σε αυτό το διάστημα."
    },
    "funnel": "Από την κλήση στην πώληση",
    "step": {
      "dials": "Κλήσεις",
      "reached": "Απάντησαν",
      "conversations": "Συζητήσεις",
      "meetings": "Συναντήσεις",
      "held": "Έγιναν",
      "sales": "Πωλήσεις"
    },
    "trend": "Εξέλιξη {per}",
    "rate_trend": "Συνάντηση ανά κλήση (%)",
    "reached": "Απάντησαν",
    "empty": "Δεν υπάρχουν κλήσεις σε αυτό το διάστημα.",
    "best_hours": "Καλύτερες ώρες (συνάντηση ανά κλήση)",
    "best_days": "Καλύτερες μέρες (συνάντηση ανά κλήση)",
    "bar_tip": "{rate} συναντήσεις ανά κλήση · {meetings} συναντήσεις από {dials} κλήσεις · απάντησαν {connect}",
    "dials_n": "{count, plural, one {# κλήση} other {# κλήσεις}}",
    "bars_note": "Οι αχνές στήλες έχουν λιγότερες από 15 κλήσεις — μην βγάζετε ακόμη συμπέρασμα.",
    "ab": "Εναρκτήρια φράση A / B",
    "by_list": "Ανά λίστα",
    "no_list": "Χωρίς λίστα",
    "meetings_title": "Συναντήσεις από κλήσεις",
    "meetings_sub": "Σημειώστε αν έγινε η συνάντηση ή αν δεν ήρθαν — έτσι μετριέται το ποσοστό προσέλευσης.",
    "booked_on": "Κλείστηκε {date}",
    "state": {
      "held": "Έγινε",
      "no_show": "Δεν ήρθε",
      "unconfirmed": "Να επιβεβαιωθεί",
      "upcoming": "Προσεχώς",
      "cancelled": "Ακυρώθηκε"
    },
    "mark_held": "Έγινε",
    "mark_noshow": "Δεν ήρθε",
    "no_meetings": "Δεν κλείστηκαν ακόμη συναντήσεις σε αυτό το διάστημα.",
    "definitions": "Απάντησαν: κάποιος σήκωσε το τηλέφωνο. Συζήτηση: επανάκληση, ενδιαφέρον ή συνάντηση, ή κάθε συνομιλία 60 δευτερολέπτων και άνω. Πώληση: συμβόλαιο του προσώπου που ξεκίνησε μετά την πρώτη κλήση.",
    "csv": {
      "day": "Ημέρα",
      "hour": "Ώρα",
      "name": "Όνομα",
      "phone": "Τηλέφωνο",
      "seconds": "Δευτερόλεπτα",
      "when": "Επανάκληση / συνάντηση"
    }
  },
  "gaps": {
    "title": "Χάρτης κενών προστασίας",
    "subtitle": "Ποιοι πελάτες δεν έχουν καταγεγραμμένη κάλυψη σε κάθε περιοχή — για ενημέρωση, όχι για πίεση.",
    "how": "Πώς υπολογίζεται",
    "empty": "Δεν υπάρχουν ακόμη πελάτες.",
    "area": {
      "life_cover": "Ασφάλιση ζωής",
      "income_protection": "Προστασία εισοδήματος",
      "beneficiaries": "Ονομαστικοί δικαιούχοι",
      "health": "Ιατροφαρμακευτική κάλυψη",
      "retirement": "Αποταμίευση για σύνταξη",
      "mortgage": "Κάλυψη στεγαστικού",
      "education": "Σπουδές παιδιών"
    },
    "short": {
      "life_cover": "Ζωή",
      "income_protection": "Εισόδημα",
      "beneficiaries": "Δικαιούχοι",
      "health": "Υγεία",
      "retirement": "Σύνταξη",
      "mortgage": "Δάνειο",
      "education": "Σπουδές"
    },
    "cell": {
      "ok": "καταγεγραμμένη",
      "gap": "τίποτα καταγεγραμμένο",
      "na": "δεν αφορά"
    },
    "list_all": "{count, plural, one {# πελάτης με τουλάχιστον ένα κενό} other {# πελάτες με τουλάχιστον ένα κενό}}",
    "list_area": "{area}: {count, plural, one {# πελάτης χωρίς καταγραφή} other {# πελάτες χωρίς καταγραφή}}",
    "recorded_only": "Μόνο ό,τι είναι καταγεγραμμένο στο AVRASTRO — μια κάλυψη αλλού δεν είναι γνωστή.",
    "campaign": "Ενημερωτική εκστρατεία",
    "client": "Πελάτης",
    "legend": "✓ καταγεγραμμένη · ○ τίποτα καταγεγραμμένο · – δεν αφορά",
    "none": "Κανένα κενό εδώ.",
    "disclaimer": "Ο χάρτης βοηθά να οργανώσετε ενημέρωση· δεν αποτελεί σύσταση. Κάθε απόφαση του πελάτη παίρνεται μετά από ανάλυση αναγκών.",
    "campaign_title": "Ενημέρωση: {area}",
    "wording_title": "Πώς γράφουμε:",
    "wording_rules": "ενημερώνουμε και προσκαλούμε σε έλεγχο — χωρίς φόβο, χωρίς βιασύνη, χωρίς προϊόντα ή τιμές. Ο πελάτης μπορεί απλώς να μην απαντήσει.",
    "language": "Γλώσσα μηνύματος",
    "channel": "Κανάλι",
    "ch": {
      "email": "E-mail",
      "whatsapp": "WhatsApp",
      "sms": "SMS",
      "phone": "Τηλέφωνο",
      "letter": "Επιστολή"
    },
    "subject": "Θέμα",
    "message": "Μήνυμα",
    "message_hint": "Το όνομα του πελάτη και το δικό σας συμπληρώνονται για κάθε πελάτη.",
    "campaign_create": "Δημιουργία εκστρατείας",
    "campaign_note": "Η εκστρατεία δημιουργείται ως πρόχειρο: το κοινό «παγώνει» μόνο με όσους έχουν δώσει συγκατάθεση για το κανάλι, και κανένα μήνυμα δεν στέλνεται αυτόματα.",
    "msg": {
      "life_cover": {
        "subject": "Ένα σύντομο ερώτημα για την οικογένειά σας",
        "body": "Καλησπέρα {first},\n\nΣτον φάκελό σας δεν βλέπω καταγεγραμμένη ασφάλιση ζωής. Ίσως έχετε κάλυψη αλλού — αν ναι, θα ήθελα απλώς να το σημειώσω. Αν θέλετε, μπορούμε να δούμε μαζί σε 20 λεπτά τι θα χρειαζόταν η οικογένειά σας αν έλειπε το εισόδημά σας.\n\nΑν δεν σας ενδιαφέρει, δεν χρειάζεται να κάνετε τίποτα.\n\n{advisor}"
      },
      "income_protection": {
        "subject": "Τι γίνεται με το εισόδημά σας αν δεν μπορείτε να εργαστείτε;",
        "body": "Καλησπέρα {first},\n\nΠολλοί δεν γνωρίζουν τι προβλέπεται αν μια ασθένεια ή ένα ατύχημα τούς κρατήσει μακριά από τη δουλειά για μήνες. Στον φάκελό σας δεν έχω καταγεγραμμένη προστασία εισοδήματος. Αν θέλετε, σας εξηγώ τις επιλογές σε μια σύντομη συνάντηση.\n\nΑν δεν σας ενδιαφέρει, δεν χρειάζεται να κάνετε τίποτα.\n\n{advisor}"
      },
      "beneficiaries": {
        "subject": "Είναι ενημερωμένοι οι δικαιούχοι σας;",
        "body": "Καλησπέρα {first},\n\nΣε ένα από τα συμβόλαιά σας ζωής δεν βλέπω ονομαστικούς δικαιούχους. Είναι ένας απλός έλεγχος που αξίζει να γίνεται, ειδικά μετά από αλλαγές στην οικογένεια. Αν θέλετε, το κοιτάμε μαζί σε λίγα λεπτά.\n\n{advisor}"
      },
      "health": {
        "subject": "Ιατροφαρμακευτική κάλυψη — ένας σύντομος έλεγχος",
        "body": "Καλησπέρα {first},\n\nΣτον φάκελό σας δεν βλέπω καταγεγραμμένο ιατροφαρμακευτικό σχέδιο. Αν έχετε κάλυψη αλλού (π.χ. από τον εργοδότη), θα ήθελα να το σημειώσω· αν όχι, μπορώ να σας εξηγήσω τι υπάρχει και πώς λειτουργεί.\n\nΑν δεν σας ενδιαφέρει, δεν χρειάζεται να κάνετε τίποτα.\n\n{advisor}"
      },
      "retirement": {
        "subject": "Η σύνταξή σας — μια εικόνα σε λίγα λεπτά",
        "body": "Καλησπέρα {first},\n\nΣτον φάκελό σας δεν έχω καταγεγραμμένη αποταμίευση για τη σύνταξη. Αν θέλετε, μπορούμε να δούμε μαζί πόσο μπορεί να χρειαστείτε και τι υπάρχει ήδη — χωρίς καμία δέσμευση.\n\n{advisor}"
      }
    }
  },
  "auditpack": {
    "title": "Φάκελος ελέγχου",
    "subtitle": "Με ένα κλικ, για έλεγχο από την ΥΕΑΕ ή την ασφαλιστική: φάκελοι πώλησης, ενημερώσεις, KYC, προφίλ κινδύνου και συγκαταθέσεις μιας περιόδου.",
    "pdf": "PDF",
    "zip": "ZIP με έγγραφα",
    "zipping": "Ετοιμάζεται…",
    "zip_done": "Ο φάκελος (ZIP) αποθηκεύτηκε · {count} αρχεία",
    "period": "Περίοδος",
    "preset": {
      "quarter": "Τελευταίο τρίμηνο",
      "year": "Φέτος",
      "12m": "12 μήνες"
    },
    "from": "Από",
    "to": "Έως",
    "files": "Φάκελοι πώλησης",
    "complete": "Πλήρεις",
    "open": "Με εκκρεμότητες",
    "clients": "Πελάτες",
    "kyc_incomplete": "KYC ελλιπή",
    "without_file": "Συμβόλαια χωρίς φάκελο",
    "files_title": "{count, plural, one {# φάκελος πώλησης} other {# φάκελοι πώλησης}}",
    "chip_complete": "Πλήρης",
    "missing_title": "Τι λείπει",
    "nothing_missing": "Δεν λείπει τίποτα στους φακέλους αυτής της περιόδου.",
    "contents": "Το ZIP περιέχει τον φάκελο ως σελίδα (ανοίξτε και εκτυπώστε σε PDF), πίνακες CSV και τα συνδεδεμένα έγγραφα από το χρηματοκιβώτιο.",
    "empty": "Δεν υπάρχουν φάκελοι πώλησης σε αυτή την περίοδο.",
    "disclaimer": "Βοήθημα για τον δικό σας φάκελο, όχι νομική συμβουλή· ό,τι ζητήσει η ΥΕΑΕ ή η ασφαλιστική προηγείται. Τίποτα δεν αλλάζει στα δεδομένα σας.",
    "doc_title": "Φάκελος ελέγχου πωλήσεων",
    "index": "Περιεχόμενα",
    "col": {
      "date": "Ημερομηνία",
      "client": "Πελάτης",
      "product": "Προϊόν",
      "kind": "Είδος",
      "status": "Κατάσταση",
      "item": "Στοιχείο",
      "given": "Δόθηκε",
      "document": "Έγγραφο",
      "purpose": "Σκοπός",
      "granted": "Δόθηκε",
      "basis": "Νομική βάση"
    },
    "kyc_title": "Γνωρίστε τον πελάτη (KYC)",
    "kyc": {
      "none": "Δεν υπάρχει",
      "incomplete": "Ελλιπής",
      "complete": "Πλήρης"
    },
    "kyc_checked": "Έλεγχος",
    "kyc_next": "Επόμενη ανασκόπηση",
    "kyc_beneficiaries": "Δικαιούχοι",
    "kyc_funds": "Προέλευση χρημάτων",
    "kyc_none": "Δεν υπάρχει φάκελος KYC.",
    "risk_none": "Δεν συνδέθηκε προφίλ κινδύνου.",
    "consents": "Συγκαταθέσεις",
    "documents": "Έγγραφα",
    "readme": "AVRASTRO — φάκελος ελέγχου πωλήσεων / sales compliance pack / пакет документов по продажам\nΠερίοδος / Period / Период: {from} – {to}\nΦάκελοι / Files / Файлов: {files}\npack.html: ανοίξτε και εκτυπώστε σε PDF / open and print to PDF / откройте и распечатайте в PDF\n*.csv: πίνακες / tables / таблицы · documents/: έγγραφα / documents / документы"
  },
  "family": {
    "title": "Οικογενειακός χάρτης",
    "subtitle": "Σύζυγος, παιδιά, γονείς, παππούδες, νονοί — και ποιος πληρώνει για ποιον.",
    "add": "Προσθήκη συγγενή",
    "edit": "Συγγενής",
    "empty": "Δεν υπάρχουν ακόμη συγγενείς.",
    "rel": {
      "spouse": "Σύζυγος",
      "partner": "Σύντροφος",
      "child": "Παιδί",
      "parent": "Γονέας",
      "grandparent": "Παππούς / γιαγιά",
      "grandchild": "Εγγόνι",
      "sibling": "Αδελφός / αδελφή",
      "godparent": "Νονός / νονά",
      "godchild": "Βαφτιστήρι",
      "other": "Άλλος"
    },
    "client": "πελάτης",
    "baptism_on": "Βάφτιση {date}",
    "policies": "{count, plural, one {# συμβόλαιο} other {# συμβόλαια}}",
    "client_pays": "Πληρώνει ο πελάτης",
    "pays_for_client": "Πληρώνει για τον πελάτη",
    "delete_confirm": "Διαγραφή του «{name}» από τον οικογενειακό χάρτη;",
    "relation": "Σχέση",
    "who": "Ποιος",
    "who_name": "Μόνο όνομα",
    "who_book": "Πρόσωπο του πελατολογίου",
    "person": "Πρόσωπο",
    "name": "Όνομα",
    "birth": "Ημερομηνία γέννησης",
    "baptism": "Ημερομηνία βάφτισης",
    "baptism_hint": "Για υπενθύμιση της επετείου.",
    "pays": "Ποιος πληρώνει",
    "pays_none": "—",
    "pays_pays_for": "Ο πελάτης πληρώνει γι’ αυτόν",
    "pays_paid_by": "Αυτός πληρώνει για τον πελάτη",
    "notes": "Σημείωση",
    "privacy": "Καταγράψτε μόνο ό,τι χρειάζεται για την εξυπηρέτηση της οικογένειας· όχι αριθμούς ταυτότητας ή στοιχεία υγείας."
  },
  "radar34": {
    "title": "Ραντάρ γεγονότων ζωής",
    "subtitle": "{count, plural, one {# γεγονός τις επόμενες 60 μέρες} other {# γεγονότα τις επόμενες 60 μέρες}}",
    "item": {
      "milestone_birthday": "Γίνεται {age}",
      "loan_ends": "Λήγει το δάνειο «{label}»",
      "policy_matures": "Λήγει το συμβόλαιο «{label}»",
      "turns18": "Ο/η {name} γίνεται 18",
      "baptism": "Επέτειος βάφτισης: {name} ({years})",
      "transparency_day": "Ημέρα διαφάνειας: {years, plural, one {# χρόνος} other {# χρόνια}} συνεργασίας — η ετήσια σύνοψη",
      "risk_review": "Το προφίλ «{level}» δεν ταιριάζει πια στον χρόνο ως τον στόχο"
    },
    "today": "σήμερα",
    "in_days": "{count, plural, one {σε # μέρα} other {σε # μέρες}} · {date}",
    "task": "Εργασία",
    "task_done": "Υπάρχει εργασία",
    "more": "+{count} ακόμη",
    "less": "Λιγότερα"
  },
  "summary": {
    "meeting_open": "Προσωπική σύνοψη συνάντησης",
    "transparency_open": "Σύνοψη διαφάνειας",
    "meeting_studio": "Προσωπική σύνοψη · {name}",
    "transparency_title": "Ετήσια σύνοψη διαφάνειας · {name}",
    "meeting": "Συνάντηση",
    "no_meeting": "Χωρίς συνάντηση",
    "language": "Γλώσσα του πελάτη",
    "language_hint": "Η σύνοψη γράφεται στη γλώσσα που διαβάζει ο πελάτης.",
    "remember_lang": "Να θυμάσαι",
    "lang_saved": "Η γλώσσα του πελάτη αποθηκεύτηκε",
    "title_label": "Τίτλος",
    "intro": "Εισαγωγή",
    "closing": "Κλείσιμο",
    "keep": "Να μπει στη σύνοψη",
    "sensitive": "Ευαίσθητο",
    "sensitive_hint": "Μοιάζει με στοιχείο υγείας ή άλλο ευαίσθητο δεδομένο — δεν μπαίνει αν δεν το επιλέξετε.",
    "add_line": "Γραμμή",
    "add_step": "Επόμενο βήμα",
    "preview": "Τι θα δει ο πελάτης",
    "meeting_note": "Μόνο ό,τι τσεκάρετε φτάνει στον πελάτη· οι εσωτερικές σας σημειώσεις δεν φαίνονται ποτέ. Το σενάριο ταινίας (JSON) μπορεί αργότερα να γίνει σύντομο αφηγηματικό βίντεο από τη ροή βίντεο.",
    "save_draft": "Αποθήκευση",
    "saved": "Η σύνοψη αποθηκεύτηκε",
    "print": "PDF",
    "portal": "Στην πύλη του πελάτη",
    "film": "Σενάριο ταινίας",
    "film_done": "Το σενάριο ταινίας (JSON) αποθηκεύτηκε",
    "published": "Δημοσιεύτηκε στην πύλη του πελάτη",
    "portal_signed_out": "Συνδεθείτε στον λογαριασμό AVRASTRO για να δημοσιεύσετε στην πύλη.",
    "portal_no_link": "Ο πελάτης δεν είναι συνδεδεμένος με λογαριασμό στο avrastro.com· εκτυπώστε το PDF ή στείλτε το.",
    "portal_no_grant": "Ο πελάτης δεν έχει επιτρέψει δημοσιεύσεις στην πύλη του.",
    "portal_failed": "Η δημοσίευση δεν ολοκληρώθηκε· δοκιμάστε ξανά.",
    "earlier": "{count, plural, one {# προηγούμενη σύνοψη} other {# προηγούμενες συνόψεις}}",
    "status": {
      "draft": "πρόχειρη",
      "final": "τελική",
      "shared": "στάλθηκε"
    },
    "shared_on": "στην πύλη {date}",
    "meeting_title": "Η συνάντησή μας της {date}",
    "meeting_intro": "Αγαπητέ/ή {name}, σας ευχαριστώ για τον χρόνο σας. Παρακάτω θα βρείτε με λίγα λόγια τι συζητήσαμε, τι συμφωνήσαμε και τα επόμενα βήματα.",
    "meeting_closing": "Για οποιαδήποτε ερώτηση είμαι στη διάθεσή σας.\n{advisor}",
    "discussed": "Τι συζητήσαμε",
    "agreed": "Τι συμφωνήσαμε",
    "next_steps": "Επόμενα βήματα",
    "step": "Βήμα",
    "who": "Ποιος",
    "when": "Έως",
    "who_advisor": "Ο σύμβουλός σας",
    "who_client": "Εσείς",
    "thanks": "Σας ευχαριστώ για την εμπιστοσύνη.",
    "film_cta": "Είμαι εδώ για κάθε ερώτηση",
    "not_advice": "Η σύνοψη αυτή είναι ενημερωτική και δεν αντικαθιστά τους όρους των συμβολαίων σας.",
    "tr": {
      "title": "Ετήσια σύνοψη διαφάνειας {year}",
      "intro": "Αγαπητέ/ή {name}, όπως κάθε χρόνο, σας στέλνω μια καθαρή εικόνα: όλα τα συμβόλαιά σας, τι πληρώνετε, ποιοι είναι οι δικαιούχοι και τι άλλαξε από {from} έως {to}.",
      "closing": "Αν κάτι δεν ισχύει πια — νέο μέλος στην οικογένεια, αλλαγή εργασίας, νέο δάνειο — πείτε μου να το δούμε μαζί.\n{advisor}",
      "note": "Τα ποσά είναι ετήσια, όπως είναι καταγεγραμμένα· οι όροι και τα έγγραφα της ασφαλιστικής σας υπερισχύουν.",
      "policies": "Τα συμβόλαιά σας",
      "policy": "Συμβόλαιο",
      "insurer": "Ασφαλιστική",
      "premium": "Ασφάλιστρο",
      "year": "έτος",
      "renewal": "Ανανέωση",
      "insured": "Ασφαλισμένος",
      "beneficiaries": "Δικαιούχοι",
      "no_beneficiary": "Δεν έχουν οριστεί",
      "totals": "Σύνολο ετήσιων ασφαλίστρων",
      "total_line": "Σύνολο: {amount} τον χρόνο",
      "changes": "Τι άλλαξε",
      "no_changes": "Καμία αλλαγή στην περίοδο.",
      "change": {
        "new": "{date}: νέο συμβόλαιο «{label}»",
        "ended": "{date}: «{label}» — {status}",
        "premium": "{date}: «{label}» — το ασφάλιστρο από {before} σε {after}",
        "claim": "{date}: αποζημίωση «{label}»"
      },
      "status": {
        "lapsed": "ακυρώθηκε λόγω μη πληρωμής",
        "cancelled": "ακυρώθηκε",
        "matured": "έληξε",
        "other": "ενημέρωση"
      },
      "to_check": "Να ελέγξουμε μαζί",
      "check_beneficiaries": "{count, plural, one {Σε # συμβόλαιο ζωής δεν έχουν οριστεί δικαιούχοι.} other {Σε # συμβόλαια ζωής δεν έχουν οριστεί δικαιούχοι.}}",
      "advisor_note": "Σημείωση συμβούλου",
      "advisor_note_hint": "Προαιρετικά· μία γραμμή ανά σημείο.",
      "from": "Περίοδος από"
    }
  },
  "askhelp": {
    "title": "Ρωτήστε το AVRASTRO",
    "subtitle": "Ερωτήσεις για το πώς δουλεύει το AVRASTRO, με απαντήσεις από τη βοήθεια, τα μαθήματα και το «Τι νέο υπάρχει».",
    "launcher": "Ρωτήστε το AVRASTRO",
    "ai_badge": "AI",
    "disclosure": "Οι απαντήσεις γράφονται από σύστημα τεχνητής νοημοσύνης (AI), μόνο από τη βοήθεια του AVRASTRO, και μπορεί να έχουν λάθη· το άρθρο που δείχνουν είναι αυτό που ισχύει.",
    "warning": "Μην επικολλάτε στοιχεία πελατών (ονόματα, τηλέφωνα, e-mail, ταυτότητες, IBAN, υγεία). Ρωτήστε για την οθόνη ή την ενέργεια. Στέλνεται μόνο η ερώτηση — ποτέ δεδομένα του CRM.",
    "label": "Η ερώτησή σας για το AVRASTRO",
    "placeholder": "π.χ. Πώς εισάγω πελάτες από Excel;",
    "ask": "Ρωτήστε",
    "thinking": "Ψάχνω στη βοήθεια…",
    "will_remove": "Πριν σταλεί θα αφαιρεθούν {count, plural, one {# στοιχείο} other {# στοιχεία}} (e-mail, τηλέφωνα, αριθμοί): «{q}»",
    "removed": "Αφαιρέθηκαν {count, plural, one {# στοιχείο} other {# στοιχεία}} πριν από την αποστολή.",
    "you": "Εσείς",
    "from_help": "Από τη βοήθεια:",
    "open_screen": "Άνοιγμα: {label}",
    "kind_article": "Άρθρο",
    "kind_lesson": "Μάθημα",
    "kind_new": "Τι νέο υπάρχει",
    "search_title": "Από την αναζήτηση στη βοήθεια",
    "off_not_signed": "Για απαντήσεις με AI συνδεθείτε στον λογαριασμό σας AVRASTRO. Μέχρι τότε, αυτά βρήκαμε στη βοήθεια:",
    "off_not_configured": "Η υπηρεσία AI δεν είναι ρυθμισμένη. Αυτά βρήκαμε στη βοήθεια:",
    "off_disabled": "Ο βοηθός είναι απενεργοποιημένος σε αυτόν τον χώρο εργασίας (Ρυθμίσεις). Αυτά βρήκαμε στη βοήθεια:",
    "off_failed": "Ο βοηθός δεν απάντησε. Αυτά βρήκαμε στη βοήθεια:",
    "off_rate": "Πολλές ερωτήσεις σε λίγο χρόνο — δοκιμάστε ξανά αργότερα. Αυτά βρήκαμε στη βοήθεια:",
    "no_results": "Δεν βρέθηκε κάτι στη βοήθεια για «{q}». Δοκιμάστε με άλλη λέξη ή δείτε τα μαθήματα.",
    "data_hint": "Για ερωτήσεις για τα δεδομένα σας (π.χ. «ποιοι πελάτες έχουν ανανέωση;») υπάρχει το «Ρώτα το AVRASTRO», που απαντά τοπικά.",
    "data_go": "Ρώτα το AVRASTRO",
    "ex1": "Πώς εισάγω πελάτες από Excel;",
    "ex2": "Πώς κάνω αντίγραφο ασφαλείας;",
    "ex3": "Τι είναι ο φάκελος πώλησης IDD;",
    "clear": "Καθαρισμός",
    "shortcut": "Ctrl+J ή ⌘J",
    "settings_title": "«Ρωτήστε το AVRASTRO» — βοήθεια με AI",
    "settings_intro": "Απαντήσεις με AI σε ερωτήσεις για τη χρήση του AVRASTRO, μόνο από τη βοήθεια, τα μαθήματα και το «Τι νέο υπάρχει». Στέλνεται μόνο η ερώτηση — e-mail, τηλέφωνα, ταυτότητες και IBAN αφαιρούνται πριν φύγει από τη συσκευή· στοιχεία πελατών δεν στέλνονται ποτέ.",
    "settings_enabled": "Ενεργό σε αυτόν τον χώρο εργασίας",
    "settings_ai_on": "Η υπηρεσία AI είναι διαθέσιμη.",
    "settings_ai_off": "Η υπηρεσία AI δεν είναι διαθέσιμη· εμφανίζεται η αναζήτηση στη βοήθεια.",
    "settings_need_account": "Χρειάζεται σύνδεση στον λογαριασμό AVRASTRO.",
    "off_health": "Μη γράφετε εδώ στοιχεία υγείας — δικά σας ή πελατών. Η ερώτηση δεν στάλθηκε. Ρωτήστε γενικά για την οθόνη ή την ενέργεια, π.χ. «πώς καταχωρίζω αποζημίωση;»."
  },
  "desktop": {
    "update": {
      "data_path": "Τα δεδομένα σας: {path}",
      "check": "Έλεγχος για ενημερώσεις",
      "current": "Εγκατεστημένη έκδοση: {version}",
      "intro": "Το AVRASTRO ελέγχει για νέα υπογεγραμμένη έκδοση όταν ανοίγει και όταν επανέρχεται η σύνδεση, και σας ρωτά πριν εγκαταστήσει.",
      "card_title": "Ενημερώσεις εφαρμογής",
      "not_configured": "Οι αυτόματες ενημερώσεις δεν είναι ενεργές σε αυτή την έκδοση. Η επόμενη έκδοση θα τις έχει· μέχρι τότε εγκαταστήστε τη νέα έκδοση χειροκίνητα.",
      "none": "Έχετε την πιο πρόσφατη έκδοση.",
      "err_check": "Ο έλεγχος για ενημερώσεις απέτυχε (χωρίς σύνδεση ή μη διαθέσιμος διακομιστής). Θα ξαναγίνει αυτόματα.",
      "err_generic": "Η ενημέρωση δεν ολοκληρώθηκε (π.χ. διακοπή σύνδεσης). Η εγκατεστημένη έκδοση και τα δεδομένα σας δεν άλλαξαν. Δοκιμάστε ξανά.",
      "err_busy": "Μια ενημέρωση εγκαθίσταται ήδη.",
      "err_signature": "Η ενημέρωση απορρίφθηκε: η υπογραφή της δεν είναι έγκυρη. Δεν άλλαξε τίποτα. Ενημερώστε την υποστήριξη του AVRASTRO.",
      "snapshot_label": "Πριν από την ενημέρωση στην {version}",
      "downloading": "Λήψη και έλεγχος υπογραφής…",
      "saving": "Αντίγραφο ασφαλείας των δεδομένων…",
      "later": "Αργότερα",
      "retry": "Δοκιμή ξανά",
      "install": "Εγκατάσταση και επανεκκίνηση",
      "safe": "Τα δεδομένα σας μένουν στον υπολογιστή όπως είναι: η ενημέρωση αντικαθιστά μόνο την εφαρμογή. Πριν από την εγκατάσταση κρατείται και αντίγραφο ασφαλείας. Η εφαρμογή θα κλείσει και θα ανοίξει ξανά.",
      "notes": "Τι αλλάζει",
      "available": "Διαθέσιμη η έκδοση {version} (έχετε την {current}).",
      "title": "Νέα έκδοση του AVRASTRO"
    },
    "notify": {
      "renewals": "Συμβόλαια για ανανέωση τις επόμενες 30 ημέρες: {n}",
      "overdue": "εκπρόθεσμες: {n}",
      "due": "Εργασίες / follow-ups για σήμερα: {n}",
      "digest_title": "Σήμερα στο AVRASTRO",
      "appt_body": "Στις {time} · {title}",
      "appt_title": "Ραντεβού σε {min} λεπτά",
      "test_failed": "Η ειδοποίηση δεν εμφανίστηκε. Ελέγξτε τις ρυθμίσεις ειδοποιήσεων του συστήματος για το AVRASTRO OS.",
      "test_sent": "Στάλθηκε δοκιμαστική ειδοποίηση. Αν δεν τη βλέπετε, ελέγξτε τις ρυθμίσεις ειδοποιήσεων του συστήματος και τη λειτουργία «Μην ενοχλείτε».",
      "test_body": "Αυτός ο υπολογιστής θα δείχνει ειδοποιήσεις του AVRASTRO όσο είναι ανοιχτό.",
      "test_title": "Οι ειδοποιήσεις λειτουργούν",
      "unavailable": "Οι ειδοποιήσεις του συστήματος δεν είναι διαθέσιμες σε αυτή την έκδοση της εφαρμογής. Εγκαταστήστε την πιο πρόσφατη.",
      "denied": "Το σύστημα δεν επιτρέπει ειδοποιήσεις στο AVRASTRO. Mac: Ρυθμίσεις συστήματος → Γνωστοποιήσεις → AVRASTRO OS → Να επιτρέπονται. Windows: Ρυθμίσεις → Σύστημα → Ειδοποιήσεις → AVRASTRO OS.",
      "limits": "Λειτουργούν όσο το AVRASTRO είναι ανοιχτό (και ελαχιστοποιημένο). Με την εφαρμογή κλειστή δεν έρχεται τίποτα σε αυτόν τον υπολογιστή — για αυτό ενεργοποιήστε ειδοποιήσεις στο app.avrastro.com (browser ή κινητό).",
      "on_state": "Ενεργές",
      "turn_on": "Ενεργοποίηση ειδοποιήσεων σε αυτόν τον υπολογιστή",
      "intro": "Ειδοποιήσεις του συστήματος (Mac: Κέντρο γνωστοποιήσεων · Windows: ειδοποιήσεις) για τα ραντεβού σας, τις εργασίες / follow-ups της ημέρας και τις ανανεώσεις, από τα δεδομένα αυτού του υπολογιστή.",
      "title": "Ειδοποιήσεις σε αυτόν τον υπολογιστή"
    }
  },
  "policy_delete": {
    "action": "Διαγραφή",
    "title": "Διαγραφή λανθασμένου συμβολαίου",
    "restore_title": "Επαναφορά διαγραμμένου συμβολαίου",
    "word": "ΔΙΑΓΡΑΦΗ",
    "steps": "Βήματα",
    "step_password": "Κωδικός πρόσβασης",
    "step_code": "Κωδικός εφαρμογής",
    "step_confirm": "Επιβεβαίωση",
    "checking": "Έλεγχος ότι η διαγραφή μπορεί να γίνει με ασφάλεια…",
    "unavailable_title": "Η διαγραφή δεν είναι διαθέσιμη εδώ",
    "unavailable_offline": "Αυτός ο χώρος εργασίας δεν έχει λογαριασμό AVRASTRO, οπότε η διαγραφή δεν μπορεί να επιβεβαιωθεί και να προστατευθεί από τον διακομιστή. Συνδεθείτε σε λογαριασμό για να διαγράφετε συμβόλαια. Μπορείτε αντί γι’ αυτό να σημειώσετε το συμβόλαιο ως ακυρωμένο — καταχωρίστηκε κατά λάθος.",
    "unavailable_nosync": "Η διαγραφή προστατεύεται από τον διακομιστή μέσω του συγχρονισμού, που δεν είναι ενεργός σε αυτή τη συσκευή. Ενεργοποιήστε τον συγχρονισμό για τον χώρο εργασίας ή σημειώστε το συμβόλαιο ως ακυρωμένο — καταχωρίστηκε κατά λάθος.",
    "mfa_title": "Ρυθμίστε πρώτα εφαρμογή ταυτοποίησης",
    "mfa_body": "Η διαγραφή συμβολαίου χρειάζεται τον κωδικό πρόσβασής σας και έναν κωδικό από εφαρμογή ταυτοποίησης (σύνδεση 2 βημάτων). Ενεργοποιήστε τη σύνδεση 2 βημάτων στον λογαριασμό σας και επιστρέψτε.",
    "mfa_setup": "Ρύθμιση σύνδεσης 2 βημάτων",
    "locked_until": "Δοκιμάστε ξανά μετά τις {time}.",
    "retry": "Δοκιμάστε ξανά",
    "intro": "Για την ασφάλειά σας, επιβεβαιώστε ότι είστε εσείς. Το συμβόλαιο αφαιρείται από λίστες, αναφορές και στατιστικά· φυλάσσεται στο αρχείο και μπορεί να επανέλθει μέσα σε {days} ημέρες.",
    "restore_intro": "Η επαναφορά διαγραμμένου συμβολαίου χρειάζεται την ίδια επιβεβαίωση: τον κωδικό πρόσβασης και κωδικό εφαρμογής ταυτοποίησης.",
    "password": "Ο κωδικός πρόσβασής σας στο AVRASTRO",
    "password_hint": "Ο κωδικός με τον οποίο συνδέεστε στο AVRASTRO. Συνδέεστε μέσω avrastro.com χωρίς κωδικό; Χρησιμοποιήστε κλειδί πρόσβασης ή ορίστε κωδικό με «Ξέχασα τον κωδικό».",
    "use_passkey": "Χρήση κλειδιού πρόσβασης",
    "passkey_ok": "Το κλειδί πρόσβασης επιβεβαιώθηκε.",
    "code_intro": "Πληκτρολογήστε νέο κωδικό από την εφαρμογή ταυτοποίησης (όχι αυτόν με τον οποίο μόλις συνδεθήκατε).",
    "code": "Κωδικός εφαρμογής ταυτοποίησης",
    "code_hint": "6 ψηφία. Οι κωδικοί ανάκτησης δεν γίνονται δεκτοί εδώ.",
    "verify": "Επαλήθευση",
    "verified": "Η ταυτότητα επιβεβαιώθηκε. Ολοκληρώστε μέσα σε {seconds} δευτ.",
    "identity": "Το συμβόλαιο που διαγράφεται",
    "product": "Προϊόν",
    "number": "Αριθμός συμβολαίου",
    "issue": "Ημερομηνία έκδοσης",
    "premium": "Ετήσιο ασφάλιστρο",
    "reason": "Αιτιολογία",
    "reason_hint": "Υποχρεωτικό — π.χ. «καταχωρίστηκε δύο φορές», «λάθος πελάτης».",
    "type_word": "Πληκτρολογήστε {word} για επιβεβαίωση",
    "soft_note": "Δεν σβήνεται τίποτα: το συμβόλαιο και ό,τι συνδέεται με αυτό φυλάσσονται κρυφά και μπορούν να επανέλθουν μέσα σε {days} ημέρες.",
    "restore_reason": "Σημείωση (προαιρετικά)",
    "confirm": "Διαγραφή συμβολαίου",
    "restore": "Επαναφορά",
    "done": "Το συμβόλαιο διαγράφηκε.",
    "done_pending": "Το συμβόλαιο διαγράφηκε σε αυτή τη συσκευή· θα επιβεβαιωθεί από τον διακομιστή όταν είστε συνδεδεμένοι.",
    "restored": "Το συμβόλαιο επανήλθε.",
    "restore_until": "Μπορεί να επανέλθει έως {date}.",
    "retained": "Η περίοδος επαναφοράς έληξε· το συμβόλαιο μένει κρυφό και φυλάσσεται στο αρχείο.",
    "deleted_on": "Διαγράφηκε στις {date}",
    "list_title": "{count, plural, one {# διαγραμμένο συμβόλαιο} other {# διαγραμμένα συμβόλαια}}",
    "view": "Προβολή",
    "linked_none": "Δεν υπάρχουν άλλες εγγραφές συνδεδεμένες με αυτό το συμβόλαιο.",
    "linked_hidden": "Κρύβονται μαζί του (φυλάσσονται, επανέρχονται με την επαναφορά):",
    "linked_kept": "Μένουν ορατά ως ιστορικό:",
    "error_alt": "Σημειώστε το αντί γι’ αυτό ως ακυρωμένο — καταχωρίστηκε κατά λάθος. Μένει ορατό με το ιστορικό του και δεν μετράει πλέον ως σε ισχύ.",
    "mark_error": "Σήμανση: καταχωρίστηκε κατά λάθος",
    "marked_error": "Σημειώθηκε ως ακυρωμένο — καταχωρίστηκε κατά λάθος.",
    "entered_in_error": "Καταχωρίστηκε κατά λάθος",
    "table": {
      "policy_adjustments": "Αλλαγές ασφαλίστρου",
      "tasks": "Εργασίες και υπενθυμίσεις",
      "documents": "Έγγραφα",
      "service_cases": "Αιτήματα εξυπηρέτησης",
      "claims": "Αποζημιώσεις",
      "production_events": "Εγγραφές παραγωγής",
      "renewals": "Ανανεώσεις",
      "commission_entries": "Εγγραφές προμηθειών",
      "premium_arrears": "Ληξιπρόθεσμα ασφάλιστρα",
      "cases": "Αιτήσεις",
      "sale_files": "Φάκελοι πώλησης"
    },
    "err": {
      "generic": "Δεν ολοκληρώθηκε ({code}).",
      "invalid_credentials": "Ο κωδικός πρόσβασης δεν είναι σωστός.",
      "reauth_invalid": "Το κλειδί πρόσβασης δεν επιβεβαιώθηκε.",
      "passkey_cancelled": "Το αίτημα κλειδιού πρόσβασης ακυρώθηκε.",
      "mfa_invalid": "Ο κωδικός της εφαρμογής δεν είναι σωστός ή έληξε.",
      "mfa_reused": "Αυτός ο κωδικός έχει ήδη χρησιμοποιηθεί. Περιμένετε τον επόμενο κωδικό στην εφαρμογή.",
      "mfa_enrolment_required": "Ρυθμίστε πρώτα τη σύνδεση 2 βημάτων (εφαρμογή ταυτοποίησης).",
      "stepup_locked": "Πάρα πολλές αποτυχημένες προσπάθειες. Για την ασφάλειά σας, η διαγραφή μπλοκάρεται για 15 λεπτά.",
      "rate_limited": "Πάρα πολλές προσπάθειες. Περιμένετε λίγα λεπτά.",
      "policy_not_synced": "Το συμβόλαιο δεν έχει φτάσει ακόμη στον διακομιστή. Περιμένετε να ολοκληρωθεί ο συγχρονισμός και δοκιμάστε ξανά.",
      "policy_already_deleted": "Το συμβόλαιο έχει ήδη διαγραφεί.",
      "policy_not_deleted": "Το συμβόλαιο δεν είναι διαγραμμένο.",
      "restore_window_passed": "Η περίοδος επαναφοράς έχει λήξει.",
      "permission": "Ο ρόλος σας δεν επιτρέπει διαγραφή συμβολαίων.",
      "network": "Δεν υπάρχει σύνδεση με τον διακομιστή. Η διαγραφή χρειάζεται σύνδεση.",
      "stepup_required": "Ο διακομιστής απέρριψε την αλλαγή: λείπει η επιβεβαίωση. Δεν διαγράφηκε τίποτα.",
      "stepup_invalid": "Ο διακομιστής απέρριψε την αλλαγή: μη έγκυρη επιβεβαίωση. Δεν άλλαξε τίποτα.",
      "stepup_expired": "Η επιβεβαίωση έληξε (5 λεπτά). Δεν άλλαξε τίποτα — ξεκινήστε ξανά.",
      "stepup_used": "Αυτή η επιβεβαίωση έχει ήδη χρησιμοποιηθεί. Δεν άλλαξε τίποτα — ξεκινήστε ξανά.",
      "stepup_mismatch": "Η επιβεβαίωση αφορούσε άλλο συμβόλαιο, συσκευή ή λογαριασμό. Δεν άλλαξε τίποτα.",
      "stepup_unavailable": "Αυτός ο διακομιστής συγχρονισμού δεν μπορεί να ασφαλίσει διαγραφές. Δεν άλλαξε τίποτα.",
      "stepup_window": "Η περίοδος επαναφοράς έληξε. Δεν άλλαξε τίποτα.",
      "policy_delete_fields": "Ο διακομιστής απέρριψε τη διαγραφή (ελέγξτε το ρολόι της συσκευής). Δεν άλλαξε τίποτα.",
      "policy_hard_delete": "Τα συμβόλαια δεν σβήνονται ποτέ· χρησιμοποιήστε τη Διαγραφή μέσα στο συμβόλαιο.",
      "policy_deleted_changed": "Ένα διαγραμμένο συμβόλαιο δεν αλλάζει.",
      "refused": "Ο διακομιστής απέρριψε την αλλαγή. Δεν άλλαξε τίποτα."
    }
  },
  "sign_optin": {
    "label": "Με την υπογραφή μου",
    "none": "Προσθέστε την εικόνα υπογραφής σας στο Branding για να υπογράφετε έγγραφα."
  },
  "rights": {
    "title": "{feature}: δεν περιλαμβάνεται στο τρέχον πακέτο σας",
    "body": "Οι εγγραφές που ήδη έχετε μένουν εδώ, μόνο για ανάγνωση — τίποτα δεν κρύβεται ή διαγράφεται. Τίποτα δεν ενεργοποιείται ή χρεώνεται χωρίς εσάς.",
    "lapsed_title": "{feature}: η συνδρομή σας έληξε",
    "lapsed_body": "Όλα μένουν ορατά, μόνο για ανάγνωση. Ανανεώστε από τον Λογαριασμό για να κάνετε ξανά αλλαγές.",
    "in_plans": "Περιλαμβάνεται στα πακέτα: {plans}",
    "in_addons": "Πρόσθετο: {addons}",
    "store": "Δεν περιλαμβάνεται στην τρέχουσα συνδρομή σας."
  },
  "notes": {
    "included": "Στο πακέτο σας",
    "upgrade": "Διαθέσιμο με αναβάθμιση: {plans}",
    "not_in_plan": "Όχι στην τρέχουσα συνδρομή σας",
    "kind": {
      "security": "Ασφάλεια",
      "fix": "Διόρθωση"
    },
    "intro": "Οι διορθώσεις ασφάλειας, συμβατότητας και σφαλμάτων φτάνουν σε όλους. Οι νέες επί πληρωμή λειτουργίες σημειώνονται: στο πακέτο σας ή διαθέσιμες με αναβάθμιση — ποτέ δεν ενεργοποιούνται ή χρεώνονται μόνες τους.",
    "intro_store": "Οι διορθώσεις ασφάλειας, συμβατότητας και σφαλμάτων φτάνουν σε όλους. Ό,τι δεν ανήκει στη συνδρομή σας σημειώνεται — τίποτα δεν ενεργοποιείται μόνο του.",
    "in_update": "Σε αυτή την ενημέρωση",
    "upgrade_hint": "Η ενημέρωση είναι δωρεάν και κρατά τα δεδομένα σας. Όσα σημειώνονται ως αναβάθμιση μένουν ανενεργά μέχρι να επιλέξετε πακέτο που τα περιλαμβάνει.",
    "upgrade_hint_store": "Η ενημέρωση είναι δωρεάν και κρατά τα δεδομένα σας. Ό,τι δεν ανήκει στη συνδρομή σας μένει ανενεργό.",
    "binary_vs_rights": "Οι ενημερώσεις (ασφάλεια, συμβατότητα, διορθώσεις) είναι για όλους, όποιο κι αν είναι το πακέτο σας· δεν αλλάζουν ποτέ ό,τι πληρώνετε."
  },
  "maint": {
    "phase": {
      "upcoming": "Προγραμματισμένη συντήρηση",
      "ongoing": "Συντήρηση σε εξέλιξη",
      "restored": "Η υπηρεσία αποκαταστάθηκε"
    },
    "window": "Πότε: {window}",
    "your_zone": "η ώρα σας ({zone})",
    "services": "Επηρεάζονται: {services}",
    "service": {
      "sync": "Συγχρονισμός συσκευών",
      "web_app": "Εφαρμογή στον browser",
      "desktop_app": "Εφαρμογή υπολογιστή",
      "account": "Σύνδεση και λογαριασμός",
      "billing": "Χρεώσεις",
      "website": "avrastro.com",
      "client_portal": "Client portal",
      "backups": "Αντίγραφα στο cloud",
      "ai": "Λειτουργίες AI",
      "notifications": "Ειδοποιήσεις",
      "updates": "Ενημερώσεις εφαρμογής"
    },
    "sync_warning": "Μπορείτε να συνεχίσετε να δουλεύετε: όσες αλλαγές κάνετε χωρίς σύνδεση μένουν σε αυτή τη συσκευή και στέλνονται όταν επανέλθει η υπηρεσία.",
    "restored_body": "Όλα λειτουργούν ξανά. Οι αλλαγές που κρατήθηκαν σε αυτή τη συσκευή στέλνονται τώρα.",
    "dismiss": "Απόκρυψη"
  },
  "sync_update": {
    "title": "Ενημερώστε το AVRASTRO για να συνεχιστεί ο συγχρονισμός.",
    "body": "Ο server δεν δέχεται πια αυτή την έκδοση, γι’ αυτό ο συγχρονισμός σταμάτησε για να προστατευτούν τα δεδομένα σας. Δεν χάνεται τίποτα: οι αλλαγές αυτής της συσκευής κρατιούνται και στέλνονται μετά την ενημέρωση.",
    "body_version": "Ο server δεν δέχεται πια αυτή την έκδοση, γι’ αυτό ο συγχρονισμός σταμάτησε για να προστατευτούν τα δεδομένα σας. Χρειάζεται η έκδοση {version} ή νεότερη. Δεν χάνεται τίποτα: οι αλλαγές αυτής της συσκευής κρατιούνται και στέλνονται μετά την ενημέρωση."
  },
  "recs": {
    "intro": "Έως τρεις ιδέες καμπάνιας από το δικό σας πελατολόγιο: τις υπάρχουσες ομάδες, τη συναίνεση, το ιστορικό επαφών, το ημερολόγιο και τις σημειώσεις αγοράς που αποθηκεύσατε με πηγή. Η καθεμία λέει γιατί προτείνεται.",
    "never_sends": "Δεν αποστέλλεται τίποτα και δεν γίνεται καμία επαφή αυτόματα. Η έγκριση δημιουργεί την καμπάνια με κοινό ελεγμένο για συναίνεση· την ξεκινάτε και στέλνετε κάθε μήνυμα εσείς.",
    "none": "Καμία πρόταση αυτή τη στιγμή: κάθε θέμα είτε δεν έχει άτομα με συναίνεση, είτε τρέχει ήδη, είτε έγινε τις τελευταίες 90 ημέρες, είτε το αφήσατε για αργότερα.",
    "why": "Γιατί προτείνεται",
    "audience": "Κοινό",
    "eligible": "Με συναίνεση για το κανάλι",
    "in_segment": "Στην ομάδα",
    "recent": "Επαφή από καμπάνια τις τελευταίες 30 ημέρες",
    "no_eligible_channel": "Κανείς σε αυτή την ομάδα δεν έχει συναίνεση για αυτό το κανάλι. Επιλέξτε άλλο κανάλι.",
    "audience_note": "Οι ίδιοι κανόνες συναίνεσης παγώνουν το ίδιο κοινό όταν εγκρίνετε (συναίνεση, ανάκληση, κανάλι, «χωρίς επικοινωνία», στοιχεία επαφής).",
    "goal_title": "Στόχος επαφών",
    "goal": "Επαφές συνολικά: {total} · περίπου {perDay} την ημέρα · πρώτη επαφή σε {days, plural, one {# εργάσιμη} other {# εργάσιμες}}.",
    "schedule": "Προτεινόμενο πρόγραμμα",
    "schedule_note": "Από {start} έως {end}. Οι ημερομηνίες γίνονται εργασίες μόνο όταν ξεκινήσετε την καμπάνια.",
    "kpis": "Πώς θα μετρηθεί",
    "kpi": {
      "contacts": "Επαφές",
      "positive": "Θετικές απαντήσεις (στόχος)",
      "meetings": "Συναντήσεις (στόχος)",
      "conversion": "Μετατροπή σε συμβόλαιο (στόχος)"
    },
    "kpi_measured": "θα μετρηθεί από τις πρώτες επαφές",
    "kpi_basis_own": "Στόχοι από τις δικές σας προηγούμενες καμπάνιες ({sample} καταγεγραμμένες επαφές).",
    "kpi_basis_none": "Χωρίς αριθμούς-στόχους ακόμη: οι προηγούμενες καμπάνιες σας έχουν {sample} καταγεγραμμένες επαφές και χρειάζονται τουλάχιστον {min}. Τίποτα δεν υποτίθεται.",
    "market": "Σημειώσεις αγοράς που αποθηκεύσατε",
    "draft": "Προσχέδιο μηνύματος (επεξεργαστείτε ελεύθερα)",
    "title_field": "Τίτλος καμπάνιας",
    "message": "Μήνυμα",
    "approve_check": "Εγκρίνω: να δημιουργηθεί η καμπάνια και να παγώσει το κοινό της με {count} άτομα με συναίνεση. Δεν αποστέλλεται τίποτα.",
    "approve": "Έγκριση και δημιουργία καμπάνιας",
    "dismiss": "Όχι τώρα (30 ημέρες)",
    "approved": "Η καμπάνια δημιουργήθηκε — το κοινό ελέγχθηκε και πάγωσε. Ξεκινήστε την όταν είστε έτοιμοι.",
    "dismissed": "Αφέθηκε για 30 ημέρες.",
    "inputs_title": "Τι χρησιμοποιούν οι προτάσεις — και τι δεν χρησιμοποιούν ποτέ",
    "inputs_used": "Χρησιμοποιούνται",
    "inputs_not_used": "Δεν χρησιμοποιούνται ποτέ",
    "input": {
      "segments": "Οι υπάρχουσες έξυπνες ομάδες του Κέντρου Καμπανιών (μαζί με τις ομάδες κενών προστασίας), και μόνο όσες χρησιμοποιεί ένα θέμα της βιβλιοθήκης.",
      "consent": "Η συναίνεση marketing και η ανάκλησή της, το κανάλι της συναίνεσης, η λίστα «χωρίς επικοινωνία», το «μην καλείτε» και αν υπάρχει τηλέφωνο ή e-mail.",
      "history": "Ιστορικό επαφών: επαφές, απαντήσεις, ραντεβού και αρνήσεις καμπανιών, ανοιχτές εργασίες καμπανιών, καμπάνιες σε εξέλιξη ή πρόσφατες.",
      "season": "Το ημερολόγιο (π.χ. το τέλος του φορολογικού έτους ή η αρχή της σχολικής χρονιάς) — μόνο ημερομηνίες.",
      "market": "Σημειώσεις αγοράς που αποθηκεύσατε εσείς με πηγή και ημερομηνία. Το AVRASTRO δεν γράφει και δεν επινοεί ποτέ ειδήσεις αγοράς.",
      "own_rates": "Τα αποτελέσματα των δικών σας προηγούμενων καμπανιών, μόνο για τους στόχους KPI και μόνο με αρκετό ιστορικό."
    },
    "not_used": {
      "health": "Καταστάσεις υγείας, ιατρικές απαντήσεις και οτιδήποτε για την υγεία ενός ατόμου.",
      "smoker": "Αν κάποιος καπνίζει.",
      "claims": "Αποζημιώσεις.",
      "medical_documents": "Ιατρικά έγγραφα και ιατρικές απαιτήσεις αιτήσεων.",
      "notes": "Σημειώσεις και κάθε ελεύθερο κείμενο.",
      "finances": "Εισόδημα, αποταμιεύσεις ή φορολογικά στοιχεία πέρα από όσα ήδη χρησιμοποιεί μια υπάρχουσα ομάδα."
    },
    "health_note": "Οι μόνες ομάδες που σχετίζονται με την υγεία είναι οι υπάρχουσες που εντοπίζουν απουσία ασφάλισης υγείας («χωρίς καταγεγραμμένη ιατροφαρμακευτική», «κενό: υγεία»)· δεν εξετάζουν ποτέ κατάσταση υγείας.",
    "market_title": "Σημειώσεις αγοράς (με πηγή)",
    "market_hint": "Προσθέστε μια εξέλιξη που διαβάσατε, με την πηγή και την ημερομηνία της, και τα θέματα που αφορά. Αναφέρεται όπως τη γράψατε στις προτάσεις για 180 ημέρες.",
    "note_add": "Προσθήκη σημείωσης αγοράς",
    "note_title": "Τι αναφέρει",
    "note_source": "Πηγή (υποχρεωτικό)",
    "note_url": "Σύνδεσμος (προαιρετικό)",
    "note_date": "Ημερομηνία δημοσίευσης",
    "note_summary": "Σύντομη περίληψη (προαιρετικό)",
    "note_themes": "Σχετικά θέματα καμπάνιας",
    "note_save": "Αποθήκευση σημείωσης",
    "note_saved": "Η σημείωση αγοράς αποθηκεύτηκε.",
    "season": {
      "tax_year_end": "Τέλος φορολογικού έτους",
      "school_year": "Νέα σχολική χρονιά",
      "new_year": "Αρχή της χρονιάς",
      "summer_travel": "Καλοκαιρινά ταξίδια",
      "spring_home": "Ανοιξιάτικος έλεγχος σπιτιού"
    },
    "reason": {
      "segment": "Άτομα στην ομάδα «{segment}»: {members} (από {population} που ελέγχθηκαν).",
      "consent": "Επιτρέπεται επαφή σε αυτό το κανάλι με βάση τους κανόνες συναίνεσης: {eligible}· μένουν εκτός: {excluded}.",
      "cool_off": "Είχαν επαφή από καμπάνια τις τελευταίες {days} ημέρες: {count} — λάβετέ το υπόψη πριν επικοινωνήσετε ξανά.",
      "last_run": "Το θέμα έτρεξε τελευταία φορά στις {date} (πριν από {days} ημέρες).",
      "never_run": "Δεν έχετε τρέξει ακόμη αυτό το θέμα.",
      "season_tax_year_end": "Ημερολόγιο: ο {month} είναι κοντά στο τέλος του φορολογικού έτους.",
      "season_school_year": "Ημερολόγιο: τον {month} οι οικογένειες ετοιμάζονται για τη σχολική χρονιά.",
      "season_new_year": "Ημερολόγιο: ο {month} είναι η αρχή της χρονιάς, συνηθισμένη εποχή για ετήσιες επανεξετάσεις.",
      "season_summer_travel": "Ημερολόγιο: ο {month} είναι εποχή καλοκαιρινών ταξιδιών.",
      "season_spring_home": "Ημερολόγιο: ο {month} είναι συνηθισμένη εποχή για έλεγχο του σπιτιού.",
      "market": "Η σημείωσή σας: «{title}» — {source}, {date}.",
      "incomplete": "Ίσως ταιριάζουν επίσης αλλά τα στοιχεία τους είναι ελλιπή (δεν συμπεριλαμβάνονται): {count}."
    }
  },
  "dayreport": {
    "title": "Απολογισμός ημέρας",
    "subtitle": "Συμπληρώνεται από όσα κατέγραψε το CRM σήμερα. Προσθέστε δικά σας σύνολα μόνο για δουλειά εκτός CRM.",
    "day": "Ημέρα",
    "recorded": "Καταγεγραμμένο",
    "self": "Δική μου καταχώριση",
    "self_short": "δικές μου",
    "total": "Μετράει",
    "metric": {
      "callsAttempted": "Κλήσεις που έγιναν",
      "callsCompleted": "Κλήσεις με συνομιλία",
      "peopleApproached": "Άτομα που προσεγγίσατε",
      "contactsCompleted": "Ολοκληρωμένες επαφές",
      "positiveReplies": "Θετικές απαντήσεις",
      "rejections": "Αρνήσεις",
      "meetingsBooked": "Ραντεβού που κλείστηκαν",
      "followupsCompleted": "Υπενθυμίσεις που ολοκληρώθηκαν"
    },
    "def": {
      "callsAttempted": "Κάθε κλήση που καταγράφηκε, και οι εργασίες κλήσης που ολοκληρώθηκαν για άτομα χωρίς καταγεγραμμένη κλήση εκείνη τη μέρα.",
      "callsCompleted": "Κλήσεις που βρήκαν το άτομο (αποτέλεσμα εκτός από «δεν απάντησε», «κατειλημμένο», «λάθος αριθμός»).",
      "peopleApproached": "Διαφορετικά άτομα ή υποψήφιοι με τους οποίους επικοινωνήσατε: κλήσεις, μηνύματα, επαφές καμπάνιας, υπενθυμίσεις με αποτέλεσμα.",
      "contactsCompleted": "Διαφορετικά άτομα με πραγματική συνομιλία, απάντηση ή ραντεβού.",
      "positiveReplies": "Άτομα των οποίων η τελευταία επαφή της ημέρας ήταν θετική.",
      "rejections": "Άτομα των οποίων η τελευταία επαφή της ημέρας ήταν άρνηση.",
      "meetingsBooked": "Διαφορετικά άτομα με ραντεβού που μπήκε στην ατζέντα σήμερα.",
      "followupsCompleted": "Εργασίες υπενθύμισης που ολοκληρώθηκαν σήμερα (μαζί με τα βήματα καμπανιών)."
    },
    "below_recorded": "λιγότερο από το καταγεγραμμένο — μετράει το καταγεγραμμένο",
    "extra": "+{n} από δική μου καταχώριση",
    "self_hint": "Η δική σας καταχώριση είναι το σύνολό σας για την ημέρα. Μετράει το μεγαλύτερο από τα δύο — ποτέ το άθροισμα — έτσι μια κλήση που καταγράφετε αργότερα δεν μετριέται δύο φορές.",
    "goals": "Στόχοι",
    "goals_self": "Στόχοι που επιτεύχθηκαν",
    "of": "από",
    "rates": "Ποσοστά",
    "rate_def": {
      "goal_completion": "στόχοι που επιτεύχθηκαν ÷ στόχοι",
      "response": "θετικές απαντήσεις ÷ άτομα που προσεγγίσατε",
      "appointment_conversion": "ραντεβού ÷ ολοκληρωμένες επαφές"
    },
    "campaigns": "Αποτελέσματα καμπανιών",
    "campaign_line": "επαφές {contacted} · απαντήσεις {responded} · ραντεβού {appointment} · αρνήσεις {opted_out} · εργασίες {tasks}",
    "rating": "Πώς ήταν η μέρα για εσάς; (1–5)",
    "rating_hint": "Η δική σας εκτίμηση — εμφανίζεται δίπλα στους αριθμούς, ποτέ μέσα σε αυτούς.",
    "notes": "Σημειώσεις",
    "feedback": "Ανατροφοδότηση",
    "fb_show": "Εμφάνιση",
    "fb_hide": "Απόκρυψη",
    "fb_own": "Με δικά μου λόγια (προαιρετικό)",
    "fb_own_hint": "Τι πήγε καλά, τι να δοκιμάσω αύριο…",
    "save": "Αποθήκευση απολογισμού",
    "saved": "Ο απολογισμός ημέρας αποθηκεύτηκε.",
    "saved_at": "Αποθηκεύτηκε {when}",
    "x_of_y": "{x} από {y} ({pct})",
    "no_denominator": "— (τίποτα για σύγκριση ακόμη)",
    "fb": {
      "quiet_day": "Δεν καταγράφηκε δραστηριότητα σήμερα. Αν ήταν μέρα γραφείου ή ξεκούρασης, είναι εντάξει.",
      "goals_all": "Επιτεύχθηκαν και οι {total} στόχοι ({met} από {total}).",
      "goals_most": "Επιτεύχθηκαν {met} από {total} στόχους.",
      "goals_some": "Επιτεύχθηκαν {met} από {total} στόχους. Οι αυριανοί στόχοι μπορούν να προσαρμοστούν σε ό,τι χωράει στη μέρα.",
      "goals_none": "Κανένας από τους {total} στόχους δεν επιτεύχθηκε σήμερα. Λιγότεροι ή μικρότεροι στόχοι αύριο ίσως ταιριάζουν καλύτερα.",
      "small_day": "Άτομα σε επαφή: {count} — πολύ λίγα για να βγει συμπέρασμα από ένα ποσοστό.",
      "response_good": "{pos} από {appr} άτομα απάντησαν θετικά.",
      "response_zero": "Καμία θετική απάντηση από {appr} άτομα σήμερα. Αξίζει να δοκιμάσετε άλλη ώρα ή διαφορετική εισαγωγή.",
      "meetings": "Ραντεβού που κλείστηκαν σήμερα: {count}.",
      "followups": "Υπενθυμίσεις που ολοκληρώθηκαν: {count}.",
      "pending": "Εργασίες ακόμη ανοιχτές για σήμερα ή νωρίτερα: {count} — μπορείτε να τις μεταφέρετε παρακάτω.",
      "low_rating": "Βαθμολογήσατε τη μέρα με {rating} στα 5. Αν θέλετε, σημειώστε τι τη δυσκόλεψε — θα φαίνεται δίπλα στη μηνιαία εικόνα.",
      "high_rating": "Βαθμολογήσατε τη μέρα με {rating} στα 5."
    },
    "relationship": "Καφέδες / γνωριμίες / συστάσεις: {done} έγιναν · {planned} ακόμη σχεδιασμένες",
    "relationship_hint": "Μετρούν χωριστά: δεν προστίθενται στα ραντεβού ούτε στα ποσοστά."
  },
  "monthly": {
    "title": "Μηνιαία απόδοση",
    "subtitle": "Μήνα με μήνα, από τις καταγραφές του CRM και τους ημερήσιους απολογισμούς σας. Η συσχέτιση δεν είναι αιτία.",
    "month": "Μήνας",
    "print": "Εκτύπωση / PDF",
    "partial": "μήνας σε εξέλιξη",
    "activity_line": "δραστηριότητα σε {active} από {working} εργάσιμες · αποθηκευμένοι απολογισμοί: {reports}",
    "split": "καταγεγραμμένα {recorded} · δικά μου {self}",
    "goals": "Στόχοι επιτεύχθηκαν / τέθηκαν",
    "campaigns": "Καμπάνιες σε εξέλιξη",
    "rates": "Ποσοστά του μήνα",
    "small_sample": "μικρό δείγμα (κάτω από {min}) — με προσοχή",
    "rates_note": "Κάθε ποσοστό δείχνει αριθμητή και παρονομαστή. Επίτευξη στόχων = στόχοι που επιτεύχθηκαν ÷ στόχοι· ανταπόκριση = θετικές απαντήσεις ÷ άτομα που προσεγγίσατε· μετατροπή σε ραντεβού = ραντεβού ÷ ολοκληρωμένες επαφές· δραστηριότητα = ημέρες με δραστηριότητα ÷ εργάσιμες.",
    "interpretation": "Τι δείχνουν οι αριθμοί",
    "priorities": "Ρεαλιστικές προτεραιότητες για τον επόμενο μήνα",
    "no_cause": "Αυτές οι γραμμές περιγράφουν τι συνέβη την ίδια περίοδο· δεν δείχνουν ότι το ένα έφερε το άλλο.",
    "trend": "Δραστηριότητα ανά μήνα (n = άτομα σε επαφή)",
    "rate_trend": "Ποσοστά ανά μήνα, % (n = άτομα σε επαφή)",
    "chart_note": "Ένας μήνας με μικρό n μπορεί να αλλάξει πολύ από τύχη.",
    "empty": "Δεν έχει καταγραφεί τίποτα αυτούς τους μήνες. Εδώ εμφανίζονται κλήσεις, εργασίες, ραντεβού, αποτελέσματα καμπανιών και απολογισμοί.",
    "table": "Μήνα με μήνα",
    "definitions": "Τα καταγεγραμμένα μεγέθη υπολογίζονται ξανά από το CRM για κάθε ημέρα, ώστε να συμφωνούν πάντα με τη δραστηριότητα. Οι δικές σας καταχωρίσεις μετρούν μόνο όπου είναι μεγαλύτερες από όσα καταγράφηκαν εκείνη τη μέρα.",
    "active_days": "Ημέρες με δραστηριότητα",
    "working_days": "Εργάσιμες",
    "reports": "Απολογισμοί",
    "avg_rating": "Μέση αυτοαξιολόγηση",
    "rate": {
      "goal_completion": "Επίτευξη στόχων",
      "response": "Ανταπόκριση",
      "appointment_conversion": "Μετατροπή σε ραντεβού",
      "call_connect": "Κλήσεις με συνομιλία",
      "activity": "Επίπεδο δραστηριότητας"
    },
    "line": {
      "no_data": "Δεν καταγράφηκε τίποτα τον μήνα {month}.",
      "activity": "Δραστηριότητα σε {active} από {working} εργάσιμες.",
      "activity_partial": "Μέχρι στιγμής αυτόν τον μήνα: δραστηριότητα σε {active} από {working} εργάσιμες.",
      "rate_small": "{rate}: {num} από {den} ({pct}) — λιγότερα από {min}, πολύ μικρό δείγμα για να διαβαστεί κάποια αλλαγή.",
      "rate_now": "{rate}: {num} από {den} ({pct})· ο προηγούμενος μήνας έχει πολύ λίγα δεδομένα για σύγκριση.",
      "rate_up": "Η {rate} ήταν υψηλότερη: {num} από {den} ({pct}) έναντι {pnum} από {pden} ({ppct}) τον προηγούμενο μήνα (+{diff}).",
      "rate_down": "Η {rate} ήταν χαμηλότερη: {num} από {den} ({pct}) έναντι {pnum} από {pden} ({ppct}) τον προηγούμενο μήνα (−{diff}).",
      "rate_same": "Η {rate} έμεινε περίπου ίδια: {num} από {den} ({pct}) έναντι {pnum} από {pden} ({ppct}).",
      "per_day_up": "{metric}: {now} ανά εργάσιμη έναντι {prev} τον προηγούμενο μήνα ({total} έναντι {ptotal} συνολικά).",
      "per_day_down": "{metric}: {now} ανά εργάσιμη έναντι {prev} τον προηγούμενο μήνα ({total} έναντι {ptotal} συνολικά).",
      "coincided": "Η υψηλότερη {rate} συνέπεσε με καμπάνιες σε εξέλιξη ({count}: {campaigns}). Το ότι συνέβησαν την ίδια περίοδο δεν δείχνει ότι η καμπάνια το έφερε.",
      "limits": "Μετράει μόνο ό,τι καταγράφηκε στο CRM· δουλειά που δεν καταγράφηκε δεν εμφανίζεται (αποθηκευμένοι απολογισμοί: {reports}).",
      "limits_self": "Περιλαμβάνει δικές σας καταχωρίσεις σε {days, plural, one {# ημέρα} other {# ημέρες}} (φαίνονται χωριστά από τα καταγεγραμμένα)· αποθηκευμένοι απολογισμοί: {reports}."
    },
    "prio": {
      "fewer_goals": "Ορίστε περίπου {perDay} στόχους την ημέρα — όσους πετύχατε κατά μέσο όρο ({num} από {den} αυτόν τον μήνα).",
      "activity_days": "Προγραμματίστε χρόνο για επαφές σε {days} από τις {working} εργάσιμες του επόμενου μήνα (αυτόν τον μήνα: {active} από {was}).",
      "response": "Δοκιμάστε διαφορετική εισαγωγή ή ώρα — {num} από {den} απάντησαν θετικά ({pct}). Το «Η βελτίωσή μου» δείχνει τις καλύτερες ώρες σας.",
      "conversion": "Σε κάθε θετική συζήτηση προτείνετε δύο συγκεκριμένες ώρες συνάντησης — {num} από {den} ολοκληρωμένες επαφές κατέληξαν σε ραντεβού ({pct}).",
      "overdue": "Ξεκινήστε τον μήνα με τις καθυστερημένες εργασίες και υπενθυμίσεις ({count}).",
      "calls_target": "Ρεαλιστικός στόχος κλήσεων: περίπου {perDay} ανά εργάσιμη (ο μέσος όρος σας στους τελευταίους ενεργούς μήνες ({months}) ήταν {avg}).",
      "keep": "Κρατήστε τον ίδιο ρυθμό — δεν ξεχωρίζει κάποια υστέρηση αυτόν τον μήνα."
    },
    "relationship": "Καφέδες / γνωριμίες",
    "relationship_hint": "καφέδες {coffee} · συστάσεις {referral} — εκτός ραντεβού"
  },
  "catalog": {
    "title": "Ασφαλιστικές & προϊόντα",
    "hint": "Η δική σας λίστα: κάθε ασφαλιστική με την οποία συνεργάζεστε → οι κατηγορίες προϊόντων της → κάθε συγκεκριμένο πρόγραμμα. Τα νέα συμβόλαια επιλέγονται από εδώ.",
    "show_inactive": "Εμφάνιση ανενεργών",
    "import": "Εισαγωγή από τα συμβόλαιά μου",
    "import_nothing": "Δεν υπάρχει κάτι νέο — κάθε ασφαλιστική και προϊόν των συμβολαίων σας είναι ήδη εδώ.",
    "empty": "Δεν υπάρχουν ακόμη ασφαλιστικές. Προσθέστε τις εταιρείες με τις οποίες συνεργάζεστε ή εισαγάγετέ τις από τα συμβόλαιά σας.",
    "counts": "{categories, plural, one {# κατηγορία} other {# κατηγορίες}} · {plans, plural, one {# πρόγραμμα} other {# προγράμματα}}",
    "insurer_name": "Όνομα ασφαλιστικής εταιρείας",
    "add_insurer": "Προσθήκη ασφαλιστικής",
    "note": "Η απενεργοποίηση κρύβει μια καταχώριση από τα νέα συμβόλαια· όσα συμβόλαια την έχουν ήδη, την κρατούν. Μια καταχώριση διαγράφεται μόνο όσο δεν τη χρησιμοποιεί κανένα συμβόλαιο.",
    "saved": "Ο κατάλογος αποθηκεύτηκε",
    "collapse": "Σύμπτυξη",
    "expand": "Ανάπτυξη",
    "inactive": "ανενεργό",
    "kind": {
      "insurer": "Ασφαλιστική",
      "category": "Κατηγορία προϊόντος",
      "plan": "Συγκεκριμένο πρόγραμμα"
    },
    "policies": "{count, plural, =0 {κανένα συμβόλαιο} one {# συμβόλαιο} other {# συμβόλαια}}",
    "up": "Μετακίνηση του {name} πάνω",
    "down": "Μετακίνηση του {name} κάτω",
    "deactivate": "Απενεργοποίηση",
    "reactivate": "Επανενεργοποίηση",
    "remove": "Διαγραφή του {name}",
    "remove_hint": "Οριστική διαγραφή (δεν το χρησιμοποιεί τίποτα)",
    "deactivated": "Το {name} απενεργοποιήθηκε",
    "reactivated": "Το {name} ενεργοποιήθηκε ξανά",
    "removed": "Το {name} διαγράφηκε",
    "category_name": "Νέα κατηγορία (π.χ. Life Protection)",
    "category_name_for": "Νέα κατηγορία της {insurer}",
    "maps_to": "Τύπος συμβολαίου",
    "add_category": "Προσθήκη κατηγορίας",
    "plan_name": "Νέο πρόγραμμα (π.χ. Life Plan 1)",
    "plan_name_for": "Νέο πρόγραμμα στην κατηγορία {category}",
    "add_plan": "Προσθήκη προγράμματος",
    "edit_title": "Επεξεργασία: {kind}",
    "insurer_code": "Κωδικός (προαιρετικά)",
    "plan_code": "Κωδικός προγράμματος (προαιρετικά)",
    "branch_inherit": "Όπως η κατηγορία του",
    "active_from": "Διατίθεται από",
    "active_to": "Διατίθεται έως",
    "update_policies": "Ενημέρωση και {count, plural, one {του # υπάρχοντος συμβολαίου} other {των # υπαρχόντων συμβολαίων}} με το νέο όνομα",
    "update_policies_category": "Ενημέρωση και του τύπου {count, plural, one {του # υπάρχοντος συμβολαίου} other {των # υπαρχόντων συμβολαίων}}",
    "history_kept": "{count, plural, one {Το υπάρχον συμβόλαιο κρατά} other {Τα # υπάρχοντα συμβόλαια κρατούν}} το όνομα με το οποίο καταχωρίστηκαν (μένουν συνδεδεμένα με αυτή την καταχώριση).",
    "import_title": "Εισαγωγή ασφαλιστικών και προϊόντων από όσα ήδη έχετε",
    "import_confirm": "Εισαγωγή",
    "import_intro": "Από το επαγγελματικό σας προφίλ και τα υπάρχοντα συμβόλαια: {insurers, plural, =0 {καμία νέα ασφαλιστική} one {# νέα ασφαλιστική} other {# νέες ασφαλιστικές}}, {categories, plural, =0 {καμία νέα κατηγορία} one {# νέα κατηγορία} other {# νέες κατηγορίες}}, {plans, plural, =0 {κανένα νέο πρόγραμμα} one {# νέο πρόγραμμα} other {# νέα προγράμματα}}. Τίποτα επινοημένο: μόνο ονόματα που υπάρχουν ήδη στα δεδομένα σας.",
    "already": "ήδη στον κατάλογο",
    "new": "νέο",
    "from_practice": "από το προφίλ σας",
    "import_link": "Σύνδεση {count, plural, one {του # υπάρχοντος συμβολαίου} other {των # υπαρχόντων συμβολαίων}} με αυτές τις καταχωρίσεις (το κείμενό τους δεν αλλάζει)",
    "import_note": "Ίδια ονόματα με διαφορετική γραφή (κεφαλαία, τόνοι) ενώνονται. Συμβόλαια χωρίς ασφαλιστική δεν περιλαμβάνονται. Οι ασφαλιστικές που γράψατε στο βήμα του προφίλ περιλαμβάνονται μόλις αποθηκευτεί το βήμα.",
    "imported": "Εισήχθησαν: {insurers} ασφαλιστικές, {plans} προγράμματα",
    "choose": "Επιλέξτε…",
    "other": "Άλλο / δεν είναι στον κατάλογό μου",
    "other_note": "Δεν είναι στον κατάλογό σας: πληκτρολογήστε το παρακάτω. Τσεκάρετε «προσθήκη στον κατάλογό μου» για να υπάρχει την επόμενη φορά.",
    "add_from_policy": "Προσθήκη της «{insurer}» και αυτού του προϊόντος στον κατάλογό μου"
  },
  "studio": {
    "title": "AI Studio",
    "subtitle": "Αναρτήσεις, διαφημίσεις, stories και reels για τις καμπάνιες σας — κάθε λέξη με τη δική σας ταυτότητα, κάθε ισχυρισμός από εγκεκριμένα στοιχεία, τίποτα χωρίς την έγκρισή σας.",
    "balance": "{total} από {allowance} μονάδες",
    "balance_hint": "1 μονάδα ≈ €0,01 κόστους παρόχου. Οι μηνιαίες μονάδες ανανεώνονται την 1η του μήνα.",
    "signed_out": "Συνδεθείτε στον λογαριασμό AVRASTRO για να χρησιμοποιήσετε το studio (χρειάζεται την πλατφόρμα).",
    "not_configured_title": "Το studio δεν έχει ενεργοποιηθεί ακόμη",
    "not_configured_body": "Οι πάροχοι εικόνας και φωνής δεν έχουν συνδεθεί ακόμη σε αυτή την πλατφόρμα.",
    "not_entitled_title": "Το AVRASTRO Studio είναι πρόσθετο",
    "not_entitled_body": "Η συνδρομή σας δεν περιλαμβάνει το studio. Διατίθεται ως πρόσθετο «AVRASTRO Studio» ή ως αυτόνομο πακέτο.",
    "fonts_missing": "Δεν φορτώθηκαν οι γραμματοσειρές· η προεπισκόπηση χρησιμοποιεί αυτές του υπολογιστή.",
    "never_posts": "Το studio δεν δημοσιεύει και δεν στέλνει τίποτα μόνο του. Οι εικόνες με σήμανση είναι δημιουργημένες με AI· τα στοιχεία προϊόντων προέρχονται μόνο από το μητρώο ισχυρισμών σας.",
    "tab": {
      "create": "Δημιουργία",
      "library": "Βιβλιοθήκη",
      "reels": "Reels",
      "claims": "Μητρώο ισχυρισμών",
      "credits": "Μονάδες"
    },
    "brief": "1. Τι θέλετε;",
    "brief_text": "Περιγράψτε το με δικά σας λόγια",
    "brief_hint": "Π.χ. «μια ζεστή ανάρτηση για γονείς για τον σχεδιασμό των σπουδών των παιδιών». Ποτέ ονόματα πελατών ή στοιχεία υγείας.",
    "topic": "Θέμα",
    "audience": "Κοινό (ομάδα, ποτέ πρόσωπο)",
    "audience_hint": "Μόνο το θέμα φτάνει στο AI — ποτέ στοιχεία κάποιου.",
    "tone": "Ύφος",
    "language": "Γλώσσα",
    "cite_facts": "Εγκεκριμένα στοιχεία που μπορεί να αναφέρει",
    "cite_hint": "Ποσά, παροχές και καλύψεις μόνο από τα επιλεγμένα στοιχεία — οτιδήποτε άλλο μπλοκάρεται.",
    "page": "σελ.",
    "until": "ισχύει έως {date}",
    "write_copy": "Γράψε τα κείμενα ({credits} μονάδα)",
    "removed": "{count, plural, one {Αφαιρέθηκε # προσωπικό στοιχείο} other {Αφαιρέθηκαν # προσωπικά στοιχεία}} πριν από το AI",
    "ideas": "Ιδέες καμπάνιας",
    "template": "2. Πρότυπο",
    "picture": "3. Εικόνα",
    "variants": "{count, plural, one {# παραλλαγή} other {# παραλλαγές}}",
    "tier_standard": "Κανονική",
    "tier_premium": "Premium",
    "make_images": "Δημιουργία εικόνων ({credits} μονάδες)",
    "own_photo": "Δική μου φωτογραφία",
    "own_photo_licence": "δική μου φωτογραφία, δικαιώματα δηλωμένα από τον χρήστη",
    "own_clip_licence": "δικό μου βίντεο, δικαιώματα δηλωμένα από τον χρήστη",
    "own_music_licence": "δική μου μουσική, άδεια δηλωμένη από τον χρήστη",
    "no_picture": "Χωρίς εικόνα",
    "working": "Γίνεται επεξεργασία…",
    "picture_note": "Το AI φτιάχνει μόνο την εικόνα· κάθε λέξη τη βάζει το πρότυπο με τις γραμματοσειρές σας. Χωρίς ομοιότητα με πραγματικά πρόσωπα, χωρίς κείμενο μέσα στην εικόνα.",
    "edit": "Επεξεργασία",
    "field": {
      "headline": "Τίτλος",
      "subline": "Υπότιτλος",
      "body": "Κείμενο",
      "cta": "Πρόσκληση σε ενέργεια",
      "caption": "Κείμενο ανάρτησης",
      "hashtags": "Hashtags",
      "script": "Αφήγηση",
      "ideas": "Ιδέες",
      "footer": "Υποσημείωση",
      "labels": "Σημάνσεις",
      "claims": "Στοιχεία που αναφέρονται",
      "title": "Τίτλος"
    },
    "contact": "Η γραμμή επικοινωνίας σας",
    "show_logo": "Το λογότυπό μου",
    "show_mark": "Σήμα AVRASTRO",
    "ai_label": "Σήμανση «{label}»",
    "marketing_label": "Σήμανση «Διαφημιστική ενημέρωση» (πάντα)",
    "font_template": "Γραμματοσειρά προτύπου",
    "colour_primary": "Κύριο χρώμα",
    "colour_accent": "Χρώμα έμφασης",
    "formats": "Μεγέθη",
    "format_1x1": "Τετράγωνο 1:1",
    "format_4x5": "Feed 4:5",
    "format_9x16": "Story / reel 9:16",
    "format_16x9": "Οριζόντιο 16:9",
    "format_banner": "Banner",
    "save_draft": "Αποθήκευση ως πρόχειρο",
    "save_changes": "Αποθήκευση αλλαγών",
    "saved": "Αποθηκεύτηκε",
    "saved_reset": "Αποθηκεύτηκε — η αλλαγή χρειάζεται νέα έγκριση",
    "approval_note": "Τίποτα δεν εξάγεται, δεν συνδέεται σε καμπάνια και δεν δημοσιεύεται πριν το εγκρίνετε. Κάθε μεταγενέστερη αλλαγή χρειάζεται νέα έγκριση.",
    "checks_ok": "Οι έλεγχοι πέρασαν",
    "checks_blocked": "Διορθώστε τα πριν από την έγκριση",
    "issue": {
      "number_without_claim": "{field}: «{quote}» — αριθμός χωρίς εγκεκριμένο στοιχείο",
      "risk_phrase": "{field}: «{quote}» — υπόσχεση που κανένας σύμβουλος δεν επιτρέπεται να δώσει",
      "medical_without_claim": "{field}: ιατρική κάλυψη χωρίς εγκεκριμένο ιατρικό στοιχείο",
      "coverage_without_claim": "{field}: τι καλύπτει ένα προϊόν, χωρίς εγκεκριμένο στοιχείο",
      "claim_expired": "Ένα στοιχείο έληξε ή αποσύρθηκε",
      "claim_unknown": "Ένα στοιχείο δεν υπάρχει στο μητρώο",
      "footer_missing": "Λείπει η σημείωση «Γενική ενημέρωση, όχι συμβουλή.»",
      "not_insurer_missing": "Λείπει το «Το AVRASTRO δεν είναι ασφαλιστική εταιρεία.»",
      "marketing_label_missing": "Λείπει η σήμανση διαφήμισης",
      "ai_label_missing": "Η εικόνα AI χρειάζεται σήμανση AI",
      "personal_data": "{field}: «{quote}» — προσωπικά στοιχεία επικοινωνίας",
      "insurer_name": "{field}: «{quote}» — όνομα ασφαλιστικής (η χρήση σημάτων ασφαλιστικών είναι κλειστή)",
      "text_too_long": "{field}: πολύ μεγάλο για κάποιο μέγεθος"
    },
    "review_title": "Έλεγχος AI:",
    "review_pass": "δεν εντόπισε προβλήματα",
    "review_flags": "{count, plural, one {# σημείο για έλεγχο} other {# σημεία για έλεγχο}}",
    "review_advisory": "Μόνο συμβουλευτικό: εσείς αποφασίζετε και εγκρίνετε.",
    "for_campaign": "Για την καμπάνια «{title}»",
    "status_draft": "Πρόχειρο",
    "status_in_review": "Σε έλεγχο",
    "status_approved": "Εγκεκριμένο",
    "status_archived": "Αρχειοθετημένο",
    "approved_by": "Εγκρίθηκε από {who}, {date}",
    "superseded": "το περιεχόμενο άλλαξε έκτοτε",
    "submit": "Για έγκριση",
    "approve": "Έγκριση",
    "reject": "Ζητήστε αλλαγές",
    "archive": "Αρχειοθέτηση",
    "restore": "Επαναφορά",
    "done_submit": "Στάλθηκε για έγκριση",
    "done_approve": "Εγκρίθηκε",
    "done_reject": "Επέστρεψε σε πρόχειρο",
    "done_archive": "Αρχειοθετήθηκε",
    "done_restore": "Επανήλθε",
    "waiting_approval": "Αναμένεται έγκριση από σύμβουλο.",
    "use": "Χρήση",
    "needs_approval": "Εγκρίνετέ το πρώτα: μετά εξαγωγή, σύνδεση σε καμπάνια ή δημοσίευση από εσάς.",
    "choose_campaign": "Επιλέξτε καμπάνια…",
    "attach": "Σύνδεση",
    "attached": "Συνδέθηκε με την καμπάνια",
    "detach": "Αφαίρεση",
    "open_campaign": "Άνοιγμα καμπάνιας",
    "copy_caption": "Αντιγραφή κειμένου ανάρτησης",
    "caption_copied": "Το κείμενο αντιγράφηκε — δημοσιεύστε το από τον δικό σας λογαριασμό",
    "handoff_note": "Η δημοσίευση γίνεται από εσάς: κατεβάστε τα αρχεία και δημοσιεύστε τα από τους λογαριασμούς σας. Τα μηνύματα σε πελάτες περνούν από το Campaign Center με τη συγκατάθεσή τους.",
    "provenance": "Προέλευση",
    "prov_ai": "Περιέχει περιεχόμενο AI (με σήμανση· και στα αρχεία που εξάγονται).",
    "prov_no_ai": "Χωρίς περιεχόμενο δημιουργημένο με AI.",
    "prov_kind_copy": "Κείμενα",
    "prov_kind_review": "Έλεγχος",
    "prov_kind_image": "Εικόνα",
    "prov_kind_video": "Πλάνα AI",
    "prov_kind_voice": "Αφήγηση",
    "prov_kind_transcribe": "Απομαγνητοφώνηση",
    "prov_kind_music": "Μουσική",
    "c2pa_note": "Τα αρχεία φέρουν τη σήμανση IPTC «δημιουργημένο με AI». Τα C2PA Content Credentials δεν υπογράφονται ακόμη (χρειάζεται πιστοποιητικό)· η προέλευση φυλάσσεται εδώ.",
    "history": "Ιστορικό",
    "hist_create": "δημιουργήθηκε",
    "hist_for_campaign": "για καμπάνια",
    "hist_edit": "τροποποιήθηκε",
    "hist_edit_reset": "τροποποιήθηκε — η έγκριση μηδενίστηκε",
    "hist_submit": "στάλθηκε για έγκριση",
    "hist_approve": "εγκρίθηκε",
    "hist_reject": "ζητήθηκαν αλλαγές",
    "hist_archive": "αρχειοθετήθηκε",
    "hist_restore": "επανήλθε",
    "hist_attach": "συνδέθηκε σε καμπάνια",
    "hist_detach": "αφαιρέθηκε από καμπάνια",
    "hist_export": "εξήχθη",
    "hist_export_review": "εξαγωγή — ξανά για έγκριση",
    "export_review": "Το αρχείο στάλθηκε για έγκριση: θα δοθεί για δημοσίευση μόνο αφού το ελέγξει ο σύμβουλος ή ο διαχειριστής.",
    "export_to_review": "Αρχείο προς έγκριση (αυτό θα δοθεί για δημοσίευση)",
    "export_open": "Άνοιγμα αρχείου",
    "all": "Όλα",
    "library_empty": "Δεν υπάρχουν ακόμη δημιουργίες.",
    "creative": "Δημιουργία",
    "campaign": "Καμπάνια",
    "updated": "Ενημέρωση",
    "kind_image": "Εικόνα",
    "kind_video": "Reel",
    "kind_story": "Story",
    "kind_carousel": "Καρουζέλ",
    "kind_copy": "Κείμενο",
    "kind_presentation": "Παρουσίαση",
    "claims_title": "Μητρώο ισχυρισμών",
    "claims_intro": "Στοιχεία προϊόντων που εγκρίνατε, το καθένα από έγγραφο-πηγή με σελίδα και ημερομηνία ισχύος. Μια δημιουργία αναφέρει ποσό, παροχή, εξαίρεση ή ιατρική κάλυψη μόνο από εδώ.",
    "claims_empty": "Δεν υπάρχουν ακόμη εγκεκριμένα στοιχεία. Χωρίς αυτά το studio γράφει μόνο γενικά, ενημερωτικά κείμενα.",
    "retired": "αποσύρθηκε",
    "retire": "Απόσυρση",
    "approved_on": "εγκρίθηκε {date}",
    "claim_new": "Νέο εγκεκριμένο στοιχείο",
    "claim_plan": "Πρόγραμμα καταλόγου (προαιρετικό)",
    "claim_product": "Προϊόν",
    "claim_statement": "Το στοιχείο, όπως το γράφει η πηγή",
    "claim_statement_hint": "Π.χ. «Νοσοκομειακή κάλυψη έως €100.000 τον χρόνο.» Χωρίς στοιχεία πελατών.",
    "claim_source": "Έγγραφο-πηγή (φυλλάδιο, δελτίο προϊόντος)",
    "claim_source_name": "Όνομα εγγράφου",
    "claim_valid_until": "Ισχύει έως",
    "claim_add": "Έγκριση και προσθήκη",
    "claim_added": "Το στοιχείο προστέθηκε",
    "claim_need_file": "Επισυνάψτε πρώτα το έγγραφο-πηγή",
    "claim_note": "Εγκρίνετε ότι το στοιχείο ισχύει για το προϊόν έως την ημερομηνία. Τα στοιχεία δεν διαγράφονται: αποσύρονται.",
    "claim_field_topic": "θέμα",
    "claim_field_product": "προϊόν",
    "claim_field_statement": "το στοιχείο",
    "claim_field_source": "πηγή",
    "claim_field_source_document": "έγγραφο-πηγή",
    "claim_field_page": "σελίδα",
    "claim_field_valid_until": "ημερομηνία ισχύος",
    "claim_field_valid_from": "ημερομηνία έναρξης",
    "claim_field_personal_data": "χωρίς προσωπικά δεδομένα",
    "credits_left": "Υπόλοιπο μονάδων",
    "credits_allowance": "Αυτόν τον μήνα",
    "credits_topup": "Επιπλέον",
    "credits_rules": "Αυστηρά όρια στον server: χωρίς υπόλοιπο δεν γίνεται δημιουργία. Μια αποτυχία επιστρέφει αυτόματα τις μονάδες. Οι μηνιαίες μονάδες που περισσεύουν λήγουν· οι επιπλέον μένουν μέχρι να χρησιμοποιηθούν.",
    "action_col": "Ενέργεια",
    "credits_col": "Μονάδες",
    "ledger": "Κινήσεις μονάδων",
    "ledger_empty": "Δεν υπάρχουν ακόμη κινήσεις.",
    "led_allowance": "μηνιαίες μονάδες",
    "led_expire": "έληξαν",
    "led_topup": "επιπλέον μονάδες",
    "led_charge": "χρήση",
    "led_refund": "επιστροφή",
    "led_adjust": "προσαρμογή",
    "action": {
      "copy": "Κείμενα (ανάρτηση, λεζάντες, σενάριο)",
      "image_standard": "Εικόνα, κανονική",
      "image_premium": "Εικόνα, premium",
      "voice_30s": "Αφήγηση ανά 30″",
      "transcribe_10min": "Απομαγνητοφώνηση ανά 10′",
      "reel_render": "Δημιουργία reel",
      "music_ai": "Μουσική AI",
      "broll_fast": "Πλάνο AI (γρήγορο)",
      "broll_premium": "Πλάνο AI (premium)"
    },
    "confirm_title": "Χρήση μονάδων;",
    "confirm_body": "Η ενέργεια «{action}» θα χρησιμοποιήσει περίπου {credits} μονάδες. Αν ο πάροχος αποτύχει, επιστρέφονται αυτόματα.",
    "confirm_ok": "Χρήση {credits} μονάδων",
    "topic_life": "Προστασία ζωής",
    "topic_medical": "Ιατρική κάλυψη",
    "topic_child_savings": "Αποταμίευση για παιδιά",
    "topic_education": "Σπουδές",
    "topic_retirement": "Σύνταξη",
    "topic_personal_accident": "Προσωπικά ατυχήματα",
    "topic_income_protection": "Προστασία εισοδήματος",
    "topic_loan_protection": "Προστασία δανείου",
    "topic_generic": "Γενικό",
    "aud_general": "Γενικό κοινό",
    "aud_parents_young_children": "Γονείς μικρών παιδιών",
    "aud_new_parents": "Νέοι γονείς",
    "aud_young_couples": "Νέα ζευγάρια",
    "aud_young_professionals": "Νέοι επαγγελματίες",
    "aud_homeowners_mortgage": "Ιδιοκτήτες με στεγαστικό",
    "aud_self_employed": "Αυτοαπασχολούμενοι",
    "aud_business_owners": "Ιδιοκτήτες επιχειρήσεων",
    "aud_pre_retirees": "40–60, σκέφτονται τη σύνταξη",
    "aud_retirees": "Συνταξιούχοι",
    "aud_drivers_families": "Οικογένειες που οδηγούν καθημερινά",
    "aud_homeowners": "Ιδιοκτήτες κατοικίας",
    "tone_warm": "Ζεστό",
    "tone_professional": "Επαγγελματικό",
    "tone_energetic": "Ζωντανό",
    "tone_calm": "Ήρεμο",
    "reels_off": "Τα reels δεν είναι ακόμη διαθέσιμα σε αυτή την πλατφόρμα (η επεξεργασία βίντεο είναι κλειστή).",
    "reel_clips": "Τα βίντεό σας",
    "reel_upload": "Ανέβασμα βίντεο",
    "ai_footage": "πλάνο AI",
    "words": "{count, plural, one {# λέξη} other {# λέξεις}}",
    "transcribe": "Απομαγνητοφώνηση ({credits} μ.)",
    "broll": "Πλάνο AI (premium)",
    "broll_note": "Μόνο ενδεικτικά πλάνα λίγων δευτερολέπτων· ποτέ ρεαλιστικά πρόσωπα ως πελάτες. Με σήμανση AI.",
    "broll_placeholder": "Π.χ. κύματα σε ήσυχη παραλία στο ηλιοβασίλεμα",
    "broll_make": "Δημιουργία πλάνου ({credits} μονάδες)",
    "broll_clip": "Πλάνο AI",
    "reel_length": "Διάρκεια: περίπου {seconds}″",
    "reel_plan": "Επιλογή καλύτερων στιγμών",
    "reel_heuristic": "Η επιλογή είναι αυτόματη και όχι τέλεια (καθαρές, ολόκληρες φράσεις με τη σειρά λήψης): ελέγξτε και αφαιρέστε κομμάτια.",
    "reel_total": "Διάρκεια reel {seconds}″",
    "reel_title": "Τίτλος",
    "reel_default_title": "Reel",
    "voiceover": "Αφήγηση (προαιρετική)",
    "voiceover_hint": "Ελέγχεται όπως κάθε κείμενο: χωρίς αριθμούς χωρίς στοιχείο, χωρίς υποσχέσεις.",
    "make_voice": "Δημιουργία αφήγησης ({credits} μονάδες)",
    "music": "Μουσική",
    "music_hint": "Δική μας μουσική (χωρίς δείγματα, χωρίς άδειες) ή δικό σας κομμάτι με άδεια.",
    "music_none": "Χωρίς μουσική",
    "music_calm": "Ήρεμη",
    "music_warm": "Ζεστή",
    "music_bright": "Φωτεινή",
    "music_own": "Δικό μου κομμάτι",
    "music_upload": "Ανέβασμα δικού μου κομματιού με άδεια",
    "transition": "Μεταξύ πλάνων",
    "transition_cut": "Κόψιμο",
    "transition_fade": "Σβήσιμο",
    "vertical": "Κάθετο 9:16",
    "horizontal": "Οριζόντιο 16:9",
    "captions": "{count, plural, one {# υπότιτλος} other {# υπότιτλοι}}",
    "reel_render": "Δημιουργία reel ({credits} μονάδες)",
    "rendering": "Δημιουργείται στην πλατφόρμα — περίπου ένα λεπτό για 30″.",
    "reel_note": "Υπότιτλοι, τίτλοι και τελική κάρτα μπαίνουν από το AVRASTRO με τις γραμματοσειρές σας· κάθε reel κλείνει με «Γενική ενημέρωση, όχι συμβουλή.»",
    "creatives": "Δημιουργίες",
    "create_for_campaign": "Δημιουργία στο AI Studio",
    "no_creatives": "Δεν έχουν συνδεθεί ακόμη δημιουργίες.",
    "choose_approved": "Επιλέξτε εγκεκριμένη δημιουργία…",
    "only_approved": "Συνδέονται μόνο εγκεκριμένες δημιουργίες· μια αλλαγή μετά την έγκριση χρειάζεται νέα έγκριση πριν από τη χρήση.",
    "err": {
      "generic": "Το studio δεν μπόρεσε να το κάνει ({code}).",
      "network": "Δεν υπάρχει σύνδεση με την πλατφόρμα.",
      "plan_feature": "Το studio δεν περιλαμβάνεται στη συνδρομή σας.",
      "studio_not_configured": "Το studio δεν είναι ενεργό σε αυτή την πλατφόρμα.",
      "studio_credits_exhausted": "Δεν φτάνουν οι μονάδες αυτού του μήνα.",
      "studio_daily_cap": "Συμπληρώθηκε το σημερινό όριο ασφαλείας· δοκιμάστε αύριο.",
      "studio_confirm_required": "Επιβεβαιώστε πρώτα τις μονάδες.",
      "studio_provider_failed": "Ο πάροχος δεν απάντησε· οι μονάδες επιστράφηκαν.",
      "studio_not_approved": "Μόνο εγκεκριμένη δημιουργία μπορεί να χρησιμοποιηθεί.",
      "studio_checks_failed": "Οι έλεγχοι βρήκαν κάτι προς διόρθωση (δείτε τη λίστα).",
      "studio_sensitive": "Η περιγραφή περιέχει στοιχεία υγείας (πάθηση, διάγνωση, φάρμακα ή επέμβαση) — δικά σας ή άλλου προσώπου, π.χ. πελάτη. Δεν στέλνονται ποτέ στο AI. Γράψτε το θέμα γενικά (π.χ. «κάλυψη σοβαρών ασθενειών»), χωρίς πρόσωπα.",
      "studio_audience": "Το κοινό πρέπει να είναι μία από τις ομάδες της λίστας.",
      "studio_type": "Αυτός ο τύπος αρχείου δεν γίνεται δεκτός.",
      "too_large": "Το αρχείο είναι πολύ μεγάλο.",
      "studio_storage_full": "Ο χώρος του studio γέμισε.",
      "licence_expired": "Η συνδρομή έληξε: οι υπάρχουσες δημιουργίες παραμένουν ορατές.",
      "permission": "Ο ρόλος σας δεν επιτρέπει αυτή την ενέργεια.",
      "studio_approver_role": "Εγκρίνει μόνο σύμβουλος ή διαχειριστής.",
      "studio_hash_mismatch": "Η δημιουργία άλλαξε στο μεταξύ· ανανεώστε.",
      "studio_status": "Η δημιουργία δεν είναι πια σε αυτή την κατάσταση· ανανεώστε.",
      "studio_claim": "Το στοιχείο χρειάζεται: {fields}.",
      "studio_claim_unknown": "Ένα στοιχείο δεν υπάρχει στο μητρώο.",
      "studio_job_failed": "Η δημιουργία απέτυχε· οι μονάδες επιστράφηκαν.",
      "studio_job_timeout": "Η δημιουργία αργεί· δείτε τη βιβλιοθήκη αργότερα.",
      "campaign_not_found": "Η καμπάνια δεν υπάρχει σε αυτόν τον χώρο εργασίας.",
      "studio_reel_length": "Ένα reel είναι έως 60 δευτερόλεπτα."
    }
  },
  "phonecal": {
    "title": "Ημερολόγιο κινητού",
    "intro": "Τα ραντεβού και το πρόγραμμά σας στο ημερολόγιο του iPhone ή του Android, συνδεδεμένα με τον λογαριασμό AVRASTRO σας. Κάθε κατηγορία είναι ξεχωριστό ημερολόγιο, ώστε να της δώσετε δικό της χρώμα στο κινητό.",
    "need_account": "Χρειάζεται σύνδεση στον λογαριασμό AVRASTRO (και συγχρονισμός): το ημερολόγιο το σερβίρει η πλατφόρμα από τα συγχρονισμένα δεδομένα σας.",
    "account": "Λογαριασμός",
    "workspace": "Χώρος εργασίας",
    "last_fetch": "Τελευταία ανάγνωση από κινητό",
    "never": "ακόμη καμία",
    "detail": "Τι γράφουν τα γεγονότα",
    "detail_initials": "Μόνο τύπος και αρχικά πελάτη (π.χ. «Ραντεβού · Μ.Γ.») — προτείνεται",
    "detail_full": "Ο τίτλος σας, το όνομα του πελάτη και ο τόπος",
    "detail_note": "Ποτέ σημειώσεις, τηλέφωνα, στοιχεία υγείας ή συμβολαίων. Με «πλήρη» στοιχεία φαίνεται ο τίτλος όπως τον γράψατε — γι’ αυτό μη γράφετε ευαίσθητα στοιχεία στους τίτλους.",
    "create": "Δημιουργία συνδέσμων ημερολογίου",
    "created": "Οι σύνδεσμοι είναι έτοιμοι",
    "saved": "Αποθηκεύτηκε — το κινητό θα το δείξει στην επόμενη ανανέωση",
    "subscribe": "Συνδρομή (iPhone)",
    "all_or_each": "Διαλέξτε είτε το «Όλα» είτε τα ξεχωριστά (για χρώμα ανά κατηγορία) — όχι και τα δύο, αλλιώς βλέπετε κάθε γεγονός δύο φορές.",
    "what": {
      "all": "Όλα μαζί σε ένα ημερολόγιο",
      "appointments": "Ραντεβού του CRM",
      "plan": "Το πρόγραμμά σας: καφές / σύσταση, προετοιμασία, εκπαίδευση, ομάδα, γραφειακά, μετακίνηση",
      "calls": "Τηλεφωνήματα και follow-up",
      "personal": "Διαλείμματα και προσωπικός χρόνος"
    },
    "qr_alt": "QR για το ημερολόγιο {name}",
    "qr_hint": "Σαρώστε με την κάμερα του iPhone για συνδρομή. Στο Android χρησιμοποιήστε τον σύνδεσμο https στο Google Calendar (υπολογιστής).",
    "qr_for": "QR για",
    "regenerate": "Νέος σύνδεσμος",
    "regenerate_confirm": "Οι σημερινοί σύνδεσμοι σταματούν αμέσως να λειτουργούν· θα χρειαστεί να προσθέσετε ξανά τα ημερολόγια στο κινητό. Συνέχεια;",
    "regenerated": "Νέοι σύνδεσμοι — οι παλιοί δεν λειτουργούν πια",
    "revoke": "Απενεργοποίηση",
    "revoke_confirm": "Οι σύνδεσμοι σταματούν αμέσως· στο κινητό τα ημερολόγια θα μείνουν κενά ή θα δείξουν σφάλμα — διαγράψτε τα από εκεί. Συνέχεια;",
    "revoked": "Το ημερολόγιο κινητού απενεργοποιήθηκε",
    "err": "Δεν έγινε ({code})",
    "iphone": {
      "1": "Στο iPhone, ανοίξτε αυτή τη σελίδα και πατήστε «Συνδρομή (iPhone)» — ή σαρώστε το QR με την κάμερα.",
      "2": "Ή χειροκίνητα: Ρυθμίσεις → Ημερολόγιο → Λογαριασμοί → Προσθήκη λογαριασμού → Άλλο → Προσθήκη ημερολογίου συνδρομής, και επικολλήστε τον σύνδεσμο.",
      "3": "Πατήστε «Επόμενο», δώστε όνομα αν θέλετε και διαλέξτε χρώμα — ένα για κάθε ημερολόγιο.",
      "4": "Στο «Αυτόματη ανανέωση» διαλέξτε «Κάθε ώρα» (ή όσο συχνά θέλετε).",
      "5": "Επαναλάβετε για κάθε κατηγορία που θέλετε (ή μόνο «Όλα»)."
    },
    "android": {
      "1": "Το Google Calendar προσθέτει ημερολόγια από σύνδεσμο μόνο από υπολογιστή: ανοίξτε calendar.google.com με τον λογαριασμό Google του κινητού.",
      "2": "Αριστερά: «Άλλα ημερολόγια» → «+» → «Από διεύθυνση URL».",
      "3": "Επικολλήστε τον σύνδεσμο https (κουμπί «Αντιγραφή») και πατήστε «Προσθήκη ημερολογίου».",
      "4": "Στις ρυθμίσεις του ημερολογίου διαλέξτε χρώμα· στο κινητό: Google Calendar → Ρυθμίσεις → το ημερολόγιο → «Συγχρονισμός» ενεργό.",
      "5": "Το Google ανανεώνει τέτοια ημερολόγια κάθε λίγες ώρες (έως και μία ημέρα) — μια αλλαγή δεν φαίνεται αμέσως."
    },
    "note_colour": "Χρώμα: το iPhone και το Google δίνουν χρώμα ανά ημερολόγιο, όχι ανά γεγονός — γι’ αυτό κάθε κατηγορία είναι ξεχωριστό ημερολόγιο.",
    "note_refresh": "Ανανέωση: το κινητό ρωτά μόνο του (iPhone συνήθως κάθε 15 λεπτά έως 1 ώρα, Google κάθε λίγες ώρες)· αμέσως δεν γίνεται.",
    "note_readonly": "Μόνο ανάγνωση: οι αλλαγές γίνονται στο CRM, όχι στο κινητό.",
    "note_sync": "Φαίνεται ό,τι έχει συγχρονιστεί με την πλατφόρμα (Συγχρονισμός ενεργός), από 30 ημέρες πριν έως 6 μήνες μπροστά.",
    "note_privacy": "Ο σύνδεσμος είναι μυστικός: όποιος τον έχει βλέπει το ημερολόγιο. Μην τον μοιράζεστε· «Νέος σύνδεσμος» ή «Απενεργοποίηση» τον σταματούν αμέσως. Τα δεδομένα μένουν στην πλατφόρμα AVRASTRO· το κινητό κρατά αντίγραφο.",
    "note_future": "Αμφίδρομος συγχρονισμός με Google / Outlook (αλλαγές από το κινητό πίσω στο CRM) θέλει δικές μας εφαρμογές OAuth στη Google / Microsoft — μελλοντική επιλογή."
  },
  "taxf": {
    "title": "Ο φορολογικός μου φάκελος",
    "subtitle": "Τα δικά σας έγγραφα και αποδείξεις ως αυτοτελώς εργαζόμενος σύμβουλος, ανά φορολογικό έτος — έτοιμα για τον λογιστή σας.",
    "year": "Φορολογικό έτος",
    "private": "Ιδιωτικός φάκελος: τον βλέπετε μόνο εσείς. Ο διευθυντής, οι βοηθοί και τα άλλα μέλη της ομάδας δεν τον βλέπουν, εκτός αν τον μοιραστείτε.",
    "shared_by": "Φάκελος συναδέλφου που σας κοινοποιήθηκε — μόνο ανάγνωση.",
    "shared_list": "Κοινοποιήθηκαν σε εσάς",
    "not_client": "Αφορά τη δική σας επιχείρηση, όχι πελάτες. Για φορολογικό σχεδιασμό πελατών:",
    "open_taxc": "Φορολογικό κέντρο",
    "start": "Άνοιγμα φακέλου {year}",
    "start_hint": "Ένας φάκελος ανά έτος: μαζεύετε εδώ αποδείξεις και βεβαιώσεις όλη τη χρονιά και στο τέλος στέλνετε στον λογιστή ένα τακτοποιημένο ZIP.",
    "created": "Ο φάκελος {year} άνοιξε· προστέθηκε υπενθύμιση στην ατζέντα.",
    "add": "Προσθήκη εγγράφου",
    "add_manual": "Χωρίς αρχείο",
    "choose": "Επιλογή αρχείων",
    "camera": "Φωτογραφία",
    "drop": "Σύρετε εδώ PDF ή φωτογραφίες (JPG, PNG, HEIC) — ή επιλέξτε αρχεία.",
    "drop_active": "Αφήστε τα αρχεία για να τα προσθέσετε",
    "unsupported": "Το «{name}» δεν είναι PDF, JPG, PNG ή HEIC.",
    "too_large": "Το «{name}» ξεπερνά τα {mb} MB.",
    "reading": "Ανάγνωση εγγράφου…",
    "queue": "Έγγραφο {n} από {total}",
    "stored": "Το έγγραφο αποθηκεύτηκε στον φάκελο.",
    "saved": "Αποθηκεύτηκε.",
    "deleted": "Αφαιρέθηκε από τον φάκελο.",
    "overview": "Ανά κατηγορία",
    "all_categories": "Όλες οι κατηγορίες",
    "count": "{count, plural, one {# έγγραφο} other {# έγγραφα}}",
    "missing_n": "{count} λείπουν",
    "other_currencies": "και σε άλλα νομίσματα: {list}",
    "total": "Σύνολο σε EUR",
    "files_n": "{count, plural, one {# αρχείο} other {# αρχεία}}",
    "items": "Έγγραφα και αποδείξεις",
    "search": "Αναζήτηση (εκδότης, σημείωση, ποσό, ημερομηνία)",
    "empty": "Δεν υπάρχει ακόμη έγγραφο σε αυτό το έτος.",
    "no_match": "Κανένα έγγραφο δεν ταιριάζει.",
    "checklist": "Τι περιμένω — λίστα ελέγχου",
    "checklist_empty": "Προσθέστε ό,τι έρχεται τακτικά (π.χ. κοινωνικές ασφαλίσεις κάθε μήνα) για να βλέπετε τι λείπει.",
    "still_missing": "Λείπουν ακόμη",
    "nothing_missing": "Δεν λείπει τίποτα από όσα περιμένετε.",
    "show_done": "Εμφάνιση και των παραληφθέντων",
    "upload_for": "Ανέβασμα",
    "waive": "Δεν χρειάζεται",
    "unwaive": "Επαναφορά",
    "notes": "Σημειώσεις για τον λογιστή",
    "notes_ph": "π.χ. «Το αυτοκίνητο χρησιμοποιείται ~70% για τη δουλειά», «Ο Μάρτιος πληρώθηκε τον Απρίλιο».",
    "accountant": "Ο λογιστής μου",
    "accountant_name": "Όνομα",
    "accountant_email": "E-mail",
    "export_zip": "ZIP για τον λογιστή",
    "exporting": "Δημιουργία ZIP…",
    "exported": "Το ZIP δημιουργήθηκε ({files} αρχεία).",
    "export_missing_files": "{count} αρχεία δεν βρέθηκαν σε αυτή τη συσκευή και λείπουν από το ZIP (δείτε το index.csv).",
    "mail_draft": "Πρόχειρο e-mail στον λογιστή",
    "mail_title": "Πρόχειρο μήνυμα για τον λογιστή",
    "mail_note": "Δεν αποστέλλεται τίποτα αυτόματα. Ανοίξτε το στο πρόγραμμα αλληλογραφίας σας, επισυνάψτε το ZIP και στείλτε το εσείς.",
    "mail_open": "Άνοιγμα στο e-mail",
    "mail_copy": "Αντιγραφή κειμένου",
    "mail_copied": "Το κείμενο αντιγράφηκε.",
    "mark_sent": "Το έστειλα στον λογιστή",
    "sent_on": "Στάλθηκε στον λογιστή στις {date}",
    "share": "Κοινοποίηση",
    "share_title": "Κοινοποίηση φακέλου {year}",
    "share_hint": "Μόνο τα μέλη της ομάδας με αυτά τα e-mail θα μπορούν να διαβάσουν τον φάκελο (όχι να τον αλλάξουν). Αφαιρέστε ένα e-mail για να σταματήσει η πρόσβαση.",
    "share_emails": "E-mail μελών (ένα ανά γραμμή)",
    "shared_with": "Κοινοποιείται σε: {list}",
    "quick": "Γρήγορη προσθήκη",
    "quick_title": "Τακτικά έγγραφα της χρονιάς",
    "quick_hint": "Δημιουργεί τις αναμενόμενες θέσεις στη λίστα ελέγχου — μία ανά μήνα, τρίμηνο ή έτος. Αν τις προσθέσετε ξανά, δεν διπλασιάζονται.",
    "quick_category": "Τι περιμένετε",
    "quick_subject": "Εταιρεία / φορέας (προαιρετικό)",
    "quick_subject_ph": "π.χ. «Δοκιμαστική Ασφαλιστική (φανταστική)»",
    "quick_add": "Προσθήκη στη λίστα",
    "quick_added": "{count, plural, one {Προστέθηκε # θέση} other {Προστέθηκαν # θέσεις}} στη λίστα ελέγχου.",
    "quick_none": "Υπάρχουν ήδη όλες — δεν προστέθηκε τίποτα.",
    "freq": {
      "monthly": "Κάθε μήνα (12)",
      "quarterly": "Κάθε τρίμηνο (4)",
      "annual": "Μία φορά τον χρόνο"
    },
    "cert": "Ετήσια βεβαίωση ασφαλίστρων",
    "cert_title": "Βεβαίωση ασφαλίστρων — μία ανά δικό σας συμβόλαιο",
    "cert_hint": "Αν είστε και πελάτης στο δικό σας CRM, επιλέξτε τον εαυτό σας για να βρεθούν τα συμβόλαιά σας ζωής, σύνταξης και υγείας. Αλλιώς γράψτε τα με το χέρι.",
    "cert_me": "Εγώ ως πελάτης (προαιρετικό)",
    "cert_manual": "Συμβόλαια με το χέρι (ένα ανά γραμμή)",
    "cert_manual_ph": "π.χ. «Ζωής — Δοκιμαστική Ασφαλιστική (φανταστική) — 12345»",
    "cert_none": "Δεν βρέθηκε συμβόλαιο ζωής, σύνταξης ή υγείας σε αυτό το άτομο.",
    "categories": "Κατηγορίες",
    "categories_title": "Κατηγορίες του {year}",
    "categories_hint": "Μετονομάστε ή κρύψτε κατηγορίες και προσθέστε δικές σας. Ισχύουν για αυτό το έτος· ένα νέο έτος τις παίρνει από το προηγούμενο.",
    "cat_hidden": "Κρυφή",
    "cat_custom": "Δική μου κατηγορία",
    "cat_new": "Νέα κατηγορία",
    "cat_group": "Ομάδα",
    "form_new": "Νέο έγγραφο",
    "form_edit": "Έγγραφο του φακέλου",
    "prefilled": "Κάποια πεδία συμπληρώθηκαν από το κείμενο του εγγράφου. Ελέγξτε τα και διορθώστε ό,τι χρειάζεται — αποθηκεύονται μόνο όταν πατήσετε «Αποθήκευση».",
    "from_doc": "από το έγγραφο",
    "no_text": "Το έγγραφο δεν έχει κείμενο για ανάγνωση (π.χ. φωτογραφία ή σάρωση) — συμπληρώστε τα πεδία.",
    "field": {
      "date": "Ημερομηνία",
      "amount": "Ποσό",
      "currency": "Νόμισμα",
      "issuer": "Εκδότης / προμηθευτής",
      "category": "Κατηγορία",
      "subcategory": "Υποκατηγορία",
      "declare": "Να δηλωθεί;",
      "status": "Κατάσταση",
      "notes": "Σημείωση για τον λογιστή",
      "files": "Αρχεία",
      "expected": "Απαντά στο αναμενόμενο",
      "period": "Περίοδος"
    },
    "none": "— κανένα —",
    "declare_hint": "Δική σας σήμανση για τον λογιστή — το AVRASTRO δεν κρίνει τι εκπίπτει.",
    "declare": {
      "yes": "Ναι",
      "no": "Όχι",
      "ask": "Να ρωτήσω τον λογιστή"
    },
    "status": {
      "missing": "Λείπει",
      "received": "Παραλήφθηκε",
      "checked": "Ελέγχθηκε",
      "waived": "Δεν χρειάζεται"
    },
    "mark_checked": "Σήμανση ως ελεγμένο",
    "add_file": "Προσθήκη αρχείου",
    "open_file": "Άνοιγμα",
    "detach": "Αφαίρεση αρχείου",
    "detach_confirm": "Να αφαιρεθεί το αρχείο από τον φάκελο;",
    "delete": "Αφαίρεση εγγράφου",
    "delete_confirm": "Να αφαιρεθεί αυτό το έγγραφο και τα αρχεία του από τον φάκελο; Μπορείτε να το αναιρέσετε αμέσως μετά.",
    "file_missing": "Το αρχείο δεν βρίσκεται σε αυτή τη συσκευή.",
    "read_only": "Μόνο ανάγνωση",
    "reminder": "Υπενθύμιση στην ατζέντα: {date}",
    "reminder_title": "Ετοιμάστε τον φορολογικό φάκελο {year}",
    "reminder_add": "Υπενθύμιση τον Μάρτιο",
    "hints": "Χρήσιμες πληροφορίες (Κύπρος)",
    "hint_mark": "για επιβεβαίωση από τον λογιστή σας",
    "hints_disclaimer": "Οργάνωση εγγράφων — όχι φορολογική συμβουλή. Το AVRASTRO δεν υπολογίζει φόρο και δεν κρίνει τι εκπίπτει· οι πληροφορίες προέρχονται από δημόσιες πηγές (έλεγχος 29/10/2026) και μπορεί να αλλάξουν.",
    "sources": "Πηγές",
    "cat_hints": "Πληροφορίες για την κατηγορία",
    "help_card": "Μαζέψτε τα δικά σας φορολογικά έγγραφα της χρονιάς σε έναν ιδιωτικό φάκελο και στείλτε τα στον λογιστή ως ένα ZIP.",
    "business_card": "Ο φορολογικός μου φάκελος {year}",
    "business_card_sub": "{items} έγγραφα · {missing} λείπουν",
    "open": "Άνοιγμα",
    "group": {
      "income": "Έσοδα",
      "contributions": "Εισφορές",
      "insurance": "Ασφάλιστρα",
      "business": "Επαγγελματικά έξοδα",
      "personal": "Προσωπικές εκπτώσεις",
      "other": "Άλλα"
    },
    "cat": {
      "commissions": "Έσοδα — καταστάσεις προμηθειών",
      "social_insurance": "Κοινωνικές ασφαλίσεις (αυτοτελώς εργαζόμενος)",
      "gesy": "Εισφορές ΓεΣΥ",
      "provident_pension": "Ταμείο προνοίας και συνταξιοδοτικά",
      "life_insurance": "Ασφάλιστρα ζωής και βεβαίωση ασφαλίστρων",
      "medical_insurance": "Ιατροφαρμακευτική ασφάλιση",
      "home_insurance": "Ασφάλιση κατοικίας (φυσικές καταστροφές)",
      "professional_indemnity": "Ασφάλιση επαγγελματικής ευθύνης",
      "licence_fees": "Άδεια, μητρώο και επαγγελματικοί φορείς",
      "cpd_training": "Συνεχής επιμόρφωση (CPD) και εκπαίδευση",
      "office_rent_utilities": "Ενοίκιο γραφείου και λογαριασμοί",
      "car_fuel": "Αυτοκίνητο και καύσιμα",
      "phone_internet": "Τηλέφωνο και internet",
      "equipment": "Εξοπλισμός",
      "software_subscriptions": "Λογισμικό και συνδρομές (και το CRM)",
      "marketing": "Προβολή και marketing",
      "travel": "Ταξίδια",
      "accounting_legal": "Λογιστικά και νομικά",
      "bank_charges": "Τραπεζικά έξοδα",
      "housing": "Ενοίκιο ή τόκοι στεγαστικού κύριας κατοικίας",
      "green_ev": "Ενεργειακή αναβάθμιση / ηλεκτρικό όχημα",
      "donations": "Δωρεές",
      "other": "Άλλα"
    },
    "sub": {
      "premium": "Απόδειξη ασφαλίστρου",
      "annual_certificate": "Ετήσια βεβαίωση ασφαλίστρων",
      "supervisor": "Εποπτική αρχή",
      "professional_body": "Επαγγελματικός σύνδεσμος",
      "registration": "Εγγραφή / ανανέωση",
      "rent": "Ενοίκιο",
      "electricity": "Ρεύμα",
      "water": "Νερό",
      "cleaning": "Καθαριότητα",
      "common_charges": "Κοινόχρηστα",
      "other": "Άλλο",
      "fuel": "Καύσιμα",
      "service": "Συντήρηση",
      "insurance": "Ασφάλιση",
      "road_tax": "Τέλη κυκλοφορίας",
      "parking": "Στάθμευση",
      "mortgage_interest": "Τόκοι στεγαστικού"
    },
    "hint": {
      "deadline_2025": "Φορολογική δήλωση 2025 (Τ.Φ.1): μέσω TAXISnet, προθεσμία 31/10/2026 (Διάταγμα 260/2026)· χωρίς τόκους ή χρεώσεις αν υποβληθεί και πληρωθεί έως 30/11/2026 (απόφαση Επιτρόπου 19/10/2026).",
      "deadline_2026": "Από το φορολογικό έτος 2026: δήλωση μέσω Tax For All, έως 31/7/2027· υποχρέωση δήλωσης για κάθε φορολογικό κάτοικο 25 έως 70 ετών, ανεξάρτητα από το εισόδημα.",
      "accounts_deadline": "Όσοι έχουν ελεγμένους/επισκοπημένους λογαριασμούς έχουν άλλη προθεσμία· π.χ. ανακοίνωση 26/3/2026: παράταση από 31/3 σε 30/4/2026.",
      "audit_threshold_2026": "Από το 2026 το όριο για υποχρεωτικούς ελεγμένους λογαριασμούς φυσικών προσώπων αυξάνεται σε €120.000 (από €70.000).",
      "threshold_2025": "Για το 2025: αφορολόγητο όριο €19.500.",
      "threshold_2026": "Για το 2026: αφορολόγητο όριο €22.000 (από €19.500) και νέες κλίμακες 20% / 25% / 30% / 35%.",
      "family_2026": "Νέες προσωπικές εκπτώσεις από το 2026 με εισοδηματικά κριτήρια οικογένειας (€100.000 χωρίς ή με 1–2 παιδιά, €150.000 με 3–4, €200.000 με 5+, €40.000 για άγαμο): παιδιά (€1.000 / €1.250 / €1.500), ενοίκιο ή τόκοι στεγαστικού (έως €2.000), ενεργειακή αναβάθμιση/ηλεκτρικό όχημα (έως €1.000). Προϋπόθεση: εμπρόθεσμη δήλωση.",
      "one_fifth": "Κοινωνικές ασφαλίσεις, ΓεΣΥ, ταμεία προνοίας/σύνταξης, ιατροφαρμακευτικά σχέδια και ασφάλιστρα ζωής εκπίπτουν μαζί έως το 1/5 του εισοδήματος — ο κανόνας ισχύει και το 2025 και από το 2026.",
      "self_employed_rates": "Αυτοτελώς εργαζόμενοι (2025): κοινωνικές ασφαλίσεις 16,6% του ασφαλιστέου εισοδήματος· ΓεΣΥ 4%.",
      "life_7pct": "Ασφάλιστρα ζωής: λαμβάνονται υπόψη έως το 7% του ασφαλισμένου ποσού. Κρατήστε την ετήσια βεβαίωση ασφαλίστρων της ασφαλιστικής.",
      "incapacity_2026": "Από 1/1/2026 εκπίπτουν και ασφάλιστρα για μόνιμη ή προσωρινή, ολική ή μερική ανικανότητα (με το ίδιο όριο 7%).",
      "home_insurance_2026": "Από 1/1/2026: ασφάλιστρα κατοικίας για φυσικές καταστροφές (πυρκαγιά, σεισμός, πλημμύρα) έως €500 τον χρόνο, για κάθε κατοικία στην Κύπρο, χωρίς εισοδηματικά κριτήρια.",
      "housing_2026": "Από το 2026: ενοίκιο ή τόκοι στεγαστικού κύριας κατοικίας στην Κύπρο έως €2.000 ανά σύζυγο/μέρος· το ενοίκιο πρέπει να πληρώνεται ηλεκτρονικά (μεταφορά, κάρτα), οι κρατικές επιδοτήσεις αφαιρούνται.",
      "green_2026": "Από το 2026: ενεργειακή αναβάθμιση κύριας κατοικίας, φωτοβολταϊκά/μπαταρίες, νέο ηλεκτρικό όχημα ή σταθμός φόρτισης έως €1.000 τον χρόνο ανά σύζυγο/μέρος· ό,τι περισσεύει μεταφέρεται έως 4 έτη.",
      "subscriptions": "Συνδρομές σε συντεχνίες και επαγγελματικούς φορείς: εκπίπτουν (πίνακας 2025)· ο οδηγός του 2026 δεν τις αναφέρει.",
      "donations": "Δωρεές σε εγκεκριμένα φιλανθρωπικά ιδρύματα: εκπίπτουν με αποδείξεις (πίνακας 2025).",
      "business_use": "Ο λογιστής σας κρίνει τι αφορά την επαγγελματική σας δραστηριότητα και σε ποιο ποσοστό (π.χ. αυτοκίνητο ή τηλέφωνο με ιδιωτική χρήση). Σημειώστε την επαγγελματική χρήση στη σημείωση."
    },
    "export": {
      "title": "Φορολογικός φάκελος {year} — Σύνοψη",
      "generated": "Δημιουργήθηκε: {at}",
      "disclaimer": "Οργάνωση εγγράφων — όχι φορολογική συμβουλή",
      "disclaimer_more": "Τα έγγραφα συγκέντρωσε ο/η σύμβουλος στο AVRASTRO. Η στήλη «Να δηλωθεί;» είναι δική του/της σήμανση· την τελική κρίση κάνει ο λογιστής. Δεν έγινε υπολογισμός φόρου.",
      "totals": "Σύνολα ανά κατηγορία",
      "category": "Κατηγορία",
      "count": "Πλήθος",
      "total_eur": "Σύνολο (EUR)",
      "to_declare": "Να δηλωθούν",
      "missing_n": "Λείπουν",
      "all": "Σύνολο",
      "no_conversion": "Ποσά σε άλλα νομίσματα εμφανίζονται χωριστά — δεν έγινε μετατροπή.",
      "documents": "Κατάλογος εγγράφων",
      "date": "Ημερομηνία",
      "issuer": "Εκδότης",
      "amount": "Ποσό",
      "declare": "Να δηλωθεί;",
      "status": "Κατάσταση",
      "files": "Αρχεία",
      "notes": "Σημείωση",
      "no_file": "χωρίς αρχείο",
      "none": "Κανένα έγγραφο.",
      "missing": "Τι λείπει ακόμη",
      "nothing_missing": "Δεν λείπει τίποτα από όσα αναμένονταν.",
      "advisor_notes": "Σημειώσεις του συμβούλου",
      "footer": "Περιεχόμενα του ZIP: ένας φάκελος ανά κατηγορία, αρχεία με όνομα ΗΗΗΗ-ΜΜ-ΗΗ_κατηγορία_εκδότης_ποσό, index.csv (UTF-8) και αυτή η σύνοψη.",
      "no": "Α/Α",
      "subcategory": "Υποκατηγορία",
      "currency": "Νόμισμα",
      "period": "Περίοδος"
    },
    "mail": {
      "subject": "Φορολογικός φάκελος {year} — {name}",
      "greeting": "Καλημέρα {name},",
      "intro": "σας στέλνω τα έγγραφα του φορολογικού έτους {year} για τη δήλωσή μου.",
      "attached": "Συνημμένο: {file} (ένας φάκελος ανά κατηγορία, index.csv και σύνοψη SYNOPSI.html).",
      "counts": "Περιλαμβάνει {items} έγγραφα ({files} αρχεία), σύνολο σε EUR {total}.",
      "missing": "Λείπουν ακόμη {n}:",
      "nothing_missing": "Δεν λείπει κάτι από όσα περίμενα.",
      "notes": "Σημειώσεις:",
      "closing": "Ευχαριστώ,"
    },
    "upcoming": "Επόμενο",
    "show_all": "Όλες οι κατηγορίες"
  }
}
